//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class StoreConnectionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    getDeliProducts(storeAccessKey?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/StoreConnection/DeliProducts?";
        if (storeAccessKey === null)
            throw new Error("The parameter 'storeAccessKey' cannot be null.");
        else if (storeAccessKey !== undefined)
            url_ += "StoreAccessKey=" + encodeURIComponent("" + storeAccessKey) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeliProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeliProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processGetDeliProducts(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    getDeliProducts2(storeAccessKey?: string | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/StoreConnection/DeliProducts?";
        if (storeAccessKey === null)
            throw new Error("The parameter 'storeAccessKey' cannot be null.");
        else if (storeAccessKey !== undefined)
            url_ += "StoreAccessKey=" + encodeURIComponent("" + storeAccessKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeliProducts2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeliProducts2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processGetDeliProducts2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    getProductsCorrelationCoefficient(storeAccessKey?: string | undefined, pluUpcs?: string[] | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/StoreConnection/ProductsCorrelationCoefficient?";
        if (storeAccessKey === null)
            throw new Error("The parameter 'storeAccessKey' cannot be null.");
        else if (storeAccessKey !== undefined)
            url_ += "StoreAccessKey=" + encodeURIComponent("" + storeAccessKey) + "&";
        if (pluUpcs === null)
            throw new Error("The parameter 'pluUpcs' cannot be null.");
        else if (pluUpcs !== undefined)
            pluUpcs && pluUpcs.forEach(item => { url_ += "PluUpcs=" + encodeURIComponent("" + item) + "&"; });
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductsCorrelationCoefficient(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductsCorrelationCoefficient(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processGetProductsCorrelationCoefficient(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    getProductsCorrelationCoefficient2(storeAccessKey?: string | undefined, pluUpcs?: string[] | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/StoreConnection/ProductsCorrelationCoefficient?";
        if (storeAccessKey === null)
            throw new Error("The parameter 'storeAccessKey' cannot be null.");
        else if (storeAccessKey !== undefined)
            url_ += "StoreAccessKey=" + encodeURIComponent("" + storeAccessKey) + "&";
        if (pluUpcs === null)
            throw new Error("The parameter 'pluUpcs' cannot be null.");
        else if (pluUpcs !== undefined)
            pluUpcs && pluUpcs.forEach(item => { url_ += "PluUpcs=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductsCorrelationCoefficient2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductsCorrelationCoefficient2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processGetProductsCorrelationCoefficient2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    getProducts(storeAccessKey?: string | undefined, departments?: string | undefined, excludedDepartments?: boolean | undefined, pluUpcs?: string[] | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/StoreConnection/Products?";
        if (storeAccessKey === null)
            throw new Error("The parameter 'storeAccessKey' cannot be null.");
        else if (storeAccessKey !== undefined)
            url_ += "StoreAccessKey=" + encodeURIComponent("" + storeAccessKey) + "&";
        if (departments === null)
            throw new Error("The parameter 'departments' cannot be null.");
        else if (departments !== undefined)
            url_ += "Departments=" + encodeURIComponent("" + departments) + "&";
        if (excludedDepartments === null)
            throw new Error("The parameter 'excludedDepartments' cannot be null.");
        else if (excludedDepartments !== undefined)
            url_ += "ExcludedDepartments=" + encodeURIComponent("" + excludedDepartments) + "&";
        if (pluUpcs === null)
            throw new Error("The parameter 'pluUpcs' cannot be null.");
        else if (pluUpcs !== undefined)
            pluUpcs && pluUpcs.forEach(item => { url_ += "PluUpcs=" + encodeURIComponent("" + item) + "&"; });
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processGetProducts(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    getProducts2(storeAccessKey?: string | undefined, departments?: string | undefined, excludedDepartments?: boolean | undefined, pluUpcs?: string[] | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/StoreConnection/Products?";
        if (storeAccessKey === null)
            throw new Error("The parameter 'storeAccessKey' cannot be null.");
        else if (storeAccessKey !== undefined)
            url_ += "StoreAccessKey=" + encodeURIComponent("" + storeAccessKey) + "&";
        if (departments === null)
            throw new Error("The parameter 'departments' cannot be null.");
        else if (departments !== undefined)
            url_ += "Departments=" + encodeURIComponent("" + departments) + "&";
        if (excludedDepartments === null)
            throw new Error("The parameter 'excludedDepartments' cannot be null.");
        else if (excludedDepartments !== undefined)
            url_ += "ExcludedDepartments=" + encodeURIComponent("" + excludedDepartments) + "&";
        if (pluUpcs === null)
            throw new Error("The parameter 'pluUpcs' cannot be null.");
        else if (pluUpcs !== undefined)
            pluUpcs && pluUpcs.forEach(item => { url_ += "PluUpcs=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProducts2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProducts2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processGetProducts2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    getPromotions(storeAccessKey?: string | undefined, pluUpcs?: string[] | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/StoreConnection/Promotions?";
        if (storeAccessKey === null)
            throw new Error("The parameter 'storeAccessKey' cannot be null.");
        else if (storeAccessKey !== undefined)
            url_ += "StoreAccessKey=" + encodeURIComponent("" + storeAccessKey) + "&";
        if (pluUpcs === null)
            throw new Error("The parameter 'pluUpcs' cannot be null.");
        else if (pluUpcs !== undefined)
            pluUpcs && pluUpcs.forEach(item => { url_ += "PluUpcs=" + encodeURIComponent("" + item) + "&"; });
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPromotions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPromotions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processGetPromotions(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    getPromotions2(storeAccessKey?: string | undefined, pluUpcs?: string[] | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/StoreConnection/Promotions?";
        if (storeAccessKey === null)
            throw new Error("The parameter 'storeAccessKey' cannot be null.");
        else if (storeAccessKey !== undefined)
            url_ += "StoreAccessKey=" + encodeURIComponent("" + storeAccessKey) + "&";
        if (pluUpcs === null)
            throw new Error("The parameter 'pluUpcs' cannot be null.");
        else if (pluUpcs !== undefined)
            pluUpcs && pluUpcs.forEach(item => { url_ += "PluUpcs=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPromotions2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPromotions2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processGetPromotions2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    getDiscounts(storeAccessKeys?: string[] | undefined, startdate?: Date | undefined, enddate?: Date | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/StoreConnection/DiscountCoupons?";
        if (storeAccessKeys === null)
            throw new Error("The parameter 'storeAccessKeys' cannot be null.");
        else if (storeAccessKeys !== undefined)
            storeAccessKeys && storeAccessKeys.forEach(item => { url_ += "StoreAccessKeys=" + encodeURIComponent("" + item) + "&"; });
        if (startdate === null)
            throw new Error("The parameter 'startdate' cannot be null.");
        else if (startdate !== undefined)
            url_ += "Startdate=" + encodeURIComponent(startdate ? "" + startdate.toISOString() : "") + "&";
        if (enddate === null)
            throw new Error("The parameter 'enddate' cannot be null.");
        else if (enddate !== undefined)
            url_ += "Enddate=" + encodeURIComponent(enddate ? "" + enddate.toISOString() : "") + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiscounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiscounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processGetDiscounts(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    getDiscounts2(storeAccessKeys?: string[] | undefined, startdate?: Date | undefined, enddate?: Date | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/StoreConnection/DiscountCoupons?";
        if (storeAccessKeys === null)
            throw new Error("The parameter 'storeAccessKeys' cannot be null.");
        else if (storeAccessKeys !== undefined)
            storeAccessKeys && storeAccessKeys.forEach(item => { url_ += "StoreAccessKeys=" + encodeURIComponent("" + item) + "&"; });
        if (startdate === null)
            throw new Error("The parameter 'startdate' cannot be null.");
        else if (startdate !== undefined)
            url_ += "Startdate=" + encodeURIComponent(startdate ? "" + startdate.toISOString() : "") + "&";
        if (enddate === null)
            throw new Error("The parameter 'enddate' cannot be null.");
        else if (enddate !== undefined)
            url_ += "Enddate=" + encodeURIComponent(enddate ? "" + enddate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiscounts2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiscounts2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processGetDiscounts2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    get(api_version?: string | null | undefined): Observable<SwaggerResponse<StoreConnection[]>> {
        let url_ = this.baseUrl + "/StoreConnection?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<StoreConnection[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<StoreConnection[]>>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SwaggerResponse<StoreConnection[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StoreConnection.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<StoreConnection[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    get2(): Observable<SwaggerResponse<StoreConnection[]>> {
        let url_ = this.baseUrl + "/api/v1/StoreConnection";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<StoreConnection[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<StoreConnection[]>>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<SwaggerResponse<StoreConnection[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StoreConnection.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<StoreConnection[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    postTransactions(storeAccessKey?: string | undefined, orderId?: string | undefined, source?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/StoreConnection/Transactions?";
        if (storeAccessKey === null)
            throw new Error("The parameter 'storeAccessKey' cannot be null.");
        else if (storeAccessKey !== undefined)
            url_ += "storeAccessKey=" + encodeURIComponent("" + storeAccessKey) + "&";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (source === null)
            throw new Error("The parameter 'source' cannot be null.");
        else if (source !== undefined)
            url_ += "source=" + encodeURIComponent("" + source) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processPostTransactions(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    postTransactions2(storeAccessKey?: string | undefined, orderId?: string | undefined, source?: string | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/StoreConnection/Transactions?";
        if (storeAccessKey === null)
            throw new Error("The parameter 'storeAccessKey' cannot be null.");
        else if (storeAccessKey !== undefined)
            url_ += "storeAccessKey=" + encodeURIComponent("" + storeAccessKey) + "&";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (source === null)
            throw new Error("The parameter 'source' cannot be null.");
        else if (source !== undefined)
            url_ += "source=" + encodeURIComponent("" + source) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostTransactions2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostTransactions2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processPostTransactions2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    postOrderRecive(storeAccessKey?: string | undefined, orderId?: string | undefined, source?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/StoreConnection/OrderRecive?";
        if (storeAccessKey === null)
            throw new Error("The parameter 'storeAccessKey' cannot be null.");
        else if (storeAccessKey !== undefined)
            url_ += "storeAccessKey=" + encodeURIComponent("" + storeAccessKey) + "&";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (source === null)
            throw new Error("The parameter 'source' cannot be null.");
        else if (source !== undefined)
            url_ += "source=" + encodeURIComponent("" + source) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostOrderRecive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostOrderRecive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processPostOrderRecive(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    postOrderRecive2(storeAccessKey?: string | undefined, orderId?: string | undefined, source?: string | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/StoreConnection/OrderRecive?";
        if (storeAccessKey === null)
            throw new Error("The parameter 'storeAccessKey' cannot be null.");
        else if (storeAccessKey !== undefined)
            url_ += "storeAccessKey=" + encodeURIComponent("" + storeAccessKey) + "&";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (source === null)
            throw new Error("The parameter 'source' cannot be null.");
        else if (source !== undefined)
            url_ += "source=" + encodeURIComponent("" + source) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostOrderRecive2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostOrderRecive2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processPostOrderRecive2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class AppCardClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    transactionsReconcile(storeId?: number | undefined, transactionFile?: FileParameter | null | undefined): Observable<SwaggerResponse<TransactionsReconcileResult[]>> {
        let url_ = this.baseUrl + "/api/v1/AppCard/transactions/file/reconcile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (storeId === null || storeId === undefined)
            throw new Error("The parameter 'storeId' cannot be null.");
        else
            content_.append("StoreId", storeId.toString());
        if (transactionFile !== null && transactionFile !== undefined)
            content_.append("TransactionFile", transactionFile.data, transactionFile.fileName ? transactionFile.fileName : "TransactionFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransactionsReconcile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransactionsReconcile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<TransactionsReconcileResult[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<TransactionsReconcileResult[]>>;
        }));
    }

    protected processTransactionsReconcile(response: HttpResponseBase): Observable<SwaggerResponse<TransactionsReconcileResult[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TransactionsReconcileResult.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<TransactionsReconcileResult[]>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class BaseDataClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    getDeaprtmrnts(stores?: number[] | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<Department[]>> {
        let url_ = this.baseUrl + "/api/BaseData/department?";
        if (stores === null)
            throw new Error("The parameter 'stores' cannot be null.");
        else if (stores !== undefined)
            stores && stores.forEach(item => { url_ += "stores=" + encodeURIComponent("" + item) + "&"; });
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeaprtmrnts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeaprtmrnts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<Department[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<Department[]>>;
        }));
    }

    protected processGetDeaprtmrnts(response: HttpResponseBase): Observable<SwaggerResponse<Department[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Department.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<Department[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    getDeaprtmrnts2(stores?: number[] | undefined): Observable<SwaggerResponse<Department[]>> {
        let url_ = this.baseUrl + "/api/v1/BaseData/department?";
        if (stores === null)
            throw new Error("The parameter 'stores' cannot be null.");
        else if (stores !== undefined)
            stores && stores.forEach(item => { url_ += "stores=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDeaprtmrnts2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDeaprtmrnts2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<Department[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<Department[]>>;
        }));
    }

    protected processGetDeaprtmrnts2(response: HttpResponseBase): Observable<SwaggerResponse<Department[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Department.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<Department[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    getVendors(stores?: number[] | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<Vendor[]>> {
        let url_ = this.baseUrl + "/api/BaseData/vendors?";
        if (stores === null)
            throw new Error("The parameter 'stores' cannot be null.");
        else if (stores !== undefined)
            stores && stores.forEach(item => { url_ += "stores=" + encodeURIComponent("" + item) + "&"; });
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVendors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<Vendor[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<Vendor[]>>;
        }));
    }

    protected processGetVendors(response: HttpResponseBase): Observable<SwaggerResponse<Vendor[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Vendor.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<Vendor[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    getVendors2(stores?: number[] | undefined): Observable<SwaggerResponse<Vendor[]>> {
        let url_ = this.baseUrl + "/api/v1/BaseData/vendors?";
        if (stores === null)
            throw new Error("The parameter 'stores' cannot be null.");
        else if (stores !== undefined)
            stores && stores.forEach(item => { url_ += "stores=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVendors2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVendors2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<Vendor[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<Vendor[]>>;
        }));
    }

    protected processGetVendors2(response: HttpResponseBase): Observable<SwaggerResponse<Vendor[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Vendor.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<Vendor[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    getBrands(stores?: number[] | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<Brand[]>> {
        let url_ = this.baseUrl + "/api/BaseData/brands?";
        if (stores === null)
            throw new Error("The parameter 'stores' cannot be null.");
        else if (stores !== undefined)
            stores && stores.forEach(item => { url_ += "stores=" + encodeURIComponent("" + item) + "&"; });
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBrands(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBrands(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<Brand[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<Brand[]>>;
        }));
    }

    protected processGetBrands(response: HttpResponseBase): Observable<SwaggerResponse<Brand[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Brand.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<Brand[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    getBrands2(stores?: number[] | undefined): Observable<SwaggerResponse<Brand[]>> {
        let url_ = this.baseUrl + "/api/v1/BaseData/brands?";
        if (stores === null)
            throw new Error("The parameter 'stores' cannot be null.");
        else if (stores !== undefined)
            stores && stores.forEach(item => { url_ += "stores=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBrands2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBrands2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<Brand[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<Brand[]>>;
        }));
    }

    protected processGetBrands2(response: HttpResponseBase): Observable<SwaggerResponse<Brand[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Brand.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<Brand[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    getTaxs(stores?: number[] | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<TaxDto[]>> {
        let url_ = this.baseUrl + "/api/BaseData/taxs?";
        if (stores === null)
            throw new Error("The parameter 'stores' cannot be null.");
        else if (stores !== undefined)
            stores && stores.forEach(item => { url_ += "stores=" + encodeURIComponent("" + item) + "&"; });
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaxs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaxs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<TaxDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<TaxDto[]>>;
        }));
    }

    protected processGetTaxs(response: HttpResponseBase): Observable<SwaggerResponse<TaxDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaxDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<TaxDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    getTaxs2(stores?: number[] | undefined): Observable<SwaggerResponse<TaxDto[]>> {
        let url_ = this.baseUrl + "/api/v1/BaseData/taxs?";
        if (stores === null)
            throw new Error("The parameter 'stores' cannot be null.");
        else if (stores !== undefined)
            stores && stores.forEach(item => { url_ += "stores=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaxs2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaxs2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<TaxDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<TaxDto[]>>;
        }));
    }

    protected processGetTaxs2(response: HttpResponseBase): Observable<SwaggerResponse<TaxDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaxDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<TaxDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    getDepartmentGroup(stores?: number[] | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<DepartmentGroupDto[]>> {
        let url_ = this.baseUrl + "/api/BaseData/department/group?";
        if (stores === null)
            throw new Error("The parameter 'stores' cannot be null.");
        else if (stores !== undefined)
            stores && stores.forEach(item => { url_ += "stores=" + encodeURIComponent("" + item) + "&"; });
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDepartmentGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDepartmentGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<DepartmentGroupDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<DepartmentGroupDto[]>>;
        }));
    }

    protected processGetDepartmentGroup(response: HttpResponseBase): Observable<SwaggerResponse<DepartmentGroupDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DepartmentGroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<DepartmentGroupDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    getDepartmentGroup2(stores?: number[] | undefined): Observable<SwaggerResponse<DepartmentGroupDto[]>> {
        let url_ = this.baseUrl + "/api/v1/BaseData/department/group?";
        if (stores === null)
            throw new Error("The parameter 'stores' cannot be null.");
        else if (stores !== undefined)
            stores && stores.forEach(item => { url_ += "stores=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDepartmentGroup2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDepartmentGroup2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<DepartmentGroupDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<DepartmentGroupDto[]>>;
        }));
    }

    protected processGetDepartmentGroup2(response: HttpResponseBase): Observable<SwaggerResponse<DepartmentGroupDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DepartmentGroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<DepartmentGroupDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class BundlesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    /**
     * 查询店铺下时间段的Bundles
     * @param storeId 店铺ID
     * @param endTime 结束时间
     * @param api_version (optional) 
     */
    getBundles(storeId: number, endTime: Date, api_version?: string | null | undefined): Observable<SwaggerResponse<BundlesDto[]>> {
        let url_ = this.baseUrl + "/api/Bundles/{storeId}/{endTime}?";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (endTime === undefined || endTime === null)
            throw new Error("The parameter 'endTime' must be defined.");
        url_ = url_.replace("{endTime}", encodeURIComponent(endTime ? "" + endTime.toISOString() : "null"));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBundles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBundles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<BundlesDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<BundlesDto[]>>;
        }));
    }

    protected processGetBundles(response: HttpResponseBase): Observable<SwaggerResponse<BundlesDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BundlesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<BundlesDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 查询店铺下时间段的Bundles
     * @param storeId 店铺ID
     * @param endTime 结束时间
     */
    getBundles2(storeId: number, endTime: Date): Observable<SwaggerResponse<BundlesDto[]>> {
        let url_ = this.baseUrl + "/api/v1/Bundles/{storeId}/{endTime}";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (endTime === undefined || endTime === null)
            throw new Error("The parameter 'endTime' must be defined.");
        url_ = url_.replace("{endTime}", encodeURIComponent(endTime ? "" + endTime.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBundles2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBundles2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<BundlesDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<BundlesDto[]>>;
        }));
    }

    protected processGetBundles2(response: HttpResponseBase): Observable<SwaggerResponse<BundlesDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BundlesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<BundlesDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    copyBundle(sourceStoreId: number, destinationStoreId: number, sourceBundleId: string, api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/Bundles/CopyBundle/{sourceStoreId}/{destinationStoreId}/{sourceBundleId}?";
        if (sourceStoreId === undefined || sourceStoreId === null)
            throw new Error("The parameter 'sourceStoreId' must be defined.");
        url_ = url_.replace("{sourceStoreId}", encodeURIComponent("" + sourceStoreId));
        if (destinationStoreId === undefined || destinationStoreId === null)
            throw new Error("The parameter 'destinationStoreId' must be defined.");
        url_ = url_.replace("{destinationStoreId}", encodeURIComponent("" + destinationStoreId));
        if (sourceBundleId === undefined || sourceBundleId === null)
            throw new Error("The parameter 'sourceBundleId' must be defined.");
        url_ = url_.replace("{sourceBundleId}", encodeURIComponent("" + sourceBundleId));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopyBundle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopyBundle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processCopyBundle(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    copyBundle2(sourceStoreId: number, destinationStoreId: number, sourceBundleId: string): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/Bundles/CopyBundle/{sourceStoreId}/{destinationStoreId}/{sourceBundleId}";
        if (sourceStoreId === undefined || sourceStoreId === null)
            throw new Error("The parameter 'sourceStoreId' must be defined.");
        url_ = url_.replace("{sourceStoreId}", encodeURIComponent("" + sourceStoreId));
        if (destinationStoreId === undefined || destinationStoreId === null)
            throw new Error("The parameter 'destinationStoreId' must be defined.");
        url_ = url_.replace("{destinationStoreId}", encodeURIComponent("" + destinationStoreId));
        if (sourceBundleId === undefined || sourceBundleId === null)
            throw new Error("The parameter 'sourceBundleId' must be defined.");
        url_ = url_.replace("{sourceBundleId}", encodeURIComponent("" + sourceBundleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCopyBundle2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCopyBundle2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processCopyBundle2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class CategroyClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    /**
     * 修改category的scale
     * @param storeId (optional) 
     * @param categoryId (optional) 
     * @param isScale (optional) 
     * @param api_version (optional) 
     */
    updateCategoryScale(storeId?: number | undefined, categoryId?: string | undefined, isScale?: boolean | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/Categroy/update/catrgory/scale?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (isScale === null)
            throw new Error("The parameter 'isScale' cannot be null.");
        else if (isScale !== undefined)
            url_ += "isScale=" + encodeURIComponent("" + isScale) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCategoryScale(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCategoryScale(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processUpdateCategoryScale(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 修改category的scale
     * @param storeId (optional) 
     * @param categoryId (optional) 
     * @param isScale (optional) 
     */
    updateCategoryScale2(storeId?: number | undefined, categoryId?: string | undefined, isScale?: boolean | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/Categroy/update/catrgory/scale?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (isScale === null)
            throw new Error("The parameter 'isScale' cannot be null.");
        else if (isScale !== undefined)
            url_ += "isScale=" + encodeURIComponent("" + isScale) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCategoryScale2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCategoryScale2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processUpdateCategoryScale2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class CompaniesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    /**
     * 创建新的公司
     * @param companyName (optional) 
     * @param api_version (optional) 
     */
    createdCompany(companyName?: string | null | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<CompanyDTO>> {
        let url_ = this.baseUrl + "/api/Companies?";
        if (companyName !== undefined && companyName !== null)
            url_ += "companyName=" + encodeURIComponent("" + companyName) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatedCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatedCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<CompanyDTO>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<CompanyDTO>>;
        }));
    }

    protected processCreatedCompany(response: HttpResponseBase): Observable<SwaggerResponse<CompanyDTO>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDTO.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<CompanyDTO>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 删除公司
     * @param id (optional) Company Id
     * @param api_version (optional) 
     */
    deleteCompany(id?: number | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/Companies?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCompany(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCompany(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processDeleteCompany(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result204: any = null;
            let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result204 = resultData204 !== undefined ? resultData204 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result204));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 更新公司名字
     * @param id (optional) Conpany Id
     * @param companyName (optional) new Compant Name
     * @param api_version (optional) 
     */
    updateCompay(id?: number | undefined, companyName?: string | null | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/Companies?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (companyName !== undefined && companyName !== null)
            url_ += "companyName=" + encodeURIComponent("" + companyName) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCompay(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCompay(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processUpdateCompay(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result204: any = null;
            let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result204 = resultData204 !== undefined ? resultData204 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result204));
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = resultData409 !== undefined ? resultData409 : <any>null;
    
            return throwException("\u65b0\u7684\u516c\u53f8\u540d\u548c\u65e7\u7684\u516c\u53f8\u540d\u91cd\u590d\u6216\u8005\u6570\u636e\u5e93\u9519\u8bef", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取所有已存在的公司
     * @param api_version (optional) 
     * @return Companies
     */
    getCompanies(api_version?: string | null | undefined): Observable<SwaggerResponse<CompaniesDTO>> {
        let url_ = this.baseUrl + "/api/Companies?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanies(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanies(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<CompaniesDTO>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<CompaniesDTO>>;
        }));
    }

    protected processGetCompanies(response: HttpResponseBase): Observable<SwaggerResponse<CompaniesDTO>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompaniesDTO.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found!", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<CompaniesDTO>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 创建新的公司
     * @param companyName (optional) 
     */
    createdCompany2(companyName?: string | null | undefined): Observable<SwaggerResponse<CompanyDTO>> {
        let url_ = this.baseUrl + "/api/v1/Companies?";
        if (companyName !== undefined && companyName !== null)
            url_ += "companyName=" + encodeURIComponent("" + companyName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatedCompany2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatedCompany2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<CompanyDTO>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<CompanyDTO>>;
        }));
    }

    protected processCreatedCompany2(response: HttpResponseBase): Observable<SwaggerResponse<CompanyDTO>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyDTO.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<CompanyDTO>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 删除公司
     * @param id (optional) Company Id
     */
    deleteCompany2(id?: number | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/Companies?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCompany2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCompany2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processDeleteCompany2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result204: any = null;
            let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result204 = resultData204 !== undefined ? resultData204 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result204));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 更新公司名字
     * @param id (optional) Conpany Id
     * @param companyName (optional) new Compant Name
     */
    updateCompay2(id?: number | undefined, companyName?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/Companies?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (companyName !== undefined && companyName !== null)
            url_ += "companyName=" + encodeURIComponent("" + companyName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCompay2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCompay2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processUpdateCompay2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result204: any = null;
            let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result204 = resultData204 !== undefined ? resultData204 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result204));
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result409 = resultData409 !== undefined ? resultData409 : <any>null;
    
            return throwException("\u65b0\u7684\u516c\u53f8\u540d\u548c\u65e7\u7684\u516c\u53f8\u540d\u91cd\u590d\u6216\u8005\u6570\u636e\u5e93\u9519\u8bef", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取所有已存在的公司
     * @return Companies
     */
    getCompanies2(): Observable<SwaggerResponse<CompaniesDTO>> {
        let url_ = this.baseUrl + "/api/v1/Companies";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanies2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanies2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<CompaniesDTO>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<CompaniesDTO>>;
        }));
    }

    protected processGetCompanies2(response: HttpResponseBase): Observable<SwaggerResponse<CompaniesDTO>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompaniesDTO.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Not Found!", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<CompaniesDTO>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class CustomerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    getAccountNumbers(companyId?: number | undefined, searchText?: string | null | undefined, stores?: number[] | null | undefined, isInActive?: boolean | null | undefined, customerLevel?: number[] | null | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<string[]>> {
        let url_ = this.baseUrl + "/api/stores/Customer/accountnumbers?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (stores !== undefined && stores !== null)
            stores && stores.forEach(item => { url_ += "stores=" + encodeURIComponent("" + item) + "&"; });
        if (isInActive !== undefined && isInActive !== null)
            url_ += "isInActive=" + encodeURIComponent("" + isInActive) + "&";
        if (customerLevel !== undefined && customerLevel !== null)
            customerLevel && customerLevel.forEach(item => { url_ += "customerLevel=" + encodeURIComponent("" + item) + "&"; });
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountNumbers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountNumbers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string[]>>;
        }));
    }

    protected processGetAccountNumbers(response: HttpResponseBase): Observable<SwaggerResponse<string[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    getAccountNumbers2(companyId?: number | undefined, searchText?: string | null | undefined, stores?: number[] | null | undefined, isInActive?: boolean | null | undefined, customerLevel?: number[] | null | undefined): Observable<SwaggerResponse<string[]>> {
        let url_ = this.baseUrl + "/api/v1/stores/Customer/accountnumbers?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        if (stores !== undefined && stores !== null)
            stores && stores.forEach(item => { url_ += "stores=" + encodeURIComponent("" + item) + "&"; });
        if (isInActive !== undefined && isInActive !== null)
            url_ += "isInActive=" + encodeURIComponent("" + isInActive) + "&";
        if (customerLevel !== undefined && customerLevel !== null)
            customerLevel && customerLevel.forEach(item => { url_ += "customerLevel=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountNumbers2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountNumbers2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string[]>>;
        }));
    }

    protected processGetAccountNumbers2(response: HttpResponseBase): Observable<SwaggerResponse<string[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    getAccountNumberDetails(body: AccountNumberDetailsBody, api_version?: string | null | undefined): Observable<SwaggerResponse<AccountNumberDetailDto[]>> {
        let url_ = this.baseUrl + "/api/stores/Customer/accountnumbers/details?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountNumberDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountNumberDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<AccountNumberDetailDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<AccountNumberDetailDto[]>>;
        }));
    }

    protected processGetAccountNumberDetails(response: HttpResponseBase): Observable<SwaggerResponse<AccountNumberDetailDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountNumberDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<AccountNumberDetailDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    getAccountNumberDetails2(body: AccountNumberDetailsBody): Observable<SwaggerResponse<AccountNumberDetailDto[]>> {
        let url_ = this.baseUrl + "/api/v1/stores/Customer/accountnumbers/details";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountNumberDetails2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountNumberDetails2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<AccountNumberDetailDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<AccountNumberDetailDto[]>>;
        }));
    }

    protected processGetAccountNumberDetails2(response: HttpResponseBase): Observable<SwaggerResponse<AccountNumberDetailDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountNumberDetailDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<AccountNumberDetailDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    exportCsv(body: AccountNumberDetailsBody, api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/stores/Customer/accountnumbers/details/export-csv?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCsv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processExportCsv(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    exportCsv2(body: AccountNumberDetailsBody): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/stores/Customer/accountnumbers/details/export-csv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportCsv2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCsv2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processExportCsv2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 用来查询某个时间段内，按顾客类型（会员 / 非会员）统计销售金额
     * @param stores (optional) 
     * @param begin (optional) 
     * @param end (optional) 
     * @param api_version (optional) 
     */
    getSalesSummaryByCustomerType(stores?: number[] | undefined, begin?: Date | undefined, end?: Date | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<CustomerTypeSalesSummaryDto[]>> {
        let url_ = this.baseUrl + "/api/stores/Customer/sales-summary/by-customer-type?";
        if (stores === null)
            throw new Error("The parameter 'stores' cannot be null.");
        else if (stores !== undefined)
            stores && stores.forEach(item => { url_ += "Stores=" + encodeURIComponent("" + item) + "&"; });
        if (begin === null)
            throw new Error("The parameter 'begin' cannot be null.");
        else if (begin !== undefined)
            url_ += "Begin=" + encodeURIComponent(begin ? "" + begin.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "End=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalesSummaryByCustomerType(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesSummaryByCustomerType(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<CustomerTypeSalesSummaryDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<CustomerTypeSalesSummaryDto[]>>;
        }));
    }

    protected processGetSalesSummaryByCustomerType(response: HttpResponseBase): Observable<SwaggerResponse<CustomerTypeSalesSummaryDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerTypeSalesSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<CustomerTypeSalesSummaryDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 用来查询某个时间段内，按顾客类型（会员 / 非会员）统计销售金额
     * @param stores (optional) 
     * @param begin (optional) 
     * @param end (optional) 
     */
    getSalesSummaryByCustomerType2(stores?: number[] | undefined, begin?: Date | undefined, end?: Date | undefined): Observable<SwaggerResponse<CustomerTypeSalesSummaryDto[]>> {
        let url_ = this.baseUrl + "/api/v1/stores/Customer/sales-summary/by-customer-type?";
        if (stores === null)
            throw new Error("The parameter 'stores' cannot be null.");
        else if (stores !== undefined)
            stores && stores.forEach(item => { url_ += "Stores=" + encodeURIComponent("" + item) + "&"; });
        if (begin === null)
            throw new Error("The parameter 'begin' cannot be null.");
        else if (begin !== undefined)
            url_ += "Begin=" + encodeURIComponent(begin ? "" + begin.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "End=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalesSummaryByCustomerType2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesSummaryByCustomerType2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<CustomerTypeSalesSummaryDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<CustomerTypeSalesSummaryDto[]>>;
        }));
    }

    protected processGetSalesSummaryByCustomerType2(response: HttpResponseBase): Observable<SwaggerResponse<CustomerTypeSalesSummaryDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerTypeSalesSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<CustomerTypeSalesSummaryDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 用来查询某个时间段内，按顾客类型（会员 / 非会员）统计每一天的销售金额
     * @param store (optional) 
     * @param begin (optional) 
     * @param end (optional) 
     * @param api_version (optional) 
     */
    getSalesSummaryByCustomerTypeDaily(store?: number | undefined, begin?: Date | undefined, end?: Date | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<CustomerTypeSalesSummaryDailyDto[]>> {
        let url_ = this.baseUrl + "/api/stores/Customer/sales-summary/by-customer-type/daily?";
        if (store === null)
            throw new Error("The parameter 'store' cannot be null.");
        else if (store !== undefined)
            url_ += "Store=" + encodeURIComponent("" + store) + "&";
        if (begin === null)
            throw new Error("The parameter 'begin' cannot be null.");
        else if (begin !== undefined)
            url_ += "Begin=" + encodeURIComponent(begin ? "" + begin.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "End=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalesSummaryByCustomerTypeDaily(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesSummaryByCustomerTypeDaily(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<CustomerTypeSalesSummaryDailyDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<CustomerTypeSalesSummaryDailyDto[]>>;
        }));
    }

    protected processGetSalesSummaryByCustomerTypeDaily(response: HttpResponseBase): Observable<SwaggerResponse<CustomerTypeSalesSummaryDailyDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerTypeSalesSummaryDailyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<CustomerTypeSalesSummaryDailyDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 用来查询某个时间段内，按顾客类型（会员 / 非会员）统计每一天的销售金额
     * @param store (optional) 
     * @param begin (optional) 
     * @param end (optional) 
     */
    getSalesSummaryByCustomerTypeDaily2(store?: number | undefined, begin?: Date | undefined, end?: Date | undefined): Observable<SwaggerResponse<CustomerTypeSalesSummaryDailyDto[]>> {
        let url_ = this.baseUrl + "/api/v1/stores/Customer/sales-summary/by-customer-type/daily?";
        if (store === null)
            throw new Error("The parameter 'store' cannot be null.");
        else if (store !== undefined)
            url_ += "Store=" + encodeURIComponent("" + store) + "&";
        if (begin === null)
            throw new Error("The parameter 'begin' cannot be null.");
        else if (begin !== undefined)
            url_ += "Begin=" + encodeURIComponent(begin ? "" + begin.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "End=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalesSummaryByCustomerTypeDaily2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesSummaryByCustomerTypeDaily2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<CustomerTypeSalesSummaryDailyDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<CustomerTypeSalesSummaryDailyDto[]>>;
        }));
    }

    protected processGetSalesSummaryByCustomerTypeDaily2(response: HttpResponseBase): Observable<SwaggerResponse<CustomerTypeSalesSummaryDailyDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerTypeSalesSummaryDailyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<CustomerTypeSalesSummaryDailyDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class DeliOrderingFoodAndroidClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    /**
     * https://connect.syncmcr.com/api/DeliOrderingFoodAndroid/apk
     * @param api_version (optional) 
     */
    downloadApk(api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/DeliOrderingFoodAndroid/apk?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadApk(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadApk(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processDownloadApk(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * https://connect.syncmcr.com/api/DeliOrderingFoodAndroid/apk
     */
    downloadApk2(): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/DeliOrderingFoodAndroid/apk";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadApk2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadApk2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processDownloadApk2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    getVersion(api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/DeliOrderingFoodAndroid/version?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processGetVersion(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    getVersion2(): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/DeliOrderingFoodAndroid/version";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVersion2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVersion2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processGetVersion2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    getConfig(api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/DeliOrderingFoodAndroid/config?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processGetConfig(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    getConfig2(): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/DeliOrderingFoodAndroid/config";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfig2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfig2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processGetConfig2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    uploadApk(api_version?: string | null | undefined, outPutFile?: FileParameter | null | undefined, apkFile?: FileParameter | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/DeliOrderingFoodAndroid/Upload?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (outPutFile !== null && outPutFile !== undefined)
            content_.append("OutPutFile", outPutFile.data, outPutFile.fileName ? outPutFile.fileName : "OutPutFile");
        if (apkFile !== null && apkFile !== undefined)
            content_.append("ApkFile", apkFile.data, apkFile.fileName ? apkFile.fileName : "ApkFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadApk(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadApk(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processUploadApk(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    uploadApk2(outPutFile?: FileParameter | null | undefined, apkFile?: FileParameter | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/DeliOrderingFoodAndroid/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (outPutFile !== null && outPutFile !== undefined)
            content_.append("OutPutFile", outPutFile.data, outPutFile.fileName ? outPutFile.fileName : "OutPutFile");
        if (apkFile !== null && apkFile !== undefined)
            content_.append("ApkFile", apkFile.data, apkFile.fileName ? apkFile.fileName : "ApkFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadApk2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadApk2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processUploadApk2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class DeliOrderingFoodCartClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    /**
     * 创建购物车
     * @param api_version (optional) 
     */
    createCart(request: CreateFoodCartRequest, api_version?: string | null | undefined): Observable<SwaggerResponse<FoodCartResponse>> {
        let url_ = this.baseUrl + "/api/Deliordering/food/cart?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCart(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCart(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FoodCartResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FoodCartResponse>>;
        }));
    }

    protected processCreateCart(response: HttpResponseBase): Observable<SwaggerResponse<FoodCartResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FoodCartResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FoodCartResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 创建购物车
     */
    createCart2(request: CreateFoodCartRequest): Observable<SwaggerResponse<FoodCartResponse>> {
        let url_ = this.baseUrl + "/api/v1/Deliordering/food/cart";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateCart2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateCart2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FoodCartResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FoodCartResponse>>;
        }));
    }

    protected processCreateCart2(response: HttpResponseBase): Observable<SwaggerResponse<FoodCartResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FoodCartResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FoodCartResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 向购物车添加商品
     * @param api_version (optional) 
     */
    addCartItem(request: AddFoodCartItemRequest, api_version?: string | null | undefined): Observable<SwaggerResponse<FoodCartResponse>> {
        let url_ = this.baseUrl + "/api/Deliordering/food/cart/item?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCartItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCartItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FoodCartResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FoodCartResponse>>;
        }));
    }

    protected processAddCartItem(response: HttpResponseBase): Observable<SwaggerResponse<FoodCartResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FoodCartResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FoodCartResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 更新购物车的商品数据
     * @param api_version (optional) 
     */
    updateCartItem(request: UpdateFoodCartItemRequest, api_version?: string | null | undefined): Observable<SwaggerResponse<FoodCartResponse>> {
        let url_ = this.baseUrl + "/api/Deliordering/food/cart/item?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCartItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCartItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FoodCartResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FoodCartResponse>>;
        }));
    }

    protected processUpdateCartItem(response: HttpResponseBase): Observable<SwaggerResponse<FoodCartResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FoodCartResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FoodCartResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 向购物车添加商品
     */
    addCartItem2(request: AddFoodCartItemRequest): Observable<SwaggerResponse<FoodCartResponse>> {
        let url_ = this.baseUrl + "/api/v1/Deliordering/food/cart/item";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCartItem2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCartItem2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FoodCartResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FoodCartResponse>>;
        }));
    }

    protected processAddCartItem2(response: HttpResponseBase): Observable<SwaggerResponse<FoodCartResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FoodCartResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FoodCartResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 更新购物车的商品数据
     */
    updateCartItem2(request: UpdateFoodCartItemRequest): Observable<SwaggerResponse<FoodCartResponse>> {
        let url_ = this.baseUrl + "/api/v1/Deliordering/food/cart/item";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCartItem2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCartItem2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FoodCartResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FoodCartResponse>>;
        }));
    }

    protected processUpdateCartItem2(response: HttpResponseBase): Observable<SwaggerResponse<FoodCartResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FoodCartResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FoodCartResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 删除购物车中的商品
     * @param api_version (optional) 
     */
    deleteCartItem(storeId: number, cartItemId: string, api_version?: string | null | undefined): Observable<SwaggerResponse<DeleteFoodCartItemResponse>> {
        let url_ = this.baseUrl + "/api/Deliordering/food/cart/item/{storeId}/{cartItemId}?";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (cartItemId === undefined || cartItemId === null)
            throw new Error("The parameter 'cartItemId' must be defined.");
        url_ = url_.replace("{cartItemId}", encodeURIComponent("" + cartItemId));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCartItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCartItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<DeleteFoodCartItemResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<DeleteFoodCartItemResponse>>;
        }));
    }

    protected processDeleteCartItem(response: HttpResponseBase): Observable<SwaggerResponse<DeleteFoodCartItemResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteFoodCartItemResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<DeleteFoodCartItemResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 删除购物车中的商品
     */
    deleteCartItem2(storeId: number, cartItemId: string): Observable<SwaggerResponse<DeleteFoodCartItemResponse>> {
        let url_ = this.baseUrl + "/api/v1/Deliordering/food/cart/item/{storeId}/{cartItemId}";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (cartItemId === undefined || cartItemId === null)
            throw new Error("The parameter 'cartItemId' must be defined.");
        url_ = url_.replace("{cartItemId}", encodeURIComponent("" + cartItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCartItem2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCartItem2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<DeleteFoodCartItemResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<DeleteFoodCartItemResponse>>;
        }));
    }

    protected processDeleteCartItem2(response: HttpResponseBase): Observable<SwaggerResponse<DeleteFoodCartItemResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteFoodCartItemResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<DeleteFoodCartItemResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 用户扫描二维码登录购物车
     * @param api_version (optional) 
     */
    loginDeliOrdering(request: LoginFoodCartRequest, api_version?: string | null | undefined): Observable<SwaggerResponse<CustomerResponse>> {
        let url_ = this.baseUrl + "/api/Deliordering/food/cart/login?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoginDeliOrdering(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginDeliOrdering(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<CustomerResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<CustomerResponse>>;
        }));
    }

    protected processLoginDeliOrdering(response: HttpResponseBase): Observable<SwaggerResponse<CustomerResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<CustomerResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 用户扫描二维码登录购物车
     */
    loginDeliOrdering2(request: LoginFoodCartRequest): Observable<SwaggerResponse<CustomerResponse>> {
        let url_ = this.baseUrl + "/api/v1/Deliordering/food/cart/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoginDeliOrdering2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginDeliOrdering2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<CustomerResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<CustomerResponse>>;
        }));
    }

    protected processLoginDeliOrdering2(response: HttpResponseBase): Observable<SwaggerResponse<CustomerResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<CustomerResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 将购物车分配给客户
     * @param api_version (optional) 
     */
    assignCartToCustomer(request: AssignCartToCustomerRequest, api_version?: string | null | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/Deliordering/food/cart/assign-cart-to-customer?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignCartToCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignCartToCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processAssignCartToCustomer(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 将购物车分配给客户
     */
    assignCartToCustomer2(request: AssignCartToCustomerRequest): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/v1/Deliordering/food/cart/assign-cart-to-customer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignCartToCustomer2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignCartToCustomer2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processAssignCartToCustomer2(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class DeliOrderingFoodCategoryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    /**
     * 获取所有分类
     * @param storeId (optional) 
     * @param languageCode (optional) 
     * @param api_version (optional) 
     */
    getCategorys(storeId?: number | undefined, languageCode?: string | null | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<FoodCategoryDto[]>> {
        let url_ = this.baseUrl + "/api/Deliordering/food/category?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (languageCode !== undefined && languageCode !== null)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCategorys(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategorys(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FoodCategoryDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FoodCategoryDto[]>>;
        }));
    }

    protected processGetCategorys(response: HttpResponseBase): Observable<SwaggerResponse<FoodCategoryDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FoodCategoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FoodCategoryDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 新增分类
     * @param storeId (optional) 
     * @param api_version (optional) 
     */
    addCategory(body: InsertFoodCategoryBody, storeId?: number | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<FoodCategoryDto>> {
        let url_ = this.baseUrl + "/api/Deliordering/food/category?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FoodCategoryDto>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FoodCategoryDto>>;
        }));
    }

    protected processAddCategory(response: HttpResponseBase): Observable<SwaggerResponse<FoodCategoryDto>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FoodCategoryDto.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FoodCategoryDto>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 更新分类
     * @param storeId (optional) 
     * @param api_version (optional) 
     */
    updateCategory(body: UpdateFoodCategoryBody, storeId?: number | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/Deliordering/food/category?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processUpdateCategory(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 删除分类
     * @param storeId (optional) 
     * @param categoryId (optional) 
     * @param api_version (optional) 
     */
    deleteCategory(storeId?: number | undefined, categoryId?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/Deliordering/food/category?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCategory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCategory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processDeleteCategory(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取所有分类
     * @param storeId (optional) 
     * @param languageCode (optional) 
     */
    getCategorys2(storeId?: number | undefined, languageCode?: string | null | undefined): Observable<SwaggerResponse<FoodCategoryDto[]>> {
        let url_ = this.baseUrl + "/api/v1/Deliordering/food/category?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (languageCode !== undefined && languageCode !== null)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCategorys2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategorys2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FoodCategoryDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FoodCategoryDto[]>>;
        }));
    }

    protected processGetCategorys2(response: HttpResponseBase): Observable<SwaggerResponse<FoodCategoryDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FoodCategoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FoodCategoryDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 新增分类
     * @param storeId (optional) 
     */
    addCategory2(body: InsertFoodCategoryBody, storeId?: number | undefined): Observable<SwaggerResponse<FoodCategoryDto>> {
        let url_ = this.baseUrl + "/api/v1/Deliordering/food/category?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddCategory2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddCategory2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FoodCategoryDto>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FoodCategoryDto>>;
        }));
    }

    protected processAddCategory2(response: HttpResponseBase): Observable<SwaggerResponse<FoodCategoryDto>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FoodCategoryDto.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FoodCategoryDto>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 更新分类
     * @param storeId (optional) 
     */
    updateCategory2(body: UpdateFoodCategoryBody, storeId?: number | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/v1/Deliordering/food/category?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateCategory2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateCategory2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processUpdateCategory2(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 删除分类
     * @param storeId (optional) 
     * @param categoryId (optional) 
     */
    deleteCategory2(storeId?: number | undefined, categoryId?: string | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/v1/Deliordering/food/category?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCategory2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCategory2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processDeleteCategory2(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 更新分类顺寻
     * @param storeId (optional) 
     * @param api_version (optional) 
     */
    updateSortOrders(body: UpdateSortOrdersBody, storeId?: number | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/Deliordering/food/category/sortorders?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSortOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSortOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processUpdateSortOrders(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 更新分类顺寻
     * @param storeId (optional) 
     */
    updateSortOrders2(body: UpdateSortOrdersBody, storeId?: number | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/v1/Deliordering/food/category/sortorders?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSortOrders2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSortOrders2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processUpdateSortOrders2(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class DeliOrderingFoodItemClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    /**
     * 获取所有分类下的商品
     * @param storeId (optional) 
     * @param foodCategoryId (optional) 
     * @param languageCode (optional) 
     * @param api_version (optional) 
     */
    getFoodItems(storeId?: number | undefined, foodCategoryId?: string | undefined, languageCode?: string | null | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<FoodItemDto[]>> {
        let url_ = this.baseUrl + "/api/Deliordering/food/items?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (foodCategoryId === null)
            throw new Error("The parameter 'foodCategoryId' cannot be null.");
        else if (foodCategoryId !== undefined)
            url_ += "foodCategoryId=" + encodeURIComponent("" + foodCategoryId) + "&";
        if (languageCode !== undefined && languageCode !== null)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFoodItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFoodItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FoodItemDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FoodItemDto[]>>;
        }));
    }

    protected processGetFoodItems(response: HttpResponseBase): Observable<SwaggerResponse<FoodItemDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FoodItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FoodItemDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 新增商品
     * @param storeId (optional) 
     * @param api_version (optional) 
     */
    addFoodItem(body: InserFoodItemBody, storeId?: number | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<FoodItemDto>> {
        let url_ = this.baseUrl + "/api/Deliordering/food/items?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddFoodItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddFoodItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FoodItemDto>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FoodItemDto>>;
        }));
    }

    protected processAddFoodItem(response: HttpResponseBase): Observable<SwaggerResponse<FoodItemDto>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FoodItemDto.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FoodItemDto>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 删除商品
     * @param storeId (optional) 
     * @param itemId (optional) 
     * @param api_version (optional) 
     */
    deleteFoodItem(storeId?: number | undefined, itemId?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/Deliordering/food/items?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (itemId === null)
            throw new Error("The parameter 'itemId' cannot be null.");
        else if (itemId !== undefined)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFoodItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFoodItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processDeleteFoodItem(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 更新商品
     * @param storeId (optional) 
     * @param api_version (optional) 
     */
    updateFoodItem(body: UpdateFoodItemBody, storeId?: number | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<FoodItemDto>> {
        let url_ = this.baseUrl + "/api/Deliordering/food/items?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFoodItem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFoodItem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FoodItemDto>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FoodItemDto>>;
        }));
    }

    protected processUpdateFoodItem(response: HttpResponseBase): Observable<SwaggerResponse<FoodItemDto>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FoodItemDto.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FoodItemDto>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取所有分类下的商品
     * @param storeId (optional) 
     * @param foodCategoryId (optional) 
     * @param languageCode (optional) 
     */
    getFoodItems2(storeId?: number | undefined, foodCategoryId?: string | undefined, languageCode?: string | null | undefined): Observable<SwaggerResponse<FoodItemDto[]>> {
        let url_ = this.baseUrl + "/api/v1/Deliordering/food/items?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (foodCategoryId === null)
            throw new Error("The parameter 'foodCategoryId' cannot be null.");
        else if (foodCategoryId !== undefined)
            url_ += "foodCategoryId=" + encodeURIComponent("" + foodCategoryId) + "&";
        if (languageCode !== undefined && languageCode !== null)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFoodItems2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFoodItems2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FoodItemDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FoodItemDto[]>>;
        }));
    }

    protected processGetFoodItems2(response: HttpResponseBase): Observable<SwaggerResponse<FoodItemDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FoodItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FoodItemDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 新增商品
     * @param storeId (optional) 
     */
    addFoodItem2(body: InserFoodItemBody, storeId?: number | undefined): Observable<SwaggerResponse<FoodItemDto>> {
        let url_ = this.baseUrl + "/api/v1/Deliordering/food/items?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddFoodItem2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddFoodItem2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FoodItemDto>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FoodItemDto>>;
        }));
    }

    protected processAddFoodItem2(response: HttpResponseBase): Observable<SwaggerResponse<FoodItemDto>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FoodItemDto.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FoodItemDto>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 删除商品
     * @param storeId (optional) 
     * @param itemId (optional) 
     */
    deleteFoodItem2(storeId?: number | undefined, itemId?: string | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/v1/Deliordering/food/items?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (itemId === null)
            throw new Error("The parameter 'itemId' cannot be null.");
        else if (itemId !== undefined)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFoodItem2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFoodItem2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processDeleteFoodItem2(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 更新商品
     * @param storeId (optional) 
     */
    updateFoodItem2(body: UpdateFoodItemBody, storeId?: number | undefined): Observable<SwaggerResponse<FoodItemDto>> {
        let url_ = this.baseUrl + "/api/v1/Deliordering/food/items?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFoodItem2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFoodItem2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FoodItemDto>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FoodItemDto>>;
        }));
    }

    protected processUpdateFoodItem2(response: HttpResponseBase): Observable<SwaggerResponse<FoodItemDto>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FoodItemDto.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FoodItemDto>>(new SwaggerResponse(status, _headers, null as any));
    }

    getFoodItemDetails(storeId?: number | undefined, itemId?: string | undefined, languageCode?: string | null | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<FoodItemDetailsDto>> {
        let url_ = this.baseUrl + "/api/Deliordering/food/items/item/details?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (itemId === null)
            throw new Error("The parameter 'itemId' cannot be null.");
        else if (itemId !== undefined)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        if (languageCode !== undefined && languageCode !== null)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFoodItemDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFoodItemDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FoodItemDetailsDto>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FoodItemDetailsDto>>;
        }));
    }

    protected processGetFoodItemDetails(response: HttpResponseBase): Observable<SwaggerResponse<FoodItemDetailsDto>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FoodItemDetailsDto.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FoodItemDetailsDto>>(new SwaggerResponse(status, _headers, null as any));
    }

    getFoodItemDetails2(storeId?: number | undefined, itemId?: string | undefined, languageCode?: string | null | undefined): Observable<SwaggerResponse<FoodItemDetailsDto>> {
        let url_ = this.baseUrl + "/api/v1/Deliordering/food/items/item/details?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (itemId === null)
            throw new Error("The parameter 'itemId' cannot be null.");
        else if (itemId !== undefined)
            url_ += "itemId=" + encodeURIComponent("" + itemId) + "&";
        if (languageCode !== undefined && languageCode !== null)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFoodItemDetails2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFoodItemDetails2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FoodItemDetailsDto>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FoodItemDetailsDto>>;
        }));
    }

    protected processGetFoodItemDetails2(response: HttpResponseBase): Observable<SwaggerResponse<FoodItemDetailsDto>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FoodItemDetailsDto.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FoodItemDetailsDto>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取商品属性组
     * @param api_version (optional) 
     */
    getFoodItemAttributeGroups(storeId: number, itemId: string, api_version?: string | null | undefined): Observable<SwaggerResponse<ProductAttributeGroupDto[]>> {
        let url_ = this.baseUrl + "/api/Deliordering/food/items/{storeId}/attribute/{itemId}/groups?";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFoodItemAttributeGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFoodItemAttributeGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<ProductAttributeGroupDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<ProductAttributeGroupDto[]>>;
        }));
    }

    protected processGetFoodItemAttributeGroups(response: HttpResponseBase): Observable<SwaggerResponse<ProductAttributeGroupDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductAttributeGroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<ProductAttributeGroupDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取商品属性组
     */
    getFoodItemAttributeGroups2(storeId: number, itemId: string): Observable<SwaggerResponse<ProductAttributeGroupDto[]>> {
        let url_ = this.baseUrl + "/api/v1/Deliordering/food/items/{storeId}/attribute/{itemId}/groups";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (itemId === undefined || itemId === null)
            throw new Error("The parameter 'itemId' must be defined.");
        url_ = url_.replace("{itemId}", encodeURIComponent("" + itemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFoodItemAttributeGroups2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFoodItemAttributeGroups2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<ProductAttributeGroupDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<ProductAttributeGroupDto[]>>;
        }));
    }

    protected processGetFoodItemAttributeGroups2(response: HttpResponseBase): Observable<SwaggerResponse<ProductAttributeGroupDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductAttributeGroupDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<ProductAttributeGroupDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取商品属性组下的所有属性项
     * @param api_version (optional) 
     */
    getFoodItemAttributeGroupItems(storeId: number, groupId: string, api_version?: string | null | undefined): Observable<SwaggerResponse<ProductAttributeItemDto[]>> {
        let url_ = this.baseUrl + "/api/Deliordering/food/items/{storeId}/attribute/{groupId}/items?";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFoodItemAttributeGroupItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFoodItemAttributeGroupItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<ProductAttributeItemDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<ProductAttributeItemDto[]>>;
        }));
    }

    protected processGetFoodItemAttributeGroupItems(response: HttpResponseBase): Observable<SwaggerResponse<ProductAttributeItemDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductAttributeItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<ProductAttributeItemDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取商品属性组下的所有属性项
     */
    getFoodItemAttributeGroupItems2(storeId: number, groupId: string): Observable<SwaggerResponse<ProductAttributeItemDto[]>> {
        let url_ = this.baseUrl + "/api/v1/Deliordering/food/items/{storeId}/attribute/{groupId}/items";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (groupId === undefined || groupId === null)
            throw new Error("The parameter 'groupId' must be defined.");
        url_ = url_.replace("{groupId}", encodeURIComponent("" + groupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFoodItemAttributeGroupItems2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFoodItemAttributeGroupItems2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<ProductAttributeItemDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<ProductAttributeItemDto[]>>;
        }));
    }

    protected processGetFoodItemAttributeGroupItems2(response: HttpResponseBase): Observable<SwaggerResponse<ProductAttributeItemDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductAttributeItemDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<ProductAttributeItemDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 更新商品排序
     * @param storeId (optional) 
     * @param api_version (optional) 
     */
    updateSortOrders(body: UpdateSortOrdersBody, storeId?: number | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/Deliordering/food/items/sortorders?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSortOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSortOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processUpdateSortOrders(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 更新商品排序
     * @param storeId (optional) 
     */
    updateSortOrders2(body: UpdateSortOrdersBody, storeId?: number | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/v1/Deliordering/food/items/sortorders?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSortOrders2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSortOrders2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processUpdateSortOrders2(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取商品基本信息
     * @param storeId (optional) 
     * @param pluId (optional) 
     * @param barcode (optional) 
     * @param languageCode (optional) 
     * @param api_version (optional) 
     */
    getItemBasicInfo(storeId?: number | undefined, pluId?: string | null | undefined, barcode?: string | null | undefined, languageCode?: string | null | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<ItemBasicInfoDto>> {
        let url_ = this.baseUrl + "/api/Deliordering/food/items/basic?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (pluId !== undefined && pluId !== null)
            url_ += "pluId=" + encodeURIComponent("" + pluId) + "&";
        if (barcode !== undefined && barcode !== null)
            url_ += "barcode=" + encodeURIComponent("" + barcode) + "&";
        if (languageCode !== undefined && languageCode !== null)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetItemBasicInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetItemBasicInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<ItemBasicInfoDto>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<ItemBasicInfoDto>>;
        }));
    }

    protected processGetItemBasicInfo(response: HttpResponseBase): Observable<SwaggerResponse<ItemBasicInfoDto>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ItemBasicInfoDto.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<ItemBasicInfoDto>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取商品基本信息
     * @param storeId (optional) 
     * @param pluId (optional) 
     * @param barcode (optional) 
     * @param languageCode (optional) 
     */
    getItemBasicInfo2(storeId?: number | undefined, pluId?: string | null | undefined, barcode?: string | null | undefined, languageCode?: string | null | undefined): Observable<SwaggerResponse<ItemBasicInfoDto>> {
        let url_ = this.baseUrl + "/api/v1/Deliordering/food/items/basic?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (pluId !== undefined && pluId !== null)
            url_ += "pluId=" + encodeURIComponent("" + pluId) + "&";
        if (barcode !== undefined && barcode !== null)
            url_ += "barcode=" + encodeURIComponent("" + barcode) + "&";
        if (languageCode !== undefined && languageCode !== null)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetItemBasicInfo2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetItemBasicInfo2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<ItemBasicInfoDto>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<ItemBasicInfoDto>>;
        }));
    }

    protected processGetItemBasicInfo2(response: HttpResponseBase): Observable<SwaggerResponse<ItemBasicInfoDto>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ItemBasicInfoDto.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<ItemBasicInfoDto>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class DeliOrderingFoodItemImageGalleryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    /**
     * 获取商品下的所有副图
     * @param storeId (optional) 
     * @param parentId (optional) 
     * @param api_version (optional) 
     */
    getImages(storeId?: number | undefined, parentId?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<FoodImageChildDto[]>> {
        let url_ = this.baseUrl + "/api/Deliordering/food/image-gallery?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (parentId === null)
            throw new Error("The parameter 'parentId' cannot be null.");
        else if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FoodImageChildDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FoodImageChildDto[]>>;
        }));
    }

    protected processGetImages(response: HttpResponseBase): Observable<SwaggerResponse<FoodImageChildDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FoodImageChildDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FoodImageChildDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 添加副图
     * @param storeId (optional) 
     * @param api_version (optional) 
     */
    addImage(items: ImageItem[], storeId?: number | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/Deliordering/food/image-gallery?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(items);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processAddImage(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 删除副图
     * @param storeId (optional) 
     * @param api_version (optional) 
     */
    deleteImages(items: ImageItem[], storeId?: number | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/Deliordering/food/image-gallery?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(items);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteImages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteImages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processDeleteImages(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取商品下的所有副图
     * @param storeId (optional) 
     * @param parentId (optional) 
     */
    getImages2(storeId?: number | undefined, parentId?: string | undefined): Observable<SwaggerResponse<FoodImageChildDto[]>> {
        let url_ = this.baseUrl + "/api/v1/Deliordering/food/image-gallery?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (parentId === null)
            throw new Error("The parameter 'parentId' cannot be null.");
        else if (parentId !== undefined)
            url_ += "parentId=" + encodeURIComponent("" + parentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetImages2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetImages2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FoodImageChildDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FoodImageChildDto[]>>;
        }));
    }

    protected processGetImages2(response: HttpResponseBase): Observable<SwaggerResponse<FoodImageChildDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FoodImageChildDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FoodImageChildDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 添加副图
     * @param storeId (optional) 
     */
    addImage2(items: ImageItem[], storeId?: number | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/v1/Deliordering/food/image-gallery?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(items);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddImage2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddImage2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processAddImage2(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 删除副图
     * @param storeId (optional) 
     */
    deleteImages2(items: ImageItem[], storeId?: number | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/v1/Deliordering/food/image-gallery?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(items);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteImages2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteImages2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processDeleteImages2(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 更新副图的循序
     * @param storeId (optional) 
     * @param api_version (optional) 
     */
    updateSortOrders(body: UpdateSortOrdersBody, storeId?: number | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/Deliordering/food/image-gallery/sortorders?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSortOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSortOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processUpdateSortOrders(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 更新副图的循序
     * @param storeId (optional) 
     */
    updateSortOrders2(body: UpdateSortOrdersBody, storeId?: number | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/v1/Deliordering/food/image-gallery/sortorders?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSortOrders2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSortOrders2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processUpdateSortOrders2(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    uploadImageToGoolgleCloud(api_version?: string | null | undefined, imageType?: string | null | undefined, file?: FileParameter | null | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/Deliordering/food/image-gallery/upload/image?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (imageType !== null && imageType !== undefined)
            content_.append("ImageType", imageType.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadImageToGoolgleCloud(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadImageToGoolgleCloud(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processUploadImageToGoolgleCloud(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    uploadImageToGoolgleCloud2(imageType?: string | null | undefined, file?: FileParameter | null | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/v1/Deliordering/food/image-gallery/upload/image";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (imageType !== null && imageType !== undefined)
            content_.append("ImageType", imageType.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadImageToGoolgleCloud2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadImageToGoolgleCloud2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processUploadImageToGoolgleCloud2(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class DeliOrderingFoodOrderClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    createOrder(storeId: number, cartId: string, api_version?: string | null | undefined): Observable<SwaggerResponse<TransactionOrderResponse>> {
        let url_ = this.baseUrl + "/api/Deliordering/food/order/{storeId}/{cartId}?";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (cartId === undefined || cartId === null)
            throw new Error("The parameter 'cartId' must be defined.");
        url_ = url_.replace("{cartId}", encodeURIComponent("" + cartId));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<TransactionOrderResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<TransactionOrderResponse>>;
        }));
    }

    protected processCreateOrder(response: HttpResponseBase): Observable<SwaggerResponse<TransactionOrderResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionOrderResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<TransactionOrderResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    createOrder2(storeId: number, cartId: string): Observable<SwaggerResponse<TransactionOrderResponse>> {
        let url_ = this.baseUrl + "/api/v1/Deliordering/food/order/{storeId}/{cartId}";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (cartId === undefined || cartId === null)
            throw new Error("The parameter 'cartId' must be defined.");
        url_ = url_.replace("{cartId}", encodeURIComponent("" + cartId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrder2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrder2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<TransactionOrderResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<TransactionOrderResponse>>;
        }));
    }

    protected processCreateOrder2(response: HttpResponseBase): Observable<SwaggerResponse<TransactionOrderResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionOrderResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<TransactionOrderResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 前台打印完成，通知后厨
     * @param storeId (optional) 
     * @param api_version (optional) 
     */
    notifyKitchenPrintReady(response: TransactionOrderResponse, storeId?: number | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/Deliordering/food/order/notify-kitchen-print-ready?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(response);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotifyKitchenPrintReady(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotifyKitchenPrintReady(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processNotifyKitchenPrintReady(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 前台打印完成，通知后厨
     * @param storeId (optional) 
     */
    notifyKitchenPrintReady2(response: TransactionOrderResponse, storeId?: number | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/v1/Deliordering/food/order/notify-kitchen-print-ready?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(response);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processNotifyKitchenPrintReady2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processNotifyKitchenPrintReady2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processNotifyKitchenPrintReady2(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    getExternalTransactionFilesSource(api_version?: string | null | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/Deliordering/food/order/source?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalTransactionFilesSource(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalTransactionFilesSource(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processGetExternalTransactionFilesSource(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    getExternalTransactionFilesSource2(): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/v1/Deliordering/food/order/source";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalTransactionFilesSource2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalTransactionFilesSource2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processGetExternalTransactionFilesSource2(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class DeliorderingFoodTranslationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    getLanguages(storeId?: number | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<DeliOrderingLanguageDto[]>> {
        let url_ = this.baseUrl + "/api/Deliordering/food/translations/languages?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<DeliOrderingLanguageDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<DeliOrderingLanguageDto[]>>;
        }));
    }

    protected processGetLanguages(response: HttpResponseBase): Observable<SwaggerResponse<DeliOrderingLanguageDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeliOrderingLanguageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<DeliOrderingLanguageDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    deleteLanguages(storeId?: number | undefined, code?: string[] | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/Deliordering/food/translations/languages?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            code && code.forEach(item => { url_ += "code=" + encodeURIComponent("" + item) + "&"; });
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLanguages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLanguages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processDeleteLanguages(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    getLanguages2(storeId?: number | undefined): Observable<SwaggerResponse<DeliOrderingLanguageDto[]>> {
        let url_ = this.baseUrl + "/api/v1/Deliordering/food/translations/languages?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLanguages2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLanguages2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<DeliOrderingLanguageDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<DeliOrderingLanguageDto[]>>;
        }));
    }

    protected processGetLanguages2(response: HttpResponseBase): Observable<SwaggerResponse<DeliOrderingLanguageDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DeliOrderingLanguageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<DeliOrderingLanguageDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    deleteLanguages2(storeId?: number | undefined, code?: string[] | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/v1/Deliordering/food/translations/languages?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            code && code.forEach(item => { url_ += "code=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLanguages2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLanguages2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processDeleteLanguages2(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    fillDefaultLanguages(storeId?: number | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/Deliordering/food/translations/languages/fill?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFillDefaultLanguages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFillDefaultLanguages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processFillDefaultLanguages(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    fillDefaultLanguages2(storeId?: number | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/v1/Deliordering/food/translations/languages/fill?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFillDefaultLanguages2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFillDefaultLanguages2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processFillDefaultLanguages2(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    syncLanguages(body: DeliOrderingLanguageBody[], storeId?: number | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/Deliordering/food/translations/languages/sync?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncLanguages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncLanguages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processSyncLanguages(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    syncLanguages2(body: DeliOrderingLanguageBody[], storeId?: number | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/v1/Deliordering/food/translations/languages/sync?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncLanguages2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncLanguages2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processSyncLanguages2(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    getCategoryTranslations(storeId?: number | undefined, categoryId?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<FoodCategoryTranslationDto[]>> {
        let url_ = this.baseUrl + "/api/Deliordering/food/translations/category?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCategoryTranslations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategoryTranslations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FoodCategoryTranslationDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FoodCategoryTranslationDto[]>>;
        }));
    }

    protected processGetCategoryTranslations(response: HttpResponseBase): Observable<SwaggerResponse<FoodCategoryTranslationDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FoodCategoryTranslationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FoodCategoryTranslationDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    getCategoryTranslations2(storeId?: number | undefined, categoryId?: string | undefined): Observable<SwaggerResponse<FoodCategoryTranslationDto[]>> {
        let url_ = this.baseUrl + "/api/v1/Deliordering/food/translations/category?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (categoryId === null)
            throw new Error("The parameter 'categoryId' cannot be null.");
        else if (categoryId !== undefined)
            url_ += "categoryId=" + encodeURIComponent("" + categoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCategoryTranslations2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCategoryTranslations2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FoodCategoryTranslationDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FoodCategoryTranslationDto[]>>;
        }));
    }

    protected processGetCategoryTranslations2(response: HttpResponseBase): Observable<SwaggerResponse<FoodCategoryTranslationDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FoodCategoryTranslationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FoodCategoryTranslationDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    syncCategoryTranslations(items: FoodCategoryTranslationSyncRequest[], storeId?: number | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/Deliordering/food/translations/category/sync?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(items);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncCategoryTranslations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncCategoryTranslations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processSyncCategoryTranslations(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    syncCategoryTranslations2(items: FoodCategoryTranslationSyncRequest[], storeId?: number | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/v1/Deliordering/food/translations/category/sync?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(items);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncCategoryTranslations2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncCategoryTranslations2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processSyncCategoryTranslations2(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    getItemTranslations(storeId?: number | undefined, pluId?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<FoodItemTranslationDto[]>> {
        let url_ = this.baseUrl + "/api/Deliordering/food/translations/item?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (pluId === null)
            throw new Error("The parameter 'pluId' cannot be null.");
        else if (pluId !== undefined)
            url_ += "pluId=" + encodeURIComponent("" + pluId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetItemTranslations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetItemTranslations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FoodItemTranslationDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FoodItemTranslationDto[]>>;
        }));
    }

    protected processGetItemTranslations(response: HttpResponseBase): Observable<SwaggerResponse<FoodItemTranslationDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FoodItemTranslationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FoodItemTranslationDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    getItemTranslations2(storeId?: number | undefined, pluId?: string | undefined): Observable<SwaggerResponse<FoodItemTranslationDto[]>> {
        let url_ = this.baseUrl + "/api/v1/Deliordering/food/translations/item?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (pluId === null)
            throw new Error("The parameter 'pluId' cannot be null.");
        else if (pluId !== undefined)
            url_ += "pluId=" + encodeURIComponent("" + pluId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetItemTranslations2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetItemTranslations2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FoodItemTranslationDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FoodItemTranslationDto[]>>;
        }));
    }

    protected processGetItemTranslations2(response: HttpResponseBase): Observable<SwaggerResponse<FoodItemTranslationDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FoodItemTranslationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FoodItemTranslationDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    syncFoodItemTranslations(requests: FoodItemTranslationSyncRequest[], storeId?: number | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/Deliordering/food/translations/item/sync?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requests);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncFoodItemTranslations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncFoodItemTranslations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processSyncFoodItemTranslations(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    syncFoodItemTranslations2(requests: FoodItemTranslationSyncRequest[], storeId?: number | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/v1/Deliordering/food/translations/item/sync?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requests);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncFoodItemTranslations2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncFoodItemTranslations2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processSyncFoodItemTranslations2(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class DevicesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    get(id: string, api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/Devices/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    put(id: string, body: Device, api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/Devices/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    get2(id: string): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/Devices/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    put2(id: string, body: Device): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/Devices/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processPut2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    postRecord(id: string, body: DeviceRecord, api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/Devices/{id}/records?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processPostRecord(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    postRecord2(id: string, body: DeviceRecord): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/Devices/{id}/records";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostRecord2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostRecord2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processPostRecord2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class I18nTranslationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    list(appCode: I18nAppCode, locale: string, page?: number | undefined, pageSize?: number | undefined): Observable<SwaggerResponse<PagedResultOfTranslationRow>> {
        let url_ = this.baseUrl + "/api/v1/i18n/{appCode}/{locale}?";
        if (appCode === undefined || appCode === null)
            throw new Error("The parameter 'appCode' must be defined.");
        url_ = url_.replace("{appCode}", encodeURIComponent("" + appCode));
        if (locale === undefined || locale === null)
            throw new Error("The parameter 'locale' must be defined.");
        url_ = url_.replace("{locale}", encodeURIComponent("" + locale));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<PagedResultOfTranslationRow>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<PagedResultOfTranslationRow>>;
        }));
    }

    protected processList(response: HttpResponseBase): Observable<SwaggerResponse<PagedResultOfTranslationRow>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PagedResultOfTranslationRow.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<PagedResultOfTranslationRow>>(new SwaggerResponse(status, _headers, null as any));
    }

    upsert(appCode: I18nAppCode, locale: string, messages: { [key: string]: string; }): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/i18n/{appCode}/{locale}";
        if (appCode === undefined || appCode === null)
            throw new Error("The parameter 'appCode' must be defined.");
        url_ = url_.replace("{appCode}", encodeURIComponent("" + appCode));
        if (locale === undefined || locale === null)
            throw new Error("The parameter 'locale' must be defined.");
        url_ = url_.replace("{locale}", encodeURIComponent("" + locale));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(messages);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processUpsert(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    delete(appCode: I18nAppCode, locale: string, keys: string[]): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/i18n/{appCode}/{locale}";
        if (appCode === undefined || appCode === null)
            throw new Error("The parameter 'appCode' must be defined.");
        url_ = url_.replace("{appCode}", encodeURIComponent("" + appCode));
        if (locale === undefined || locale === null)
            throw new Error("The parameter 'locale' must be defined.");
        url_ = url_.replace("{locale}", encodeURIComponent("" + locale));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(keys);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    getGenerate(appCode: I18nAppCode, locale: string): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/i18n/{appCode}/{locale}/generate";
        if (appCode === undefined || appCode === null)
            throw new Error("The parameter 'appCode' must be defined.");
        url_ = url_.replace("{appCode}", encodeURIComponent("" + appCode));
        if (locale === undefined || locale === null)
            throw new Error("The parameter 'locale' must be defined.");
        url_ = url_.replace("{locale}", encodeURIComponent("" + locale));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGenerate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGenerate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processGetGenerate(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class InvoicesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    uploadDataWithFile(api_version?: string | null | undefined, storeId?: number | undefined, supplierType?: string | null | undefined, invoiceDocuments?: FileParameter | null | undefined, productDocuments?: FileParameter[] | null | undefined, invoiceAndProductData?: FileParameter | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/Invoices/Upload?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (storeId === null || storeId === undefined)
            throw new Error("The parameter 'storeId' cannot be null.");
        else
            content_.append("StoreId", storeId.toString());
        if (supplierType !== null && supplierType !== undefined)
            content_.append("SupplierType", supplierType.toString());
        if (invoiceDocuments !== null && invoiceDocuments !== undefined)
            content_.append("InvoiceDocuments", invoiceDocuments.data, invoiceDocuments.fileName ? invoiceDocuments.fileName : "InvoiceDocuments");
        if (productDocuments !== null && productDocuments !== undefined)
            productDocuments.forEach(item_ => content_.append("ProductDocuments", item_.data, item_.fileName ? item_.fileName : "ProductDocuments") );
        if (invoiceAndProductData !== null && invoiceAndProductData !== undefined)
            content_.append("InvoiceAndProductData", invoiceAndProductData.data, invoiceAndProductData.fileName ? invoiceAndProductData.fileName : "InvoiceAndProductData");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadDataWithFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadDataWithFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processUploadDataWithFile(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    uploadDataWithFile2(storeId?: number | undefined, supplierType?: string | null | undefined, invoiceDocuments?: FileParameter | null | undefined, productDocuments?: FileParameter[] | null | undefined, invoiceAndProductData?: FileParameter | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/Invoices/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (storeId === null || storeId === undefined)
            throw new Error("The parameter 'storeId' cannot be null.");
        else
            content_.append("StoreId", storeId.toString());
        if (supplierType !== null && supplierType !== undefined)
            content_.append("SupplierType", supplierType.toString());
        if (invoiceDocuments !== null && invoiceDocuments !== undefined)
            content_.append("InvoiceDocuments", invoiceDocuments.data, invoiceDocuments.fileName ? invoiceDocuments.fileName : "InvoiceDocuments");
        if (productDocuments !== null && productDocuments !== undefined)
            productDocuments.forEach(item_ => content_.append("ProductDocuments", item_.data, item_.fileName ? item_.fileName : "ProductDocuments") );
        if (invoiceAndProductData !== null && invoiceAndProductData !== undefined)
            content_.append("InvoiceAndProductData", invoiceAndProductData.data, invoiceAndProductData.fileName ? invoiceAndProductData.fileName : "InvoiceAndProductData");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadDataWithFile2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadDataWithFile2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processUploadDataWithFile2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class MCRPriceCheckerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    getProduct(storeId: number, barcode: string, api_version?: string | null | undefined): Observable<SwaggerResponse<GetProductResponse>> {
        let url_ = this.baseUrl + "/api/MCRPriceChecker/{storeId}/{barcode}?";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (barcode === undefined || barcode === null)
            throw new Error("The parameter 'barcode' must be defined.");
        url_ = url_.replace("{barcode}", encodeURIComponent("" + barcode));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<GetProductResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<GetProductResponse>>;
        }));
    }

    protected processGetProduct(response: HttpResponseBase): Observable<SwaggerResponse<GetProductResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProductResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<GetProductResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    getProduct2(storeId: number, barcode: string): Observable<SwaggerResponse<GetProductResponse>> {
        let url_ = this.baseUrl + "/api/v1/MCRPriceChecker/{storeId}/{barcode}";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (barcode === undefined || barcode === null)
            throw new Error("The parameter 'barcode' must be defined.");
        url_ = url_.replace("{barcode}", encodeURIComponent("" + barcode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProduct2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProduct2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<GetProductResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<GetProductResponse>>;
        }));
    }

    protected processGetProduct2(response: HttpResponseBase): Observable<SwaggerResponse<GetProductResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProductResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<GetProductResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * https://connect.syncmcr.com/api/MCRPriceChecker/apk
     * @param api_version (optional) 
     */
    downloadApk(api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/MCRPriceChecker/apk?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadApk(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadApk(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processDownloadApk(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * https://connect.syncmcr.com/api/MCRPriceChecker/apk
     */
    downloadApk2(): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/MCRPriceChecker/apk";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadApk2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadApk2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processDownloadApk2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    getVersion(api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/MCRPriceChecker/version?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processGetVersion(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    getVersion2(): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/MCRPriceChecker/version";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVersion2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVersion2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processGetVersion2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    getConfig(api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/MCRPriceChecker/config?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processGetConfig(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    getConfig2(): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/MCRPriceChecker/config";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetConfig2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetConfig2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processGetConfig2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    uploadApk(api_version?: string | null | undefined, outPutFile?: FileParameter | null | undefined, apkFile?: FileParameter | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/MCRPriceChecker/Upload?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (outPutFile !== null && outPutFile !== undefined)
            content_.append("OutPutFile", outPutFile.data, outPutFile.fileName ? outPutFile.fileName : "OutPutFile");
        if (apkFile !== null && apkFile !== undefined)
            content_.append("ApkFile", apkFile.data, apkFile.fileName ? apkFile.fileName : "ApkFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadApk(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadApk(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processUploadApk(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    uploadApk2(outPutFile?: FileParameter | null | undefined, apkFile?: FileParameter | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/MCRPriceChecker/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (outPutFile !== null && outPutFile !== undefined)
            content_.append("OutPutFile", outPutFile.data, outPutFile.fileName ? outPutFile.fileName : "OutPutFile");
        if (apkFile !== null && apkFile !== undefined)
            content_.append("ApkFile", apkFile.data, apkFile.fileName ? apkFile.fileName : "ApkFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadApk2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadApk2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processUploadApk2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class MixcodeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    /**
     * 转移当前店铺的Mixcode数据到目标店铺
     * @param api_version (optional) 
     */
    transferMixcode(body: TransferMixcodeBodyDto, api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/transfer?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransferMixcode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransferMixcode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processTransferMixcode(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取当前店铺下的所有Mixcode
     * @param currentStore (optional) 当前店铺
     * @param api_version (optional) 
     */
    mixcodes(currentStore?: number | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<string[]>> {
        let url_ = this.baseUrl + "/api/Mixcode?";
        if (currentStore === null)
            throw new Error("The parameter 'currentStore' cannot be null.");
        else if (currentStore !== undefined)
            url_ += "currentStore=" + encodeURIComponent("" + currentStore) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMixcodes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMixcodes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string[]>>;
        }));
    }

    protected processMixcodes(response: HttpResponseBase): Observable<SwaggerResponse<string[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取当前店铺下的所有Mixcode
     * @param currentStore (optional) 当前店铺
     */
    mixcodes2(currentStore?: number | undefined): Observable<SwaggerResponse<string[]>> {
        let url_ = this.baseUrl + "/api/v1/Mixcode?";
        if (currentStore === null)
            throw new Error("The parameter 'currentStore' cannot be null.");
        else if (currentStore !== undefined)
            url_ += "currentStore=" + encodeURIComponent("" + currentStore) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMixcodes2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMixcodes2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string[]>>;
        }));
    }

    protected processMixcodes2(response: HttpResponseBase): Observable<SwaggerResponse<string[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string[]>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class NationsbenefitsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    accountValidation(body: AVSRequest, api_version?: string | null | undefined): Observable<SwaggerResponse<AVSResponse>> {
        let url_ = this.baseUrl + "/nationsbenefits/accountValidation?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccountValidation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccountValidation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<AVSResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<AVSResponse>>;
        }));
    }

    protected processAccountValidation(response: HttpResponseBase): Observable<SwaggerResponse<AVSResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AVSResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<AVSResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    accountValidation2(body: AVSRequest): Observable<SwaggerResponse<AVSResponse>> {
        let url_ = this.baseUrl + "/api/v1/nationsbenefits/accountValidation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccountValidation2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccountValidation2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<AVSResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<AVSResponse>>;
        }));
    }

    protected processAccountValidation2(response: HttpResponseBase): Observable<SwaggerResponse<AVSResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AVSResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<AVSResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    balanceInquiry(body: BIRequest, api_version?: string | null | undefined): Observable<SwaggerResponse<BIResponse>> {
        let url_ = this.baseUrl + "/nationsbenefits/balanceInquiry?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBalanceInquiry(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBalanceInquiry(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<BIResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<BIResponse>>;
        }));
    }

    protected processBalanceInquiry(response: HttpResponseBase): Observable<SwaggerResponse<BIResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BIResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<BIResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    balanceInquiry2(body: BIRequest): Observable<SwaggerResponse<BIResponse>> {
        let url_ = this.baseUrl + "/api/v1/nationsbenefits/balanceInquiry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBalanceInquiry2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBalanceInquiry2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<BIResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<BIResponse>>;
        }));
    }

    protected processBalanceInquiry2(response: HttpResponseBase): Observable<SwaggerResponse<BIResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BIResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<BIResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    analyze(body: AnalyzeRequest, api_version?: string | null | undefined): Observable<SwaggerResponse<AnalyzeResponse>> {
        let url_ = this.baseUrl + "/nationsbenefits/analyze?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAnalyze(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAnalyze(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<AnalyzeResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<AnalyzeResponse>>;
        }));
    }

    protected processAnalyze(response: HttpResponseBase): Observable<SwaggerResponse<AnalyzeResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AnalyzeResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<AnalyzeResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    analyze2(body: AnalyzeRequest): Observable<SwaggerResponse<AnalyzeResponse>> {
        let url_ = this.baseUrl + "/api/v1/nationsbenefits/analyze";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAnalyze2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAnalyze2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<AnalyzeResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<AnalyzeResponse>>;
        }));
    }

    protected processAnalyze2(response: HttpResponseBase): Observable<SwaggerResponse<AnalyzeResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AnalyzeResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<AnalyzeResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    redeem(body: RedeemRequest, api_version?: string | null | undefined): Observable<SwaggerResponse<RedeemResponse>> {
        let url_ = this.baseUrl + "/nationsbenefits/redeem?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRedeem(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRedeem(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<RedeemResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<RedeemResponse>>;
        }));
    }

    protected processRedeem(response: HttpResponseBase): Observable<SwaggerResponse<RedeemResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RedeemResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<RedeemResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    redeem2(body: RedeemRequest): Observable<SwaggerResponse<RedeemResponse>> {
        let url_ = this.baseUrl + "/api/v1/nationsbenefits/redeem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRedeem2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRedeem2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<RedeemResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<RedeemResponse>>;
        }));
    }

    protected processRedeem2(response: HttpResponseBase): Observable<SwaggerResponse<RedeemResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RedeemResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<RedeemResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    void(body: VoidRequest, api_version?: string | null | undefined): Observable<SwaggerResponse<VoidResponse>> {
        let url_ = this.baseUrl + "/nationsbenefits/void?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVoid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVoid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<VoidResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<VoidResponse>>;
        }));
    }

    protected processVoid(response: HttpResponseBase): Observable<SwaggerResponse<VoidResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoidResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<VoidResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    void2(body: VoidRequest): Observable<SwaggerResponse<VoidResponse>> {
        let url_ = this.baseUrl + "/api/v1/nationsbenefits/void";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVoid2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVoid2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<VoidResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<VoidResponse>>;
        }));
    }

    protected processVoid2(response: HttpResponseBase): Observable<SwaggerResponse<VoidResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoidResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<VoidResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    reversal(body: ReversalRequest, api_version?: string | null | undefined): Observable<SwaggerResponse<ReversalResponse>> {
        let url_ = this.baseUrl + "/nationsbenefits/reversal?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReversal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReversal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<ReversalResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<ReversalResponse>>;
        }));
    }

    protected processReversal(response: HttpResponseBase): Observable<SwaggerResponse<ReversalResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReversalResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<ReversalResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    reversal2(body: ReversalRequest): Observable<SwaggerResponse<ReversalResponse>> {
        let url_ = this.baseUrl + "/api/v1/nationsbenefits/reversal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReversal2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReversal2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<ReversalResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<ReversalResponse>>;
        }));
    }

    protected processReversal2(response: HttpResponseBase): Observable<SwaggerResponse<ReversalResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReversalResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<ReversalResponse>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class NegativePriceProductMovementReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    getNegativePriceProductMovement(stores?: number[] | undefined, begin?: Date | undefined, end?: Date | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<NegativePriceProductMovementDto[]>> {
        let url_ = this.baseUrl + "/api/NegativePriceProductMovementReport?";
        if (stores === null)
            throw new Error("The parameter 'stores' cannot be null.");
        else if (stores !== undefined)
            stores && stores.forEach(item => { url_ += "stores=" + encodeURIComponent("" + item) + "&"; });
        if (begin === null)
            throw new Error("The parameter 'begin' cannot be null.");
        else if (begin !== undefined)
            url_ += "begin=" + encodeURIComponent(begin ? "" + begin.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNegativePriceProductMovement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNegativePriceProductMovement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<NegativePriceProductMovementDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<NegativePriceProductMovementDto[]>>;
        }));
    }

    protected processGetNegativePriceProductMovement(response: HttpResponseBase): Observable<SwaggerResponse<NegativePriceProductMovementDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NegativePriceProductMovementDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<NegativePriceProductMovementDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    getNegativePriceProductMovement2(stores?: number[] | undefined, begin?: Date | undefined, end?: Date | undefined): Observable<SwaggerResponse<NegativePriceProductMovementDto[]>> {
        let url_ = this.baseUrl + "/api/v1/NegativePriceProductMovementReport?";
        if (stores === null)
            throw new Error("The parameter 'stores' cannot be null.");
        else if (stores !== undefined)
            stores && stores.forEach(item => { url_ += "stores=" + encodeURIComponent("" + item) + "&"; });
        if (begin === null)
            throw new Error("The parameter 'begin' cannot be null.");
        else if (begin !== undefined)
            url_ += "begin=" + encodeURIComponent(begin ? "" + begin.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetNegativePriceProductMovement2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetNegativePriceProductMovement2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<NegativePriceProductMovementDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<NegativePriceProductMovementDto[]>>;
        }));
    }

    protected processGetNegativePriceProductMovement2(response: HttpResponseBase): Observable<SwaggerResponse<NegativePriceProductMovementDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NegativePriceProductMovementDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<NegativePriceProductMovementDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class PayMentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    /**
     * 获取支付信息
     * @param storeId 店铺id
     * @param paymentId 支付Id
     * @param api_version (optional) 
     * @return Success!
     */
    getPayMentContent(storeId: number, paymentId: string, api_version?: string | null | undefined): Observable<SwaggerResponse<TransactionResponse>> {
        let url_ = this.baseUrl + "/approval/transaction/{storeId}/{paymentId}?";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (paymentId === undefined || paymentId === null)
            throw new Error("The parameter 'paymentId' must be defined.");
        url_ = url_.replace("{paymentId}", encodeURIComponent("" + paymentId));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayMentContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayMentContent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<TransactionResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<TransactionResponse>>;
        }));
    }

    protected processGetPayMentContent(response: HttpResponseBase): Observable<SwaggerResponse<TransactionResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<TransactionResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取支付信息
     * @param storeId 店铺id
     * @param paymentId 支付Id
     * @return Success!
     */
    getPayMentContent2(storeId: number, paymentId: string): Observable<SwaggerResponse<TransactionResponse>> {
        let url_ = this.baseUrl + "/api/v1/approval/transaction/{storeId}/{paymentId}";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (paymentId === undefined || paymentId === null)
            throw new Error("The parameter 'paymentId' must be defined.");
        url_ = url_.replace("{paymentId}", encodeURIComponent("" + paymentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPayMentContent2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPayMentContent2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<TransactionResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<TransactionResponse>>;
        }));
    }

    protected processGetPayMentContent2(response: HttpResponseBase): Observable<SwaggerResponse<TransactionResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransactionResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<TransactionResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 验证信用卡用户支付
     * @param userPayment 用户支付信息
     * @param storeId (optional) 店铺id
     * @param paymentId (optional) 支付id
     * @param api_version (optional) 
     * @return Success!
     */
    putUserPayMent(userPayment: UserPayment, storeId?: number | undefined, paymentId?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/approval/modify/userPayMent?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userPayment);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutUserPayMent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutUserPayMent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processPutUserPayMent(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 验证信用卡用户支付
     * @param userPayment 用户支付信息
     * @param storeId (optional) 店铺id
     * @param paymentId (optional) 支付id
     * @return Success!
     */
    putUserPayMent2(userPayment: UserPayment, storeId?: number | undefined, paymentId?: string | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/approval/modify/userPayMent?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userPayment);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutUserPayMent2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutUserPayMent2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processPutUserPayMent2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 修改状态
     * @param storeId (optional) 店铺id
     * @param paymentId (optional) 支付id
     * @param statusText (optional) 状态文本
     * @param api_version (optional) 
     * @return Success!
     */
    putPayMentStatus(storeId?: number | undefined, paymentId?: string | undefined, statusText?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/approval/modify/status?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        if (statusText === null)
            throw new Error("The parameter 'statusText' cannot be null.");
        else if (statusText !== undefined)
            url_ += "statusText=" + encodeURIComponent("" + statusText) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutPayMentStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutPayMentStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processPutPayMentStatus(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 修改状态
     * @param storeId (optional) 店铺id
     * @param paymentId (optional) 支付id
     * @param statusText (optional) 状态文本
     * @return Success!
     */
    putPayMentStatus2(storeId?: number | undefined, paymentId?: string | undefined, statusText?: string | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/approval/modify/status?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (paymentId === null)
            throw new Error("The parameter 'paymentId' cannot be null.");
        else if (paymentId !== undefined)
            url_ += "paymentId=" + encodeURIComponent("" + paymentId) + "&";
        if (statusText === null)
            throw new Error("The parameter 'statusText' cannot be null.");
        else if (statusText !== undefined)
            url_ += "statusText=" + encodeURIComponent("" + statusText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutPayMentStatus2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutPayMentStatus2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processPutPayMentStatus2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class PosuserLogIntTokenClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    /**
     * 获取Token 重定向
     * @param storeId 商店id
     * @param registerNumber 收银台id
     * @param devmode (optional) true:开发者模式 false: 生产模式
     * @param api_version (optional) 
     */
    getLoginToken(storeId: string, registerNumber: string, devmode?: boolean | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/posuserlogintoken/{storeId}/{registerNumber}?";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (registerNumber === undefined || registerNumber === null)
            throw new Error("The parameter 'registerNumber' must be defined.");
        url_ = url_.replace("{registerNumber}", encodeURIComponent("" + registerNumber));
        if (devmode === null)
            throw new Error("The parameter 'devmode' cannot be null.");
        else if (devmode !== undefined)
            url_ += "devmode=" + encodeURIComponent("" + devmode) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLoginToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLoginToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processGetLoginToken(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 302) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result302: any = null;
            let resultData302 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result302 = resultData302 !== undefined ? resultData302 : <any>null;
    
            return throwException("\u91cd\u5b9a\u5411", status, _responseText, _headers, result302);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取Token 重定向
     * @param storeId 商店id
     * @param registerNumber 收银台id
     * @param devmode (optional) true:开发者模式 false: 生产模式
     */
    getLoginToken2(storeId: string, registerNumber: string, devmode?: boolean | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/v1/PosuserLogIntToken/posuserlogintoken/{storeId}/{registerNumber}?";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (registerNumber === undefined || registerNumber === null)
            throw new Error("The parameter 'registerNumber' must be defined.");
        url_ = url_.replace("{registerNumber}", encodeURIComponent("" + registerNumber));
        if (devmode === null)
            throw new Error("The parameter 'devmode' cannot be null.");
        else if (devmode !== undefined)
            url_ += "devmode=" + encodeURIComponent("" + devmode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLoginToken2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLoginToken2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processGetLoginToken2(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 302) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result302: any = null;
            let resultData302 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result302 = resultData302 !== undefined ? resultData302 : <any>null;
    
            return throwException("\u91cd\u5b9a\u5411", status, _responseText, _headers, result302);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 登录
     * @param userLoginToken Token
     * @param lanenumber 手机号
     * @param api_version (optional) 
     * @return 请求成功
     */
    userLogin(userLoginToken: string, lanenumber: string, api_version?: string | null | undefined): Observable<SwaggerResponse<CustomerResponse2>> {
        let url_ = this.baseUrl + "/userLogin/{userLoginToken}/{lanenumber}?";
        if (userLoginToken === undefined || userLoginToken === null)
            throw new Error("The parameter 'userLoginToken' must be defined.");
        url_ = url_.replace("{userLoginToken}", encodeURIComponent("" + userLoginToken));
        if (lanenumber === undefined || lanenumber === null)
            throw new Error("The parameter 'lanenumber' must be defined.");
        url_ = url_.replace("{lanenumber}", encodeURIComponent("" + lanenumber));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<CustomerResponse2>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<CustomerResponse2>>;
        }));
    }

    protected processUserLogin(response: HttpResponseBase): Observable<SwaggerResponse<CustomerResponse2>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerResponse2.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<CustomerResponse2>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 登录
     * @param userLoginToken Token
     * @param lanenumber 手机号
     * @return 请求成功
     */
    userLogin2(userLoginToken: string, lanenumber: string): Observable<SwaggerResponse<CustomerResponse2>> {
        let url_ = this.baseUrl + "/api/v1/PosuserLogIntToken/userLogin/{userLoginToken}/{lanenumber}";
        if (userLoginToken === undefined || userLoginToken === null)
            throw new Error("The parameter 'userLoginToken' must be defined.");
        url_ = url_.replace("{userLoginToken}", encodeURIComponent("" + userLoginToken));
        if (lanenumber === undefined || lanenumber === null)
            throw new Error("The parameter 'lanenumber' must be defined.");
        url_ = url_.replace("{lanenumber}", encodeURIComponent("" + lanenumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserLogin2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserLogin2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<CustomerResponse2>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<CustomerResponse2>>;
        }));
    }

    protected processUserLogin2(response: HttpResponseBase): Observable<SwaggerResponse<CustomerResponse2>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerResponse2.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<CustomerResponse2>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取用户登录状态
     * @param api_version (optional) 
     */
    getUserLoginSatatus(userLoginToken: string, loginRecordID: string | null, api_version?: string | null | undefined): Observable<SwaggerResponse<LoginStatus>> {
        let url_ = this.baseUrl + "/userLogin/status/{userLoginToken}/{loginRecordID}?";
        if (userLoginToken === undefined || userLoginToken === null)
            throw new Error("The parameter 'userLoginToken' must be defined.");
        url_ = url_.replace("{userLoginToken}", encodeURIComponent("" + userLoginToken));
        if (loginRecordID === undefined || loginRecordID === null)
            throw new Error("The parameter 'loginRecordID' must be defined.");
        url_ = url_.replace("{loginRecordID}", encodeURIComponent("" + loginRecordID));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserLoginSatatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserLoginSatatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<LoginStatus>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<LoginStatus>>;
        }));
    }

    protected processGetUserLoginSatatus(response: HttpResponseBase): Observable<SwaggerResponse<LoginStatus>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<LoginStatus>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取用户登录状态
     */
    getUserLoginSatatus2(userLoginToken: string, loginRecordID: string | null): Observable<SwaggerResponse<LoginStatus>> {
        let url_ = this.baseUrl + "/api/v1/PosuserLogIntToken/userLogin/status/{userLoginToken}/{loginRecordID}";
        if (userLoginToken === undefined || userLoginToken === null)
            throw new Error("The parameter 'userLoginToken' must be defined.");
        url_ = url_.replace("{userLoginToken}", encodeURIComponent("" + userLoginToken));
        if (loginRecordID === undefined || loginRecordID === null)
            throw new Error("The parameter 'loginRecordID' must be defined.");
        url_ = url_.replace("{loginRecordID}", encodeURIComponent("" + loginRecordID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserLoginSatatus2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserLoginSatatus2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<LoginStatus>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<LoginStatus>>;
        }));
    }

    protected processGetUserLoginSatatus2(response: HttpResponseBase): Observable<SwaggerResponse<LoginStatus>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<LoginStatus>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 注册
     * @param registerToken 注册Token
     * @param customerItem 新用户数据
     * @param api_version (optional) 
     * @return 请求成功
     */
    userRegister(registerToken: string, customerItem: RegisterRequest, api_version?: string | null | undefined): Observable<SwaggerResponse<CustomerResponse2>> {
        let url_ = this.baseUrl + "/userRegisterTask/{registerToken}?";
        if (registerToken === undefined || registerToken === null)
            throw new Error("The parameter 'registerToken' must be defined.");
        url_ = url_.replace("{registerToken}", encodeURIComponent("" + registerToken));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerItem);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<CustomerResponse2>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<CustomerResponse2>>;
        }));
    }

    protected processUserRegister(response: HttpResponseBase): Observable<SwaggerResponse<CustomerResponse2>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerResponse2.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<CustomerResponse2>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 注册
     * @param registerToken 注册Token
     * @param customerItem 新用户数据
     * @return 请求成功
     */
    userRegister2(registerToken: string, customerItem: RegisterRequest): Observable<SwaggerResponse<CustomerResponse2>> {
        let url_ = this.baseUrl + "/api/v1/PosuserLogIntToken/userRegisterTask/{registerToken}";
        if (registerToken === undefined || registerToken === null)
            throw new Error("The parameter 'registerToken' must be defined.");
        url_ = url_.replace("{registerToken}", encodeURIComponent("" + registerToken));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerItem);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserRegister2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserRegister2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<CustomerResponse2>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<CustomerResponse2>>;
        }));
    }

    protected processUserRegister2(response: HttpResponseBase): Observable<SwaggerResponse<CustomerResponse2>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerResponse2.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<CustomerResponse2>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 修改用户数据
     * @param storeId 店铺id
     * @param phoneNumber 用户账户
     * @param custom 用户数据
     * @param api_version (optional) 
     * @return 更新成功
     */
    userUpdate(storeId: number, phoneNumber: string, custom: CustomUpdateRequest, api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/{storeId}/{phoneNumber}?";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (phoneNumber === undefined || phoneNumber === null)
            throw new Error("The parameter 'phoneNumber' must be defined.");
        url_ = url_.replace("{phoneNumber}", encodeURIComponent("" + phoneNumber));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(custom);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processUserUpdate(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 修改用户数据
     * @param storeId 店铺id
     * @param phoneNumber 用户账户
     * @param custom 用户数据
     * @return 更新成功
     */
    userUpdate2(storeId: number, phoneNumber: string, custom: CustomUpdateRequest): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/PosuserLogIntToken/{storeId}/{phoneNumber}";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (phoneNumber === undefined || phoneNumber === null)
            throw new Error("The parameter 'phoneNumber' must be defined.");
        url_ = url_.replace("{phoneNumber}", encodeURIComponent("" + phoneNumber));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(custom);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUserUpdate2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUserUpdate2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processUserUpdate2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    getCustomer(storeId?: number | undefined, phoneNumber?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<CustomerResponse>> {
        let url_ = this.baseUrl + "/customer?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (phoneNumber === null)
            throw new Error("The parameter 'phoneNumber' cannot be null.");
        else if (phoneNumber !== undefined)
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomer(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomer(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<CustomerResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<CustomerResponse>>;
        }));
    }

    protected processGetCustomer(response: HttpResponseBase): Observable<SwaggerResponse<CustomerResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<CustomerResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    getCustomer2(storeId?: number | undefined, phoneNumber?: string | undefined): Observable<SwaggerResponse<CustomerResponse>> {
        let url_ = this.baseUrl + "/api/v1/PosuserLogIntToken/customer?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (phoneNumber === null)
            throw new Error("The parameter 'phoneNumber' cannot be null.");
        else if (phoneNumber !== undefined)
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCustomer2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCustomer2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<CustomerResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<CustomerResponse>>;
        }));
    }

    protected processGetCustomer2(response: HttpResponseBase): Observable<SwaggerResponse<CustomerResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<CustomerResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取用户消费金额
     * @param stores (optional) 
     * @param phoneNumber (optional) 
     * @param api_version (optional) 
     */
    getTotalAmount(stores?: number[] | undefined, phoneNumber?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<CustomerTotalAmountResponse>> {
        let url_ = this.baseUrl + "/totalAmount?";
        if (stores === null)
            throw new Error("The parameter 'stores' cannot be null.");
        else if (stores !== undefined)
            stores && stores.forEach(item => { url_ += "stores=" + encodeURIComponent("" + item) + "&"; });
        if (phoneNumber === null)
            throw new Error("The parameter 'phoneNumber' cannot be null.");
        else if (phoneNumber !== undefined)
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalAmount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalAmount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<CustomerTotalAmountResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<CustomerTotalAmountResponse>>;
        }));
    }

    protected processGetTotalAmount(response: HttpResponseBase): Observable<SwaggerResponse<CustomerTotalAmountResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerTotalAmountResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<CustomerTotalAmountResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取用户消费金额
     * @param stores (optional) 
     * @param phoneNumber (optional) 
     */
    getTotalAmount2(stores?: number[] | undefined, phoneNumber?: string | undefined): Observable<SwaggerResponse<CustomerTotalAmountResponse>> {
        let url_ = this.baseUrl + "/api/v1/PosuserLogIntToken/totalAmount?";
        if (stores === null)
            throw new Error("The parameter 'stores' cannot be null.");
        else if (stores !== undefined)
            stores && stores.forEach(item => { url_ += "stores=" + encodeURIComponent("" + item) + "&"; });
        if (phoneNumber === null)
            throw new Error("The parameter 'phoneNumber' cannot be null.");
        else if (phoneNumber !== undefined)
            url_ += "phoneNumber=" + encodeURIComponent("" + phoneNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTotalAmount2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTotalAmount2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<CustomerTotalAmountResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<CustomerTotalAmountResponse>>;
        }));
    }

    protected processGetTotalAmount2(response: HttpResponseBase): Observable<SwaggerResponse<CustomerTotalAmountResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerTotalAmountResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<CustomerTotalAmountResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    getPointBalance(pointBalanceAccessKey?: string | undefined, accountNumber?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/test?";
        if (pointBalanceAccessKey === null)
            throw new Error("The parameter 'pointBalanceAccessKey' cannot be null.");
        else if (pointBalanceAccessKey !== undefined)
            url_ += "PointBalanceAccessKey=" + encodeURIComponent("" + pointBalanceAccessKey) + "&";
        if (accountNumber === null)
            throw new Error("The parameter 'accountNumber' cannot be null.");
        else if (accountNumber !== undefined)
            url_ += "accountNumber=" + encodeURIComponent("" + accountNumber) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPointBalance(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPointBalance(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processGetPointBalance(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    getPointBalance2(pointBalanceAccessKey?: string | undefined, accountNumber?: string | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/PosuserLogIntToken/test?";
        if (pointBalanceAccessKey === null)
            throw new Error("The parameter 'pointBalanceAccessKey' cannot be null.");
        else if (pointBalanceAccessKey !== undefined)
            url_ += "PointBalanceAccessKey=" + encodeURIComponent("" + pointBalanceAccessKey) + "&";
        if (accountNumber === null)
            throw new Error("The parameter 'accountNumber' cannot be null.");
        else if (accountNumber !== undefined)
            url_ += "accountNumber=" + encodeURIComponent("" + accountNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPointBalance2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPointBalance2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processGetPointBalance2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class ProductClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    /**
     * 根据条形码获取当前公司下所有店铺符合条件的商品详细数据
     * @param companyId (optional) 公司id
     * @param barcode (optional) 商品条形码
     * @param api_version (optional) 
     */
    getProductDetails(companyId?: string | undefined, barcode?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<CompanyProductsDTO>> {
        let url_ = this.baseUrl + "/api/Product/details?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (barcode === null)
            throw new Error("The parameter 'barcode' cannot be null.");
        else if (barcode !== undefined)
            url_ += "barcode=" + encodeURIComponent("" + barcode) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductDetails(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductDetails(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<CompanyProductsDTO>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<CompanyProductsDTO>>;
        }));
    }

    protected processGetProductDetails(response: HttpResponseBase): Observable<SwaggerResponse<CompanyProductsDTO>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyProductsDTO.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<CompanyProductsDTO>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 根据条形码获取当前公司下所有店铺符合条件的商品详细数据
     * @param companyId (optional) 公司id
     * @param barcode (optional) 商品条形码
     */
    getProductDetails2(companyId?: string | undefined, barcode?: string | undefined): Observable<SwaggerResponse<CompanyProductsDTO>> {
        let url_ = this.baseUrl + "/api/v1/Product/details?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (barcode === null)
            throw new Error("The parameter 'barcode' cannot be null.");
        else if (barcode !== undefined)
            url_ += "barcode=" + encodeURIComponent("" + barcode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductDetails2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductDetails2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<CompanyProductsDTO>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<CompanyProductsDTO>>;
        }));
    }

    protected processGetProductDetails2(response: HttpResponseBase): Observable<SwaggerResponse<CompanyProductsDTO>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CompanyProductsDTO.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<CompanyProductsDTO>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 根据条形码获取当前公司下所有店铺符合条件的商品基本数据
     * @param companyId (optional) 公司ID
     * @param barcode (optional) 条形码
     * @param api_version (optional) 
     */
    getBasicProductInfo(companyId?: string | undefined, barcode?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<GetStoreProductDto[]>> {
        let url_ = this.baseUrl + "/api/Product/basic-info?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (barcode === null)
            throw new Error("The parameter 'barcode' cannot be null.");
        else if (barcode !== undefined)
            url_ += "barcode=" + encodeURIComponent("" + barcode) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBasicProductInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBasicProductInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<GetStoreProductDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<GetStoreProductDto[]>>;
        }));
    }

    protected processGetBasicProductInfo(response: HttpResponseBase): Observable<SwaggerResponse<GetStoreProductDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetStoreProductDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<GetStoreProductDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 根据条形码获取当前公司下所有店铺符合条件的商品基本数据
     * @param companyId (optional) 公司ID
     * @param barcode (optional) 条形码
     */
    getBasicProductInfo2(companyId?: string | undefined, barcode?: string | undefined): Observable<SwaggerResponse<GetStoreProductDto[]>> {
        let url_ = this.baseUrl + "/api/v1/Product/basic-info?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (barcode === null)
            throw new Error("The parameter 'barcode' cannot be null.");
        else if (barcode !== undefined)
            url_ += "barcode=" + encodeURIComponent("" + barcode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBasicProductInfo2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBasicProductInfo2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<GetStoreProductDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<GetStoreProductDto[]>>;
        }));
    }

    protected processGetBasicProductInfo2(response: HttpResponseBase): Observable<SwaggerResponse<GetStoreProductDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetStoreProductDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<GetStoreProductDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取商品图片
     * @param storeId (optional) 
     * @param imageId (optional) 
     * @param api_version (optional) 
     */
    getProductImage(storeId?: number | undefined, imageId?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/Product/Image?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (imageId === null)
            throw new Error("The parameter 'imageId' cannot be null.");
        else if (imageId !== undefined)
            url_ += "imageId=" + encodeURIComponent("" + imageId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductImage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processGetProductImage(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取商品图片
     * @param storeId (optional) 
     * @param imageId (optional) 
     */
    getProductImage2(storeId?: number | undefined, imageId?: string | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/Product/Image?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (imageId === null)
            throw new Error("The parameter 'imageId' cannot be null.");
        else if (imageId !== undefined)
            url_ += "imageId=" + encodeURIComponent("" + imageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductImage2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductImage2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processGetProductImage2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取商品动销数据
     * @param storeId (optional) 
     * @param barcode (optional) 
     * @param api_version (optional) 
     */
    getDetailMovement(storeId?: number | undefined, barcode?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/Product/detail-movement?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (barcode === null)
            throw new Error("The parameter 'barcode' cannot be null.");
        else if (barcode !== undefined)
            url_ += "barcode=" + encodeURIComponent("" + barcode) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetailMovement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetailMovement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processGetDetailMovement(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取商品动销数据
     * @param storeId (optional) 
     * @param barcode (optional) 
     */
    getDetailMovement2(storeId?: number | undefined, barcode?: string | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/v1/Product/detail-movement?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (barcode === null)
            throw new Error("The parameter 'barcode' cannot be null.");
        else if (barcode !== undefined)
            url_ += "barcode=" + encodeURIComponent("" + barcode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDetailMovement2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDetailMovement2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processGetDetailMovement2(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取商品采购数据
     * @param storeIds (optional) 
     * @param barcode (optional) 
     * @param api_version (optional) 
     */
    getOrderHistoryItems(storeIds?: number[] | undefined, barcode?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/Product/order-history-items?";
        if (storeIds === null)
            throw new Error("The parameter 'storeIds' cannot be null.");
        else if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "storeIds=" + encodeURIComponent("" + item) + "&"; });
        if (barcode === null)
            throw new Error("The parameter 'barcode' cannot be null.");
        else if (barcode !== undefined)
            url_ += "barcode=" + encodeURIComponent("" + barcode) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderHistoryItems(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderHistoryItems(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processGetOrderHistoryItems(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取商品采购数据
     * @param storeIds (optional) 
     * @param barcode (optional) 
     */
    getOrderHistoryItems2(storeIds?: number[] | undefined, barcode?: string | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/v1/Product/order-history-items?";
        if (storeIds === null)
            throw new Error("The parameter 'storeIds' cannot be null.");
        else if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "storeIds=" + encodeURIComponent("" + item) + "&"; });
        if (barcode === null)
            throw new Error("The parameter 'barcode' cannot be null.");
        else if (barcode !== undefined)
            url_ += "barcode=" + encodeURIComponent("" + barcode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOrderHistoryItems2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOrderHistoryItems2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processGetOrderHistoryItems2(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class ProductImagesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    /**
     * 获取数据库商品图片
     * @param storeAccessKey (optional) 
     * @param api_version (optional) 
     */
    get(pluUpc: string, storeAccessKey?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/ProductImages/{pluUpc}?";
        if (pluUpc === undefined || pluUpc === null)
            throw new Error("The parameter 'pluUpc' must be defined.");
        url_ = url_.replace("{pluUpc}", encodeURIComponent("" + pluUpc));
        if (storeAccessKey === null)
            throw new Error("The parameter 'storeAccessKey' cannot be null.");
        else if (storeAccessKey !== undefined)
            url_ += "storeAccessKey=" + encodeURIComponent("" + storeAccessKey) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 删除图片（目前仅用于测试）
     * @param storeAccessKey (optional) 
     * @param api_version (optional) 
     */
    delete(pluUpc: string, storeAccessKey?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/ProductImages/{pluUpc}?";
        if (pluUpc === undefined || pluUpc === null)
            throw new Error("The parameter 'pluUpc' must be defined.");
        url_ = url_.replace("{pluUpc}", encodeURIComponent("" + pluUpc));
        if (storeAccessKey === null)
            throw new Error("The parameter 'storeAccessKey' cannot be null.");
        else if (storeAccessKey !== undefined)
            url_ += "storeAccessKey=" + encodeURIComponent("" + storeAccessKey) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取数据库商品图片
     * @param storeAccessKey (optional) 
     */
    get2(pluUpc: string, storeAccessKey?: string | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/ProductImages/{pluUpc}?";
        if (pluUpc === undefined || pluUpc === null)
            throw new Error("The parameter 'pluUpc' must be defined.");
        url_ = url_.replace("{pluUpc}", encodeURIComponent("" + pluUpc));
        if (storeAccessKey === null)
            throw new Error("The parameter 'storeAccessKey' cannot be null.");
        else if (storeAccessKey !== undefined)
            url_ += "storeAccessKey=" + encodeURIComponent("" + storeAccessKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 删除图片（目前仅用于测试）
     * @param storeAccessKey (optional) 
     */
    delete2(pluUpc: string, storeAccessKey?: string | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/v1/ProductImages/{pluUpc}?";
        if (pluUpc === undefined || pluUpc === null)
            throw new Error("The parameter 'pluUpc' must be defined.");
        url_ = url_.replace("{pluUpc}", encodeURIComponent("" + pluUpc));
        if (storeAccessKey === null)
            throw new Error("The parameter 'storeAccessKey' cannot be null.");
        else if (storeAccessKey !== undefined)
            url_ += "storeAccessKey=" + encodeURIComponent("" + storeAccessKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processDelete2(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 同步商品图片
     * @param storeAccessKey (optional) 
     * @param api_version (optional) 
     */
    synchronization(body: ProductImageSynchronizationBody, storeAccessKey?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<string[]>> {
        let url_ = this.baseUrl + "/ProductImages/Synchronization?";
        if (storeAccessKey === null)
            throw new Error("The parameter 'storeAccessKey' cannot be null.");
        else if (storeAccessKey !== undefined)
            url_ += "storeAccessKey=" + encodeURIComponent("" + storeAccessKey) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSynchronization(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSynchronization(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string[]>>;
        }));
    }

    protected processSynchronization(response: HttpResponseBase): Observable<SwaggerResponse<string[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 同步商品图片
     * @param storeAccessKey (optional) 
     */
    synchronization2(body: ProductImageSynchronizationBody, storeAccessKey?: string | undefined): Observable<SwaggerResponse<string[]>> {
        let url_ = this.baseUrl + "/api/v1/ProductImages/Synchronization?";
        if (storeAccessKey === null)
            throw new Error("The parameter 'storeAccessKey' cannot be null.");
        else if (storeAccessKey !== undefined)
            url_ += "storeAccessKey=" + encodeURIComponent("" + storeAccessKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSynchronization2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSynchronization2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string[]>>;
        }));
    }

    protected processSynchronization2(response: HttpResponseBase): Observable<SwaggerResponse<string[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string[]>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class ProductInfoCompletionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    postProductInfoCompletion(request: BarcodesBody, api_version?: string | null | undefined): Observable<SwaggerResponse<BarcodeInfo[]>> {
        let url_ = this.baseUrl + "/ProductInfoCompletion/plc?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostProductInfoCompletion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostProductInfoCompletion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<BarcodeInfo[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<BarcodeInfo[]>>;
        }));
    }

    protected processPostProductInfoCompletion(response: HttpResponseBase): Observable<SwaggerResponse<BarcodeInfo[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BarcodeInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<BarcodeInfo[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    postProductInfoCompletion2(request: BarcodesBody): Observable<SwaggerResponse<BarcodeInfo[]>> {
        let url_ = this.baseUrl + "/api/v1/ProductInfoCompletion/plc";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostProductInfoCompletion2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostProductInfoCompletion2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<BarcodeInfo[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<BarcodeInfo[]>>;
        }));
    }

    protected processPostProductInfoCompletion2(response: HttpResponseBase): Observable<SwaggerResponse<BarcodeInfo[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BarcodeInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<BarcodeInfo[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    getProductDescription(pLUUPC: string, api_version?: string | null | undefined): Observable<SwaggerResponse<ServiceResponseOfProductResult>> {
        let url_ = this.baseUrl + "/ProductInfoCompletion/description/{PLUUPC}?";
        if (pLUUPC === undefined || pLUUPC === null)
            throw new Error("The parameter 'pLUUPC' must be defined.");
        url_ = url_.replace("{PLUUPC}", encodeURIComponent("" + pLUUPC));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductDescription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductDescription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<ServiceResponseOfProductResult>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<ServiceResponseOfProductResult>>;
        }));
    }

    protected processGetProductDescription(response: HttpResponseBase): Observable<SwaggerResponse<ServiceResponseOfProductResult>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceResponseOfProductResult.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ServiceResponseOfProductResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<ServiceResponseOfProductResult>>(new SwaggerResponse(status, _headers, null as any));
    }

    getProductDescription2(pLUUPC: string): Observable<SwaggerResponse<ServiceResponseOfProductResult>> {
        let url_ = this.baseUrl + "/api/v1/ProductInfoCompletion/description/{PLUUPC}";
        if (pLUUPC === undefined || pLUUPC === null)
            throw new Error("The parameter 'pLUUPC' must be defined.");
        url_ = url_.replace("{PLUUPC}", encodeURIComponent("" + pLUUPC));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductDescription2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductDescription2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<ServiceResponseOfProductResult>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<ServiceResponseOfProductResult>>;
        }));
    }

    protected processGetProductDescription2(response: HttpResponseBase): Observable<SwaggerResponse<ServiceResponseOfProductResult>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ServiceResponseOfProductResult.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ServiceResponseOfProductResult.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<ServiceResponseOfProductResult>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class ProductManagementClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    /**
     * 根据条件获取指定店铺下的商品条码(在商品条码和描述中只能二选其一)
     * @param stores (optional) 店铺ID
     * @param barcode (optional) 商品条码
     * @param description (optional) 商品描述
     * @param department (optional) 部门描述
     * @param vendor (optional) 
     * @param brand (optional) 
     * @param deptGroup (optional) 
     * @param excludeUniformValues (optional) 根据（Description,Department,Vendor,Brand,Tax,Price,UnitCost,Size,ProfitMargin)排除多家店铺相同的数据,例子：new string[]{"Description","Department"}
     * @param saleable (optional) 只获取纯数字或者包含字符～的商品
     * @param api_version (optional) 
     * @return 店铺条码数组
     */
    storeProductCode(stores?: number[] | undefined, barcode?: string | null | undefined, description?: string | null | undefined, department?: string | null | undefined, vendor?: string | null | undefined, brand?: string | null | undefined, deptGroup?: string | null | undefined, excludeUniformValues?: string[] | null | undefined, saleable?: boolean | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<KeyValuePairedOfIntegerAndString[]>> {
        let url_ = this.baseUrl + "/api/ProductManagement/product/code?";
        if (stores === null)
            throw new Error("The parameter 'stores' cannot be null.");
        else if (stores !== undefined)
            stores && stores.forEach(item => { url_ += "stores=" + encodeURIComponent("" + item) + "&"; });
        if (barcode !== undefined && barcode !== null)
            url_ += "barcode=" + encodeURIComponent("" + barcode) + "&";
        if (description !== undefined && description !== null)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        if (department !== undefined && department !== null)
            url_ += "department=" + encodeURIComponent("" + department) + "&";
        if (vendor !== undefined && vendor !== null)
            url_ += "vendor=" + encodeURIComponent("" + vendor) + "&";
        if (brand !== undefined && brand !== null)
            url_ += "brand=" + encodeURIComponent("" + brand) + "&";
        if (deptGroup !== undefined && deptGroup !== null)
            url_ += "deptGroup=" + encodeURIComponent("" + deptGroup) + "&";
        if (excludeUniformValues !== undefined && excludeUniformValues !== null)
            excludeUniformValues && excludeUniformValues.forEach(item => { url_ += "excludeUniformValues=" + encodeURIComponent("" + item) + "&"; });
        if (saleable === null)
            throw new Error("The parameter 'saleable' cannot be null.");
        else if (saleable !== undefined)
            url_ += "saleable=" + encodeURIComponent("" + saleable) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStoreProductCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStoreProductCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<KeyValuePairedOfIntegerAndString[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<KeyValuePairedOfIntegerAndString[]>>;
        }));
    }

    protected processStoreProductCode(response: HttpResponseBase): Observable<SwaggerResponse<KeyValuePairedOfIntegerAndString[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KeyValuePairedOfIntegerAndString.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<KeyValuePairedOfIntegerAndString[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 更新商品信息
     * @param api_version (optional) 
     */
    updateProduct(updateProduct: UpdateProductDto, api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/ProductManagement/product/code?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateProduct);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProduct(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProduct(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processUpdateProduct(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 根据条件获取指定店铺下的商品条码(在商品条码和描述中只能二选其一)
     * @param stores (optional) 店铺ID
     * @param barcode (optional) 商品条码
     * @param description (optional) 商品描述
     * @param department (optional) 部门描述
     * @param vendor (optional) 
     * @param brand (optional) 
     * @param deptGroup (optional) 
     * @param excludeUniformValues (optional) 根据（Description,Department,Vendor,Brand,Tax,Price,UnitCost,Size,ProfitMargin)排除多家店铺相同的数据,例子：new string[]{"Description","Department"}
     * @param saleable (optional) 只获取纯数字或者包含字符～的商品
     * @return 店铺条码数组
     */
    storeProductCode2(stores?: number[] | undefined, barcode?: string | null | undefined, description?: string | null | undefined, department?: string | null | undefined, vendor?: string | null | undefined, brand?: string | null | undefined, deptGroup?: string | null | undefined, excludeUniformValues?: string[] | null | undefined, saleable?: boolean | undefined): Observable<SwaggerResponse<KeyValuePairedOfIntegerAndString[]>> {
        let url_ = this.baseUrl + "/api/v1/ProductManagement/product/code?";
        if (stores === null)
            throw new Error("The parameter 'stores' cannot be null.");
        else if (stores !== undefined)
            stores && stores.forEach(item => { url_ += "stores=" + encodeURIComponent("" + item) + "&"; });
        if (barcode !== undefined && barcode !== null)
            url_ += "barcode=" + encodeURIComponent("" + barcode) + "&";
        if (description !== undefined && description !== null)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        if (department !== undefined && department !== null)
            url_ += "department=" + encodeURIComponent("" + department) + "&";
        if (vendor !== undefined && vendor !== null)
            url_ += "vendor=" + encodeURIComponent("" + vendor) + "&";
        if (brand !== undefined && brand !== null)
            url_ += "brand=" + encodeURIComponent("" + brand) + "&";
        if (deptGroup !== undefined && deptGroup !== null)
            url_ += "deptGroup=" + encodeURIComponent("" + deptGroup) + "&";
        if (excludeUniformValues !== undefined && excludeUniformValues !== null)
            excludeUniformValues && excludeUniformValues.forEach(item => { url_ += "excludeUniformValues=" + encodeURIComponent("" + item) + "&"; });
        if (saleable === null)
            throw new Error("The parameter 'saleable' cannot be null.");
        else if (saleable !== undefined)
            url_ += "saleable=" + encodeURIComponent("" + saleable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStoreProductCode2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStoreProductCode2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<KeyValuePairedOfIntegerAndString[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<KeyValuePairedOfIntegerAndString[]>>;
        }));
    }

    protected processStoreProductCode2(response: HttpResponseBase): Observable<SwaggerResponse<KeyValuePairedOfIntegerAndString[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KeyValuePairedOfIntegerAndString.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<KeyValuePairedOfIntegerAndString[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 更新商品信息
     */
    updateProduct2(updateProduct: UpdateProductDto): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/ProductManagement/product/code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateProduct);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProduct2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProduct2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processUpdateProduct2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    exportCsv(storeCodes: KeyValuePairedOfIntegerAndString[], api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/ProductManagement/product/export-csv?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(storeCodes);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCsv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processExportCsv(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    exportCsv2(storeCodes: KeyValuePairedOfIntegerAndString[]): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/ProductManagement/product/export-csv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(storeCodes);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportCsv2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportCsv2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processExportCsv2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 根据条形码获取指定店铺下的商品信息
     * @param api_version (optional) 
     */
    storeProductCodeInfo(storeCodes: KeyValuePairedOfIntegerAndString[], api_version?: string | null | undefined): Observable<SwaggerResponse<ProductInfoDto[]>> {
        let url_ = this.baseUrl + "/api/ProductManagement/product/code/info?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(storeCodes);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStoreProductCodeInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStoreProductCodeInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<ProductInfoDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<ProductInfoDto[]>>;
        }));
    }

    protected processStoreProductCodeInfo(response: HttpResponseBase): Observable<SwaggerResponse<ProductInfoDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<ProductInfoDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 根据条形码获取指定店铺下的商品信息
     */
    storeProductCodeInfo2(storeCodes: KeyValuePairedOfIntegerAndString[]): Observable<SwaggerResponse<ProductInfoDto[]>> {
        let url_ = this.baseUrl + "/api/v1/ProductManagement/product/code/info";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(storeCodes);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStoreProductCodeInfo2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStoreProductCodeInfo2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<ProductInfoDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<ProductInfoDto[]>>;
        }));
    }

    protected processStoreProductCodeInfo2(response: HttpResponseBase): Observable<SwaggerResponse<ProductInfoDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProductInfoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<ProductInfoDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    getDpetBindTaxIds(storeId?: number | undefined, deptId?: number | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<string[]>> {
        let url_ = this.baseUrl + "/api/ProductManagement/product/dept/tax/ids?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (deptId === null)
            throw new Error("The parameter 'deptId' cannot be null.");
        else if (deptId !== undefined)
            url_ += "deptId=" + encodeURIComponent("" + deptId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDpetBindTaxIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDpetBindTaxIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string[]>>;
        }));
    }

    protected processGetDpetBindTaxIds(response: HttpResponseBase): Observable<SwaggerResponse<string[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    getDpetBindTaxIds2(storeId?: number | undefined, deptId?: number | undefined): Observable<SwaggerResponse<string[]>> {
        let url_ = this.baseUrl + "/api/v1/ProductManagement/product/dept/tax/ids?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (deptId === null)
            throw new Error("The parameter 'deptId' cannot be null.");
        else if (deptId !== undefined)
            url_ += "deptId=" + encodeURIComponent("" + deptId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDpetBindTaxIds2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDpetBindTaxIds2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string[]>>;
        }));
    }

    protected processGetDpetBindTaxIds2(response: HttpResponseBase): Observable<SwaggerResponse<string[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string[]>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class ProductReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    /**
     * 获取所有店铺正在出售的商品
     * @param storeArrays (optional) 
     * @param nonmovementDate (optional) 
     * @param api_version (optional) 
     * @return 请求成功
     */
    getAllStoreProducts(storeArrays?: number[] | null | undefined, nonmovementDate?: Date | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<ProductReportResponse>> {
        let url_ = this.baseUrl + "/movement/products?";
        if (storeArrays !== undefined && storeArrays !== null)
            storeArrays && storeArrays.forEach(item => { url_ += "StoreArrays=" + encodeURIComponent("" + item) + "&"; });
        if (nonmovementDate === null)
            throw new Error("The parameter 'nonmovementDate' cannot be null.");
        else if (nonmovementDate !== undefined)
            url_ += "NonmovementDate=" + encodeURIComponent(nonmovementDate ? "" + nonmovementDate.toISOString() : "") + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStoreProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStoreProducts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<ProductReportResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<ProductReportResponse>>;
        }));
    }

    protected processGetAllStoreProducts(response: HttpResponseBase): Observable<SwaggerResponse<ProductReportResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductReportResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<ProductReportResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取所有店铺正在出售的商品
     * @param storeArrays (optional) 
     * @param nonmovementDate (optional) 
     * @return 请求成功
     */
    getAllStoreProducts2(storeArrays?: number[] | null | undefined, nonmovementDate?: Date | undefined): Observable<SwaggerResponse<ProductReportResponse>> {
        let url_ = this.baseUrl + "/api/v1/movement/products?";
        if (storeArrays !== undefined && storeArrays !== null)
            storeArrays && storeArrays.forEach(item => { url_ += "StoreArrays=" + encodeURIComponent("" + item) + "&"; });
        if (nonmovementDate === null)
            throw new Error("The parameter 'nonmovementDate' cannot be null.");
        else if (nonmovementDate !== undefined)
            url_ += "NonmovementDate=" + encodeURIComponent(nonmovementDate ? "" + nonmovementDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllStoreProducts2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllStoreProducts2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<ProductReportResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<ProductReportResponse>>;
        }));
    }

    protected processGetAllStoreProducts2(response: HttpResponseBase): Observable<SwaggerResponse<ProductReportResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProductReportResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<ProductReportResponse>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class PromoSalesReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    /**
     * 获取促销时期商品的销售报表
     */
    getPromoSales(request: GetPromoSalesRequest): Observable<SwaggerResponse<PromoSalesDto[]>> {
        let url_ = this.baseUrl + "/api/v1/PromoSalesReport/promo-sales";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPromoSales(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPromoSales(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<PromoSalesDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<PromoSalesDto[]>>;
        }));
    }

    protected processGetPromoSales(response: HttpResponseBase): Observable<SwaggerResponse<PromoSalesDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PromoSalesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<PromoSalesDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取促销的批次信息
     * @param stores (optional) 
     * @param promoBegin (optional) 开始日期 (ISO 8601 格式: yyyy-MM-ddTHH:mm:ssZ)
     * @param promoEnd (optional) 结束日期 (ISO 8601 格式: yyyy-MM-ddTHH:mm:ssZ)
     */
    getBacthPromos(stores?: number[] | null | undefined, promoBegin?: Date | null | undefined, promoEnd?: Date | null | undefined): Observable<SwaggerResponse<BatchPromoDto[]>> {
        let url_ = this.baseUrl + "/api/v1/PromoSalesReport/promo-batch?";
        if (stores !== undefined && stores !== null)
            stores && stores.forEach(item => { url_ += "Stores=" + encodeURIComponent("" + item) + "&"; });
        if (promoBegin !== undefined && promoBegin !== null)
            url_ += "PromoBegin=" + encodeURIComponent(promoBegin ? "" + promoBegin.toISOString() : "") + "&";
        if (promoEnd !== undefined && promoEnd !== null)
            url_ += "PromoEnd=" + encodeURIComponent(promoEnd ? "" + promoEnd.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBacthPromos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBacthPromos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<BatchPromoDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<BatchPromoDto[]>>;
        }));
    }

    protected processGetBacthPromos(response: HttpResponseBase): Observable<SwaggerResponse<BatchPromoDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BatchPromoDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<BatchPromoDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    getProductSalesByPricing(request: PricePeriodSalesRequest[]): Observable<SwaggerResponse<PricePeriodSalesDto[]>> {
        let url_ = this.baseUrl + "/api/v1/PromoSalesReport/product-sales-by-pricing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProductSalesByPricing(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProductSalesByPricing(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<PricePeriodSalesDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<PricePeriodSalesDto[]>>;
        }));
    }

    protected processGetProductSalesByPricing(response: HttpResponseBase): Observable<SwaggerResponse<PricePeriodSalesDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PricePeriodSalesDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<PricePeriodSalesDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class ReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    getToken(requestDto: GetTokenRequestDto, api_version?: string | null | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/Report/reportToken?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processGetToken(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    getToken2(requestDto: GetTokenRequestDto): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/v1/Report/reportToken";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetToken2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetToken2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processGetToken2(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    getDiscountStoreCoupons(storeAccessKeys?: string[] | undefined, beginDate?: Date | undefined, endDate?: Date | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<DiscountStoreCouponResponseDto>> {
        let url_ = this.baseUrl + "/api/Report/discountStoreCoupons?";
        if (storeAccessKeys === null)
            throw new Error("The parameter 'storeAccessKeys' cannot be null.");
        else if (storeAccessKeys !== undefined)
            storeAccessKeys && storeAccessKeys.forEach(item => { url_ += "storeAccessKeys=" + encodeURIComponent("" + item) + "&"; });
        if (beginDate === null)
            throw new Error("The parameter 'beginDate' cannot be null.");
        else if (beginDate !== undefined)
            url_ += "beginDate=" + encodeURIComponent(beginDate ? "" + beginDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiscountStoreCoupons(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiscountStoreCoupons(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<DiscountStoreCouponResponseDto>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<DiscountStoreCouponResponseDto>>;
        }));
    }

    protected processGetDiscountStoreCoupons(response: HttpResponseBase): Observable<SwaggerResponse<DiscountStoreCouponResponseDto>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiscountStoreCouponResponseDto.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<DiscountStoreCouponResponseDto>>(new SwaggerResponse(status, _headers, null as any));
    }

    getDiscountStoreCoupons2(storeAccessKeys?: string[] | undefined, beginDate?: Date | undefined, endDate?: Date | undefined): Observable<SwaggerResponse<DiscountStoreCouponResponseDto>> {
        let url_ = this.baseUrl + "/api/v1/Report/discountStoreCoupons?";
        if (storeAccessKeys === null)
            throw new Error("The parameter 'storeAccessKeys' cannot be null.");
        else if (storeAccessKeys !== undefined)
            storeAccessKeys && storeAccessKeys.forEach(item => { url_ += "storeAccessKeys=" + encodeURIComponent("" + item) + "&"; });
        if (beginDate === null)
            throw new Error("The parameter 'beginDate' cannot be null.");
        else if (beginDate !== undefined)
            url_ += "beginDate=" + encodeURIComponent(beginDate ? "" + beginDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDiscountStoreCoupons2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDiscountStoreCoupons2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<DiscountStoreCouponResponseDto>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<DiscountStoreCouponResponseDto>>;
        }));
    }

    protected processGetDiscountStoreCoupons2(response: HttpResponseBase): Observable<SwaggerResponse<DiscountStoreCouponResponseDto>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DiscountStoreCouponResponseDto.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<DiscountStoreCouponResponseDto>>(new SwaggerResponse(status, _headers, null as any));
    }

    getStoreList(token?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<StoreListDto>> {
        let url_ = this.baseUrl + "/api/Report/stores?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "ReportToken": token !== undefined && token !== null ? "" + token : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStoreList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStoreList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<StoreListDto>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<StoreListDto>>;
        }));
    }

    protected processGetStoreList(response: HttpResponseBase): Observable<SwaggerResponse<StoreListDto>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StoreListDto.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<StoreListDto>>(new SwaggerResponse(status, _headers, null as any));
    }

    getStoreList2(token?: string | undefined): Observable<SwaggerResponse<StoreListDto>> {
        let url_ = this.baseUrl + "/api/v1/Report/stores";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "ReportToken": token !== undefined && token !== null ? "" + token : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStoreList2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStoreList2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<StoreListDto>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<StoreListDto>>;
        }));
    }

    protected processGetStoreList2(response: HttpResponseBase): Observable<SwaggerResponse<StoreListDto>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StoreListDto.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<StoreListDto>>(new SwaggerResponse(status, _headers, null as any));
    }

    getHourSales(token?: string | undefined, storeId?: number | undefined, beginDate?: Date | undefined, endDate?: Date | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<HourlySalesResponseDto>> {
        let url_ = this.baseUrl + "/api/Report/hourSales?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (beginDate === null)
            throw new Error("The parameter 'beginDate' cannot be null.");
        else if (beginDate !== undefined)
            url_ += "beginDate=" + encodeURIComponent(beginDate ? "" + beginDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "ReportToken": token !== undefined && token !== null ? "" + token : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHourSales(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHourSales(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<HourlySalesResponseDto>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<HourlySalesResponseDto>>;
        }));
    }

    protected processGetHourSales(response: HttpResponseBase): Observable<SwaggerResponse<HourlySalesResponseDto>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HourlySalesResponseDto.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<HourlySalesResponseDto>>(new SwaggerResponse(status, _headers, null as any));
    }

    getHourSales2(token?: string | undefined, storeId?: number | undefined, beginDate?: Date | undefined, endDate?: Date | undefined): Observable<SwaggerResponse<HourlySalesResponseDto>> {
        let url_ = this.baseUrl + "/api/v1/Report/hourSales?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (beginDate === null)
            throw new Error("The parameter 'beginDate' cannot be null.");
        else if (beginDate !== undefined)
            url_ += "beginDate=" + encodeURIComponent(beginDate ? "" + beginDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "ReportToken": token !== undefined && token !== null ? "" + token : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHourSales2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHourSales2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<HourlySalesResponseDto>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<HourlySalesResponseDto>>;
        }));
    }

    protected processGetHourSales2(response: HttpResponseBase): Observable<SwaggerResponse<HourlySalesResponseDto>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HourlySalesResponseDto.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<HourlySalesResponseDto>>(new SwaggerResponse(status, _headers, null as any));
    }

    getDepartmentGroupSales(token?: string | undefined, storeId?: number | undefined, beginDate?: Date | undefined, endDate?: Date | undefined, otherDepartment?: boolean | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<DepartmentGroupSalesResponseDto>> {
        let url_ = this.baseUrl + "/api/Report/departmentGroupSales?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (beginDate === null)
            throw new Error("The parameter 'beginDate' cannot be null.");
        else if (beginDate !== undefined)
            url_ += "beginDate=" + encodeURIComponent(beginDate ? "" + beginDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (otherDepartment === null)
            throw new Error("The parameter 'otherDepartment' cannot be null.");
        else if (otherDepartment !== undefined)
            url_ += "OtherDepartment=" + encodeURIComponent("" + otherDepartment) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "ReportToken": token !== undefined && token !== null ? "" + token : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDepartmentGroupSales(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDepartmentGroupSales(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<DepartmentGroupSalesResponseDto>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<DepartmentGroupSalesResponseDto>>;
        }));
    }

    protected processGetDepartmentGroupSales(response: HttpResponseBase): Observable<SwaggerResponse<DepartmentGroupSalesResponseDto>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DepartmentGroupSalesResponseDto.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<DepartmentGroupSalesResponseDto>>(new SwaggerResponse(status, _headers, null as any));
    }

    getDepartmentGroupSales2(token?: string | undefined, storeId?: number | undefined, beginDate?: Date | undefined, endDate?: Date | undefined, otherDepartment?: boolean | undefined): Observable<SwaggerResponse<DepartmentGroupSalesResponseDto>> {
        let url_ = this.baseUrl + "/api/v1/Report/departmentGroupSales?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (beginDate === null)
            throw new Error("The parameter 'beginDate' cannot be null.");
        else if (beginDate !== undefined)
            url_ += "beginDate=" + encodeURIComponent(beginDate ? "" + beginDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (otherDepartment === null)
            throw new Error("The parameter 'otherDepartment' cannot be null.");
        else if (otherDepartment !== undefined)
            url_ += "OtherDepartment=" + encodeURIComponent("" + otherDepartment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "ReportToken": token !== undefined && token !== null ? "" + token : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDepartmentGroupSales2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDepartmentGroupSales2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<DepartmentGroupSalesResponseDto>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<DepartmentGroupSalesResponseDto>>;
        }));
    }

    protected processGetDepartmentGroupSales2(response: HttpResponseBase): Observable<SwaggerResponse<DepartmentGroupSalesResponseDto>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DepartmentGroupSalesResponseDto.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<DepartmentGroupSalesResponseDto>>(new SwaggerResponse(status, _headers, null as any));
    }

    getTenders(token?: string | undefined, storeId?: number | undefined, beginDate?: Date | undefined, endDate?: Date | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<TenderResponse>> {
        let url_ = this.baseUrl + "/api/Report/tenders?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (beginDate === null)
            throw new Error("The parameter 'beginDate' cannot be null.");
        else if (beginDate !== undefined)
            url_ += "beginDate=" + encodeURIComponent(beginDate ? "" + beginDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "ReportToken": token !== undefined && token !== null ? "" + token : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<TenderResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<TenderResponse>>;
        }));
    }

    protected processGetTenders(response: HttpResponseBase): Observable<SwaggerResponse<TenderResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenderResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<TenderResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    getTenders2(token?: string | undefined, storeId?: number | undefined, beginDate?: Date | undefined, endDate?: Date | undefined): Observable<SwaggerResponse<TenderResponse>> {
        let url_ = this.baseUrl + "/api/v1/Report/tenders?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (beginDate === null)
            throw new Error("The parameter 'beginDate' cannot be null.");
        else if (beginDate !== undefined)
            url_ += "beginDate=" + encodeURIComponent(beginDate ? "" + beginDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "ReportToken": token !== undefined && token !== null ? "" + token : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTenders2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTenders2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<TenderResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<TenderResponse>>;
        }));
    }

    protected processGetTenders2(response: HttpResponseBase): Observable<SwaggerResponse<TenderResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TenderResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<TenderResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    getSummary(token?: string | undefined, storeId?: number | undefined, beginDate?: Date | undefined, endDate?: Date | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<SummaryResponseDto>> {
        let url_ = this.baseUrl + "/api/Report/summary?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (beginDate === null)
            throw new Error("The parameter 'beginDate' cannot be null.");
        else if (beginDate !== undefined)
            url_ += "beginDate=" + encodeURIComponent(beginDate ? "" + beginDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "ReportToken": token !== undefined && token !== null ? "" + token : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<SummaryResponseDto>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<SummaryResponseDto>>;
        }));
    }

    protected processGetSummary(response: HttpResponseBase): Observable<SwaggerResponse<SummaryResponseDto>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SummaryResponseDto.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<SummaryResponseDto>>(new SwaggerResponse(status, _headers, null as any));
    }

    getSummary2(token?: string | undefined, storeId?: number | undefined, beginDate?: Date | undefined, endDate?: Date | undefined): Observable<SwaggerResponse<SummaryResponseDto>> {
        let url_ = this.baseUrl + "/api/v1/Report/summary?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (beginDate === null)
            throw new Error("The parameter 'beginDate' cannot be null.");
        else if (beginDate !== undefined)
            url_ += "beginDate=" + encodeURIComponent(beginDate ? "" + beginDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "ReportToken": token !== undefined && token !== null ? "" + token : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSummary2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSummary2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<SummaryResponseDto>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<SummaryResponseDto>>;
        }));
    }

    protected processGetSummary2(response: HttpResponseBase): Observable<SwaggerResponse<SummaryResponseDto>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SummaryResponseDto.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<SummaryResponseDto>>(new SwaggerResponse(status, _headers, null as any));
    }

    sayHello(name?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<HelloReply2Dto>> {
        let url_ = this.baseUrl + "/api/Report/SayHello?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSayHello(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSayHello(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<HelloReply2Dto>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<HelloReply2Dto>>;
        }));
    }

    protected processSayHello(response: HttpResponseBase): Observable<SwaggerResponse<HelloReply2Dto>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HelloReply2Dto.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<HelloReply2Dto>>(new SwaggerResponse(status, _headers, null as any));
    }

    sayHello2(name?: string | undefined): Observable<SwaggerResponse<HelloReply2Dto>> {
        let url_ = this.baseUrl + "/api/v1/Report/SayHello?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSayHello2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSayHello2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<HelloReply2Dto>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<HelloReply2Dto>>;
        }));
    }

    protected processSayHello2(response: HttpResponseBase): Observable<SwaggerResponse<HelloReply2Dto>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HelloReply2Dto.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<HelloReply2Dto>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class ReportJobClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    /**
     * 测试邮件服务
     * @param reportType (optional) 
     * @param reportDataDateRangeType (optional) 
     * @param email (optional) 
     * @param environment (optional) 生产使用：Production
     * @param api_version (optional) 
     */
    sendTestEmail(reportType?: ReportJobType | undefined, reportDataDateRangeType?: ReportDataDateRangeType | undefined, email?: string | undefined, environment?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/ReportJob/send?";
        if (reportType === null)
            throw new Error("The parameter 'reportType' cannot be null.");
        else if (reportType !== undefined)
            url_ += "reportType=" + encodeURIComponent("" + reportType) + "&";
        if (reportDataDateRangeType === null)
            throw new Error("The parameter 'reportDataDateRangeType' cannot be null.");
        else if (reportDataDateRangeType !== undefined)
            url_ += "reportDataDateRangeType=" + encodeURIComponent("" + reportDataDateRangeType) + "&";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (environment === null)
            throw new Error("The parameter 'environment' cannot be null.");
        else if (environment !== undefined)
            url_ += "environment=" + encodeURIComponent("" + environment) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processSendTestEmail(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 测试邮件服务
     * @param reportType (optional) 
     * @param reportDataDateRangeType (optional) 
     * @param email (optional) 
     * @param environment (optional) 生产使用：Production
     */
    sendTestEmail2(reportType?: ReportJobType | undefined, reportDataDateRangeType?: ReportDataDateRangeType | undefined, email?: string | undefined, environment?: string | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/ReportJob/send?";
        if (reportType === null)
            throw new Error("The parameter 'reportType' cannot be null.");
        else if (reportType !== undefined)
            url_ += "reportType=" + encodeURIComponent("" + reportType) + "&";
        if (reportDataDateRangeType === null)
            throw new Error("The parameter 'reportDataDateRangeType' cannot be null.");
        else if (reportDataDateRangeType !== undefined)
            url_ += "reportDataDateRangeType=" + encodeURIComponent("" + reportDataDateRangeType) + "&";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (environment === null)
            throw new Error("The parameter 'environment' cannot be null.");
        else if (environment !== undefined)
            url_ += "environment=" + encodeURIComponent("" + environment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendTestEmail2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendTestEmail2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processSendTestEmail2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    createReportJob(request: ReportJobRequest, isBuild?: boolean | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<ReportJobItem>> {
        let url_ = this.baseUrl + "/api/ReportJob?";
        if (isBuild === null)
            throw new Error("The parameter 'isBuild' cannot be null.");
        else if (isBuild !== undefined)
            url_ += "isBuild=" + encodeURIComponent("" + isBuild) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateReportJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateReportJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<ReportJobItem>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<ReportJobItem>>;
        }));
    }

    protected processCreateReportJob(response: HttpResponseBase): Observable<SwaggerResponse<ReportJobItem>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportJobItem.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<ReportJobItem>>(new SwaggerResponse(status, _headers, null as any));
    }

    getReportJobs(api_version?: string | null | undefined): Observable<SwaggerResponse<ReportJobItem[]>> {
        let url_ = this.baseUrl + "/api/ReportJob?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportJobs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportJobs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<ReportJobItem[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<ReportJobItem[]>>;
        }));
    }

    protected processGetReportJobs(response: HttpResponseBase): Observable<SwaggerResponse<ReportJobItem[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReportJobItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<ReportJobItem[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    deleteReportJob(jobKey?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/ReportJob?";
        if (jobKey === null)
            throw new Error("The parameter 'jobKey' cannot be null.");
        else if (jobKey !== undefined)
            url_ += "jobKey=" + encodeURIComponent("" + jobKey) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteReportJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteReportJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processDeleteReportJob(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    modifityReportJob(date: JobExcuteDate, jobKey?: string | undefined, isBuild?: boolean | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<ReportJobItem>> {
        let url_ = this.baseUrl + "/api/ReportJob?";
        if (jobKey === null)
            throw new Error("The parameter 'jobKey' cannot be null.");
        else if (jobKey !== undefined)
            url_ += "jobKey=" + encodeURIComponent("" + jobKey) + "&";
        if (isBuild === null)
            throw new Error("The parameter 'isBuild' cannot be null.");
        else if (isBuild !== undefined)
            url_ += "isBuild=" + encodeURIComponent("" + isBuild) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(date);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processModifityReportJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processModifityReportJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<ReportJobItem>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<ReportJobItem>>;
        }));
    }

    protected processModifityReportJob(response: HttpResponseBase): Observable<SwaggerResponse<ReportJobItem>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportJobItem.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<ReportJobItem>>(new SwaggerResponse(status, _headers, null as any));
    }

    createReportJob2(request: ReportJobRequest, isBuild?: boolean | undefined): Observable<SwaggerResponse<ReportJobItem>> {
        let url_ = this.baseUrl + "/api/v1/ReportJob?";
        if (isBuild === null)
            throw new Error("The parameter 'isBuild' cannot be null.");
        else if (isBuild !== undefined)
            url_ += "isBuild=" + encodeURIComponent("" + isBuild) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateReportJob2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateReportJob2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<ReportJobItem>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<ReportJobItem>>;
        }));
    }

    protected processCreateReportJob2(response: HttpResponseBase): Observable<SwaggerResponse<ReportJobItem>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportJobItem.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<ReportJobItem>>(new SwaggerResponse(status, _headers, null as any));
    }

    getReportJobs2(): Observable<SwaggerResponse<ReportJobItem[]>> {
        let url_ = this.baseUrl + "/api/v1/ReportJob";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetReportJobs2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetReportJobs2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<ReportJobItem[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<ReportJobItem[]>>;
        }));
    }

    protected processGetReportJobs2(response: HttpResponseBase): Observable<SwaggerResponse<ReportJobItem[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ReportJobItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<ReportJobItem[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    deleteReportJob2(jobKey?: string | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/v1/ReportJob?";
        if (jobKey === null)
            throw new Error("The parameter 'jobKey' cannot be null.");
        else if (jobKey !== undefined)
            url_ += "jobKey=" + encodeURIComponent("" + jobKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteReportJob2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteReportJob2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processDeleteReportJob2(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    modifityReportJob2(date: JobExcuteDate, jobKey?: string | undefined, isBuild?: boolean | undefined): Observable<SwaggerResponse<ReportJobItem>> {
        let url_ = this.baseUrl + "/api/v1/ReportJob?";
        if (jobKey === null)
            throw new Error("The parameter 'jobKey' cannot be null.");
        else if (jobKey !== undefined)
            url_ += "jobKey=" + encodeURIComponent("" + jobKey) + "&";
        if (isBuild === null)
            throw new Error("The parameter 'isBuild' cannot be null.");
        else if (isBuild !== undefined)
            url_ += "isBuild=" + encodeURIComponent("" + isBuild) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(date);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processModifityReportJob2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processModifityReportJob2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<ReportJobItem>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<ReportJobItem>>;
        }));
    }

    protected processModifityReportJob2(response: HttpResponseBase): Observable<SwaggerResponse<ReportJobItem>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ReportJobItem.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<ReportJobItem>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class SettingConfigClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    /**
     * 获取默认字段属性
     * @param api_version (optional) 
     * @return Success!
     */
    getDefaultField(api_version?: string | null | undefined): Observable<SwaggerResponse<SettingConfigResponse>> {
        let url_ = this.baseUrl + "/approval/DefaultField?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultField(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultField(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<SettingConfigResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<SettingConfigResponse>>;
        }));
    }

    protected processGetDefaultField(response: HttpResponseBase): Observable<SwaggerResponse<SettingConfigResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SettingConfigResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<SettingConfigResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取默认字段属性
     * @return Success!
     */
    getDefaultField2(): Observable<SwaggerResponse<SettingConfigResponse>> {
        let url_ = this.baseUrl + "/api/v1/approval/DefaultField";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDefaultField2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDefaultField2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<SettingConfigResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<SettingConfigResponse>>;
        }));
    }

    protected processGetDefaultField2(response: HttpResponseBase): Observable<SwaggerResponse<SettingConfigResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SettingConfigResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<SettingConfigResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 修改属性
     * @param storeId 店铺id
     * @param config 属性基本信息
     * @param api_version (optional) 
     * @return Success!
     */
    postSettingConfigField(storeId: number, config: SettingConfigResponse, api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/approval/ModeifyField/{storeId}?";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(config);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostSettingConfigField(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostSettingConfigField(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processPostSettingConfigField(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 修改属性
     * @param storeId 店铺id
     * @param config 属性基本信息
     * @return Success!
     */
    postSettingConfigField2(storeId: number, config: SettingConfigResponse): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/approval/ModeifyField/{storeId}";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(config);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostSettingConfigField2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostSettingConfigField2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processPostSettingConfigField2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取所有字段
     * @param storeId 店铺id
     * @param api_version (optional) 
     * @return Success!
     */
    getFieldName(storeId: number, api_version?: string | null | undefined): Observable<SwaggerResponse<SettingConfigResponse>> {
        let url_ = this.baseUrl + "/approval/GetAllField/{storeId}?";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFieldName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFieldName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<SettingConfigResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<SettingConfigResponse>>;
        }));
    }

    protected processGetFieldName(response: HttpResponseBase): Observable<SwaggerResponse<SettingConfigResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SettingConfigResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<SettingConfigResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取所有字段
     * @param storeId 店铺id
     * @return Success!
     */
    getFieldName2(storeId: number): Observable<SwaggerResponse<SettingConfigResponse>> {
        let url_ = this.baseUrl + "/api/v1/approval/GetAllField/{storeId}";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFieldName2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFieldName2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<SettingConfigResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<SettingConfigResponse>>;
        }));
    }

    protected processGetFieldName2(response: HttpResponseBase): Observable<SwaggerResponse<SettingConfigResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SettingConfigResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<SettingConfigResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 判断storeId 是否存在
     * @param storeId (optional) 
     * @param api_version (optional) 
     * @return Success!
     */
    getStoreId(storeId?: number | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/approval?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStoreId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStoreId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processGetStoreId(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 判断storeId 是否存在
     * @param storeId (optional) 
     * @return Success!
     */
    getStoreId2(storeId?: number | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/approval?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStoreId2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStoreId2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processGetStoreId2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class SharedTemplatesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    /**
     * 获取所有的共享模板 Version 1.6
     * @param api_version (optional) 
     * @return Success!
     */
    getSharedTemplate(api_version?: string | null | undefined): Observable<SwaggerResponse<SharedTemplate>> {
        let url_ = this.baseUrl + "/approval/All/SharedTemplate?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSharedTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSharedTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<SharedTemplate>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<SharedTemplate>>;
        }));
    }

    protected processGetSharedTemplate(response: HttpResponseBase): Observable<SwaggerResponse<SharedTemplate>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SharedTemplate.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<SharedTemplate>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取所有的共享模板 Version 1.6
     * @return Success!
     */
    getSharedTemplate2(): Observable<SwaggerResponse<SharedTemplate>> {
        let url_ = this.baseUrl + "/api/v1/approval/All/SharedTemplate";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSharedTemplate2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSharedTemplate2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<SharedTemplate>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<SharedTemplate>>;
        }));
    }

    protected processGetSharedTemplate2(response: HttpResponseBase): Observable<SwaggerResponse<SharedTemplate>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SharedTemplate.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<SharedTemplate>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 搜索共享库中的模板
     * @param templateName (optional) 
     * @param guid (optional) 
     * @param storeId (optional) 
     * @param api_version (optional) 
     * @return Success!
     */
    searchTemplate(templateName?: string | undefined, guid?: string | undefined, storeId?: number | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<SearchTemplate>> {
        let url_ = this.baseUrl + "/approval/Search/Template?";
        if (templateName === null)
            throw new Error("The parameter 'templateName' cannot be null.");
        else if (templateName !== undefined)
            url_ += "templateName=" + encodeURIComponent("" + templateName) + "&";
        if (guid === null)
            throw new Error("The parameter 'guid' cannot be null.");
        else if (guid !== undefined)
            url_ += "guid=" + encodeURIComponent("" + guid) + "&";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchTemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchTemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<SearchTemplate>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<SearchTemplate>>;
        }));
    }

    protected processSearchTemplate(response: HttpResponseBase): Observable<SwaggerResponse<SearchTemplate>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchTemplate.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<SearchTemplate>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 搜索共享库中的模板
     * @param templateName (optional) 
     * @param guid (optional) 
     * @param storeId (optional) 
     * @return Success!
     */
    searchTemplate2(templateName?: string | undefined, guid?: string | undefined, storeId?: number | undefined): Observable<SwaggerResponse<SearchTemplate>> {
        let url_ = this.baseUrl + "/api/v1/approval/Search/Template?";
        if (templateName === null)
            throw new Error("The parameter 'templateName' cannot be null.");
        else if (templateName !== undefined)
            url_ += "templateName=" + encodeURIComponent("" + templateName) + "&";
        if (guid === null)
            throw new Error("The parameter 'guid' cannot be null.");
        else if (guid !== undefined)
            url_ += "guid=" + encodeURIComponent("" + guid) + "&";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchTemplate2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchTemplate2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<SearchTemplate>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<SearchTemplate>>;
        }));
    }

    protected processSearchTemplate2(response: HttpResponseBase): Observable<SwaggerResponse<SearchTemplate>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchTemplate.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<SearchTemplate>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取商店名
     * @param storeId (optional) 
     * @param api_version (optional) 
     */
    getStoreName(storeId?: number | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/approval/StoreName?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStoreName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStoreName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processGetStoreName(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取商店名
     * @param storeId (optional) 
     */
    getStoreName2(storeId?: number | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/v1/approval/StoreName?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStoreName2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStoreName2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processGetStoreName2(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class SqlExecutorClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    excute(request: QuerySqlRequest, api_version?: string | null | undefined): Observable<SwaggerResponse<SqlExecutorResponseDto[]>> {
        let url_ = this.baseUrl + "/api/SqlExecutor/excute?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExcute(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExcute(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<SqlExecutorResponseDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<SqlExecutorResponseDto[]>>;
        }));
    }

    protected processExcute(response: HttpResponseBase): Observable<SwaggerResponse<SqlExecutorResponseDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SqlExecutorResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<SqlExecutorResponseDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    excute2(request: QuerySqlRequest): Observable<SwaggerResponse<SqlExecutorResponseDto[]>> {
        let url_ = this.baseUrl + "/api/v1/SqlExecutor/excute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExcute2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExcute2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<SqlExecutorResponseDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<SqlExecutorResponseDto[]>>;
        }));
    }

    protected processExcute2(response: HttpResponseBase): Observable<SwaggerResponse<SqlExecutorResponseDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SqlExecutorResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<SqlExecutorResponseDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    getSqlTempletes(api_version?: string | null | undefined): Observable<SwaggerResponse<SqlTempleteDto[]>> {
        let url_ = this.baseUrl + "/api/SqlExecutor/templetes?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSqlTempletes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSqlTempletes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<SqlTempleteDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<SqlTempleteDto[]>>;
        }));
    }

    protected processGetSqlTempletes(response: HttpResponseBase): Observable<SwaggerResponse<SqlTempleteDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SqlTempleteDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<SqlTempleteDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    getSqlTempletes2(): Observable<SwaggerResponse<SqlTempleteDto[]>> {
        let url_ = this.baseUrl + "/api/v1/SqlExecutor/templetes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSqlTempletes2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSqlTempletes2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<SqlTempleteDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<SqlTempleteDto[]>>;
        }));
    }

    protected processGetSqlTempletes2(response: HttpResponseBase): Observable<SwaggerResponse<SqlTempleteDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SqlTempleteDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<SqlTempleteDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    saveSqlTemplete(sqlTemplete: SqlTempleteDto, api_version?: string | null | undefined): Observable<SwaggerResponse<SqlTempleteDto>> {
        let url_ = this.baseUrl + "/api/SqlExecutor/templete/save?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sqlTemplete);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveSqlTemplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveSqlTemplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<SqlTempleteDto>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<SqlTempleteDto>>;
        }));
    }

    protected processSaveSqlTemplete(response: HttpResponseBase): Observable<SwaggerResponse<SqlTempleteDto>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SqlTempleteDto.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<SqlTempleteDto>>(new SwaggerResponse(status, _headers, null as any));
    }

    saveSqlTemplete2(sqlTemplete: SqlTempleteDto): Observable<SwaggerResponse<SqlTempleteDto>> {
        let url_ = this.baseUrl + "/api/v1/SqlExecutor/templete/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sqlTemplete);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSaveSqlTemplete2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSaveSqlTemplete2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<SqlTempleteDto>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<SqlTempleteDto>>;
        }));
    }

    protected processSaveSqlTemplete2(response: HttpResponseBase): Observable<SwaggerResponse<SqlTempleteDto>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SqlTempleteDto.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<SqlTempleteDto>>(new SwaggerResponse(status, _headers, null as any));
    }

    deleteSqlTemplete(templeteDescription: string, api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/SqlExecutor/templete/{templeteDescription}?";
        if (templeteDescription === undefined || templeteDescription === null)
            throw new Error("The parameter 'templeteDescription' must be defined.");
        url_ = url_.replace("{templeteDescription}", encodeURIComponent("" + templeteDescription));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSqlTemplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSqlTemplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processDeleteSqlTemplete(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    deleteSqlTemplete2(templeteDescription: string): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/SqlExecutor/templete/{templeteDescription}";
        if (templeteDescription === undefined || templeteDescription === null)
            throw new Error("The parameter 'templeteDescription' must be defined.");
        url_ = url_.replace("{templeteDescription}", encodeURIComponent("" + templeteDescription));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteSqlTemplete2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteSqlTemplete2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processDeleteSqlTemplete2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class StoreChainCodeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    /**
     * 根据条件获取指定店铺下的商品条码(在商品条码和描述中只能二选其一)
     * @param stores (optional) 店铺ID
     * @param type (optional) 查询类型( None:全部商品 | Normal:普通商品 | Internal:内部商品
     * @param isIncludeChainCode (optional) 是否包含供应链码(True: 只返回供应链码不为空 | False: 只返回供应链码为空 | null: 返回所有)
     * @param barcode (optional) 商品条码
     * @param description (optional) 商品描述
     * @param department (optional) 部门描述
     * @param filterSharedProducts (optional) 是否过滤出多家店铺共同拥有的商品(True: 过滤 | False： 不过滤)
     * @param api_version (optional) 
     * @return 店铺条码数组
     */
    storeProductCode(stores?: number[] | undefined, type?: StoreChainCodeType | undefined, isIncludeChainCode?: boolean | null | undefined, barcode?: string | null | undefined, description?: string | null | undefined, department?: string | null | undefined, filterSharedProducts?: boolean | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<KeyValuePairedOfIntegerAndString[]>> {
        let url_ = this.baseUrl + "/api/StoreChainCode/product/code?";
        if (stores === null)
            throw new Error("The parameter 'stores' cannot be null.");
        else if (stores !== undefined)
            stores && stores.forEach(item => { url_ += "stores=" + encodeURIComponent("" + item) + "&"; });
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (isIncludeChainCode !== undefined && isIncludeChainCode !== null)
            url_ += "isIncludeChainCode=" + encodeURIComponent("" + isIncludeChainCode) + "&";
        if (barcode !== undefined && barcode !== null)
            url_ += "barcode=" + encodeURIComponent("" + barcode) + "&";
        if (description !== undefined && description !== null)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        if (department !== undefined && department !== null)
            url_ += "department=" + encodeURIComponent("" + department) + "&";
        if (filterSharedProducts === null)
            throw new Error("The parameter 'filterSharedProducts' cannot be null.");
        else if (filterSharedProducts !== undefined)
            url_ += "filterSharedProducts=" + encodeURIComponent("" + filterSharedProducts) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStoreProductCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStoreProductCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<KeyValuePairedOfIntegerAndString[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<KeyValuePairedOfIntegerAndString[]>>;
        }));
    }

    protected processStoreProductCode(response: HttpResponseBase): Observable<SwaggerResponse<KeyValuePairedOfIntegerAndString[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KeyValuePairedOfIntegerAndString.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<KeyValuePairedOfIntegerAndString[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 根据条件获取指定店铺下的商品条码(在商品条码和描述中只能二选其一)
     * @param stores (optional) 店铺ID
     * @param type (optional) 查询类型( None:全部商品 | Normal:普通商品 | Internal:内部商品
     * @param isIncludeChainCode (optional) 是否包含供应链码(True: 只返回供应链码不为空 | False: 只返回供应链码为空 | null: 返回所有)
     * @param barcode (optional) 商品条码
     * @param description (optional) 商品描述
     * @param department (optional) 部门描述
     * @param filterSharedProducts (optional) 是否过滤出多家店铺共同拥有的商品(True: 过滤 | False： 不过滤)
     * @return 店铺条码数组
     */
    storeProductCode2(stores?: number[] | undefined, type?: StoreChainCodeType | undefined, isIncludeChainCode?: boolean | null | undefined, barcode?: string | null | undefined, description?: string | null | undefined, department?: string | null | undefined, filterSharedProducts?: boolean | undefined): Observable<SwaggerResponse<KeyValuePairedOfIntegerAndString[]>> {
        let url_ = this.baseUrl + "/api/v1/StoreChainCode/product/code?";
        if (stores === null)
            throw new Error("The parameter 'stores' cannot be null.");
        else if (stores !== undefined)
            stores && stores.forEach(item => { url_ += "stores=" + encodeURIComponent("" + item) + "&"; });
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (isIncludeChainCode !== undefined && isIncludeChainCode !== null)
            url_ += "isIncludeChainCode=" + encodeURIComponent("" + isIncludeChainCode) + "&";
        if (barcode !== undefined && barcode !== null)
            url_ += "barcode=" + encodeURIComponent("" + barcode) + "&";
        if (description !== undefined && description !== null)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        if (department !== undefined && department !== null)
            url_ += "department=" + encodeURIComponent("" + department) + "&";
        if (filterSharedProducts === null)
            throw new Error("The parameter 'filterSharedProducts' cannot be null.");
        else if (filterSharedProducts !== undefined)
            url_ += "filterSharedProducts=" + encodeURIComponent("" + filterSharedProducts) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStoreProductCode2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStoreProductCode2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<KeyValuePairedOfIntegerAndString[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<KeyValuePairedOfIntegerAndString[]>>;
        }));
    }

    protected processStoreProductCode2(response: HttpResponseBase): Observable<SwaggerResponse<KeyValuePairedOfIntegerAndString[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KeyValuePairedOfIntegerAndString.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<KeyValuePairedOfIntegerAndString[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 根据条形码获取指定店铺下的商品信息
     * @param api_version (optional) 
     */
    storeProductCodeInfo(storeCodes: KeyValuePairedOfIntegerAndString[], api_version?: string | null | undefined): Observable<SwaggerResponse<StoreChainCodeInfo[]>> {
        let url_ = this.baseUrl + "/api/StoreChainCode/product/code/info?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(storeCodes);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStoreProductCodeInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStoreProductCodeInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<StoreChainCodeInfo[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<StoreChainCodeInfo[]>>;
        }));
    }

    protected processStoreProductCodeInfo(response: HttpResponseBase): Observable<SwaggerResponse<StoreChainCodeInfo[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StoreChainCodeInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<StoreChainCodeInfo[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 更新多家店铺中内部商品的唯一内部条码
     * @param isUpdatePLuEnabled (optional) 是否启用更新PLU表中这件商品本身(Desc|Department)
     * @param api_version (optional) 
     */
    updateProductInfo(chainCodeDto: UpdateProductChainCodeDto, isUpdatePLuEnabled?: boolean | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/StoreChainCode/product/code/info?";
        if (isUpdatePLuEnabled === null)
            throw new Error("The parameter 'isUpdatePLuEnabled' cannot be null.");
        else if (isUpdatePLuEnabled !== undefined)
            url_ += "isUpdatePLuEnabled=" + encodeURIComponent("" + isUpdatePLuEnabled) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(chainCodeDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProductInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProductInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processUpdateProductInfo(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 根据条形码获取指定店铺下的商品信息
     */
    storeProductCodeInfo2(storeCodes: KeyValuePairedOfIntegerAndString[]): Observable<SwaggerResponse<StoreChainCodeInfo[]>> {
        let url_ = this.baseUrl + "/api/v1/StoreChainCode/product/code/info";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(storeCodes);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStoreProductCodeInfo2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStoreProductCodeInfo2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<StoreChainCodeInfo[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<StoreChainCodeInfo[]>>;
        }));
    }

    protected processStoreProductCodeInfo2(response: HttpResponseBase): Observable<SwaggerResponse<StoreChainCodeInfo[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StoreChainCodeInfo.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<StoreChainCodeInfo[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 更新多家店铺中内部商品的唯一内部条码
     * @param isUpdatePLuEnabled (optional) 是否启用更新PLU表中这件商品本身(Desc|Department)
     */
    updateProductInfo2(chainCodeDto: UpdateProductChainCodeDto, isUpdatePLuEnabled?: boolean | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/StoreChainCode/product/code/info?";
        if (isUpdatePLuEnabled === null)
            throw new Error("The parameter 'isUpdatePLuEnabled' cannot be null.");
        else if (isUpdatePLuEnabled !== undefined)
            url_ += "isUpdatePLuEnabled=" + encodeURIComponent("" + isUpdatePLuEnabled) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(chainCodeDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProductInfo2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProductInfo2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processUpdateProductInfo2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 是否允许更新
     * @param stores (optional) 店铺
     * @param department (optional) 部门
     * @param api_version (optional) 
     * @return True：允许更新 | False：不允许更新
     */
    isUpdatePermitted(stores?: number[] | undefined, department?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<KeyValuePairedOfIntegerAndBoolean[]>> {
        let url_ = this.baseUrl + "/api/StoreChainCode/product/code/update/is-permitted?";
        if (stores === null)
            throw new Error("The parameter 'stores' cannot be null.");
        else if (stores !== undefined)
            stores && stores.forEach(item => { url_ += "stores=" + encodeURIComponent("" + item) + "&"; });
        if (department === null)
            throw new Error("The parameter 'department' cannot be null.");
        else if (department !== undefined)
            url_ += "department=" + encodeURIComponent("" + department) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsUpdatePermitted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsUpdatePermitted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<KeyValuePairedOfIntegerAndBoolean[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<KeyValuePairedOfIntegerAndBoolean[]>>;
        }));
    }

    protected processIsUpdatePermitted(response: HttpResponseBase): Observable<SwaggerResponse<KeyValuePairedOfIntegerAndBoolean[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KeyValuePairedOfIntegerAndBoolean.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<KeyValuePairedOfIntegerAndBoolean[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 是否允许更新
     * @param stores (optional) 店铺
     * @param department (optional) 部门
     * @return True：允许更新 | False：不允许更新
     */
    isUpdatePermitted2(stores?: number[] | undefined, department?: string | undefined): Observable<SwaggerResponse<KeyValuePairedOfIntegerAndBoolean[]>> {
        let url_ = this.baseUrl + "/api/v1/StoreChainCode/product/code/update/is-permitted?";
        if (stores === null)
            throw new Error("The parameter 'stores' cannot be null.");
        else if (stores !== undefined)
            stores && stores.forEach(item => { url_ += "stores=" + encodeURIComponent("" + item) + "&"; });
        if (department === null)
            throw new Error("The parameter 'department' cannot be null.");
        else if (department !== undefined)
            url_ += "department=" + encodeURIComponent("" + department) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsUpdatePermitted2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsUpdatePermitted2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<KeyValuePairedOfIntegerAndBoolean[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<KeyValuePairedOfIntegerAndBoolean[]>>;
        }));
    }

    protected processIsUpdatePermitted2(response: HttpResponseBase): Observable<SwaggerResponse<KeyValuePairedOfIntegerAndBoolean[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(KeyValuePairedOfIntegerAndBoolean.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<KeyValuePairedOfIntegerAndBoolean[]>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class StoreDataCloneClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    /**
     * 克隆商品数据
     * @param api_version (optional) 
     */
    productClone(dto: StoreDataCloneBody, api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/StoreDataClone/clone/product?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProductClone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProductClone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processProductClone(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 克隆商品数据
     */
    productClone2(dto: StoreDataCloneBody): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/StoreDataClone/clone/product";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProductClone2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProductClone2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processProductClone2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 克隆商品属性
     * @param api_version (optional) 
     */
    productAttributeClone(dto: StoreDataCloneBody, api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/StoreDataClone/clone/product/attribute?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProductAttributeClone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProductAttributeClone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processProductAttributeClone(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 克隆商品属性
     */
    productAttributeClone2(dto: StoreDataCloneBody): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/StoreDataClone/clone/product/attribute";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProductAttributeClone2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProductAttributeClone2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processProductAttributeClone2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    mutiBarcodeClone(cloneBody: MutiBarcodeCloneBody, api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/StoreDataClone/clone/mutibarcode?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cloneBody);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMutiBarcodeClone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMutiBarcodeClone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processMutiBarcodeClone(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    mutiBarcodeClone2(cloneBody: MutiBarcodeCloneBody): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/StoreDataClone/clone/mutibarcode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cloneBody);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMutiBarcodeClone2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMutiBarcodeClone2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processMutiBarcodeClone2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    getBarCode(storeId?: number | undefined, departments?: string[] | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<string[]>> {
        let url_ = this.baseUrl + "/api/StoreDataClone/clone/barcodes?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (departments === null)
            throw new Error("The parameter 'departments' cannot be null.");
        else if (departments !== undefined)
            departments && departments.forEach(item => { url_ += "departments=" + encodeURIComponent("" + item) + "&"; });
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBarCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBarCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string[]>>;
        }));
    }

    protected processGetBarCode(response: HttpResponseBase): Observable<SwaggerResponse<string[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    getBarCode2(storeId?: number | undefined, departments?: string[] | undefined): Observable<SwaggerResponse<string[]>> {
        let url_ = this.baseUrl + "/api/v1/StoreDataClone/clone/barcodes?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (departments === null)
            throw new Error("The parameter 'departments' cannot be null.");
        else if (departments !== undefined)
            departments && departments.forEach(item => { url_ += "departments=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBarCode2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBarCode2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string[]>>;
        }));
    }

    protected processGetBarCode2(response: HttpResponseBase): Observable<SwaggerResponse<string[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string[]>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class StoreGroupSaleByCustomerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    getSale(storeIds?: number[] | undefined, salesRanking?: number | undefined, begin?: Date | undefined, end?: Date | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<GroupSaleResponse>> {
        let url_ = this.baseUrl + "/api/StoreGroupSaleByCustomer/groupTotalSale?";
        if (storeIds === null)
            throw new Error("The parameter 'storeIds' cannot be null.");
        else if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "storeIds=" + encodeURIComponent("" + item) + "&"; });
        if (salesRanking === null)
            throw new Error("The parameter 'salesRanking' cannot be null.");
        else if (salesRanking !== undefined)
            url_ += "salesRanking=" + encodeURIComponent("" + salesRanking) + "&";
        if (begin === null)
            throw new Error("The parameter 'begin' cannot be null.");
        else if (begin !== undefined)
            url_ += "begin=" + encodeURIComponent(begin ? "" + begin.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSale(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSale(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<GroupSaleResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<GroupSaleResponse>>;
        }));
    }

    protected processGetSale(response: HttpResponseBase): Observable<SwaggerResponse<GroupSaleResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupSaleResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<GroupSaleResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    getSale2(storeIds?: number[] | undefined, salesRanking?: number | undefined, begin?: Date | undefined, end?: Date | undefined): Observable<SwaggerResponse<GroupSaleResponse>> {
        let url_ = this.baseUrl + "/api/v1/StoreGroupSaleByCustomer/groupTotalSale?";
        if (storeIds === null)
            throw new Error("The parameter 'storeIds' cannot be null.");
        else if (storeIds !== undefined)
            storeIds && storeIds.forEach(item => { url_ += "storeIds=" + encodeURIComponent("" + item) + "&"; });
        if (salesRanking === null)
            throw new Error("The parameter 'salesRanking' cannot be null.");
        else if (salesRanking !== undefined)
            url_ += "salesRanking=" + encodeURIComponent("" + salesRanking) + "&";
        if (begin === null)
            throw new Error("The parameter 'begin' cannot be null.");
        else if (begin !== undefined)
            url_ += "begin=" + encodeURIComponent(begin ? "" + begin.toISOString() : "") + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent(end ? "" + end.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSale2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSale2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<GroupSaleResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<GroupSaleResponse>>;
        }));
    }

    protected processGetSale2(response: HttpResponseBase): Observable<SwaggerResponse<GroupSaleResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupSaleResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<GroupSaleResponse>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class StoreInventoryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    /**
     * 多家店铺：搜索商品条码
     * @param storeIdList (optional) 店铺ID列表
     * @param searchType (optional) 搜索类型 (Text / UPC)
     * @param brand (optional) 品牌
     * @param vendor (optional) 供货商
     * @param department (optional) 部门
     * @param searchText (optional) 搜索内容
     * @param isVisible (optional) 只返回库存(>=0)的商品(Default: False)
     * @param minInventory (optional) 最小库存数量(Default: null)
     * @param api_version (optional) 
     */
    getBarCodeList(storeIdList?: number[] | undefined, searchType?: SearchType | undefined, brand?: string | null | undefined, vendor?: string | null | undefined, department?: string | null | undefined, searchText?: string | null | undefined, isVisible?: boolean | undefined, minInventory?: number | null | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<string[]>> {
        let url_ = this.baseUrl + "/api/StoreInventory/barCodeList?";
        if (storeIdList === null)
            throw new Error("The parameter 'storeIdList' cannot be null.");
        else if (storeIdList !== undefined)
            storeIdList && storeIdList.forEach(item => { url_ += "StoreIdList=" + encodeURIComponent("" + item) + "&"; });
        if (searchType === null)
            throw new Error("The parameter 'searchType' cannot be null.");
        else if (searchType !== undefined)
            url_ += "SearchType=" + encodeURIComponent("" + searchType) + "&";
        if (brand !== undefined && brand !== null)
            url_ += "brand=" + encodeURIComponent("" + brand) + "&";
        if (vendor !== undefined && vendor !== null)
            url_ += "vendor=" + encodeURIComponent("" + vendor) + "&";
        if (department !== undefined && department !== null)
            url_ += "department=" + encodeURIComponent("" + department) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (isVisible === null)
            throw new Error("The parameter 'isVisible' cannot be null.");
        else if (isVisible !== undefined)
            url_ += "isVisible=" + encodeURIComponent("" + isVisible) + "&";
        if (minInventory !== undefined && minInventory !== null)
            url_ += "minInventory=" + encodeURIComponent("" + minInventory) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBarCodeList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBarCodeList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string[]>>;
        }));
    }

    protected processGetBarCodeList(response: HttpResponseBase): Observable<SwaggerResponse<string[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 多家店铺：搜索商品条码
     * @param storeIdList (optional) 店铺ID列表
     * @param searchType (optional) 搜索类型 (Text / UPC)
     * @param brand (optional) 品牌
     * @param vendor (optional) 供货商
     * @param department (optional) 部门
     * @param searchText (optional) 搜索内容
     * @param isVisible (optional) 只返回库存(>=0)的商品(Default: False)
     * @param minInventory (optional) 最小库存数量(Default: null)
     */
    getBarCodeList2(storeIdList?: number[] | undefined, searchType?: SearchType | undefined, brand?: string | null | undefined, vendor?: string | null | undefined, department?: string | null | undefined, searchText?: string | null | undefined, isVisible?: boolean | undefined, minInventory?: number | null | undefined): Observable<SwaggerResponse<string[]>> {
        let url_ = this.baseUrl + "/api/v1/StoreInventory/barCodeList?";
        if (storeIdList === null)
            throw new Error("The parameter 'storeIdList' cannot be null.");
        else if (storeIdList !== undefined)
            storeIdList && storeIdList.forEach(item => { url_ += "StoreIdList=" + encodeURIComponent("" + item) + "&"; });
        if (searchType === null)
            throw new Error("The parameter 'searchType' cannot be null.");
        else if (searchType !== undefined)
            url_ += "SearchType=" + encodeURIComponent("" + searchType) + "&";
        if (brand !== undefined && brand !== null)
            url_ += "brand=" + encodeURIComponent("" + brand) + "&";
        if (vendor !== undefined && vendor !== null)
            url_ += "vendor=" + encodeURIComponent("" + vendor) + "&";
        if (department !== undefined && department !== null)
            url_ += "department=" + encodeURIComponent("" + department) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (isVisible === null)
            throw new Error("The parameter 'isVisible' cannot be null.");
        else if (isVisible !== undefined)
            url_ += "isVisible=" + encodeURIComponent("" + isVisible) + "&";
        if (minInventory !== undefined && minInventory !== null)
            url_ += "minInventory=" + encodeURIComponent("" + minInventory) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBarCodeList2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBarCodeList2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string[]>>;
        }));
    }

    protected processGetBarCodeList2(response: HttpResponseBase): Observable<SwaggerResponse<string[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 多家店铺：商品库存信息
     * @param api_version (optional) 
     */
    getStoreInventorys(request: SearchStoreInventroyRequest, api_version?: string | null | undefined): Observable<SwaggerResponse<StoreInventoryDto[]>> {
        let url_ = this.baseUrl + "/api/StoreInventory/inventories?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStoreInventorys(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStoreInventorys(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<StoreInventoryDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<StoreInventoryDto[]>>;
        }));
    }

    protected processGetStoreInventorys(response: HttpResponseBase): Observable<SwaggerResponse<StoreInventoryDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StoreInventoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<StoreInventoryDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 多家店铺：商品库存信息
     */
    getStoreInventorys2(request: SearchStoreInventroyRequest): Observable<SwaggerResponse<StoreInventoryDto[]>> {
        let url_ = this.baseUrl + "/api/v1/StoreInventory/inventories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStoreInventorys2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStoreInventorys2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<StoreInventoryDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<StoreInventoryDto[]>>;
        }));
    }

    protected processGetStoreInventorys2(response: HttpResponseBase): Observable<SwaggerResponse<StoreInventoryDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StoreInventoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<StoreInventoryDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取所有商品转移请求订单
     * @param storeIdList (optional) 
     * @param queryDays (optional) 查询天数范围(默认30天)
     * @param isReceived (optional) 是否包含已收到的请求(默认不包含)
     * @param api_version (optional) 
     */
    getAllTransferRequest(storeIdList?: number[] | undefined, queryDays?: number | undefined, isReceived?: boolean | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<GetTransferResponseDto[]>> {
        let url_ = this.baseUrl + "/api/StoreInventory/transferRequest?";
        if (storeIdList === null)
            throw new Error("The parameter 'storeIdList' cannot be null.");
        else if (storeIdList !== undefined)
            storeIdList && storeIdList.forEach(item => { url_ += "storeIdList=" + encodeURIComponent("" + item) + "&"; });
        if (queryDays === null)
            throw new Error("The parameter 'queryDays' cannot be null.");
        else if (queryDays !== undefined)
            url_ += "queryDays=" + encodeURIComponent("" + queryDays) + "&";
        if (isReceived === null)
            throw new Error("The parameter 'isReceived' cannot be null.");
        else if (isReceived !== undefined)
            url_ += "isReceived=" + encodeURIComponent("" + isReceived) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTransferRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTransferRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<GetTransferResponseDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<GetTransferResponseDto[]>>;
        }));
    }

    protected processGetAllTransferRequest(response: HttpResponseBase): Observable<SwaggerResponse<GetTransferResponseDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetTransferResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<GetTransferResponseDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 创建商品转移请求订单
     * @param api_version (optional) 
     */
    createTransferRequest(createTransferRequest: CreateTransferRequestDto, api_version?: string | null | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/StoreInventory/transferRequest?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createTransferRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTransferRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTransferRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processCreateTransferRequest(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 删除多个商品转移请求订单
     * @param api_version (optional) 
     */
    deleteTransferRequest(transferRequestIdList: string[], api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/StoreInventory/transferRequest?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(transferRequestIdList);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTransferRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTransferRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processDeleteTransferRequest(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取所有商品转移请求订单
     * @param storeIdList (optional) 
     * @param queryDays (optional) 查询天数范围(默认30天)
     * @param isReceived (optional) 是否包含已收到的请求(默认不包含)
     */
    getAllTransferRequest2(storeIdList?: number[] | undefined, queryDays?: number | undefined, isReceived?: boolean | undefined): Observable<SwaggerResponse<GetTransferResponseDto[]>> {
        let url_ = this.baseUrl + "/api/v1/StoreInventory/transferRequest?";
        if (storeIdList === null)
            throw new Error("The parameter 'storeIdList' cannot be null.");
        else if (storeIdList !== undefined)
            storeIdList && storeIdList.forEach(item => { url_ += "storeIdList=" + encodeURIComponent("" + item) + "&"; });
        if (queryDays === null)
            throw new Error("The parameter 'queryDays' cannot be null.");
        else if (queryDays !== undefined)
            url_ += "queryDays=" + encodeURIComponent("" + queryDays) + "&";
        if (isReceived === null)
            throw new Error("The parameter 'isReceived' cannot be null.");
        else if (isReceived !== undefined)
            url_ += "isReceived=" + encodeURIComponent("" + isReceived) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTransferRequest2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTransferRequest2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<GetTransferResponseDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<GetTransferResponseDto[]>>;
        }));
    }

    protected processGetAllTransferRequest2(response: HttpResponseBase): Observable<SwaggerResponse<GetTransferResponseDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GetTransferResponseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<GetTransferResponseDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 创建商品转移请求订单
     */
    createTransferRequest2(createTransferRequest: CreateTransferRequestDto): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/v1/StoreInventory/transferRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createTransferRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTransferRequest2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTransferRequest2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processCreateTransferRequest2(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 删除多个商品转移请求订单
     */
    deleteTransferRequest2(transferRequestIdList: string[]): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/StoreInventory/transferRequest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(transferRequestIdList);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTransferRequest2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTransferRequest2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processDeleteTransferRequest2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 搜索转移请求订单
     * @param requestId (optional) 订单id
     * @param api_version (optional) 
     */
    searchTransferRequest(requestId?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<GetTransferResponseDto>> {
        let url_ = this.baseUrl + "/api/StoreInventory/transferRequest/search?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchTransferRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchTransferRequest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<GetTransferResponseDto>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<GetTransferResponseDto>>;
        }));
    }

    protected processSearchTransferRequest(response: HttpResponseBase): Observable<SwaggerResponse<GetTransferResponseDto>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTransferResponseDto.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<GetTransferResponseDto>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 搜索转移请求订单
     * @param requestId (optional) 订单id
     */
    searchTransferRequest2(requestId?: string | undefined): Observable<SwaggerResponse<GetTransferResponseDto>> {
        let url_ = this.baseUrl + "/api/v1/StoreInventory/transferRequest/search?";
        if (requestId === null)
            throw new Error("The parameter 'requestId' cannot be null.");
        else if (requestId !== undefined)
            url_ += "requestId=" + encodeURIComponent("" + requestId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchTransferRequest2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchTransferRequest2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<GetTransferResponseDto>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<GetTransferResponseDto>>;
        }));
    }

    protected processSearchTransferRequest2(response: HttpResponseBase): Observable<SwaggerResponse<GetTransferResponseDto>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTransferResponseDto.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<GetTransferResponseDto>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 更新转移请求订单状态
     * @param transferRequestId (optional) 转移请求ID
     * @param status (optional) 订单状态
     * @param userId (optional) 
     * @param api_version (optional) 
     */
    updateTransferRequestStatus(transferRequestId?: string | undefined, status?: TransferStatus | undefined, userId?: number | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<GetTransferResponseDto>> {
        let url_ = this.baseUrl + "/api/StoreInventory/transferRequest/status?";
        if (transferRequestId === null)
            throw new Error("The parameter 'transferRequestId' cannot be null.");
        else if (transferRequestId !== undefined)
            url_ += "transferRequestId=" + encodeURIComponent("" + transferRequestId) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTransferRequestStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTransferRequestStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<GetTransferResponseDto>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<GetTransferResponseDto>>;
        }));
    }

    protected processUpdateTransferRequestStatus(response: HttpResponseBase): Observable<SwaggerResponse<GetTransferResponseDto>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTransferResponseDto.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<GetTransferResponseDto>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 更新转移请求订单状态
     * @param transferRequestId (optional) 转移请求ID
     * @param status (optional) 订单状态
     * @param userId (optional) 
     */
    updateTransferRequestStatus2(transferRequestId?: string | undefined, status?: TransferStatus | undefined, userId?: number | undefined): Observable<SwaggerResponse<GetTransferResponseDto>> {
        let url_ = this.baseUrl + "/api/v1/StoreInventory/transferRequest/status?";
        if (transferRequestId === null)
            throw new Error("The parameter 'transferRequestId' cannot be null.");
        else if (transferRequestId !== undefined)
            url_ += "transferRequestId=" + encodeURIComponent("" + transferRequestId) + "&";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTransferRequestStatus2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTransferRequestStatus2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<GetTransferResponseDto>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<GetTransferResponseDto>>;
        }));
    }

    protected processUpdateTransferRequestStatus2(response: HttpResponseBase): Observable<SwaggerResponse<GetTransferResponseDto>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTransferResponseDto.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<GetTransferResponseDto>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 更新商品仓库的库存
     * @param api_version (optional) 
     */
    updateStoreInvertory(bodyDto: UpdateStoreInventoryDto, api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/StoreInventory/transferRequest/update-store-warehouse-inventory?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bodyDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStoreInvertory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStoreInvertory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processUpdateStoreInvertory(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 更新商品仓库的库存
     */
    updateStoreInvertory2(bodyDto: UpdateStoreInventoryDto): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/StoreInventory/transferRequest/update-store-warehouse-inventory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(bodyDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStoreInvertory2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStoreInvertory2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processUpdateStoreInvertory2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 更新商品转移请求订单中的商品数据
     * @param productInfos 商品信息列表
     * @param transferRequestID (optional) 转移请求ID
     * @param api_version (optional) 
     */
    updateTransferProductInfo(productInfos: TransferProductInfo[], transferRequestID?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/StoreInventory/transferRequest/products?";
        if (transferRequestID === null)
            throw new Error("The parameter 'transferRequestID' cannot be null.");
        else if (transferRequestID !== undefined)
            url_ += "transferRequestID=" + encodeURIComponent("" + transferRequestID) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productInfos);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTransferProductInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTransferProductInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processUpdateTransferProductInfo(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 更新商品转移请求订单中的商品数据
     * @param productInfos 商品信息列表
     * @param transferRequestID (optional) 转移请求ID
     */
    updateTransferProductInfo2(productInfos: TransferProductInfo[], transferRequestID?: string | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/StoreInventory/transferRequest/products?";
        if (transferRequestID === null)
            throw new Error("The parameter 'transferRequestID' cannot be null.");
        else if (transferRequestID !== undefined)
            url_ += "transferRequestID=" + encodeURIComponent("" + transferRequestID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productInfos);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTransferProductInfo2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTransferProductInfo2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processUpdateTransferProductInfo2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 更新转移请求中商品实际收到的货品数量
     * @param transferRequestID (optional) 转移请求ID
     * @param barCode (optional) 当前订单中的商品条码
     * @param receiveQty (optional) 商品实际收到的数量
     * @param api_version (optional) 
     */
    updateTransferProductReceivedQty(transferRequestID?: string | undefined, barCode?: string | undefined, receiveQty?: number | null | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/StoreInventory/transferRequest/products/receive/qty?";
        if (transferRequestID === null)
            throw new Error("The parameter 'transferRequestID' cannot be null.");
        else if (transferRequestID !== undefined)
            url_ += "transferRequestID=" + encodeURIComponent("" + transferRequestID) + "&";
        if (barCode === null)
            throw new Error("The parameter 'barCode' cannot be null.");
        else if (barCode !== undefined)
            url_ += "barCode=" + encodeURIComponent("" + barCode) + "&";
        if (receiveQty !== undefined && receiveQty !== null)
            url_ += "receiveQty=" + encodeURIComponent("" + receiveQty) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTransferProductReceivedQty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTransferProductReceivedQty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processUpdateTransferProductReceivedQty(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 更新转移请求中商品实际收到的货品数量
     * @param transferRequestID (optional) 转移请求ID
     * @param barCode (optional) 当前订单中的商品条码
     * @param receiveQty (optional) 商品实际收到的数量
     */
    updateTransferProductReceivedQty2(transferRequestID?: string | undefined, barCode?: string | undefined, receiveQty?: number | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/StoreInventory/transferRequest/products/receive/qty?";
        if (transferRequestID === null)
            throw new Error("The parameter 'transferRequestID' cannot be null.");
        else if (transferRequestID !== undefined)
            url_ += "transferRequestID=" + encodeURIComponent("" + transferRequestID) + "&";
        if (barCode === null)
            throw new Error("The parameter 'barCode' cannot be null.");
        else if (barCode !== undefined)
            url_ += "barCode=" + encodeURIComponent("" + barCode) + "&";
        if (receiveQty !== undefined && receiveQty !== null)
            url_ += "receiveQty=" + encodeURIComponent("" + receiveQty) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateTransferProductReceivedQty2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateTransferProductReceivedQty2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processUpdateTransferProductReceivedQty2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取仓库列表
     * @param stores (optional) 
     * @param api_version (optional) 
     */
    getWareHouse(stores?: number[] | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<WareHouseDto[]>> {
        let url_ = this.baseUrl + "/api/StoreInventory/warehouse?";
        if (stores === null)
            throw new Error("The parameter 'stores' cannot be null.");
        else if (stores !== undefined)
            stores && stores.forEach(item => { url_ += "stores=" + encodeURIComponent("" + item) + "&"; });
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWareHouse(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWareHouse(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<WareHouseDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<WareHouseDto[]>>;
        }));
    }

    protected processGetWareHouse(response: HttpResponseBase): Observable<SwaggerResponse<WareHouseDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WareHouseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<WareHouseDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取仓库列表
     * @param stores (optional) 
     */
    getWareHouse2(stores?: number[] | undefined): Observable<SwaggerResponse<WareHouseDto[]>> {
        let url_ = this.baseUrl + "/api/v1/StoreInventory/warehouse?";
        if (stores === null)
            throw new Error("The parameter 'stores' cannot be null.");
        else if (stores !== undefined)
            stores && stores.forEach(item => { url_ += "stores=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWareHouse2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWareHouse2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<WareHouseDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<WareHouseDto[]>>;
        }));
    }

    protected processGetWareHouse2(response: HttpResponseBase): Observable<SwaggerResponse<WareHouseDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WareHouseDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<WareHouseDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class StoreReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    /**
     * 部门数据比较（按照组比较并且查询）
     * @param reportType (optional) 
     * @param api_version (optional) 
     */
    getDepartmentCompaeison(body: DepartmentBodys, reportType?: ReportType | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<DepartmentDifferenceReportDto[]>> {
        let url_ = this.baseUrl + "/api/StoreReport/report/GetDepartmentCompaeison?";
        if (reportType === null)
            throw new Error("The parameter 'reportType' cannot be null.");
        else if (reportType !== undefined)
            url_ += "reportType=" + encodeURIComponent("" + reportType) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDepartmentCompaeison(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDepartmentCompaeison(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<DepartmentDifferenceReportDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<DepartmentDifferenceReportDto[]>>;
        }));
    }

    protected processGetDepartmentCompaeison(response: HttpResponseBase): Observable<SwaggerResponse<DepartmentDifferenceReportDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DepartmentDifferenceReportDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<DepartmentDifferenceReportDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 部门数据比较（按照组比较并且查询）
     * @param reportType (optional) 
     */
    getDepartmentCompaeison2(body: DepartmentBodys, reportType?: ReportType | undefined): Observable<SwaggerResponse<DepartmentDifferenceReportDto[]>> {
        let url_ = this.baseUrl + "/api/v1/StoreReport/report/GetDepartmentCompaeison?";
        if (reportType === null)
            throw new Error("The parameter 'reportType' cannot be null.");
        else if (reportType !== undefined)
            url_ += "reportType=" + encodeURIComponent("" + reportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDepartmentCompaeison2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDepartmentCompaeison2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<DepartmentDifferenceReportDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<DepartmentDifferenceReportDto[]>>;
        }));
    }

    protected processGetDepartmentCompaeison2(response: HttpResponseBase): Observable<SwaggerResponse<DepartmentDifferenceReportDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DepartmentDifferenceReportDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<DepartmentDifferenceReportDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 分组总和差异化报表
     * @param reportType (optional) 
     * @param api_version (optional) 
     */
    getGroupCompaeisonReport(body: DepartmentBodys, reportType?: ReportType | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<GroupDifferenceReportDto>> {
        let url_ = this.baseUrl + "/api/StoreReport/report/GetGroupCompaeisonReport?";
        if (reportType === null)
            throw new Error("The parameter 'reportType' cannot be null.");
        else if (reportType !== undefined)
            url_ += "reportType=" + encodeURIComponent("" + reportType) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGroupCompaeisonReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroupCompaeisonReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<GroupDifferenceReportDto>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<GroupDifferenceReportDto>>;
        }));
    }

    protected processGetGroupCompaeisonReport(response: HttpResponseBase): Observable<SwaggerResponse<GroupDifferenceReportDto>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupDifferenceReportDto.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<GroupDifferenceReportDto>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 分组总和差异化报表
     * @param reportType (optional) 
     */
    getGroupCompaeisonReport2(body: DepartmentBodys, reportType?: ReportType | undefined): Observable<SwaggerResponse<GroupDifferenceReportDto>> {
        let url_ = this.baseUrl + "/api/v1/StoreReport/report/GetGroupCompaeisonReport?";
        if (reportType === null)
            throw new Error("The parameter 'reportType' cannot be null.");
        else if (reportType !== undefined)
            url_ += "reportType=" + encodeURIComponent("" + reportType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGroupCompaeisonReport2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGroupCompaeisonReport2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<GroupDifferenceReportDto>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<GroupDifferenceReportDto>>;
        }));
    }

    protected processGetGroupCompaeisonReport2(response: HttpResponseBase): Observable<SwaggerResponse<GroupDifferenceReportDto>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GroupDifferenceReportDto.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<GroupDifferenceReportDto>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 店铺数据报表
     * @param api_version (optional) 
     */
    getStoreGroupComparison(body: DepartmentBody, api_version?: string | null | undefined): Observable<SwaggerResponse<StoreGroupComparisonDto[]>> {
        let url_ = this.baseUrl + "/api/StoreReport/report/GetStoreGroupComparison?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStoreGroupComparison(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStoreGroupComparison(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<StoreGroupComparisonDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<StoreGroupComparisonDto[]>>;
        }));
    }

    protected processGetStoreGroupComparison(response: HttpResponseBase): Observable<SwaggerResponse<StoreGroupComparisonDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StoreGroupComparisonDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<StoreGroupComparisonDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 店铺数据报表
     */
    getStoreGroupComparison2(body: DepartmentBody): Observable<SwaggerResponse<StoreGroupComparisonDto[]>> {
        let url_ = this.baseUrl + "/api/v1/StoreReport/report/GetStoreGroupComparison";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStoreGroupComparison2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStoreGroupComparison2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<StoreGroupComparisonDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<StoreGroupComparisonDto[]>>;
        }));
    }

    protected processGetStoreGroupComparison2(response: HttpResponseBase): Observable<SwaggerResponse<StoreGroupComparisonDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StoreGroupComparisonDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<StoreGroupComparisonDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class StoreSalesRankingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    /**
     * 获取店铺商品销售榜
     * @param stores (optional) 店铺
     * @param begin (optional) 起始
     * @param end (optional) 结束
     * @param salesRankingCount (optional) 榜单数
     * @param department (optional) 部门
     * @param api_version (optional) 
     */
    getSalesRanking(stores?: number[] | undefined, begin?: string | undefined, end?: string | undefined, salesRankingCount?: number | undefined, department?: string | null | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<SalesRankingDto[]>> {
        let url_ = this.baseUrl + "/api/StoreSalesRanking?";
        if (stores === null)
            throw new Error("The parameter 'stores' cannot be null.");
        else if (stores !== undefined)
            stores && stores.forEach(item => { url_ += "stores=" + encodeURIComponent("" + item) + "&"; });
        if (begin === null)
            throw new Error("The parameter 'begin' cannot be null.");
        else if (begin !== undefined)
            url_ += "begin=" + encodeURIComponent("" + begin) + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent("" + end) + "&";
        if (salesRankingCount === null)
            throw new Error("The parameter 'salesRankingCount' cannot be null.");
        else if (salesRankingCount !== undefined)
            url_ += "salesRankingCount=" + encodeURIComponent("" + salesRankingCount) + "&";
        if (department !== undefined && department !== null)
            url_ += "department=" + encodeURIComponent("" + department) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalesRanking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesRanking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<SalesRankingDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<SalesRankingDto[]>>;
        }));
    }

    protected processGetSalesRanking(response: HttpResponseBase): Observable<SwaggerResponse<SalesRankingDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesRankingDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<SalesRankingDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取店铺商品销售榜
     * @param stores (optional) 店铺
     * @param begin (optional) 起始
     * @param end (optional) 结束
     * @param salesRankingCount (optional) 榜单数
     * @param department (optional) 部门
     */
    getSalesRanking2(stores?: number[] | undefined, begin?: string | undefined, end?: string | undefined, salesRankingCount?: number | undefined, department?: string | null | undefined): Observable<SwaggerResponse<SalesRankingDto[]>> {
        let url_ = this.baseUrl + "/api/v1/StoreSalesRanking?";
        if (stores === null)
            throw new Error("The parameter 'stores' cannot be null.");
        else if (stores !== undefined)
            stores && stores.forEach(item => { url_ += "stores=" + encodeURIComponent("" + item) + "&"; });
        if (begin === null)
            throw new Error("The parameter 'begin' cannot be null.");
        else if (begin !== undefined)
            url_ += "begin=" + encodeURIComponent("" + begin) + "&";
        if (end === null)
            throw new Error("The parameter 'end' cannot be null.");
        else if (end !== undefined)
            url_ += "end=" + encodeURIComponent("" + end) + "&";
        if (salesRankingCount === null)
            throw new Error("The parameter 'salesRankingCount' cannot be null.");
        else if (salesRankingCount !== undefined)
            url_ += "salesRankingCount=" + encodeURIComponent("" + salesRankingCount) + "&";
        if (department !== undefined && department !== null)
            url_ += "department=" + encodeURIComponent("" + department) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSalesRanking2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSalesRanking2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<SalesRankingDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<SalesRankingDto[]>>;
        }));
    }

    protected processGetSalesRanking2(response: HttpResponseBase): Observable<SwaggerResponse<SalesRankingDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SalesRankingDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<SalesRankingDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class StoresClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    /**
     * Created Stores
     * @param companyId (optional) 
     * @param api_version (optional) 
     * @return Created Success!
     */
    createdStore(storeDTO: StoreDTO, companyId?: number | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<StoreDTO>> {
        let url_ = this.baseUrl + "/api/Stores?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(storeDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatedStore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatedStore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<StoreDTO>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<StoreDTO>>;
        }));
    }

    protected processCreatedStore(response: HttpResponseBase): Observable<SwaggerResponse<StoreDTO>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StoreDTO.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<StoreDTO>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Delete Stores
     * @param companyId (optional) 
     * @param storeId (optional) 
     * @param api_version (optional) 
     */
    deleteStore(companyId?: number | undefined, storeId?: number | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/Stores?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteStore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteStore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processDeleteStore(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result204: any = null;
            let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result204 = resultData204 !== undefined ? resultData204 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result204));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Update Store
     * @param companyId (optional) Company Id
     * @param api_version (optional) 
     * @return Update Success!
     */
    updateStore(storeDTO: StoreDTO, companyId?: number | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/Stores?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(storeDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processUpdateStore(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result204: any = null;
            let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result204 = resultData204 !== undefined ? resultData204 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result204));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Get Stores
     * @param companyId (optional) 
     * @param storeId (optional) 
     * @param api_version (optional) 
     * @return Stores
     */
    getCompanyStore(companyId?: number[] | null | undefined, storeId?: number[] | null | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<StoresDTO>> {
        let url_ = this.baseUrl + "/api/Stores?";
        if (companyId !== undefined && companyId !== null)
            companyId && companyId.forEach(item => { url_ += "companyId=" + encodeURIComponent("" + item) + "&"; });
        if (storeId !== undefined && storeId !== null)
            storeId && storeId.forEach(item => { url_ += "storeId=" + encodeURIComponent("" + item) + "&"; });
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyStore(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyStore(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<StoresDTO>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<StoresDTO>>;
        }));
    }

    protected processGetCompanyStore(response: HttpResponseBase): Observable<SwaggerResponse<StoresDTO>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result204: any = null;
            let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result204 = resultData204 !== undefined ? resultData204 : <any>null;
    
            return throwException("Stores", status, _responseText, _headers, result204);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StoresDTO.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<StoresDTO>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Created Stores
     * @param companyId (optional) 
     * @return Created Success!
     */
    createdStore2(storeDTO: StoreDTO, companyId?: number | undefined): Observable<SwaggerResponse<StoreDTO>> {
        let url_ = this.baseUrl + "/api/v1/Stores?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(storeDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreatedStore2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreatedStore2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<StoreDTO>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<StoreDTO>>;
        }));
    }

    protected processCreatedStore2(response: HttpResponseBase): Observable<SwaggerResponse<StoreDTO>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StoreDTO.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<StoreDTO>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Delete Stores
     * @param companyId (optional) 
     * @param storeId (optional) 
     */
    deleteStore2(companyId?: number | undefined, storeId?: number | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/Stores?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteStore2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteStore2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processDeleteStore2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result204: any = null;
            let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result204 = resultData204 !== undefined ? resultData204 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result204));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Update Store
     * @param companyId (optional) Company Id
     * @return Update Success!
     */
    updateStore2(storeDTO: StoreDTO, companyId?: number | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/Stores?";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(storeDTO);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStore2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStore2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processUpdateStore2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result204: any = null;
            let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result204 = resultData204 !== undefined ? resultData204 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result204));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * Get Stores
     * @param companyId (optional) 
     * @param storeId (optional) 
     * @return Stores
     */
    getCompanyStore2(companyId?: number[] | null | undefined, storeId?: number[] | null | undefined): Observable<SwaggerResponse<StoresDTO>> {
        let url_ = this.baseUrl + "/api/v1/Stores?";
        if (companyId !== undefined && companyId !== null)
            companyId && companyId.forEach(item => { url_ += "companyId=" + encodeURIComponent("" + item) + "&"; });
        if (storeId !== undefined && storeId !== null)
            storeId && storeId.forEach(item => { url_ += "storeId=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCompanyStore2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCompanyStore2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<StoresDTO>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<StoresDTO>>;
        }));
    }

    protected processGetCompanyStore2(response: HttpResponseBase): Observable<SwaggerResponse<StoresDTO>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result204: any = null;
            let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result204 = resultData204 !== undefined ? resultData204 : <any>null;
    
            return throwException("Stores", status, _responseText, _headers, result204);
            }));
        } else if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StoresDTO.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<StoresDTO>>(new SwaggerResponse(status, _headers, null as any));
    }

    getStoreId(encryptedId?: string | null | undefined, storeId?: string | null | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<StoreDTO>> {
        let url_ = this.baseUrl + "/api/Stores/details?";
        if (encryptedId !== undefined && encryptedId !== null)
            url_ += "encryptedId=" + encodeURIComponent("" + encryptedId) + "&";
        if (storeId !== undefined && storeId !== null)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStoreId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStoreId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<StoreDTO>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<StoreDTO>>;
        }));
    }

    protected processGetStoreId(response: HttpResponseBase): Observable<SwaggerResponse<StoreDTO>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StoreDTO.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<StoreDTO>>(new SwaggerResponse(status, _headers, null as any));
    }

    getStoreId2(encryptedId?: string | null | undefined, storeId?: string | null | undefined): Observable<SwaggerResponse<StoreDTO>> {
        let url_ = this.baseUrl + "/api/v1/Stores/details?";
        if (encryptedId !== undefined && encryptedId !== null)
            url_ += "encryptedId=" + encodeURIComponent("" + encryptedId) + "&";
        if (storeId !== undefined && storeId !== null)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStoreId2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStoreId2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<StoreDTO>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<StoreDTO>>;
        }));
    }

    protected processGetStoreId2(response: HttpResponseBase): Observable<SwaggerResponse<StoreDTO>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StoreDTO.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<StoreDTO>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取商店的配置
     * @param api_version (optional) 
     */
    getSetting(storeId: number, settingTabType: SettingTabType, api_version?: string | null | undefined): Observable<SwaggerResponse<SettingTab>> {
        let url_ = this.baseUrl + "/api/Stores/setting/{storeId}/{settingTabType}?";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (settingTabType === undefined || settingTabType === null)
            throw new Error("The parameter 'settingTabType' must be defined.");
        url_ = url_.replace("{settingTabType}", encodeURIComponent("" + settingTabType));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<SettingTab>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<SettingTab>>;
        }));
    }

    protected processGetSetting(response: HttpResponseBase): Observable<SwaggerResponse<SettingTab>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SettingTab.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<SettingTab>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取商店的配置
     */
    getSetting2(storeId: number, settingTabType: SettingTabType): Observable<SwaggerResponse<SettingTab>> {
        let url_ = this.baseUrl + "/api/v1/Stores/setting/{storeId}/{settingTabType}";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (settingTabType === undefined || settingTabType === null)
            throw new Error("The parameter 'settingTabType' must be defined.");
        url_ = url_.replace("{settingTabType}", encodeURIComponent("" + settingTabType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSetting2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSetting2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<SettingTab>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<SettingTab>>;
        }));
    }

    protected processGetSetting2(response: HttpResponseBase): Observable<SwaggerResponse<SettingTab>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SettingTab.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<SettingTab>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 立即执行Job
     * @param api_version (optional) 
     */
    executeJob(storeId: number, settingTabType: SettingTabType, api_version?: string | null | undefined): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/Stores/setting/jobs/{storeId}/{settingTabType}?";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (settingTabType === undefined || settingTabType === null)
            throw new Error("The parameter 'settingTabType' must be defined.");
        url_ = url_.replace("{settingTabType}", encodeURIComponent("" + settingTabType));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExecuteJob(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExecuteJob(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processExecuteJob(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result204: any = null;
            let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result204 = resultData204 !== undefined ? resultData204 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result204));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 立即执行Job
     */
    executeJob2(storeId: number, settingTabType: SettingTabType): Observable<SwaggerResponse<string>> {
        let url_ = this.baseUrl + "/api/v1/Stores/setting/jobs/{storeId}/{settingTabType}";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (settingTabType === undefined || settingTabType === null)
            throw new Error("The parameter 'settingTabType' must be defined.");
        url_ = url_.replace("{settingTabType}", encodeURIComponent("" + settingTabType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExecuteJob2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExecuteJob2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<string>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<string>>;
        }));
    }

    protected processExecuteJob2(response: HttpResponseBase): Observable<SwaggerResponse<string>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result204: any = null;
            let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result204 = resultData204 !== undefined ? resultData204 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result204));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<string>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取默认配置
     * @param api_version (optional) 
     */
    getSettingDefaultValue(settingTabType: SettingTabType, api_version?: string | null | undefined): Observable<SwaggerResponse<SettingItem[]>> {
        let url_ = this.baseUrl + "/api/Stores/setting/{settingTabType}/default?";
        if (settingTabType === undefined || settingTabType === null)
            throw new Error("The parameter 'settingTabType' must be defined.");
        url_ = url_.replace("{settingTabType}", encodeURIComponent("" + settingTabType));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSettingDefaultValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSettingDefaultValue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<SettingItem[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<SettingItem[]>>;
        }));
    }

    protected processGetSettingDefaultValue(response: HttpResponseBase): Observable<SwaggerResponse<SettingItem[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SettingItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<SettingItem[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取默认配置
     */
    getSettingDefaultValue2(settingTabType: SettingTabType): Observable<SwaggerResponse<SettingItem[]>> {
        let url_ = this.baseUrl + "/api/v1/Stores/setting/{settingTabType}/default";
        if (settingTabType === undefined || settingTabType === null)
            throw new Error("The parameter 'settingTabType' must be defined.");
        url_ = url_.replace("{settingTabType}", encodeURIComponent("" + settingTabType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSettingDefaultValue2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSettingDefaultValue2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<SettingItem[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<SettingItem[]>>;
        }));
    }

    protected processGetSettingDefaultValue2(response: HttpResponseBase): Observable<SwaggerResponse<SettingItem[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SettingItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<SettingItem[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 上传密钥
     * @param api_version (optional) 
     * @param formFile (optional) 
     */
    uploadSshPrivateKeyFile(settingTabType: SettingTabType, api_version?: string | null | undefined, formFile?: FileParameter | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/Stores/settings/nationsbenefits/{settingTabType}/sshprivatekey?";
        if (settingTabType === undefined || settingTabType === null)
            throw new Error("The parameter 'settingTabType' must be defined.");
        url_ = url_.replace("{settingTabType}", encodeURIComponent("" + settingTabType));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formFile !== null && formFile !== undefined)
            content_.append("formFile", formFile.data, formFile.fileName ? formFile.fileName : "formFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadSshPrivateKeyFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadSshPrivateKeyFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processUploadSshPrivateKeyFile(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 上传密钥
     * @param formFile (optional) 
     */
    uploadSshPrivateKeyFile2(settingTabType: SettingTabType, formFile?: FileParameter | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/Stores/settings/nationsbenefits/{settingTabType}/sshprivatekey";
        if (settingTabType === undefined || settingTabType === null)
            throw new Error("The parameter 'settingTabType' must be defined.");
        url_ = url_.replace("{settingTabType}", encodeURIComponent("" + settingTabType));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (formFile !== null && formFile !== undefined)
            content_.append("formFile", formFile.data, formFile.fileName ? formFile.fileName : "formFile");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadSshPrivateKeyFile2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadSshPrivateKeyFile2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processUploadSshPrivateKeyFile2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 下载csv
     * @param storeId (optional) 
     * @param settingTabType (optional) 
     * @param timestamp (optional) 
     * @param api_version (optional) 
     */
    downLoadCSV(storeId?: number | undefined, settingTabType?: SettingTabType | undefined, timestamp?: string | null | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/Stores/settings/nationsbenefits/download-csv?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (settingTabType === null)
            throw new Error("The parameter 'settingTabType' cannot be null.");
        else if (settingTabType !== undefined)
            url_ += "settingTabType=" + encodeURIComponent("" + settingTabType) + "&";
        if (timestamp !== undefined && timestamp !== null)
            url_ += "timestamp=" + encodeURIComponent("" + timestamp) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownLoadCSV(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownLoadCSV(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processDownLoadCSV(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 下载csv
     * @param storeId (optional) 
     * @param settingTabType (optional) 
     * @param timestamp (optional) 
     */
    downLoadCSV2(storeId?: number | undefined, settingTabType?: SettingTabType | undefined, timestamp?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/Stores/settings/nationsbenefits/download-csv?";
        if (storeId === null)
            throw new Error("The parameter 'storeId' cannot be null.");
        else if (storeId !== undefined)
            url_ += "storeId=" + encodeURIComponent("" + storeId) + "&";
        if (settingTabType === null)
            throw new Error("The parameter 'settingTabType' cannot be null.");
        else if (settingTabType !== undefined)
            url_ += "settingTabType=" + encodeURIComponent("" + settingTabType) + "&";
        if (timestamp !== undefined && timestamp !== null)
            url_ += "timestamp=" + encodeURIComponent("" + timestamp) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownLoadCSV2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownLoadCSV2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processDownLoadCSV2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取任务执行日志
     * @param api_version (optional) 
     */
    getExcuteJobLog(storeId: number, settingTabType: SettingTabType, date: string, api_version?: string | null | undefined): Observable<SwaggerResponse<ExcuteJobResponse>> {
        let url_ = this.baseUrl + "/api/Stores/settings/jobs/log/{storeId}/{settingTabType}/{date}?";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (settingTabType === undefined || settingTabType === null)
            throw new Error("The parameter 'settingTabType' must be defined.");
        url_ = url_.replace("{settingTabType}", encodeURIComponent("" + settingTabType));
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent("" + date));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExcuteJobLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExcuteJobLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<ExcuteJobResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<ExcuteJobResponse>>;
        }));
    }

    protected processGetExcuteJobLog(response: HttpResponseBase): Observable<SwaggerResponse<ExcuteJobResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExcuteJobResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<ExcuteJobResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 获取任务执行日志
     */
    getExcuteJobLog2(storeId: number, settingTabType: SettingTabType, date: string): Observable<SwaggerResponse<ExcuteJobResponse>> {
        let url_ = this.baseUrl + "/api/v1/Stores/settings/jobs/log/{storeId}/{settingTabType}/{date}";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (settingTabType === undefined || settingTabType === null)
            throw new Error("The parameter 'settingTabType' must be defined.");
        url_ = url_.replace("{settingTabType}", encodeURIComponent("" + settingTabType));
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent("" + date));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExcuteJobLog2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExcuteJobLog2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<ExcuteJobResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<ExcuteJobResponse>>;
        }));
    }

    protected processGetExcuteJobLog2(response: HttpResponseBase): Observable<SwaggerResponse<ExcuteJobResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExcuteJobResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<ExcuteJobResponse>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class TemporaryTokenClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    /**
     * 生成带有时效性的Token
     * @param storeId 商店ID
     * @param userId 用户ID
     * @param eventId 事件ID
     * @param devmode (optional) 模式{true：开发模式 false：生产模式}
     * @param api_version (optional) 
     */
    getTemporaryToken(storeId: number, userId: number, eventId: number, devmode?: boolean | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/approval/{storeId}/{userId}/{eventId}?";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (eventId === undefined || eventId === null)
            throw new Error("The parameter 'eventId' must be defined.");
        url_ = url_.replace("{eventId}", encodeURIComponent("" + eventId));
        if (devmode === null)
            throw new Error("The parameter 'devmode' cannot be null.");
        else if (devmode !== undefined)
            url_ += "devmode=" + encodeURIComponent("" + devmode) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTemporaryToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemporaryToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processGetTemporaryToken(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 302) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result302: any = null;
            let resultData302 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result302 = resultData302 !== undefined ? resultData302 : <any>null;
    
            return throwException("\u91cd\u5b9a\u5411", status, _responseText, _headers, result302);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 生成带有时效性的Token
     * @param storeId 商店ID
     * @param userId 用户ID
     * @param eventId 事件ID
     * @param devmode (optional) 模式{true：开发模式 false：生产模式}
     */
    getTemporaryToken2(storeId: number, userId: number, eventId: number, devmode?: boolean | undefined): Observable<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/v1/approval/{storeId}/{userId}/{eventId}?";
        if (storeId === undefined || storeId === null)
            throw new Error("The parameter 'storeId' must be defined.");
        url_ = url_.replace("{storeId}", encodeURIComponent("" + storeId));
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (eventId === undefined || eventId === null)
            throw new Error("The parameter 'eventId' must be defined.");
        url_ = url_.replace("{eventId}", encodeURIComponent("" + eventId));
        if (devmode === null)
            throw new Error("The parameter 'devmode' cannot be null.");
        else if (devmode !== undefined)
            url_ += "devmode=" + encodeURIComponent("" + devmode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTemporaryToken2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTemporaryToken2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<void>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<void>>;
        }));
    }

    protected processGetTemporaryToken2(response: HttpResponseBase): Observable<SwaggerResponse<void>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 302) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result302: any = null;
            let resultData302 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result302 = resultData302 !== undefined ? resultData302 : <any>null;
    
            return throwException("\u91cd\u5b9a\u5411", status, _responseText, _headers, result302);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 验证Token和Token的时效性
     * @param temporarytoken token
     * @param api_version (optional) 
     * @return 返回事件内容
     */
    getEventContent(temporarytoken: string, api_version?: string | null | undefined): Observable<SwaggerResponse<EventResponse>> {
        let url_ = this.baseUrl + "/approval/eventContent/{temporarytoken}?";
        if (temporarytoken === undefined || temporarytoken === null)
            throw new Error("The parameter 'temporarytoken' must be defined.");
        url_ = url_.replace("{temporarytoken}", encodeURIComponent("" + temporarytoken));
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEventContent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventContent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<EventResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<EventResponse>>;
        }));
    }

    protected processGetEventContent(response: HttpResponseBase): Observable<SwaggerResponse<EventResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EventResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<EventResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 验证Token和Token的时效性
     * @param temporarytoken token
     * @return 返回事件内容
     */
    getEventContent2(temporarytoken: string): Observable<SwaggerResponse<EventResponse>> {
        let url_ = this.baseUrl + "/api/v1/approval/eventContent/{temporarytoken}";
        if (temporarytoken === undefined || temporarytoken === null)
            throw new Error("The parameter 'temporarytoken' must be defined.");
        url_ = url_.replace("{temporarytoken}", encodeURIComponent("" + temporarytoken));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEventContent2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEventContent2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<EventResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<EventResponse>>;
        }));
    }

    protected processGetEventContent2(response: HttpResponseBase): Observable<SwaggerResponse<EventResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EventResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<EventResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 授权
     * @param temporarytoken token
     * @param eventApproved (optional) 状态
     * @param api_version (optional) 
     * @return Token验证成功
     */
    postAuthorize(temporarytoken: string, eventApproved?: EventApproved | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<EventResponse>> {
        let url_ = this.baseUrl + "/approval/response/{temporarytoken}?";
        if (temporarytoken === undefined || temporarytoken === null)
            throw new Error("The parameter 'temporarytoken' must be defined.");
        url_ = url_.replace("{temporarytoken}", encodeURIComponent("" + temporarytoken));
        if (eventApproved === null)
            throw new Error("The parameter 'eventApproved' cannot be null.");
        else if (eventApproved !== undefined)
            url_ += "eventApproved=" + encodeURIComponent("" + eventApproved) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostAuthorize(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostAuthorize(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<EventResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<EventResponse>>;
        }));
    }

    protected processPostAuthorize(response: HttpResponseBase): Observable<SwaggerResponse<EventResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EventResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<EventResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 授权
     * @param temporarytoken token
     * @param eventApproved (optional) 状态
     * @return Token验证成功
     */
    postAuthorize2(temporarytoken: string, eventApproved?: EventApproved | undefined): Observable<SwaggerResponse<EventResponse>> {
        let url_ = this.baseUrl + "/api/v1/approval/response/{temporarytoken}?";
        if (temporarytoken === undefined || temporarytoken === null)
            throw new Error("The parameter 'temporarytoken' must be defined.");
        url_ = url_.replace("{temporarytoken}", encodeURIComponent("" + temporarytoken));
        if (eventApproved === null)
            throw new Error("The parameter 'eventApproved' cannot be null.");
        else if (eventApproved !== undefined)
            url_ += "eventApproved=" + encodeURIComponent("" + eventApproved) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostAuthorize2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostAuthorize2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<EventResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<EventResponse>>;
        }));
    }

    protected processPostAuthorize2(response: HttpResponseBase): Observable<SwaggerResponse<EventResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EventResponse.fromJS(resultData200);
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<EventResponse>>(new SwaggerResponse(status, _headers, null as any));
    }
}

@Injectable()
export class UserClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "https://connect.syncmcr.com";
    }

    getUsers(companyName?: string | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<UsersDto[]>> {
        let url_ = this.baseUrl + "/api/User?";
        if (companyName === null)
            throw new Error("The parameter 'companyName' cannot be null.");
        else if (companyName !== undefined)
            url_ += "companyName=" + encodeURIComponent("" + companyName) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<UsersDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<UsersDto[]>>;
        }));
    }

    protected processGetUsers(response: HttpResponseBase): Observable<SwaggerResponse<UsersDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UsersDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<UsersDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    updateUser(newUser: UpdateUser, userId?: number | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/User?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newUser);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processUpdateUser(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    deleteUser(userId?: number | undefined, api_version?: string | null | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/User?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processDeleteUser(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    getUsers2(companyName?: string | undefined): Observable<SwaggerResponse<UsersDto[]>> {
        let url_ = this.baseUrl + "/api/v1/User?";
        if (companyName === null)
            throw new Error("The parameter 'companyName' cannot be null.");
        else if (companyName !== undefined)
            url_ += "companyName=" + encodeURIComponent("" + companyName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsers2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsers2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<UsersDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<UsersDto[]>>;
        }));
    }

    protected processGetUsers2(response: HttpResponseBase): Observable<SwaggerResponse<UsersDto[]>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UsersDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<UsersDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    updateUser2(newUser: UpdateUser, userId?: number | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/User?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newUser);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUser2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUser2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processUpdateUser2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    deleteUser2(userId?: number | undefined): Observable<SwaggerResponse<FileResponse>> {
        let url_ = this.baseUrl + "/api/v1/User?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUser2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUser2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<FileResponse>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<FileResponse>>;
        }));
    }

    protected processDeleteUser2(response: HttpResponseBase): Observable<SwaggerResponse<FileResponse>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf(new SwaggerResponse(status, _headers, { fileName: fileName, data: responseBlob as any, status: status, headers: _headers }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<FileResponse>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 注册用户接口
     * @param obfuscatedDto 混淆后的注册信息(传入时先转换JSON，再转换成Base64)
     * @param api_version (optional) 
     */
    registerUser(obfuscatedDto: string, api_version?: string | null | undefined): Observable<SwaggerResponse<number>> {
        let url_ = this.baseUrl + "/api/User/register?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(obfuscatedDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<number>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<number>>;
        }));
    }

    protected processRegisterUser(response: HttpResponseBase): Observable<SwaggerResponse<number>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<number>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * 注册用户接口
     * @param obfuscatedDto 混淆后的注册信息(传入时先转换JSON，再转换成Base64)
     */
    registerUser2(obfuscatedDto: string): Observable<SwaggerResponse<number>> {
        let url_ = this.baseUrl + "/api/v1/User/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(obfuscatedDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterUser2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterUser2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<number>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<number>>;
        }));
    }

    protected processRegisterUser2(response: HttpResponseBase): Observable<SwaggerResponse<number>> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwaggerResponse<number>>(new SwaggerResponse(status, _headers, null as any));
    }
}

export class StoreConnection implements IStoreConnection {
    storeId?: number;
    storeName?: string | undefined;
    commpanyName?: string | undefined;
    created?: Date;
    status?: string | undefined;
    accessKey?: string | undefined;
    ip?: string | undefined;

    constructor(data?: IStoreConnection) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeId = _data["storeId"];
            this.storeName = _data["storeName"];
            this.commpanyName = _data["commpanyName"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.status = _data["status"];
            this.accessKey = _data["accessKey"];
            this.ip = _data["ip"];
        }
    }

    static fromJS(data: any): StoreConnection {
        data = typeof data === 'object' ? data : {};
        let result = new StoreConnection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["storeName"] = this.storeName;
        data["commpanyName"] = this.commpanyName;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["status"] = this.status;
        data["accessKey"] = this.accessKey;
        data["ip"] = this.ip;
        return data;
    }
}

export interface IStoreConnection {
    storeId?: number;
    storeName?: string | undefined;
    commpanyName?: string | undefined;
    created?: Date;
    status?: string | undefined;
    accessKey?: string | undefined;
    ip?: string | undefined;
}

export class TransactionsReconcileResult implements ITransactionsReconcileResult {
    transactionNumber?: string;
    laneNumber?: number;
    itemType?: TransactionType;

    constructor(data?: ITransactionsReconcileResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionNumber = _data["transactionNumber"];
            this.laneNumber = _data["laneNumber"];
            this.itemType = _data["itemType"];
        }
    }

    static fromJS(data: any): TransactionsReconcileResult {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionsReconcileResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionNumber"] = this.transactionNumber;
        data["laneNumber"] = this.laneNumber;
        data["itemType"] = this.itemType;
        return data;
    }
}

export interface ITransactionsReconcileResult {
    transactionNumber?: string;
    laneNumber?: number;
    itemType?: TransactionType;
}

export enum TransactionType {
    POS_ONLY = "POS_ONLY",
    AppCard_ONLY = "AppCard_ONLY",
    AmountMissmatch = "AmountMissmatch",
}

export class Department implements IDepartment {
    id?: number;
    departmentDesc?: string | undefined;

    constructor(data?: IDepartment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.departmentDesc = _data["departmentDesc"];
        }
    }

    static fromJS(data: any): Department {
        data = typeof data === 'object' ? data : {};
        let result = new Department();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["departmentDesc"] = this.departmentDesc;
        return data;
    }
}

export interface IDepartment {
    id?: number;
    departmentDesc?: string | undefined;
}

export class Vendor implements IVendor {
    id?: string;
    vendorDesc?: string | undefined;

    constructor(data?: IVendor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.vendorDesc = _data["vendorDesc"];
        }
    }

    static fromJS(data: any): Vendor {
        data = typeof data === 'object' ? data : {};
        let result = new Vendor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["vendorDesc"] = this.vendorDesc;
        return data;
    }
}

export interface IVendor {
    id?: string;
    vendorDesc?: string | undefined;
}

export class Brand implements IBrand {
    id?: number;
    brandDesc?: string | undefined;

    constructor(data?: IBrand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.brandDesc = _data["brandDesc"];
        }
    }

    static fromJS(data: any): Brand {
        data = typeof data === 'object' ? data : {};
        let result = new Brand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["brandDesc"] = this.brandDesc;
        return data;
    }
}

export interface IBrand {
    id?: number;
    brandDesc?: string | undefined;
}

export class TaxDto implements ITaxDto {
    id?: number;
    percentage?: number | undefined;
    descript?: string | undefined;

    constructor(data?: ITaxDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.percentage = _data["percentage"];
            this.descript = _data["descript"];
        }
    }

    static fromJS(data: any): TaxDto {
        data = typeof data === 'object' ? data : {};
        let result = new TaxDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["percentage"] = this.percentage;
        data["descript"] = this.descript;
        return data;
    }
}

export interface ITaxDto {
    id?: number;
    percentage?: number | undefined;
    descript?: string | undefined;
}

export class DepartmentGroupDto implements IDepartmentGroupDto {
    id?: number | undefined;
    description?: string | undefined;

    constructor(data?: IDepartmentGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): DepartmentGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }
}

export interface IDepartmentGroupDto {
    id?: number | undefined;
    description?: string | undefined;
}

export class BundlesDto implements IBundlesDto {
    id?: string;
    description?: string | undefined;
    beginDate?: Date;
    endDate?: Date;
    forceBundleTotal?: number | undefined;

    constructor(data?: IBundlesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.beginDate = _data["beginDate"] ? new Date(_data["beginDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.forceBundleTotal = _data["forceBundleTotal"];
        }
    }

    static fromJS(data: any): BundlesDto {
        data = typeof data === 'object' ? data : {};
        let result = new BundlesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["forceBundleTotal"] = this.forceBundleTotal;
        return data;
    }
}

export interface IBundlesDto {
    id?: string;
    description?: string | undefined;
    beginDate?: Date;
    endDate?: Date;
    forceBundleTotal?: number | undefined;
}

export class CompanyDTO implements ICompanyDTO {
    id?: number;
    companyName?: string | undefined;

    constructor(data?: ICompanyDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.companyName = _data["companyName"];
        }
    }

    static fromJS(data: any): CompanyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["companyName"] = this.companyName;
        return data;
    }
}

export interface ICompanyDTO {
    id?: number;
    companyName?: string | undefined;
}

export class CompaniesDTO implements ICompaniesDTO {
    companies?: CompanyDTO[];

    constructor(data?: ICompaniesDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["companies"])) {
                this.companies = [] as any;
                for (let item of _data["companies"])
                    this.companies!.push(CompanyDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CompaniesDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CompaniesDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.companies)) {
            data["companies"] = [];
            for (let item of this.companies)
                data["companies"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ICompaniesDTO {
    companies?: CompanyDTO[];
}

export class AccountNumberDetailDto implements IAccountNumberDetailDto {
    id?: number;
    accountNumber?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    telPhone?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    createdDate?: Date | undefined;
    lastVisit?: Date | undefined;
    lastVisitStore?: string | undefined;
    inactive?: number | undefined;
    mergedTo?: string | undefined;
    customerLevel?: number | undefined;
    loyaltyEXCLUDE?: number | undefined;
    managerNeededForThisCustomer?: number | undefined;
    memo?: string | undefined;
    oneTimeDiscount?: number | undefined;
    taxExPt?: number | undefined;
    birthday?: Date | undefined;
    pointBlance?: number;
    yearToDateSales?: number | undefined;

    constructor(data?: IAccountNumberDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountNumber = _data["accountNumber"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.telPhone = _data["telPhone"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.lastVisit = _data["lastVisit"] ? new Date(_data["lastVisit"].toString()) : <any>undefined;
            this.lastVisitStore = _data["lastVisitStore"];
            this.inactive = _data["inactive"];
            this.mergedTo = _data["mergedTo"];
            this.customerLevel = _data["customerLevel"];
            this.loyaltyEXCLUDE = _data["loyaltyEXCLUDE"];
            this.managerNeededForThisCustomer = _data["managerNeededForThisCustomer"];
            this.memo = _data["memo"];
            this.oneTimeDiscount = _data["oneTimeDiscount"];
            this.taxExPt = _data["taxExPt"];
            this.birthday = _data["birthday"] ? new Date(_data["birthday"].toString()) : <any>undefined;
            this.pointBlance = _data["pointBlance"];
            this.yearToDateSales = _data["yearToDateSales"];
        }
    }

    static fromJS(data: any): AccountNumberDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountNumberDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountNumber"] = this.accountNumber;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["telPhone"] = this.telPhone;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["lastVisit"] = this.lastVisit ? this.lastVisit.toISOString() : <any>undefined;
        data["lastVisitStore"] = this.lastVisitStore;
        data["inactive"] = this.inactive;
        data["mergedTo"] = this.mergedTo;
        data["customerLevel"] = this.customerLevel;
        data["loyaltyEXCLUDE"] = this.loyaltyEXCLUDE;
        data["managerNeededForThisCustomer"] = this.managerNeededForThisCustomer;
        data["memo"] = this.memo;
        data["oneTimeDiscount"] = this.oneTimeDiscount;
        data["taxExPt"] = this.taxExPt;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["pointBlance"] = this.pointBlance;
        data["yearToDateSales"] = this.yearToDateSales;
        return data;
    }
}

export interface IAccountNumberDetailDto {
    id?: number;
    accountNumber?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    telPhone?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipCode?: string | undefined;
    createdDate?: Date | undefined;
    lastVisit?: Date | undefined;
    lastVisitStore?: string | undefined;
    inactive?: number | undefined;
    mergedTo?: string | undefined;
    customerLevel?: number | undefined;
    loyaltyEXCLUDE?: number | undefined;
    managerNeededForThisCustomer?: number | undefined;
    memo?: string | undefined;
    oneTimeDiscount?: number | undefined;
    taxExPt?: number | undefined;
    birthday?: Date | undefined;
    pointBlance?: number;
    yearToDateSales?: number | undefined;
}

export class AccountNumberDetailsBody implements IAccountNumberDetailsBody {
    accountNumbers!: AccountNumerDto[];

    constructor(data?: IAccountNumberDetailsBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.accountNumbers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accountNumbers"])) {
                this.accountNumbers = [] as any;
                for (let item of _data["accountNumbers"])
                    this.accountNumbers!.push(AccountNumerDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccountNumberDetailsBody {
        data = typeof data === 'object' ? data : {};
        let result = new AccountNumberDetailsBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accountNumbers)) {
            data["accountNumbers"] = [];
            for (let item of this.accountNumbers)
                data["accountNumbers"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IAccountNumberDetailsBody {
    accountNumbers: AccountNumerDto[];
}

export class AccountNumerDto implements IAccountNumerDto {
    id?: number;
    storeId?: number;
    accountNumber?: string;
    lastVisit?: Date | undefined;

    constructor(data?: IAccountNumerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.storeId = _data["storeId"];
            this.accountNumber = _data["accountNumber"];
            this.lastVisit = _data["lastVisit"] ? new Date(_data["lastVisit"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AccountNumerDto {
        data = typeof data === 'object' ? data : {};
        let result = new AccountNumerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeId"] = this.storeId;
        data["accountNumber"] = this.accountNumber;
        data["lastVisit"] = this.lastVisit ? this.lastVisit.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAccountNumerDto {
    id?: number;
    storeId?: number;
    accountNumber?: string;
    lastVisit?: Date | undefined;
}

export class CustomerTypeSalesSummaryDto implements ICustomerTypeSalesSummaryDto {
    storeId?: number;
    storeName?: string;
    loyaltyCustomer?: number | undefined;
    regularCustomer?: number | undefined;
    loyaltyCustomerOrderCount?: number | undefined;
    regularCustomerOrderCount?: number | undefined;

    constructor(data?: ICustomerTypeSalesSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeId = _data["storeId"];
            this.storeName = _data["storeName"];
            this.loyaltyCustomer = _data["loyaltyCustomer"];
            this.regularCustomer = _data["regularCustomer"];
            this.loyaltyCustomerOrderCount = _data["loyaltyCustomerOrderCount"];
            this.regularCustomerOrderCount = _data["regularCustomerOrderCount"];
        }
    }

    static fromJS(data: any): CustomerTypeSalesSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerTypeSalesSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["storeName"] = this.storeName;
        data["loyaltyCustomer"] = this.loyaltyCustomer;
        data["regularCustomer"] = this.regularCustomer;
        data["loyaltyCustomerOrderCount"] = this.loyaltyCustomerOrderCount;
        data["regularCustomerOrderCount"] = this.regularCustomerOrderCount;
        return data;
    }
}

export interface ICustomerTypeSalesSummaryDto {
    storeId?: number;
    storeName?: string;
    loyaltyCustomer?: number | undefined;
    regularCustomer?: number | undefined;
    loyaltyCustomerOrderCount?: number | undefined;
    regularCustomerOrderCount?: number | undefined;
}

export class CustomerTypeSalesSummaryDailyDto implements ICustomerTypeSalesSummaryDailyDto {
    loyaltyCustomer?: number | undefined;
    regularCustomer?: number | undefined;
    saleDate?: Date | undefined;
    loyaltyCustomerOrderCount?: number | undefined;
    regularCustomerOrderCount?: number | undefined;

    constructor(data?: ICustomerTypeSalesSummaryDailyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loyaltyCustomer = _data["loyaltyCustomer"];
            this.regularCustomer = _data["regularCustomer"];
            this.saleDate = _data["saleDate"] ? new Date(_data["saleDate"].toString()) : <any>undefined;
            this.loyaltyCustomerOrderCount = _data["loyaltyCustomerOrderCount"];
            this.regularCustomerOrderCount = _data["regularCustomerOrderCount"];
        }
    }

    static fromJS(data: any): CustomerTypeSalesSummaryDailyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerTypeSalesSummaryDailyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loyaltyCustomer"] = this.loyaltyCustomer;
        data["regularCustomer"] = this.regularCustomer;
        data["saleDate"] = this.saleDate ? this.saleDate.toISOString() : <any>undefined;
        data["loyaltyCustomerOrderCount"] = this.loyaltyCustomerOrderCount;
        data["regularCustomerOrderCount"] = this.regularCustomerOrderCount;
        return data;
    }
}

export interface ICustomerTypeSalesSummaryDailyDto {
    loyaltyCustomer?: number | undefined;
    regularCustomer?: number | undefined;
    saleDate?: Date | undefined;
    loyaltyCustomerOrderCount?: number | undefined;
    regularCustomerOrderCount?: number | undefined;
}

export class FoodCartResponse implements IFoodCartResponse {
    cart?: FoodCart | undefined;
    item?: FoodCartItem | undefined;

    constructor(data?: IFoodCartResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cart = _data["cart"] ? FoodCart.fromJS(_data["cart"]) : <any>undefined;
            this.item = _data["item"] ? FoodCartItem.fromJS(_data["item"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FoodCartResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FoodCartResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cart"] = this.cart ? this.cart.toJSON() : <any>undefined;
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFoodCartResponse {
    cart?: FoodCart | undefined;
    item?: FoodCartItem | undefined;
}

export class FoodCart implements IFoodCart {
    id?: string;
    totalAmount?: number | undefined;
    totalTaxAmount?: number | undefined;
    accountNumber?: string;

    constructor(data?: IFoodCart) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.totalAmount = _data["totalAmount"];
            this.totalTaxAmount = _data["totalTaxAmount"];
            this.accountNumber = _data["accountNumber"];
        }
    }

    static fromJS(data: any): FoodCart {
        data = typeof data === 'object' ? data : {};
        let result = new FoodCart();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["totalAmount"] = this.totalAmount;
        data["totalTaxAmount"] = this.totalTaxAmount;
        data["accountNumber"] = this.accountNumber;
        return data;
    }
}

export interface IFoodCart {
    id?: string;
    totalAmount?: number | undefined;
    totalTaxAmount?: number | undefined;
    accountNumber?: string;
}

export class FoodCartItem implements IFoodCartItem {
    id?: string;
    card_ID?: string;
    foodItem_ID?: string;
    price?: number;
    quantity?: number;
    subtotal?: number;
    taxAmount?: number;
    selectedAttibutes?: ProductAttributeItem[];
    createdTime?: Date;
    memo?: string | undefined;

    constructor(data?: IFoodCartItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.card_ID = _data["card_ID"];
            this.foodItem_ID = _data["foodItem_ID"];
            this.price = _data["price"];
            this.quantity = _data["quantity"];
            this.subtotal = _data["subtotal"];
            this.taxAmount = _data["taxAmount"];
            if (Array.isArray(_data["selectedAttibutes"])) {
                this.selectedAttibutes = [] as any;
                for (let item of _data["selectedAttibutes"])
                    this.selectedAttibutes!.push(ProductAttributeItem.fromJS(item));
            }
            this.createdTime = _data["createdTime"] ? new Date(_data["createdTime"].toString()) : <any>undefined;
            this.memo = _data["memo"];
        }
    }

    static fromJS(data: any): FoodCartItem {
        data = typeof data === 'object' ? data : {};
        let result = new FoodCartItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["card_ID"] = this.card_ID;
        data["foodItem_ID"] = this.foodItem_ID;
        data["price"] = this.price;
        data["quantity"] = this.quantity;
        data["subtotal"] = this.subtotal;
        data["taxAmount"] = this.taxAmount;
        if (Array.isArray(this.selectedAttibutes)) {
            data["selectedAttibutes"] = [];
            for (let item of this.selectedAttibutes)
                data["selectedAttibutes"].push(item ? item.toJSON() : <any>undefined);
        }
        data["createdTime"] = this.createdTime ? this.createdTime.toISOString() : <any>undefined;
        data["memo"] = this.memo;
        return data;
    }
}

export interface IFoodCartItem {
    id?: string;
    card_ID?: string;
    foodItem_ID?: string;
    price?: number;
    quantity?: number;
    subtotal?: number;
    taxAmount?: number;
    selectedAttibutes?: ProductAttributeItem[];
    createdTime?: Date;
    memo?: string | undefined;
}

export class ProductAttributeItem implements IProductAttributeItem {
    id?: string;
    name?: string | undefined;
    price?: number;

    constructor(data?: IProductAttributeItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): ProductAttributeItem {
        data = typeof data === 'object' ? data : {};
        let result = new ProductAttributeItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["price"] = this.price;
        return data;
    }
}

export interface IProductAttributeItem {
    id?: string;
    name?: string | undefined;
    price?: number;
}

export class CreateFoodCartRequest implements ICreateFoodCartRequest {
    storeId?: number;
    accountNumber?: string | undefined;
    foodCartItem?: InsertFoodCartItemBody | undefined;

    constructor(data?: ICreateFoodCartRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeId = _data["storeId"];
            this.accountNumber = _data["accountNumber"];
            this.foodCartItem = _data["foodCartItem"] ? InsertFoodCartItemBody.fromJS(_data["foodCartItem"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CreateFoodCartRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFoodCartRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["accountNumber"] = this.accountNumber;
        data["foodCartItem"] = this.foodCartItem ? this.foodCartItem.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICreateFoodCartRequest {
    storeId?: number;
    accountNumber?: string | undefined;
    foodCartItem?: InsertFoodCartItemBody | undefined;
}

export class InsertFoodCartItemBody implements IInsertFoodCartItemBody {
    foodItem_ID?: string;
    price?: number;
    quantity?: number;
    memo?: string | undefined;
    /** 选择的商品属性组 */
    selectedAttibutes?: ProductAttributeItem[];

    constructor(data?: IInsertFoodCartItemBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.foodItem_ID = _data["foodItem_ID"];
            this.price = _data["price"];
            this.quantity = _data["quantity"];
            this.memo = _data["memo"];
            if (Array.isArray(_data["selectedAttibutes"])) {
                this.selectedAttibutes = [] as any;
                for (let item of _data["selectedAttibutes"])
                    this.selectedAttibutes!.push(ProductAttributeItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InsertFoodCartItemBody {
        data = typeof data === 'object' ? data : {};
        let result = new InsertFoodCartItemBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["foodItem_ID"] = this.foodItem_ID;
        data["price"] = this.price;
        data["quantity"] = this.quantity;
        data["memo"] = this.memo;
        if (Array.isArray(this.selectedAttibutes)) {
            data["selectedAttibutes"] = [];
            for (let item of this.selectedAttibutes)
                data["selectedAttibutes"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IInsertFoodCartItemBody {
    foodItem_ID?: string;
    price?: number;
    quantity?: number;
    memo?: string | undefined;
    /** 选择的商品属性组 */
    selectedAttibutes?: ProductAttributeItem[];
}

export class AddFoodCartItemRequest implements IAddFoodCartItemRequest {
    storeId?: number;
    cartId?: string;
    foodCartItem?: InsertFoodCartItemBody | undefined;

    constructor(data?: IAddFoodCartItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeId = _data["storeId"];
            this.cartId = _data["cartId"];
            this.foodCartItem = _data["foodCartItem"] ? InsertFoodCartItemBody.fromJS(_data["foodCartItem"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddFoodCartItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddFoodCartItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["cartId"] = this.cartId;
        data["foodCartItem"] = this.foodCartItem ? this.foodCartItem.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAddFoodCartItemRequest {
    storeId?: number;
    cartId?: string;
    foodCartItem?: InsertFoodCartItemBody | undefined;
}

export class UpdateFoodCartItemRequest implements IUpdateFoodCartItemRequest {
    storeId?: number;
    cartItemId?: string;
    quantity?: number;
    price?: number;
    memo?: string | undefined;
    /** 选择的商品属性组 */
    selectedAttibutes?: ProductAttributeItem[];

    constructor(data?: IUpdateFoodCartItemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeId = _data["storeId"];
            this.cartItemId = _data["cartItemId"];
            this.quantity = _data["quantity"];
            this.price = _data["price"];
            this.memo = _data["memo"];
            if (Array.isArray(_data["selectedAttibutes"])) {
                this.selectedAttibutes = [] as any;
                for (let item of _data["selectedAttibutes"])
                    this.selectedAttibutes!.push(ProductAttributeItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateFoodCartItemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFoodCartItemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["cartItemId"] = this.cartItemId;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["memo"] = this.memo;
        if (Array.isArray(this.selectedAttibutes)) {
            data["selectedAttibutes"] = [];
            for (let item of this.selectedAttibutes)
                data["selectedAttibutes"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IUpdateFoodCartItemRequest {
    storeId?: number;
    cartItemId?: string;
    quantity?: number;
    price?: number;
    memo?: string | undefined;
    /** 选择的商品属性组 */
    selectedAttibutes?: ProductAttributeItem[];
}

export class DeleteFoodCartItemResponse implements IDeleteFoodCartItemResponse {
    cart?: FoodCart | undefined;

    constructor(data?: IDeleteFoodCartItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cart = _data["cart"] ? FoodCart.fromJS(_data["cart"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DeleteFoodCartItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteFoodCartItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cart"] = this.cart ? this.cart.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDeleteFoodCartItemResponse {
    cart?: FoodCart | undefined;
}

export class Response implements IResponse {
    responseType?: string | undefined;

    constructor(data?: IResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseType = _data["responseType"];
        }
    }

    static fromJS(data: any): Response {
        data = typeof data === 'object' ? data : {};
        let result = new Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseType"] = this.responseType;
        return data;
    }
}

export interface IResponse {
    responseType?: string | undefined;
}

export class CustomerResponse extends Response implements ICustomerResponse {
    customer?: CustomerDto | undefined;

    constructor(data?: ICustomerResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.customer = _data["customer"] ? CustomerDto.fromJS(_data["customer"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): CustomerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customer"] = this.customer ? this.customer.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface ICustomerResponse extends IResponse {
    customer?: CustomerDto | undefined;
}

export class CustomerDto implements ICustomerDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    cellphone?: string | undefined;
    tellphone?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipcode?: string | undefined;
    createdDate?: Date | undefined;
    birthday?: Date | undefined;
    lastVisit?: Date | undefined;
    cardNumberForPos?: string | undefined;
    mergedto?: string | undefined;
    pointBalance?: number | undefined;
    customerLevel?: number | undefined;
    discountCode?: string | undefined;
    memo?: string | undefined;
    inactive?: boolean | undefined;
    loyaltyExcluded?: boolean | undefined;
    managerNeeded?: boolean | undefined;
    oneTimeDiscount?: boolean | undefined;
    taxExempt?: boolean | undefined;

    constructor(data?: ICustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.cellphone = _data["cellphone"];
            this.tellphone = _data["tellphone"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipcode = _data["zipcode"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.birthday = _data["birthday"] ? new Date(_data["birthday"].toString()) : <any>undefined;
            this.lastVisit = _data["lastVisit"] ? new Date(_data["lastVisit"].toString()) : <any>undefined;
            this.cardNumberForPos = _data["cardNumberForPos"];
            this.mergedto = _data["mergedto"];
            this.pointBalance = _data["pointBalance"];
            this.customerLevel = _data["customerLevel"];
            this.discountCode = _data["discountCode"];
            this.memo = _data["memo"];
            this.inactive = _data["inactive"];
            this.loyaltyExcluded = _data["loyaltyExcluded"];
            this.managerNeeded = _data["managerNeeded"];
            this.oneTimeDiscount = _data["oneTimeDiscount"];
            this.taxExempt = _data["taxExempt"];
        }
    }

    static fromJS(data: any): CustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["cellphone"] = this.cellphone;
        data["tellphone"] = this.tellphone;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipcode"] = this.zipcode;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["lastVisit"] = this.lastVisit ? this.lastVisit.toISOString() : <any>undefined;
        data["cardNumberForPos"] = this.cardNumberForPos;
        data["mergedto"] = this.mergedto;
        data["pointBalance"] = this.pointBalance;
        data["customerLevel"] = this.customerLevel;
        data["discountCode"] = this.discountCode;
        data["memo"] = this.memo;
        data["inactive"] = this.inactive;
        data["loyaltyExcluded"] = this.loyaltyExcluded;
        data["managerNeeded"] = this.managerNeeded;
        data["oneTimeDiscount"] = this.oneTimeDiscount;
        data["taxExempt"] = this.taxExempt;
        return data;
    }
}

export interface ICustomerDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    cellphone?: string | undefined;
    tellphone?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zipcode?: string | undefined;
    createdDate?: Date | undefined;
    birthday?: Date | undefined;
    lastVisit?: Date | undefined;
    cardNumberForPos?: string | undefined;
    mergedto?: string | undefined;
    pointBalance?: number | undefined;
    customerLevel?: number | undefined;
    discountCode?: string | undefined;
    memo?: string | undefined;
    inactive?: boolean | undefined;
    loyaltyExcluded?: boolean | undefined;
    managerNeeded?: boolean | undefined;
    oneTimeDiscount?: boolean | undefined;
    taxExempt?: boolean | undefined;
}

export class LoginFoodCartRequest implements ILoginFoodCartRequest {
    cartID?: string | undefined;
    storeId!: number;
    accountNumber?: string | undefined;

    constructor(data?: ILoginFoodCartRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cartID = _data["cartID"];
            this.storeId = _data["storeId"];
            this.accountNumber = _data["accountNumber"];
        }
    }

    static fromJS(data: any): LoginFoodCartRequest {
        data = typeof data === 'object' ? data : {};
        let result = new LoginFoodCartRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cartID"] = this.cartID;
        data["storeId"] = this.storeId;
        data["accountNumber"] = this.accountNumber;
        return data;
    }
}

export interface ILoginFoodCartRequest {
    cartID?: string | undefined;
    storeId: number;
    accountNumber?: string | undefined;
}

export class AssignCartToCustomerRequest implements IAssignCartToCustomerRequest {
    storeId!: number;
    cartID!: string;
    accountNumber!: string;

    constructor(data?: IAssignCartToCustomerRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeId = _data["storeId"];
            this.cartID = _data["cartID"];
            this.accountNumber = _data["accountNumber"];
        }
    }

    static fromJS(data: any): AssignCartToCustomerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssignCartToCustomerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["cartID"] = this.cartID;
        data["accountNumber"] = this.accountNumber;
        return data;
    }
}

export interface IAssignCartToCustomerRequest {
    storeId: number;
    cartID: string;
    accountNumber: string;
}

export class FoodCategoryDto implements IFoodCategoryDto {
    id?: string;
    name?: string | undefined;
    stortOrder?: number;
    parentId?: string | undefined;
    createDate?: Date | undefined;
    imagePath?: string | undefined;

    constructor(data?: IFoodCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.stortOrder = _data["stortOrder"];
            this.parentId = _data["parentId"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.imagePath = _data["imagePath"];
        }
    }

    static fromJS(data: any): FoodCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new FoodCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["stortOrder"] = this.stortOrder;
        data["parentId"] = this.parentId;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["imagePath"] = this.imagePath;
        return data;
    }
}

export interface IFoodCategoryDto {
    id?: string;
    name?: string | undefined;
    stortOrder?: number;
    parentId?: string | undefined;
    createDate?: Date | undefined;
    imagePath?: string | undefined;
}

export class InsertFoodCategoryBody implements IInsertFoodCategoryBody {
    id?: string;
    name?: string | undefined;
    stortOrder?: number;
    imagePath?: string | undefined;
    parentId?: string | undefined;

    constructor(data?: IInsertFoodCategoryBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.stortOrder = _data["stortOrder"];
            this.imagePath = _data["imagePath"];
            this.parentId = _data["parentId"];
        }
    }

    static fromJS(data: any): InsertFoodCategoryBody {
        data = typeof data === 'object' ? data : {};
        let result = new InsertFoodCategoryBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["stortOrder"] = this.stortOrder;
        data["imagePath"] = this.imagePath;
        data["parentId"] = this.parentId;
        return data;
    }
}

export interface IInsertFoodCategoryBody {
    id?: string;
    name?: string | undefined;
    stortOrder?: number;
    imagePath?: string | undefined;
    parentId?: string | undefined;
}

export class UpdateFoodCategoryBody implements IUpdateFoodCategoryBody {
    id?: string;
    name?: string | undefined;
    imagePath?: string | undefined;

    constructor(data?: IUpdateFoodCategoryBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.imagePath = _data["imagePath"];
        }
    }

    static fromJS(data: any): UpdateFoodCategoryBody {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFoodCategoryBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["imagePath"] = this.imagePath;
        return data;
    }
}

export interface IUpdateFoodCategoryBody {
    id?: string;
    name?: string | undefined;
    imagePath?: string | undefined;
}

export class UpdateSortOrdersBody implements IUpdateSortOrdersBody {
    sortOrderItems?: SortOrderItem[];

    constructor(data?: IUpdateSortOrdersBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sortOrderItems"])) {
                this.sortOrderItems = [] as any;
                for (let item of _data["sortOrderItems"])
                    this.sortOrderItems!.push(SortOrderItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpdateSortOrdersBody {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSortOrdersBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sortOrderItems)) {
            data["sortOrderItems"] = [];
            for (let item of this.sortOrderItems)
                data["sortOrderItems"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IUpdateSortOrdersBody {
    sortOrderItems?: SortOrderItem[];
}

export class SortOrderItem implements ISortOrderItem {
    id?: string;
    sortOrder?: number;

    constructor(data?: ISortOrderItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): SortOrderItem {
        data = typeof data === 'object' ? data : {};
        let result = new SortOrderItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface ISortOrderItem {
    id?: string;
    sortOrder?: number;
}

export class FoodItemDto implements IFoodItemDto {
    id?: string;
    foodCategory_ID?: string | undefined;
    productDetails?: string | undefined;
    foodImagePath?: string | undefined;
    plU_ID?: string | undefined;
    barcode?: string | undefined;
    createDate?: Date | undefined;
    description?: string | undefined;
    price?: number | undefined;
    priceBase?: number | undefined;
    sortOrder?: number | undefined;
    is_Weight?: boolean;
    randomWeightPrice?: number | undefined;

    constructor(data?: IFoodItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.foodCategory_ID = _data["foodCategory_ID"];
            this.productDetails = _data["productDetails"];
            this.foodImagePath = _data["foodImagePath"];
            this.plU_ID = _data["plU_ID"];
            this.barcode = _data["barcode"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.price = _data["price"];
            this.priceBase = _data["priceBase"];
            this.sortOrder = _data["sortOrder"];
            this.is_Weight = _data["is_Weight"];
            this.randomWeightPrice = _data["randomWeightPrice"];
        }
    }

    static fromJS(data: any): FoodItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new FoodItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["foodCategory_ID"] = this.foodCategory_ID;
        data["productDetails"] = this.productDetails;
        data["foodImagePath"] = this.foodImagePath;
        data["plU_ID"] = this.plU_ID;
        data["barcode"] = this.barcode;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["price"] = this.price;
        data["priceBase"] = this.priceBase;
        data["sortOrder"] = this.sortOrder;
        data["is_Weight"] = this.is_Weight;
        data["randomWeightPrice"] = this.randomWeightPrice;
        return data;
    }
}

export interface IFoodItemDto {
    id?: string;
    foodCategory_ID?: string | undefined;
    productDetails?: string | undefined;
    foodImagePath?: string | undefined;
    plU_ID?: string | undefined;
    barcode?: string | undefined;
    createDate?: Date | undefined;
    description?: string | undefined;
    price?: number | undefined;
    priceBase?: number | undefined;
    sortOrder?: number | undefined;
    is_Weight?: boolean;
    randomWeightPrice?: number | undefined;
}

/** FoodItem详细信息 */
export class FoodItemDetailsDto implements IFoodItemDetailsDto {
    /** 商品基本信息 */
    item?: FoodItemDto | undefined;
    /** 商品副图数组 */
    imageGallery?: string[];
    /** 商品属性组列表 */
    attributeGroup?: ProductAttributeGroupDto[];

    constructor(data?: IFoodItemDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item = _data["item"] ? FoodItemDto.fromJS(_data["item"]) : <any>undefined;
            if (Array.isArray(_data["imageGallery"])) {
                this.imageGallery = [] as any;
                for (let item of _data["imageGallery"])
                    this.imageGallery!.push(item);
            }
            if (Array.isArray(_data["attributeGroup"])) {
                this.attributeGroup = [] as any;
                for (let item of _data["attributeGroup"])
                    this.attributeGroup!.push(ProductAttributeGroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FoodItemDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new FoodItemDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item"] = this.item ? this.item.toJSON() : <any>undefined;
        if (Array.isArray(this.imageGallery)) {
            data["imageGallery"] = [];
            for (let item of this.imageGallery)
                data["imageGallery"].push(item);
        }
        if (Array.isArray(this.attributeGroup)) {
            data["attributeGroup"] = [];
            for (let item of this.attributeGroup)
                data["attributeGroup"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

/** FoodItem详细信息 */
export interface IFoodItemDetailsDto {
    /** 商品基本信息 */
    item?: FoodItemDto | undefined;
    /** 商品副图数组 */
    imageGallery?: string[];
    /** 商品属性组列表 */
    attributeGroup?: ProductAttributeGroupDto[];
}

export class ProductAttributeGroupDto implements IProductAttributeGroupDto {
    /** 组ID */
    id?: string;
    /** 商品ID */
    plU_ID?: string | undefined;
    /** 组描述 */
    description?: string | undefined;
    /** 最大选择数量 */
    maximumSelected?: number | undefined;
    /** 最小选择数量 */
    minimumSelected?: number | undefined;
    /** 组成员列表 */
    items?: ProductAttributeItemDto[];

    constructor(data?: IProductAttributeGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.plU_ID = _data["plU_ID"];
            this.description = _data["description"];
            this.maximumSelected = _data["maximumSelected"];
            this.minimumSelected = _data["minimumSelected"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ProductAttributeItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductAttributeGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductAttributeGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["plU_ID"] = this.plU_ID;
        data["description"] = this.description;
        data["maximumSelected"] = this.maximumSelected;
        data["minimumSelected"] = this.minimumSelected;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IProductAttributeGroupDto {
    /** 组ID */
    id?: string;
    /** 商品ID */
    plU_ID?: string | undefined;
    /** 组描述 */
    description?: string | undefined;
    /** 最大选择数量 */
    maximumSelected?: number | undefined;
    /** 最小选择数量 */
    minimumSelected?: number | undefined;
    /** 组成员列表 */
    items?: ProductAttributeItemDto[];
}

export class ProductAttributeItemDto implements IProductAttributeItemDto {
    id?: string;
    name?: string | undefined;
    price?: number | undefined;
    productAttributeGroup_ID?: string;
    color?: string | undefined;
    /** 显示位置 */
    displayIndex?: number | undefined;
    /** 默认当前是否选中 */
    checkedByDefault?: number | undefined;
    instruction?: number | undefined;

    constructor(data?: IProductAttributeItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.price = _data["price"];
            this.productAttributeGroup_ID = _data["productAttributeGroup_ID"];
            this.color = _data["color"];
            this.displayIndex = _data["displayIndex"];
            this.checkedByDefault = _data["checkedByDefault"];
            this.instruction = _data["instruction"];
        }
    }

    static fromJS(data: any): ProductAttributeItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductAttributeItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["price"] = this.price;
        data["productAttributeGroup_ID"] = this.productAttributeGroup_ID;
        data["color"] = this.color;
        data["displayIndex"] = this.displayIndex;
        data["checkedByDefault"] = this.checkedByDefault;
        data["instruction"] = this.instruction;
        return data;
    }
}

export interface IProductAttributeItemDto {
    id?: string;
    name?: string | undefined;
    price?: number | undefined;
    productAttributeGroup_ID?: string;
    color?: string | undefined;
    /** 显示位置 */
    displayIndex?: number | undefined;
    /** 默认当前是否选中 */
    checkedByDefault?: number | undefined;
    instruction?: number | undefined;
}

export class InserFoodItemBody implements IInserFoodItemBody {
    id?: string;
    foodCategory_ID?: string | undefined;
    productDetails?: string | undefined;
    foodImagePath?: string | undefined;
    barcode?: string | undefined;
    sortOrder?: number | undefined;

    constructor(data?: IInserFoodItemBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.foodCategory_ID = _data["foodCategory_ID"];
            this.productDetails = _data["productDetails"];
            this.foodImagePath = _data["foodImagePath"];
            this.barcode = _data["barcode"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): InserFoodItemBody {
        data = typeof data === 'object' ? data : {};
        let result = new InserFoodItemBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["foodCategory_ID"] = this.foodCategory_ID;
        data["productDetails"] = this.productDetails;
        data["foodImagePath"] = this.foodImagePath;
        data["barcode"] = this.barcode;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IInserFoodItemBody {
    id?: string;
    foodCategory_ID?: string | undefined;
    productDetails?: string | undefined;
    foodImagePath?: string | undefined;
    barcode?: string | undefined;
    sortOrder?: number | undefined;
}

export class UpdateFoodItemBody implements IUpdateFoodItemBody {
    pluId?: string | undefined;
    productDetails?: string | undefined;
    foodImagePath?: string | undefined;
    foodCategory_ID?: string | undefined;

    constructor(data?: IUpdateFoodItemBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pluId = _data["pluId"];
            this.productDetails = _data["productDetails"];
            this.foodImagePath = _data["foodImagePath"];
            this.foodCategory_ID = _data["foodCategory_ID"];
        }
    }

    static fromJS(data: any): UpdateFoodItemBody {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFoodItemBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pluId"] = this.pluId;
        data["productDetails"] = this.productDetails;
        data["foodImagePath"] = this.foodImagePath;
        data["foodCategory_ID"] = this.foodCategory_ID;
        return data;
    }
}

export interface IUpdateFoodItemBody {
    pluId?: string | undefined;
    productDetails?: string | undefined;
    foodImagePath?: string | undefined;
    foodCategory_ID?: string | undefined;
}

export class ItemBasicInfoDto implements IItemBasicInfoDto {
    id?: string | undefined;
    barcode?: string | undefined;
    pluId?: string | undefined;
    description?: string | undefined;
    deatils?: string | undefined;
    imagePath?: string | undefined;
    is_Weight?: boolean;

    constructor(data?: IItemBasicInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.barcode = _data["barcode"];
            this.pluId = _data["pluId"];
            this.description = _data["description"];
            this.deatils = _data["deatils"];
            this.imagePath = _data["imagePath"];
            this.is_Weight = _data["is_Weight"];
        }
    }

    static fromJS(data: any): ItemBasicInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ItemBasicInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["barcode"] = this.barcode;
        data["pluId"] = this.pluId;
        data["description"] = this.description;
        data["deatils"] = this.deatils;
        data["imagePath"] = this.imagePath;
        data["is_Weight"] = this.is_Weight;
        return data;
    }
}

export interface IItemBasicInfoDto {
    id?: string | undefined;
    barcode?: string | undefined;
    pluId?: string | undefined;
    description?: string | undefined;
    deatils?: string | undefined;
    imagePath?: string | undefined;
    is_Weight?: boolean;
}

export class FoodImageChildDto implements IFoodImageChildDto {
    id?: string;
    imagePath?: string | undefined;
    sortOrder?: number | undefined;

    constructor(data?: IFoodImageChildDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.imagePath = _data["imagePath"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): FoodImageChildDto {
        data = typeof data === 'object' ? data : {};
        let result = new FoodImageChildDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["imagePath"] = this.imagePath;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IFoodImageChildDto {
    id?: string;
    imagePath?: string | undefined;
    sortOrder?: number | undefined;
}

export class ImageItem implements IImageItem {
    parent_ID?: string;
    id?: string;
    imagePath?: string | undefined;
    sortOrder?: number | undefined;

    constructor(data?: IImageItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parent_ID = _data["parent_ID"];
            this.id = _data["id"];
            this.imagePath = _data["imagePath"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): ImageItem {
        data = typeof data === 'object' ? data : {};
        let result = new ImageItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parent_ID"] = this.parent_ID;
        data["id"] = this.id;
        data["imagePath"] = this.imagePath;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IImageItem {
    parent_ID?: string;
    id?: string;
    imagePath?: string | undefined;
    sortOrder?: number | undefined;
}

export class TransactionOrderResponse implements ITransactionOrderResponse {
    /** 交易ID */
    transactionID?: string | undefined;
    /** 交易时间 */
    transactionDate?: Date;
    /** 未含税总额 */
    subtotal?: number;
    /** 商品总数量 */
    totalQuantity?: number;
    /** 总税额 */
    totalTaxAmount?: number;
    /** 含税总额 */
    totalAmount?: number;
    /** 当天订单号 */
    dailyTrxNumber?: number;
    products?: Product[];

    constructor(data?: ITransactionOrderResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionID = _data["transactionID"];
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : <any>undefined;
            this.subtotal = _data["subtotal"];
            this.totalQuantity = _data["totalQuantity"];
            this.totalTaxAmount = _data["totalTaxAmount"];
            this.totalAmount = _data["totalAmount"];
            this.dailyTrxNumber = _data["dailyTrxNumber"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(Product.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TransactionOrderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionOrderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionID"] = this.transactionID;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : <any>undefined;
        data["subtotal"] = this.subtotal;
        data["totalQuantity"] = this.totalQuantity;
        data["totalTaxAmount"] = this.totalTaxAmount;
        data["totalAmount"] = this.totalAmount;
        data["dailyTrxNumber"] = this.dailyTrxNumber;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ITransactionOrderResponse {
    /** 交易ID */
    transactionID?: string | undefined;
    /** 交易时间 */
    transactionDate?: Date;
    /** 未含税总额 */
    subtotal?: number;
    /** 商品总数量 */
    totalQuantity?: number;
    /** 总税额 */
    totalTaxAmount?: number;
    /** 含税总额 */
    totalAmount?: number;
    /** 当天订单号 */
    dailyTrxNumber?: number;
    products?: Product[];
}

export class Product implements IProduct {
    description?: string | undefined;
    pluId?: string | undefined;
    price?: number;
    quantity?: number;
    memo?: string | undefined;
    attributes?: AttributeItem[] | undefined;
    attributesPre?: string[] | undefined;

    constructor(data?: IProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.pluId = _data["pluId"];
            this.price = _data["price"];
            this.quantity = _data["quantity"];
            this.memo = _data["memo"];
            if (Array.isArray(_data["attributes"])) {
                this.attributes = [] as any;
                for (let item of _data["attributes"])
                    this.attributes!.push(AttributeItem.fromJS(item));
            }
            if (Array.isArray(_data["attributesPre"])) {
                this.attributesPre = [] as any;
                for (let item of _data["attributesPre"])
                    this.attributesPre!.push(item);
            }
        }
    }

    static fromJS(data: any): Product {
        data = typeof data === 'object' ? data : {};
        let result = new Product();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["pluId"] = this.pluId;
        data["price"] = this.price;
        data["quantity"] = this.quantity;
        data["memo"] = this.memo;
        if (Array.isArray(this.attributes)) {
            data["attributes"] = [];
            for (let item of this.attributes)
                data["attributes"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.attributesPre)) {
            data["attributesPre"] = [];
            for (let item of this.attributesPre)
                data["attributesPre"].push(item);
        }
        return data;
    }
}

export interface IProduct {
    description?: string | undefined;
    pluId?: string | undefined;
    price?: number;
    quantity?: number;
    memo?: string | undefined;
    attributes?: AttributeItem[] | undefined;
    attributesPre?: string[] | undefined;
}

export class AttributeItem implements IAttributeItem {
    name?: string | undefined;
    price?: number;
    prefixId?: string | undefined;
    attributeId?: string | undefined;

    constructor(data?: IAttributeItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.price = _data["price"];
            this.prefixId = _data["prefixId"];
            this.attributeId = _data["attributeId"];
        }
    }

    static fromJS(data: any): AttributeItem {
        data = typeof data === 'object' ? data : {};
        let result = new AttributeItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["price"] = this.price;
        data["prefixId"] = this.prefixId;
        data["attributeId"] = this.attributeId;
        return data;
    }
}

export interface IAttributeItem {
    name?: string | undefined;
    price?: number;
    prefixId?: string | undefined;
    attributeId?: string | undefined;
}

export class DeliOrderingLanguageDto implements IDeliOrderingLanguageDto {
    code?: string | undefined;
    name?: string | undefined;
    sort?: number;

    constructor(data?: IDeliOrderingLanguageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.sort = _data["sort"];
        }
    }

    static fromJS(data: any): DeliOrderingLanguageDto {
        data = typeof data === 'object' ? data : {};
        let result = new DeliOrderingLanguageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["sort"] = this.sort;
        return data;
    }
}

export interface IDeliOrderingLanguageDto {
    code?: string | undefined;
    name?: string | undefined;
    sort?: number;
}

export class DeliOrderingLanguageBody implements IDeliOrderingLanguageBody {
    code?: string | undefined;
    name?: string | undefined;
    sort?: number;

    constructor(data?: IDeliOrderingLanguageBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.sort = _data["sort"];
        }
    }

    static fromJS(data: any): DeliOrderingLanguageBody {
        data = typeof data === 'object' ? data : {};
        let result = new DeliOrderingLanguageBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["sort"] = this.sort;
        return data;
    }
}

export interface IDeliOrderingLanguageBody {
    code?: string | undefined;
    name?: string | undefined;
    sort?: number;
}

export class FoodCategoryTranslationDto implements IFoodCategoryTranslationDto {
    category_ID?: string;
    language_Code?: string | undefined;
    language_Name?: string | undefined;
    name?: string | undefined;

    constructor(data?: IFoodCategoryTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category_ID = _data["category_ID"];
            this.language_Code = _data["language_Code"];
            this.language_Name = _data["language_Name"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): FoodCategoryTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new FoodCategoryTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category_ID"] = this.category_ID;
        data["language_Code"] = this.language_Code;
        data["language_Name"] = this.language_Name;
        data["name"] = this.name;
        return data;
    }
}

export interface IFoodCategoryTranslationDto {
    category_ID?: string;
    language_Code?: string | undefined;
    language_Name?: string | undefined;
    name?: string | undefined;
}

export class FoodCategoryTranslationSyncRequest implements IFoodCategoryTranslationSyncRequest {
    category_ID?: string;
    language_Code?: string | undefined;
    name?: string | undefined;

    constructor(data?: IFoodCategoryTranslationSyncRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category_ID = _data["category_ID"];
            this.language_Code = _data["language_Code"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): FoodCategoryTranslationSyncRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FoodCategoryTranslationSyncRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category_ID"] = this.category_ID;
        data["language_Code"] = this.language_Code;
        data["name"] = this.name;
        return data;
    }
}

export interface IFoodCategoryTranslationSyncRequest {
    category_ID?: string;
    language_Code?: string | undefined;
    name?: string | undefined;
}

export class FoodItemTranslationDto implements IFoodItemTranslationDto {
    foodItem_ID?: string;
    language_Name?: string | undefined;
    language_Code?: string | undefined;
    description?: string | undefined;
    detailDescription?: string | undefined;

    constructor(data?: IFoodItemTranslationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.foodItem_ID = _data["foodItem_ID"];
            this.language_Name = _data["language_Name"];
            this.language_Code = _data["language_Code"];
            this.description = _data["description"];
            this.detailDescription = _data["detailDescription"];
        }
    }

    static fromJS(data: any): FoodItemTranslationDto {
        data = typeof data === 'object' ? data : {};
        let result = new FoodItemTranslationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["foodItem_ID"] = this.foodItem_ID;
        data["language_Name"] = this.language_Name;
        data["language_Code"] = this.language_Code;
        data["description"] = this.description;
        data["detailDescription"] = this.detailDescription;
        return data;
    }
}

export interface IFoodItemTranslationDto {
    foodItem_ID?: string;
    language_Name?: string | undefined;
    language_Code?: string | undefined;
    description?: string | undefined;
    detailDescription?: string | undefined;
}

export class FoodItemTranslationSyncRequest implements IFoodItemTranslationSyncRequest {
    foodItem_ID?: string;
    language_Code?: string | undefined;
    description?: string | undefined;
    detailDescription?: string | undefined;

    constructor(data?: IFoodItemTranslationSyncRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.foodItem_ID = _data["foodItem_ID"];
            this.language_Code = _data["language_Code"];
            this.description = _data["description"];
            this.detailDescription = _data["detailDescription"];
        }
    }

    static fromJS(data: any): FoodItemTranslationSyncRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FoodItemTranslationSyncRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["foodItem_ID"] = this.foodItem_ID;
        data["language_Code"] = this.language_Code;
        data["description"] = this.description;
        data["detailDescription"] = this.detailDescription;
        return data;
    }
}

export interface IFoodItemTranslationSyncRequest {
    foodItem_ID?: string;
    language_Code?: string | undefined;
    description?: string | undefined;
    detailDescription?: string | undefined;
}

export class Device implements IDevice {
    id?: string;
    name?: string | undefined;
    stationNumber?: string | undefined;
    storeName?: string | undefined;
    storeId?: number | undefined;

    constructor(data?: IDevice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.stationNumber = _data["stationNumber"];
            this.storeName = _data["storeName"];
            this.storeId = _data["storeId"];
        }
    }

    static fromJS(data: any): Device {
        data = typeof data === 'object' ? data : {};
        let result = new Device();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["stationNumber"] = this.stationNumber;
        data["storeName"] = this.storeName;
        data["storeId"] = this.storeId;
        return data;
    }
}

export interface IDevice {
    id?: string;
    name?: string | undefined;
    stationNumber?: string | undefined;
    storeName?: string | undefined;
    storeId?: number | undefined;
}

export class DeviceRecord implements IDeviceRecord {
    id?: number;
    beginTime?: Date;
    endTime?: Date;
    link?: string | undefined;
    deviceId?: string | undefined;

    constructor(data?: IDeviceRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.beginTime = _data["beginTime"] ? new Date(_data["beginTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? new Date(_data["endTime"].toString()) : <any>undefined;
            this.link = _data["link"];
            this.deviceId = _data["deviceId"];
        }
    }

    static fromJS(data: any): DeviceRecord {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["beginTime"] = this.beginTime ? this.beginTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        data["link"] = this.link;
        data["deviceId"] = this.deviceId;
        return data;
    }
}

export interface IDeviceRecord {
    id?: number;
    beginTime?: Date;
    endTime?: Date;
    link?: string | undefined;
    deviceId?: string | undefined;
}

export class PagedResultOfTranslationRow implements IPagedResultOfTranslationRow {
    items?: TranslationRow[];
    total?: number;
    page?: number;
    pageSize?: number;

    constructor(data?: IPagedResultOfTranslationRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TranslationRow.fromJS(item));
            }
            this.total = _data["total"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): PagedResultOfTranslationRow {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultOfTranslationRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        data["total"] = this.total;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IPagedResultOfTranslationRow {
    items?: TranslationRow[];
    total?: number;
    page?: number;
    pageSize?: number;
}

export class TranslationRow implements ITranslationRow {
    id?: number;
    key?: string;
    value?: string;

    constructor(data?: ITranslationRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): TranslationRow {
        data = typeof data === 'object' ? data : {};
        let result = new TranslationRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface ITranslationRow {
    id?: number;
    key?: string;
    value?: string;
}

export enum I18nAppCode {
    None = "None",
    Deliordering = "Deliordering",
}

export class GetProductResponse implements IGetProductResponse {
    product?: Product2 | undefined;

    constructor(data?: IGetProductResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.product = _data["product"] ? Product2.fromJS(_data["product"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetProductResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProductResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetProductResponse {
    product?: Product2 | undefined;
}

export class Product2 implements IProduct2 {
    id?: string;
    upc?: string | undefined;
    description?: string | undefined;
    pricebase?: number;
    price?: number;
    randomWeightPrice?: number;
    enableSingleSplitPrice?: boolean;
    singleSplitPrice?: number;
    imageURI?: string | undefined;
    size?: string | undefined;
    wic?: boolean;
    scale?: boolean;
    pauseWeight?: boolean;
    tare?: boolean;
    vendorNumber?: string | undefined;
    unitCost?: number;
    qtyincase?: number;
    caseCost?: number;
    aisle?: Selectitem | undefined;
    discontinued?: boolean;
    inactiveEStore?: boolean;
    promos?: Promotion[];
    vendor?: Selectitem | undefined;
    department?: Selectitem | undefined;
    mixcode?: Selectitem | undefined;
    deposit?: Selectitem | undefined;
    brand?: Selectitem | undefined;
    scaleMode?: Selectitem | undefined;
    tax?: Selectitem[];
    uom?: Selectitem | undefined;
    cvv?: Selectitem | undefined;
    ebt?: Selectitem | undefined;
    _01_TaxesJson?: string | undefined;
    _02_DepartmentTax?: string | undefined;

    constructor(data?: IProduct2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.upc = _data["upc"];
            this.description = _data["description"];
            this.pricebase = _data["pricebase"];
            this.price = _data["price"];
            this.randomWeightPrice = _data["randomWeightPrice"];
            this.enableSingleSplitPrice = _data["enableSingleSplitPrice"];
            this.singleSplitPrice = _data["singleSplitPrice"];
            this.imageURI = _data["imageURI"];
            this.size = _data["size"];
            this.wic = _data["wic"];
            this.scale = _data["scale"];
            this.pauseWeight = _data["pauseWeight"];
            this.tare = _data["tare"];
            this.vendorNumber = _data["vendorNumber"];
            this.unitCost = _data["unitCost"];
            this.qtyincase = _data["qtyincase"];
            this.caseCost = _data["caseCost"];
            this.aisle = _data["aisle"] ? Selectitem.fromJS(_data["aisle"]) : <any>undefined;
            this.discontinued = _data["discontinued"];
            this.inactiveEStore = _data["inactiveEStore"];
            if (Array.isArray(_data["promos"])) {
                this.promos = [] as any;
                for (let item of _data["promos"])
                    this.promos!.push(Promotion.fromJS(item));
            }
            this.vendor = _data["vendor"] ? Selectitem.fromJS(_data["vendor"]) : <any>undefined;
            this.department = _data["department"] ? Selectitem.fromJS(_data["department"]) : <any>undefined;
            this.mixcode = _data["mixcode"] ? Selectitem.fromJS(_data["mixcode"]) : <any>undefined;
            this.deposit = _data["deposit"] ? Selectitem.fromJS(_data["deposit"]) : <any>undefined;
            this.brand = _data["brand"] ? Selectitem.fromJS(_data["brand"]) : <any>undefined;
            this.scaleMode = _data["scaleMode"] ? Selectitem.fromJS(_data["scaleMode"]) : <any>undefined;
            if (Array.isArray(_data["tax"])) {
                this.tax = [] as any;
                for (let item of _data["tax"])
                    this.tax!.push(Selectitem.fromJS(item));
            }
            this.uom = _data["uom"] ? Selectitem.fromJS(_data["uom"]) : <any>undefined;
            this.cvv = _data["cvv"] ? Selectitem.fromJS(_data["cvv"]) : <any>undefined;
            this.ebt = _data["ebt"] ? Selectitem.fromJS(_data["ebt"]) : <any>undefined;
            this._01_TaxesJson = _data["_01_TaxesJson"];
            this._02_DepartmentTax = _data["_02_DepartmentTax"];
        }
    }

    static fromJS(data: any): Product2 {
        data = typeof data === 'object' ? data : {};
        let result = new Product2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["upc"] = this.upc;
        data["description"] = this.description;
        data["pricebase"] = this.pricebase;
        data["price"] = this.price;
        data["randomWeightPrice"] = this.randomWeightPrice;
        data["enableSingleSplitPrice"] = this.enableSingleSplitPrice;
        data["singleSplitPrice"] = this.singleSplitPrice;
        data["imageURI"] = this.imageURI;
        data["size"] = this.size;
        data["wic"] = this.wic;
        data["scale"] = this.scale;
        data["pauseWeight"] = this.pauseWeight;
        data["tare"] = this.tare;
        data["vendorNumber"] = this.vendorNumber;
        data["unitCost"] = this.unitCost;
        data["qtyincase"] = this.qtyincase;
        data["caseCost"] = this.caseCost;
        data["aisle"] = this.aisle ? this.aisle.toJSON() : <any>undefined;
        data["discontinued"] = this.discontinued;
        data["inactiveEStore"] = this.inactiveEStore;
        if (Array.isArray(this.promos)) {
            data["promos"] = [];
            for (let item of this.promos)
                data["promos"].push(item ? item.toJSON() : <any>undefined);
        }
        data["vendor"] = this.vendor ? this.vendor.toJSON() : <any>undefined;
        data["department"] = this.department ? this.department.toJSON() : <any>undefined;
        data["mixcode"] = this.mixcode ? this.mixcode.toJSON() : <any>undefined;
        data["deposit"] = this.deposit ? this.deposit.toJSON() : <any>undefined;
        data["brand"] = this.brand ? this.brand.toJSON() : <any>undefined;
        data["scaleMode"] = this.scaleMode ? this.scaleMode.toJSON() : <any>undefined;
        if (Array.isArray(this.tax)) {
            data["tax"] = [];
            for (let item of this.tax)
                data["tax"].push(item ? item.toJSON() : <any>undefined);
        }
        data["uom"] = this.uom ? this.uom.toJSON() : <any>undefined;
        data["cvv"] = this.cvv ? this.cvv.toJSON() : <any>undefined;
        data["ebt"] = this.ebt ? this.ebt.toJSON() : <any>undefined;
        data["_01_TaxesJson"] = this._01_TaxesJson;
        data["_02_DepartmentTax"] = this._02_DepartmentTax;
        return data;
    }
}

export interface IProduct2 {
    id?: string;
    upc?: string | undefined;
    description?: string | undefined;
    pricebase?: number;
    price?: number;
    randomWeightPrice?: number;
    enableSingleSplitPrice?: boolean;
    singleSplitPrice?: number;
    imageURI?: string | undefined;
    size?: string | undefined;
    wic?: boolean;
    scale?: boolean;
    pauseWeight?: boolean;
    tare?: boolean;
    vendorNumber?: string | undefined;
    unitCost?: number;
    qtyincase?: number;
    caseCost?: number;
    aisle?: Selectitem | undefined;
    discontinued?: boolean;
    inactiveEStore?: boolean;
    promos?: Promotion[];
    vendor?: Selectitem | undefined;
    department?: Selectitem | undefined;
    mixcode?: Selectitem | undefined;
    deposit?: Selectitem | undefined;
    brand?: Selectitem | undefined;
    scaleMode?: Selectitem | undefined;
    tax?: Selectitem[];
    uom?: Selectitem | undefined;
    cvv?: Selectitem | undefined;
    ebt?: Selectitem | undefined;
    _01_TaxesJson?: string | undefined;
    _02_DepartmentTax?: string | undefined;
}

export class Selectitem implements ISelectitem {
    value?: string | undefined;
    text?: string | undefined;

    constructor(data?: ISelectitem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): Selectitem {
        data = typeof data === 'object' ? data : {};
        let result = new Selectitem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["text"] = this.text;
        return data;
    }
}

export interface ISelectitem {
    value?: string | undefined;
    text?: string | undefined;
}

export class Promotion implements IPromotion {
    promoDate?: string | undefined;
    price?: string | undefined;
    customerLevel?: string | undefined;
    limit?: string | undefined;
    promoType?: Type;
    singleSplitPrice?: number;
    _02_PromoType?: number | undefined;

    constructor(data?: IPromotion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.promoDate = _data["promoDate"];
            this.price = _data["price"];
            this.customerLevel = _data["customerLevel"];
            this.limit = _data["limit"];
            this.promoType = _data["promoType"];
            this.singleSplitPrice = _data["singleSplitPrice"];
            this._02_PromoType = _data["_02_PromoType"];
        }
    }

    static fromJS(data: any): Promotion {
        data = typeof data === 'object' ? data : {};
        let result = new Promotion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["promoDate"] = this.promoDate;
        data["price"] = this.price;
        data["customerLevel"] = this.customerLevel;
        data["limit"] = this.limit;
        data["promoType"] = this.promoType;
        data["singleSplitPrice"] = this.singleSplitPrice;
        data["_02_PromoType"] = this._02_PromoType;
        return data;
    }
}

export interface IPromotion {
    promoDate?: string | undefined;
    price?: string | undefined;
    customerLevel?: string | undefined;
    limit?: string | undefined;
    promoType?: Type;
    singleSplitPrice?: number;
    _02_PromoType?: number | undefined;
}

export enum Type {
    Current = "Current",
    Future = "Future",
}

export class TransferMixcodeBodyDto implements ITransferMixcodeBodyDto {
    currentStore!: number;
    targentStore!: number;
    mixcodes?: string[];

    constructor(data?: ITransferMixcodeBodyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentStore = _data["currentStore"];
            this.targentStore = _data["targentStore"];
            if (Array.isArray(_data["mixcodes"])) {
                this.mixcodes = [] as any;
                for (let item of _data["mixcodes"])
                    this.mixcodes!.push(item);
            }
        }
    }

    static fromJS(data: any): TransferMixcodeBodyDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransferMixcodeBodyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentStore"] = this.currentStore;
        data["targentStore"] = this.targentStore;
        if (Array.isArray(this.mixcodes)) {
            data["mixcodes"] = [];
            for (let item of this.mixcodes)
                data["mixcodes"].push(item);
        }
        return data;
    }
}

export interface ITransferMixcodeBodyDto {
    currentStore: number;
    targentStore: number;
    mixcodes?: string[];
}

export class AVSResponse implements IAVSResponse {
    response!: Response5;
    nbInternalTrace!: NationsInternalTrace;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;

    constructor(data?: IAVSResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.response = new Response5();
            this.nbInternalTrace = new NationsInternalTrace();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.response = _data["response"] ? Response5.fromJS(_data["response"]) : new Response5();
            this.nbInternalTrace = _data["nbInternalTrace"] ? NationsInternalTrace.fromJS(_data["nbInternalTrace"]) : new NationsInternalTrace();
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): AVSResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AVSResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["response"] = this.response ? this.response.toJSON() : <any>undefined;
        data["nbInternalTrace"] = this.nbInternalTrace ? this.nbInternalTrace.toJSON() : <any>undefined;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        return data;
    }
}

export interface IAVSResponse {
    response: Response5;
    nbInternalTrace: NationsInternalTrace;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;
}

export class Response5 implements IResponse5 {
    memberIDs?: Member[] | undefined;
    /** Additional status information in human readable form */
    status?: string | undefined;
    /** Additional status information */
    code?: string | undefined;
    details?: ExceptionDetails | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;

    constructor(data?: IResponse5) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["memberIDs"])) {
                this.memberIDs = [] as any;
                for (let item of _data["memberIDs"])
                    this.memberIDs!.push(Member.fromJS(item));
            }
            this.status = _data["status"];
            this.code = _data["code"];
            this.details = _data["details"] ? ExceptionDetails.fromJS(_data["details"]) : <any>undefined;
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): Response5 {
        data = typeof data === 'object' ? data : {};
        let result = new Response5();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.memberIDs)) {
            data["memberIDs"] = [];
            for (let item of this.memberIDs)
                data["memberIDs"].push(item ? item.toJSON() : <any>undefined);
        }
        data["status"] = this.status;
        data["code"] = this.code;
        data["details"] = this.details ? this.details.toJSON() : <any>undefined;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        return data;
    }
}

export interface IResponse5 {
    memberIDs?: Member[] | undefined;
    /** Additional status information in human readable form */
    status?: string | undefined;
    /** Additional status information */
    code?: string | undefined;
    details?: ExceptionDetails | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;
}

export class Member implements IMember {
    /** The type of identifier for the member.  Note that the panHashId and trackOneId must be in SHA-256 UTF-8 Format. */
    uidType!: MemberUidType;
    /** The unique NationsBenefits identifier for the member. */
    uid!: string;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;

    constructor(data?: IMember) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.uidType = _data["uidType"];
            this.uid = _data["uid"];
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): Member {
        data = typeof data === 'object' ? data : {};
        let result = new Member();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["uidType"] = this.uidType;
        data["uid"] = this.uid;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        return data;
    }
}

export interface IMember {
    /** The type of identifier for the member.  Note that the panHashId and trackOneId must be in SHA-256 UTF-8 Format. */
    uidType: MemberUidType;
    /** The unique NationsBenefits identifier for the member. */
    uid: string;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;
}

export enum MemberUidType {
    PanHashId = "panHashId",
    TrackTwoId = "trackTwoId",
    TrackOneId = "trackOneId",
    ClientMemberId = "clientMemberId",
    QrCodeId = "qrCodeId",
}

export class ExceptionDetails implements IExceptionDetails {
    /** Message element experiencing an error condition */
    propertyName!: string;
    /** Reason that message element is experiencing an error condition */
    errorMessage!: string;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;

    constructor(data?: IExceptionDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.propertyName = _data["propertyName"];
            this.errorMessage = _data["errorMessage"];
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): ExceptionDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ExceptionDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["propertyName"] = this.propertyName;
        data["errorMessage"] = this.errorMessage;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        return data;
    }
}

export interface IExceptionDetails {
    /** Message element experiencing an error condition */
    propertyName: string;
    /** Reason that message element is experiencing an error condition */
    errorMessage: string;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;
}

/** Object for internal NationsBenefits for developer and debugging purposes */
export class NationsInternalTrace implements INationsInternalTrace {
    /** Nations Internal Code used for debugging. */
    statusCode!: string;
    /** A unique ID generated by Nations for tracing. */
    traceId!: string;
    traceIdDate!: Date;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;

    constructor(data?: INationsInternalTrace) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.statusCode = _data["statusCode"];
            this.traceId = _data["traceId"];
            this.traceIdDate = _data["traceIdDate"] ? new Date(_data["traceIdDate"].toString()) : <any>undefined;
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): NationsInternalTrace {
        data = typeof data === 'object' ? data : {};
        let result = new NationsInternalTrace();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["statusCode"] = this.statusCode;
        data["traceId"] = this.traceId;
        data["traceIdDate"] = this.traceIdDate ? this.traceIdDate.toISOString() : <any>undefined;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        return data;
    }
}

/** Object for internal NationsBenefits for developer and debugging purposes */
export interface INationsInternalTrace {
    /** Nations Internal Code used for debugging. */
    statusCode: string;
    /** A unique ID generated by Nations for tracing. */
    traceId: string;
    traceIdDate: Date;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;
}

export class AVSRequest implements IAVSRequest {
    /** Card PAN in SHA-256 UTF-8 Format */
    pan!: string;
    /** Card CVV in SHA-256 UTF-8 Format */
    cvv!: string;
    /** Expiration date from card in format MM/YY */
    expiration!: string;
    additionalInfo!: AdditionalAVSData[];
    entryMode?: AVSRequestEntryMode | undefined;
    merchant!: Merchant;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;

    constructor(data?: IAVSRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.additionalInfo = [];
            this.merchant = new Merchant();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.pan = _data["pan"];
            this.cvv = _data["cvv"];
            this.expiration = _data["expiration"];
            if (Array.isArray(_data["additionalInfo"])) {
                this.additionalInfo = [] as any;
                for (let item of _data["additionalInfo"])
                    this.additionalInfo!.push(AdditionalAVSData.fromJS(item));
            }
            this.entryMode = _data["entryMode"];
            this.merchant = _data["merchant"] ? Merchant.fromJS(_data["merchant"]) : new Merchant();
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): AVSRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AVSRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["pan"] = this.pan;
        data["cvv"] = this.cvv;
        data["expiration"] = this.expiration;
        if (Array.isArray(this.additionalInfo)) {
            data["additionalInfo"] = [];
            for (let item of this.additionalInfo)
                data["additionalInfo"].push(item ? item.toJSON() : <any>undefined);
        }
        data["entryMode"] = this.entryMode;
        data["merchant"] = this.merchant ? this.merchant.toJSON() : <any>undefined;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        return data;
    }
}

export interface IAVSRequest {
    /** Card PAN in SHA-256 UTF-8 Format */
    pan: string;
    /** Card CVV in SHA-256 UTF-8 Format */
    cvv: string;
    /** Expiration date from card in format MM/YY */
    expiration: string;
    additionalInfo: AdditionalAVSData[];
    entryMode?: AVSRequestEntryMode | undefined;
    merchant: Merchant;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;
}

export class AdditionalAVSData implements IAdditionalAVSData {
    dataType!: AdditionalAVSDataDataType;
    value!: string;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;

    constructor(data?: IAdditionalAVSData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.dataType = _data["dataType"];
            this.value = _data["value"];
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): AdditionalAVSData {
        data = typeof data === 'object' ? data : {};
        let result = new AdditionalAVSData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["dataType"] = this.dataType;
        data["value"] = this.value;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        return data;
    }
}

export interface IAdditionalAVSData {
    dataType: AdditionalAVSDataDataType;
    value: string;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;
}

export enum AdditionalAVSDataDataType {
    BillingZipCode = "billingZipCode",
    DateOfBirth = "dateOfBirth",
}

export enum AVSRequestEntryMode {
    Swipe = "swipe",
    Dip = "dip",
    Tap = "tap",
    Keyed = "keyed",
    Stored = "stored",
}

export class Merchant implements IMerchant {
    /** The unique identifier for the parent entity of the retailer or the processing entity. */
    entityId!: string;
    /** The unique identifier for the store. */
    storeId!: string;
    /** The identifier for the terminal. */
    terminalId?: string | undefined;
    /** The merchant category code. */
    mcc?: string | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;

    constructor(data?: IMerchant) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.entityId = _data["entityId"];
            this.storeId = _data["storeId"];
            this.terminalId = _data["terminalId"];
            this.mcc = _data["mcc"];
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): Merchant {
        data = typeof data === 'object' ? data : {};
        let result = new Merchant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["entityId"] = this.entityId;
        data["storeId"] = this.storeId;
        data["terminalId"] = this.terminalId;
        data["mcc"] = this.mcc;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        return data;
    }
}

export interface IMerchant {
    /** The unique identifier for the parent entity of the retailer or the processing entity. */
    entityId: string;
    /** The unique identifier for the store. */
    storeId: string;
    /** The identifier for the terminal. */
    terminalId?: string | undefined;
    /** The merchant category code. */
    mcc?: string | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;
}

export class BIResponse implements IBIResponse {
    response!: Response6;
    nbInternalTrace!: NationsInternalTrace;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;

    constructor(data?: IBIResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.response = new Response6();
            this.nbInternalTrace = new NationsInternalTrace();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.response = _data["response"] ? Response6.fromJS(_data["response"]) : new Response6();
            this.nbInternalTrace = _data["nbInternalTrace"] ? NationsInternalTrace.fromJS(_data["nbInternalTrace"]) : new NationsInternalTrace();
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): BIResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BIResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["response"] = this.response ? this.response.toJSON() : <any>undefined;
        data["nbInternalTrace"] = this.nbInternalTrace ? this.nbInternalTrace.toJSON() : <any>undefined;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        return data;
    }
}

export interface IBIResponse {
    response: Response6;
    nbInternalTrace: NationsInternalTrace;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;
}

export class Response6 implements IResponse6 {
    balances?: BalanceItem[] | undefined;
    /** Additional status information in human readable form */
    status?: string | undefined;
    /** Additional status information */
    code?: string | undefined;
    applicationVersion?: string | undefined;
    last4Card?: string | undefined;
    cardStatus?: string | undefined;
    details?: ExceptionDetails | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;

    constructor(data?: IResponse6) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["balances"])) {
                this.balances = [] as any;
                for (let item of _data["balances"])
                    this.balances!.push(BalanceItem.fromJS(item));
            }
            this.status = _data["status"];
            this.code = _data["code"];
            this.applicationVersion = _data["applicationVersion"];
            this.last4Card = _data["last4Card"];
            this.cardStatus = _data["cardStatus"];
            this.details = _data["details"] ? ExceptionDetails.fromJS(_data["details"]) : <any>undefined;
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): Response6 {
        data = typeof data === 'object' ? data : {};
        let result = new Response6();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.balances)) {
            data["balances"] = [];
            for (let item of this.balances)
                data["balances"].push(item ? item.toJSON() : <any>undefined);
        }
        data["status"] = this.status;
        data["code"] = this.code;
        data["applicationVersion"] = this.applicationVersion;
        data["last4Card"] = this.last4Card;
        data["cardStatus"] = this.cardStatus;
        data["details"] = this.details ? this.details.toJSON() : <any>undefined;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        return data;
    }
}

export interface IResponse6 {
    balances?: BalanceItem[] | undefined;
    /** Additional status information in human readable form */
    status?: string | undefined;
    /** Additional status information */
    code?: string | undefined;
    applicationVersion?: string | undefined;
    last4Card?: string | undefined;
    cardStatus?: string | undefined;
    details?: ExceptionDetails | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;
}

export class BalanceItem implements IBalanceItem {
    /** Internal purse identifier */
    purseId!: string;
    /** The human readable name of the purse (e.g. "OTC", "Healthy Living") */
    purseName?: string | undefined;
    /** Relative priority for this purse, lower is higher priority */
    priority?: number | undefined;
    /** The current amount in the purse. */
    amount?: number;
    /** The currency code for the transaction. */
    currencyCode?: BalanceItemCurrencyCode | undefined;
    /** The date when the balance will expire (e.g., "2023-07-19"). Note that these dates will be in ET.  This value may be omitted. */
    expiration?: string | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;

    constructor(data?: IBalanceItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.purseId = _data["purseId"];
            this.purseName = _data["purseName"];
            this.priority = _data["priority"];
            this.amount = _data["amount"];
            this.currencyCode = _data["currencyCode"];
            this.expiration = _data["expiration"];
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): BalanceItem {
        data = typeof data === 'object' ? data : {};
        let result = new BalanceItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["purseId"] = this.purseId;
        data["purseName"] = this.purseName;
        data["priority"] = this.priority;
        data["amount"] = this.amount;
        data["currencyCode"] = this.currencyCode;
        data["expiration"] = this.expiration;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        return data;
    }
}

export interface IBalanceItem {
    /** Internal purse identifier */
    purseId: string;
    /** The human readable name of the purse (e.g. "OTC", "Healthy Living") */
    purseName?: string | undefined;
    /** Relative priority for this purse, lower is higher priority */
    priority?: number | undefined;
    /** The current amount in the purse. */
    amount?: number;
    /** The currency code for the transaction. */
    currencyCode?: BalanceItemCurrencyCode | undefined;
    /** The date when the balance will expire (e.g., "2023-07-19"). Note that these dates will be in ET.  This value may be omitted. */
    expiration?: string | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;
}

export enum BalanceItemCurrencyCode {
    USD = "USD",
    CAD = "CAD",
}

export class BIRequest implements IBIRequest {
    member!: Member;
    merchant!: Merchant;
    applicationVersion?: string | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;

    constructor(data?: IBIRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.member = new Member();
            this.merchant = new Merchant();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.member = _data["member"] ? Member.fromJS(_data["member"]) : new Member();
            this.merchant = _data["merchant"] ? Merchant.fromJS(_data["merchant"]) : new Merchant();
            this.applicationVersion = _data["applicationVersion"];
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): BIRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BIRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        data["merchant"] = this.merchant ? this.merchant.toJSON() : <any>undefined;
        data["applicationVersion"] = this.applicationVersion;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        return data;
    }
}

export interface IBIRequest {
    member: Member;
    merchant: Merchant;
    applicationVersion?: string | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;
}

export class AnalyzeResponse implements IAnalyzeResponse {
    response!: Authorization;
    nbInternalTrace!: NationsInternalTrace;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;

    constructor(data?: IAnalyzeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.response = new Authorization();
            this.nbInternalTrace = new NationsInternalTrace();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.response = _data["response"] ? Authorization.fromJS(_data["response"]) : new Authorization();
            this.nbInternalTrace = _data["nbInternalTrace"] ? NationsInternalTrace.fromJS(_data["nbInternalTrace"]) : new NationsInternalTrace();
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): AnalyzeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AnalyzeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["response"] = this.response ? this.response.toJSON() : <any>undefined;
        data["nbInternalTrace"] = this.nbInternalTrace ? this.nbInternalTrace.toJSON() : <any>undefined;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        return data;
    }
}

export interface IAnalyzeResponse {
    response: Authorization;
    nbInternalTrace: NationsInternalTrace;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;
}

export class Authorization implements IAuthorization {
    /** Retailer generated unique identifier for the transaction. */
    merchantTransactionId!: string;
    /** The unique identifier for the transaction generated by Nations. */
    nationsBenefitsTransactionId!: string;
    /** The total authorized transaction amount (includes tax and refundable deposits). */
    authorizedTransactionAmount?: number;
    /** Authorization reason provides detailed information about the transaction status */
    status!: string;
    /** Authorization code represents the status of the transaction */
    code!: string;
    /** The details of authorization at a line item level. */
    authorizationDetails!: AuthLineItemDetails[];
    /** Array of purse utilization details. */
    purseUtilization!: PurseUsage[];
    /** Maximum amount that will be funded for this transaction to allow for retailer funding options. */
    maxFundingAmount?: number | undefined;
    details?: ExceptionDetails | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;

    constructor(data?: IAuthorization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.authorizationDetails = [];
            this.purseUtilization = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.merchantTransactionId = _data["merchantTransactionId"];
            this.nationsBenefitsTransactionId = _data["nationsBenefitsTransactionId"];
            this.authorizedTransactionAmount = _data["authorizedTransactionAmount"];
            this.status = _data["status"];
            this.code = _data["code"];
            if (Array.isArray(_data["authorizationDetails"])) {
                this.authorizationDetails = [] as any;
                for (let item of _data["authorizationDetails"])
                    this.authorizationDetails!.push(AuthLineItemDetails.fromJS(item));
            }
            if (Array.isArray(_data["purseUtilization"])) {
                this.purseUtilization = [] as any;
                for (let item of _data["purseUtilization"])
                    this.purseUtilization!.push(PurseUsage.fromJS(item));
            }
            this.maxFundingAmount = _data["maxFundingAmount"];
            this.details = _data["details"] ? ExceptionDetails.fromJS(_data["details"]) : <any>undefined;
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): Authorization {
        data = typeof data === 'object' ? data : {};
        let result = new Authorization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["merchantTransactionId"] = this.merchantTransactionId;
        data["nationsBenefitsTransactionId"] = this.nationsBenefitsTransactionId;
        data["authorizedTransactionAmount"] = this.authorizedTransactionAmount;
        data["status"] = this.status;
        data["code"] = this.code;
        if (Array.isArray(this.authorizationDetails)) {
            data["authorizationDetails"] = [];
            for (let item of this.authorizationDetails)
                data["authorizationDetails"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.purseUtilization)) {
            data["purseUtilization"] = [];
            for (let item of this.purseUtilization)
                data["purseUtilization"].push(item ? item.toJSON() : <any>undefined);
        }
        data["maxFundingAmount"] = this.maxFundingAmount;
        data["details"] = this.details ? this.details.toJSON() : <any>undefined;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        return data;
    }
}

export interface IAuthorization {
    /** Retailer generated unique identifier for the transaction. */
    merchantTransactionId: string;
    /** The unique identifier for the transaction generated by Nations. */
    nationsBenefitsTransactionId: string;
    /** The total authorized transaction amount (includes tax and refundable deposits). */
    authorizedTransactionAmount?: number;
    /** Authorization reason provides detailed information about the transaction status */
    status: string;
    /** Authorization code represents the status of the transaction */
    code: string;
    /** The details of authorization at a line item level. */
    authorizationDetails: AuthLineItemDetails[];
    /** Array of purse utilization details. */
    purseUtilization: PurseUsage[];
    /** Maximum amount that will be funded for this transaction to allow for retailer funding options. */
    maxFundingAmount?: number | undefined;
    details?: ExceptionDetails | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;
}

export class AuthLineItemDetails implements IAuthLineItemDetails {
    /** The line item number. */
    lineItemNumber?: number;
    /** The product code as passed in the request for the line item. */
    productCode!: string;
    /** The product code type as passed in the request for the line item. */
    productCodeType!: string;
    /** The authorized transaction amount (does not include tax and refundable deposits) for this line item. */
    authorizedAmountBeforeTax?: number;
    /** The authorized tax for this line item. */
    authorizedTax?: number;
    /** The authorized fee for this line item. */
    authorizedFees?: number;
    /** Summary of the authorization. */
    authResult!: AuthLineItemDetailsAuthResult;
    /** The name of the benefit type authorized for this line item. NA = No Benefit. */
    benefitName!: string;
    /** Authorization code represents the status of the transaction */
    code?: number;
    /** Authorization reason provides detailed information about the transaction status */
    status!: string;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;

    constructor(data?: IAuthLineItemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.lineItemNumber = _data["lineItemNumber"];
            this.productCode = _data["productCode"];
            this.productCodeType = _data["productCodeType"];
            this.authorizedAmountBeforeTax = _data["authorizedAmountBeforeTax"];
            this.authorizedTax = _data["authorizedTax"];
            this.authorizedFees = _data["authorizedFees"];
            this.authResult = _data["authResult"];
            this.benefitName = _data["benefitName"];
            this.code = _data["code"];
            this.status = _data["status"];
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): AuthLineItemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new AuthLineItemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["lineItemNumber"] = this.lineItemNumber;
        data["productCode"] = this.productCode;
        data["productCodeType"] = this.productCodeType;
        data["authorizedAmountBeforeTax"] = this.authorizedAmountBeforeTax;
        data["authorizedTax"] = this.authorizedTax;
        data["authorizedFees"] = this.authorizedFees;
        data["authResult"] = this.authResult;
        data["benefitName"] = this.benefitName;
        data["code"] = this.code;
        data["status"] = this.status;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        return data;
    }
}

export interface IAuthLineItemDetails {
    /** The line item number. */
    lineItemNumber?: number;
    /** The product code as passed in the request for the line item. */
    productCode: string;
    /** The product code type as passed in the request for the line item. */
    productCodeType: string;
    /** The authorized transaction amount (does not include tax and refundable deposits) for this line item. */
    authorizedAmountBeforeTax?: number;
    /** The authorized tax for this line item. */
    authorizedTax?: number;
    /** The authorized fee for this line item. */
    authorizedFees?: number;
    /** Summary of the authorization. */
    authResult: AuthLineItemDetailsAuthResult;
    /** The name of the benefit type authorized for this line item. NA = No Benefit. */
    benefitName: string;
    /** Authorization code represents the status of the transaction */
    code?: number;
    /** Authorization reason provides detailed information about the transaction status */
    status: string;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;
}

export enum AuthLineItemDetailsAuthResult {
    APPROVED = "APPROVED",
    DECLINED = "DECLINED",
    APPROVED_PARTIAL = "APPROVED_PARTIAL",
}

export class PurseUsage implements IPurseUsage {
    /** Name of the purse. */
    purseName?: string | undefined;
    /** Amount used from the purse. */
    amountUsed?: number | undefined;
    /** Remaining balance in the purse. */
    remainingBalance?: number | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;

    constructor(data?: IPurseUsage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.purseName = _data["purseName"];
            this.amountUsed = _data["amountUsed"];
            this.remainingBalance = _data["remainingBalance"];
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): PurseUsage {
        data = typeof data === 'object' ? data : {};
        let result = new PurseUsage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["purseName"] = this.purseName;
        data["amountUsed"] = this.amountUsed;
        data["remainingBalance"] = this.remainingBalance;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        return data;
    }
}

export interface IPurseUsage {
    /** Name of the purse. */
    purseName?: string | undefined;
    /** Amount used from the purse. */
    amountUsed?: number | undefined;
    /** Remaining balance in the purse. */
    remainingBalance?: number | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;
}

export class AnalyzeRequest implements IAnalyzeRequest {
    member!: Member;
    merchant!: Merchant;
    transaction!: Transaction;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;

    constructor(data?: IAnalyzeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.member = new Member();
            this.merchant = new Merchant();
            this.transaction = new Transaction();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.member = _data["member"] ? Member.fromJS(_data["member"]) : new Member();
            this.merchant = _data["merchant"] ? Merchant.fromJS(_data["merchant"]) : new Merchant();
            this.transaction = _data["transaction"] ? Transaction.fromJS(_data["transaction"]) : new Transaction();
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): AnalyzeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AnalyzeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["member"] = this.member ? this.member.toJSON() : <any>undefined;
        data["merchant"] = this.merchant ? this.merchant.toJSON() : <any>undefined;
        data["transaction"] = this.transaction ? this.transaction.toJSON() : <any>undefined;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        return data;
    }
}

export interface IAnalyzeRequest {
    member: Member;
    merchant: Merchant;
    transaction: Transaction;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;
}

export class Transaction implements ITransaction {
    /** Merchant generated unique identifier for the transaction. */
    merchantTransactionId!: string;
    /** ISO 8601; The local date and time when the transaction was made, represented in local time and expressed with its UTC offset (e.g., "2023-07-19T13:20:30+01:00"). */
    transactionLocalDateTime!: string;
    /** The currency code for the transaction. */
    transactionCurrencyCode!: TransactionCurrencyCode;
    lineItems!: LineItem[];
    /** Maximum amount that will be funded for this transaction to allow for retailer funding options.  Note that this feature is not currently supported for mixed transactions. */
    maxFundingAmount?: number | undefined;
    /** The NationsBenefits transaction ID that was used in a related transaction, e.g. eCommerce initial order capture. */
    parentNationsBenefitsTransactionId?: string | undefined;
    /** The name of the retailer at which the transaction was executed. */
    transactionRetailer?: string | undefined;
    transactionRetailerLocation?: RetailerLocation | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;

    constructor(data?: ITransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.lineItems = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.merchantTransactionId = _data["merchantTransactionId"];
            this.transactionLocalDateTime = _data["transactionLocalDateTime"];
            this.transactionCurrencyCode = _data["transactionCurrencyCode"];
            if (Array.isArray(_data["lineItems"])) {
                this.lineItems = [] as any;
                for (let item of _data["lineItems"])
                    this.lineItems!.push(LineItem.fromJS(item));
            }
            this.maxFundingAmount = _data["maxFundingAmount"];
            this.parentNationsBenefitsTransactionId = _data["parentNationsBenefitsTransactionId"];
            this.transactionRetailer = _data["transactionRetailer"];
            this.transactionRetailerLocation = _data["transactionRetailerLocation"] ? RetailerLocation.fromJS(_data["transactionRetailerLocation"]) : <any>undefined;
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): Transaction {
        data = typeof data === 'object' ? data : {};
        let result = new Transaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["merchantTransactionId"] = this.merchantTransactionId;
        data["transactionLocalDateTime"] = this.transactionLocalDateTime;
        data["transactionCurrencyCode"] = this.transactionCurrencyCode;
        if (Array.isArray(this.lineItems)) {
            data["lineItems"] = [];
            for (let item of this.lineItems)
                data["lineItems"].push(item ? item.toJSON() : <any>undefined);
        }
        data["maxFundingAmount"] = this.maxFundingAmount;
        data["parentNationsBenefitsTransactionId"] = this.parentNationsBenefitsTransactionId;
        data["transactionRetailer"] = this.transactionRetailer;
        data["transactionRetailerLocation"] = this.transactionRetailerLocation ? this.transactionRetailerLocation.toJSON() : <any>undefined;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        return data;
    }
}

export interface ITransaction {
    /** Merchant generated unique identifier for the transaction. */
    merchantTransactionId: string;
    /** ISO 8601; The local date and time when the transaction was made, represented in local time and expressed with its UTC offset (e.g., "2023-07-19T13:20:30+01:00"). */
    transactionLocalDateTime: string;
    /** The currency code for the transaction. */
    transactionCurrencyCode: TransactionCurrencyCode;
    lineItems: LineItem[];
    /** Maximum amount that will be funded for this transaction to allow for retailer funding options.  Note that this feature is not currently supported for mixed transactions. */
    maxFundingAmount?: number | undefined;
    /** The NationsBenefits transaction ID that was used in a related transaction, e.g. eCommerce initial order capture. */
    parentNationsBenefitsTransactionId?: string | undefined;
    /** The name of the retailer at which the transaction was executed. */
    transactionRetailer?: string | undefined;
    transactionRetailerLocation?: RetailerLocation | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;
}

export enum TransactionCurrencyCode {
    USD = "USD",
    CAD = "CAD",
}

export class LineItem implements ILineItem {
    /** The line item number. */
    lineItemNumber?: number;
    /** The type of the product code. */
    productCodeType!: LineItemProductCodeType;
    /** The unique product identifier. If the productCodeType = 'CAT_SUBCAT', the code would be a combination of item product category code and sub category code delimited by '|' */
    productCode!: string;
    /** The unit price of the product. This number is positive for sale and negative for a return. */
    unitPrice?: number;
    /** The quantity of the product. If negative value is passed, it will be interpreted as positive. */
    quantity?: number;
    /** The unit of weight or volume for the product. Use 'COUNT' for countable quantities. */
    units!: LineItemUnits;
    /** This array contains tax details for the line item. */
    taxes?: TaxDetails[] | undefined;
    /** This object contains fees such as CRV and Bottle refund details for the line item. */
    fees?: FeesDetails[] | undefined;
    /** This object contains key value pairs provided by retailer to perform custom actions in the request */
    optionalFields?: OptionalFields[] | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;

    constructor(data?: ILineItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.lineItemNumber = _data["lineItemNumber"];
            this.productCodeType = _data["productCodeType"];
            this.productCode = _data["productCode"];
            this.unitPrice = _data["unitPrice"];
            this.quantity = _data["quantity"];
            this.units = _data["units"];
            if (Array.isArray(_data["taxes"])) {
                this.taxes = [] as any;
                for (let item of _data["taxes"])
                    this.taxes!.push(TaxDetails.fromJS(item));
            }
            if (Array.isArray(_data["fees"])) {
                this.fees = [] as any;
                for (let item of _data["fees"])
                    this.fees!.push(FeesDetails.fromJS(item));
            }
            if (Array.isArray(_data["optionalFields"])) {
                this.optionalFields = [] as any;
                for (let item of _data["optionalFields"])
                    this.optionalFields!.push(OptionalFields.fromJS(item));
            }
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): LineItem {
        data = typeof data === 'object' ? data : {};
        let result = new LineItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["lineItemNumber"] = this.lineItemNumber;
        data["productCodeType"] = this.productCodeType;
        data["productCode"] = this.productCode;
        data["unitPrice"] = this.unitPrice;
        data["quantity"] = this.quantity;
        data["units"] = this.units;
        if (Array.isArray(this.taxes)) {
            data["taxes"] = [];
            for (let item of this.taxes)
                data["taxes"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.fees)) {
            data["fees"] = [];
            for (let item of this.fees)
                data["fees"].push(item ? item.toJSON() : <any>undefined);
        }
        if (Array.isArray(this.optionalFields)) {
            data["optionalFields"] = [];
            for (let item of this.optionalFields)
                data["optionalFields"].push(item ? item.toJSON() : <any>undefined);
        }
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        return data;
    }
}

export interface ILineItem {
    /** The line item number. */
    lineItemNumber?: number;
    /** The type of the product code. */
    productCodeType: LineItemProductCodeType;
    /** The unique product identifier. If the productCodeType = 'CAT_SUBCAT', the code would be a combination of item product category code and sub category code delimited by '|' */
    productCode: string;
    /** The unit price of the product. This number is positive for sale and negative for a return. */
    unitPrice?: number;
    /** The quantity of the product. If negative value is passed, it will be interpreted as positive. */
    quantity?: number;
    /** The unit of weight or volume for the product. Use 'COUNT' for countable quantities. */
    units: LineItemUnits;
    /** This array contains tax details for the line item. */
    taxes?: TaxDetails[] | undefined;
    /** This object contains fees such as CRV and Bottle refund details for the line item. */
    fees?: FeesDetails[] | undefined;
    /** This object contains key value pairs provided by retailer to perform custom actions in the request */
    optionalFields?: OptionalFields[] | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;
}

export enum LineItemProductCodeType {
    UPC = "UPC",
    PLU = "PLU",
    GTIN = "GTIN",
    CAT_SUBCAT = "CAT_SUBCAT",
    ICD10 = "ICD10",
    OTHER = "OTHER",
}

export enum LineItemUnits {
    COUNT = "COUNT",
    GM = "GM",
    OZ = "OZ",
    LB = "LB",
    KG = "KG",
    GAL = "GAL",
    FLOZ = "FLOZ",
    L = "L",
    ML = "ML",
}

export class TaxDetails implements ITaxDetails {
    /** Type of tax that is associated with the item.  Examples include SALES, VAT, GST, EXCISE, IMPORT_DUTY, LUXURY, OTHER */
    taxType!: string;
    /** Amount of the specific tax. */
    value?: number;
    /** Total amount of calculated tax amount if calculated by BAS, not necessarily covered by benefits.  Only visible if merchant tax flag set. */
    totalTaxAmount?: number;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;

    constructor(data?: ITaxDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.taxType = _data["taxType"];
            this.value = _data["value"];
            this.totalTaxAmount = _data["totalTaxAmount"];
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): TaxDetails {
        data = typeof data === 'object' ? data : {};
        let result = new TaxDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["taxType"] = this.taxType;
        data["value"] = this.value;
        data["totalTaxAmount"] = this.totalTaxAmount;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        return data;
    }
}

export interface ITaxDetails {
    /** Type of tax that is associated with the item.  Examples include SALES, VAT, GST, EXCISE, IMPORT_DUTY, LUXURY, OTHER */
    taxType: string;
    /** Amount of the specific tax. */
    value?: number;
    /** Total amount of calculated tax amount if calculated by BAS, not necessarily covered by benefits.  Only visible if merchant tax flag set. */
    totalTaxAmount?: number;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;
}

export class FeesDetails implements IFeesDetails {
    /** Type of refundable deposit or other fees associated with an item.  Examples include DEPOSIT, TARE, COST_PLUS, OTHER */
    feeType!: string;
    /** Amount of the specific fees. */
    value?: number;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;

    constructor(data?: IFeesDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.feeType = _data["feeType"];
            this.value = _data["value"];
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): FeesDetails {
        data = typeof data === 'object' ? data : {};
        let result = new FeesDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["feeType"] = this.feeType;
        data["value"] = this.value;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        return data;
    }
}

export interface IFeesDetails {
    /** Type of refundable deposit or other fees associated with an item.  Examples include DEPOSIT, TARE, COST_PLUS, OTHER */
    feeType: string;
    /** Amount of the specific fees. */
    value?: number;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;
}

export class OptionalFields implements IOptionalFields {
    /** Retailer specific option to provide to BAS generally for custom requests */
    name!: string;
    /** Value associated with retailer specific option */
    value!: string;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;

    constructor(data?: IOptionalFields) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.value = _data["value"];
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): OptionalFields {
        data = typeof data === 'object' ? data : {};
        let result = new OptionalFields();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["value"] = this.value;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        return data;
    }
}

export interface IOptionalFields {
    /** Retailer specific option to provide to BAS generally for custom requests */
    name: string;
    /** Value associated with retailer specific option */
    value: string;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;
}

/** The the address of the retailer at which the transaction was executed. */
export class RetailerLocation implements IRetailerLocation {
    /** Retail location first part of street address */
    addressLine1!: string;
    /** Retail location second part of street address */
    addressLine2?: string | undefined;
    /** Retail location city */
    city!: string;
    /** Retail location state */
    state!: string;
    /** Retail location zip */
    zip!: string;
    /** Retail location country */
    country?: string | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;

    constructor(data?: IRetailerLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.country = _data["country"];
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): RetailerLocation {
        data = typeof data === 'object' ? data : {};
        let result = new RetailerLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["country"] = this.country;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        return data;
    }
}

/** The the address of the retailer at which the transaction was executed. */
export interface IRetailerLocation {
    /** Retail location first part of street address */
    addressLine1: string;
    /** Retail location second part of street address */
    addressLine2?: string | undefined;
    /** Retail location city */
    city: string;
    /** Retail location state */
    state: string;
    /** Retail location zip */
    zip: string;
    /** Retail location country */
    country?: string | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;
}

export class RedeemResponse implements IRedeemResponse {
    response!: Response7;
    nbInternalTrace!: NationsInternalTrace;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;

    constructor(data?: IRedeemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.response = new Response7();
            this.nbInternalTrace = new NationsInternalTrace();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.response = _data["response"] ? Response7.fromJS(_data["response"]) : new Response7();
            this.nbInternalTrace = _data["nbInternalTrace"] ? NationsInternalTrace.fromJS(_data["nbInternalTrace"]) : new NationsInternalTrace();
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): RedeemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RedeemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["response"] = this.response ? this.response.toJSON() : <any>undefined;
        data["nbInternalTrace"] = this.nbInternalTrace ? this.nbInternalTrace.toJSON() : <any>undefined;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        return data;
    }
}

export interface IRedeemResponse {
    response: Response7;
    nbInternalTrace: NationsInternalTrace;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;
}

export class Response7 implements IResponse7 {
    /** The unique identifier for the transaction that was generated by NationsBenefits in response to the Analyze call. */
    nationsBenefitsTransactionId?: string | undefined;
    /** The status of the redemption. */
    status?: string | undefined;
    /** The code associated with the redemption status. */
    code?: string | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;

    constructor(data?: IResponse7) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.nationsBenefitsTransactionId = _data["nationsBenefitsTransactionId"];
            this.status = _data["status"];
            this.code = _data["code"];
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): Response7 {
        data = typeof data === 'object' ? data : {};
        let result = new Response7();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["nationsBenefitsTransactionId"] = this.nationsBenefitsTransactionId;
        data["status"] = this.status;
        data["code"] = this.code;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        return data;
    }
}

export interface IResponse7 {
    /** The unique identifier for the transaction that was generated by NationsBenefits in response to the Analyze call. */
    nationsBenefitsTransactionId?: string | undefined;
    /** The status of the redemption. */
    status?: string | undefined;
    /** The code associated with the redemption status. */
    code?: string | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;
}

export class RedeemRequest implements IRedeemRequest {
    /** The unique identifier for the transaction that was generated by NationsBenefits in response to the Analyze call. */
    nationsBenefitsTransactionId!: string;
    /** Type of the redemption transaction. Each type corresponds to different transaction actions internally: - "000": Default type if not provided, often representing generic handshake representing authorized transaction amount redemption from the Issuer (happy-path). - "100": For voiding a previously authorized request/transaction. - "200": For reversing a previously authorized request/transaction. - "300": For voiding an auth, used in the scenarios where the POS/merchant receives an incorrect amount ($) from the Issuer. Defaults to '000' if not provided. */
    redeemType?: RedeemRequestRedeemType | undefined;
    /** The redeemed amount. */
    redeemedAmount?: number;
    /** Optional data field for the merchant to send additional information. */
    merchantDiscretionaryData?: string | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;

    constructor(data?: IRedeemRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.nationsBenefitsTransactionId = _data["nationsBenefitsTransactionId"];
            this.redeemType = _data["redeemType"];
            this.redeemedAmount = _data["redeemedAmount"];
            this.merchantDiscretionaryData = _data["merchantDiscretionaryData"];
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): RedeemRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RedeemRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["nationsBenefitsTransactionId"] = this.nationsBenefitsTransactionId;
        data["redeemType"] = this.redeemType;
        data["redeemedAmount"] = this.redeemedAmount;
        data["merchantDiscretionaryData"] = this.merchantDiscretionaryData;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        return data;
    }
}

export interface IRedeemRequest {
    /** The unique identifier for the transaction that was generated by NationsBenefits in response to the Analyze call. */
    nationsBenefitsTransactionId: string;
    /** Type of the redemption transaction. Each type corresponds to different transaction actions internally: - "000": Default type if not provided, often representing generic handshake representing authorized transaction amount redemption from the Issuer (happy-path). - "100": For voiding a previously authorized request/transaction. - "200": For reversing a previously authorized request/transaction. - "300": For voiding an auth, used in the scenarios where the POS/merchant receives an incorrect amount ($) from the Issuer. Defaults to '000' if not provided. */
    redeemType?: RedeemRequestRedeemType | undefined;
    /** The redeemed amount. */
    redeemedAmount?: number;
    /** Optional data field for the merchant to send additional information. */
    merchantDiscretionaryData?: string | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;
}

export enum RedeemRequestRedeemType {
    _000 = "000",
    _100 = "100",
    _200 = "200",
    _300 = "300",
}

export class VoidResponse implements IVoidResponse {
    response!: Response8;
    /** Optional data field for the merchant to send additional information. */
    merchantDiscretionaryData?: string | undefined;
    nbInternalTrace!: NationsInternalTrace;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;

    constructor(data?: IVoidResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.response = new Response8();
            this.nbInternalTrace = new NationsInternalTrace();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.response = _data["response"] ? Response8.fromJS(_data["response"]) : new Response8();
            this.merchantDiscretionaryData = _data["merchantDiscretionaryData"];
            this.nbInternalTrace = _data["nbInternalTrace"] ? NationsInternalTrace.fromJS(_data["nbInternalTrace"]) : new NationsInternalTrace();
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): VoidResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VoidResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["response"] = this.response ? this.response.toJSON() : <any>undefined;
        data["merchantDiscretionaryData"] = this.merchantDiscretionaryData;
        data["nbInternalTrace"] = this.nbInternalTrace ? this.nbInternalTrace.toJSON() : <any>undefined;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        return data;
    }
}

export interface IVoidResponse {
    response: Response8;
    /** Optional data field for the merchant to send additional information. */
    merchantDiscretionaryData?: string | undefined;
    nbInternalTrace: NationsInternalTrace;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;
}

export class Response8 implements IResponse8 {
    /** The unique identifier for the transaction that was generated by NationsBenefits in response to the Analyze call. */
    nationsBenefitsTransactionId?: string | undefined;
    /** The status of the void. */
    status?: string | undefined;
    /** The code associated with the void status. */
    code?: string | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;

    constructor(data?: IResponse8) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.nationsBenefitsTransactionId = _data["nationsBenefitsTransactionId"];
            this.status = _data["status"];
            this.code = _data["code"];
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): Response8 {
        data = typeof data === 'object' ? data : {};
        let result = new Response8();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["nationsBenefitsTransactionId"] = this.nationsBenefitsTransactionId;
        data["status"] = this.status;
        data["code"] = this.code;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        return data;
    }
}

export interface IResponse8 {
    /** The unique identifier for the transaction that was generated by NationsBenefits in response to the Analyze call. */
    nationsBenefitsTransactionId?: string | undefined;
    /** The status of the void. */
    status?: string | undefined;
    /** The code associated with the void status. */
    code?: string | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;
}

export class VoidRequest implements IVoidRequest {
    /** The unique identifier for the transaction that was generated by BAS in response to the Analyze call. */
    nationsBenefitsTransactionId!: string;
    /** Optional data field for the merchant to send additional information. */
    merchantDiscretionaryData?: string | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;

    constructor(data?: IVoidRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.nationsBenefitsTransactionId = _data["nationsBenefitsTransactionId"];
            this.merchantDiscretionaryData = _data["merchantDiscretionaryData"];
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): VoidRequest {
        data = typeof data === 'object' ? data : {};
        let result = new VoidRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["nationsBenefitsTransactionId"] = this.nationsBenefitsTransactionId;
        data["merchantDiscretionaryData"] = this.merchantDiscretionaryData;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        return data;
    }
}

export interface IVoidRequest {
    /** The unique identifier for the transaction that was generated by BAS in response to the Analyze call. */
    nationsBenefitsTransactionId: string;
    /** Optional data field for the merchant to send additional information. */
    merchantDiscretionaryData?: string | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;
}

export class ReversalResponse implements IReversalResponse {
    response!: Response9;
    /** Optional data field for the merchant to send additional information. */
    merchantDiscretionaryData?: string | undefined;
    nbInternalTrace!: NationsInternalTrace;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;

    constructor(data?: IReversalResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.response = new Response9();
            this.nbInternalTrace = new NationsInternalTrace();
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.response = _data["response"] ? Response9.fromJS(_data["response"]) : new Response9();
            this.merchantDiscretionaryData = _data["merchantDiscretionaryData"];
            this.nbInternalTrace = _data["nbInternalTrace"] ? NationsInternalTrace.fromJS(_data["nbInternalTrace"]) : new NationsInternalTrace();
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): ReversalResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ReversalResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["response"] = this.response ? this.response.toJSON() : <any>undefined;
        data["merchantDiscretionaryData"] = this.merchantDiscretionaryData;
        data["nbInternalTrace"] = this.nbInternalTrace ? this.nbInternalTrace.toJSON() : <any>undefined;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        return data;
    }
}

export interface IReversalResponse {
    response: Response9;
    /** Optional data field for the merchant to send additional information. */
    merchantDiscretionaryData?: string | undefined;
    nbInternalTrace: NationsInternalTrace;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;
}

export class Response9 implements IResponse9 {
    /** The unique identifier for the transaction that was generated by NationsBenefits in response to the Analyze call. */
    nationsBenefitsTransactionId?: string | undefined;
    /** The status of the reversal. */
    status?: string | undefined;
    /** The code associated with the reversal status. */
    code?: string | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;

    constructor(data?: IResponse9) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.nationsBenefitsTransactionId = _data["nationsBenefitsTransactionId"];
            this.status = _data["status"];
            this.code = _data["code"];
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): Response9 {
        data = typeof data === 'object' ? data : {};
        let result = new Response9();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["nationsBenefitsTransactionId"] = this.nationsBenefitsTransactionId;
        data["status"] = this.status;
        data["code"] = this.code;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        return data;
    }
}

export interface IResponse9 {
    /** The unique identifier for the transaction that was generated by NationsBenefits in response to the Analyze call. */
    nationsBenefitsTransactionId?: string | undefined;
    /** The status of the reversal. */
    status?: string | undefined;
    /** The code associated with the reversal status. */
    code?: string | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;
}

export class ReversalRequest implements IReversalRequest {
    /** The unique identifier for the transaction that was generated by BAS in response to the Analyze call.  Note that this value will not be required if a combination of the entityId, merchantTransactionId, and transactionLocalDateTime are all provided. */
    nationsBenefitsTransactionId!: string;
    /** Optional data field for the merchant to send additional information. */
    merchantDiscretionaryData?: string | undefined;
    /** The unique identifier for the parent entity of the retailer or the processing entity. */
    entityId?: string | undefined;
    /** The unique identifier for the store of the retailer or the processing entity. */
    storeId?: string | undefined;
    /** The unique identifier for the termina entity of the retailer or the processing entity. */
    terminalId?: string | undefined;
    /** Merchant generated unique identifier for the transaction. */
    merchantTransactionId?: string | undefined;
    /** ISO 8601; The local date and time when the transaction was made, represented in local time and expressed with its UTC offset (e.g., "2023-07-19T13:20:30+01:00"). */
    transactionLocalDateTime?: string | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;

    constructor(data?: IReversalRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.nationsBenefitsTransactionId = _data["nationsBenefitsTransactionId"];
            this.merchantDiscretionaryData = _data["merchantDiscretionaryData"];
            this.entityId = _data["entityId"];
            this.storeId = _data["storeId"];
            this.terminalId = _data["terminalId"];
            this.merchantTransactionId = _data["merchantTransactionId"];
            this.transactionLocalDateTime = _data["transactionLocalDateTime"];
            if (_data["additionalProperties"]) {
                this.additionalProperties = {} as any;
                for (let key in _data["additionalProperties"]) {
                    if (_data["additionalProperties"].hasOwnProperty(key))
                        (<any>this.additionalProperties)![key] = _data["additionalProperties"][key];
                }
            }
        }
    }

    static fromJS(data: any): ReversalRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReversalRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["nationsBenefitsTransactionId"] = this.nationsBenefitsTransactionId;
        data["merchantDiscretionaryData"] = this.merchantDiscretionaryData;
        data["entityId"] = this.entityId;
        data["storeId"] = this.storeId;
        data["terminalId"] = this.terminalId;
        data["merchantTransactionId"] = this.merchantTransactionId;
        data["transactionLocalDateTime"] = this.transactionLocalDateTime;
        if (this.additionalProperties) {
            data["additionalProperties"] = {};
            for (let key in this.additionalProperties) {
                if (this.additionalProperties.hasOwnProperty(key))
                    (<any>data["additionalProperties"])[key] = (<any>this.additionalProperties)[key];
            }
        }
        return data;
    }
}

export interface IReversalRequest {
    /** The unique identifier for the transaction that was generated by BAS in response to the Analyze call.  Note that this value will not be required if a combination of the entityId, merchantTransactionId, and transactionLocalDateTime are all provided. */
    nationsBenefitsTransactionId: string;
    /** Optional data field for the merchant to send additional information. */
    merchantDiscretionaryData?: string | undefined;
    /** The unique identifier for the parent entity of the retailer or the processing entity. */
    entityId?: string | undefined;
    /** The unique identifier for the store of the retailer or the processing entity. */
    storeId?: string | undefined;
    /** The unique identifier for the termina entity of the retailer or the processing entity. */
    terminalId?: string | undefined;
    /** Merchant generated unique identifier for the transaction. */
    merchantTransactionId?: string | undefined;
    /** ISO 8601; The local date and time when the transaction was made, represented in local time and expressed with its UTC offset (e.g., "2023-07-19T13:20:30+01:00"). */
    transactionLocalDateTime?: string | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;

    [key: string]: any;
}

export class NegativePriceProductMovementDto implements INegativePriceProductMovementDto {
    upc?: string | undefined;
    datetime?: Date | undefined;
    description?: string | undefined;
    transactionNumber?: string | undefined;
    qty?: number;
    sales?: number;
    storeId?: number;
    storeName?: string | undefined;

    constructor(data?: INegativePriceProductMovementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.upc = _data["upc"];
            this.datetime = _data["datetime"] ? new Date(_data["datetime"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.transactionNumber = _data["transactionNumber"];
            this.qty = _data["qty"];
            this.sales = _data["sales"];
            this.storeId = _data["storeId"];
            this.storeName = _data["storeName"];
        }
    }

    static fromJS(data: any): NegativePriceProductMovementDto {
        data = typeof data === 'object' ? data : {};
        let result = new NegativePriceProductMovementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["upc"] = this.upc;
        data["datetime"] = this.datetime ? this.datetime.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["transactionNumber"] = this.transactionNumber;
        data["qty"] = this.qty;
        data["sales"] = this.sales;
        data["storeId"] = this.storeId;
        data["storeName"] = this.storeName;
        return data;
    }
}

export interface INegativePriceProductMovementDto {
    upc?: string | undefined;
    datetime?: Date | undefined;
    description?: string | undefined;
    transactionNumber?: string | undefined;
    qty?: number;
    sales?: number;
    storeId?: number;
    storeName?: string | undefined;
}

export class ResponseBase implements IResponseBase {

    constructor(data?: IResponseBase) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ResponseBase {
        data = typeof data === 'object' ? data : {};
        let result = new ResponseBase();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IResponseBase {
}

export class TransactionResponse extends ResponseBase implements ITransactionResponse {
    transation?: TransationTan | undefined;
    amount?: string | undefined;
    transationStatue?: string | undefined;

    constructor(data?: ITransactionResponse) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.transation = _data["transation"] ? TransationTan.fromJS(_data["transation"]) : <any>undefined;
            this.amount = _data["amount"];
            this.transationStatue = _data["transationStatue"];
        }
    }

    static override fromJS(data: any): TransactionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transation"] = this.transation ? this.transation.toJSON() : <any>undefined;
        data["amount"] = this.amount;
        data["transationStatue"] = this.transationStatue;
        super.toJSON(data);
        return data;
    }
}

export interface ITransactionResponse extends IResponseBase {
    transation?: TransationTan | undefined;
    amount?: string | undefined;
    transationStatue?: string | undefined;
}

export class TransationTan implements ITransationTan {
    total?: number;
    tax?: number;
    subtotal?: number;
    cardtype?: string | undefined;
    items?: TransationItem[] | undefined;

    constructor(data?: ITransationTan) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            this.tax = _data["tax"];
            this.subtotal = _data["subtotal"];
            this.cardtype = _data["cardtype"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TransationItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TransationTan {
        data = typeof data === 'object' ? data : {};
        let result = new TransationTan();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        data["tax"] = this.tax;
        data["subtotal"] = this.subtotal;
        data["cardtype"] = this.cardtype;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ITransationTan {
    total?: number;
    tax?: number;
    subtotal?: number;
    cardtype?: string | undefined;
    items?: TransationItem[] | undefined;
}

export class TransationItem implements ITransationItem {
    description?: string | undefined;
    qty?: number;
    price?: number;

    constructor(data?: ITransationItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.qty = _data["qty"];
            this.price = _data["price"];
        }
    }

    static fromJS(data: any): TransationItem {
        data = typeof data === 'object' ? data : {};
        let result = new TransationItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["qty"] = this.qty;
        data["price"] = this.price;
        return data;
    }
}

export interface ITransationItem {
    description?: string | undefined;
    qty?: number;
    price?: number;
}

export class UserPayment implements IUserPayment {
    cardNumber?: string | undefined;
    pin?: string | undefined;
    cardName?: string | undefined;
    cardDate?: Date;
    cvc?: string | undefined;
    zip?: string | undefined;

    constructor(data?: IUserPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardNumber = _data["cardNumber"];
            this.pin = _data["pin"];
            this.cardName = _data["cardName"];
            this.cardDate = _data["cardDate"] ? new Date(_data["cardDate"].toString()) : <any>undefined;
            this.cvc = _data["cvc"];
            this.zip = _data["zip"];
        }
    }

    static fromJS(data: any): UserPayment {
        data = typeof data === 'object' ? data : {};
        let result = new UserPayment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardNumber"] = this.cardNumber;
        data["pin"] = this.pin;
        data["cardName"] = this.cardName;
        data["cardDate"] = this.cardDate ? this.cardDate.toISOString() : <any>undefined;
        data["cvc"] = this.cvc;
        data["zip"] = this.zip;
        return data;
    }
}

export interface IUserPayment {
    cardNumber?: string | undefined;
    pin?: string | undefined;
    cardName?: string | undefined;
    cardDate?: Date;
    cvc?: string | undefined;
    zip?: string | undefined;
}

/** 登录后返回数据 */
export class CustomerResponse2 implements ICustomerResponse2 {
    user?: UserItem | undefined;
    token?: RegToken | undefined;
    loginRecordID?: string | undefined;

    constructor(data?: ICustomerResponse2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserItem.fromJS(_data["user"]) : <any>undefined;
            this.token = _data["token"] ? RegToken.fromJS(_data["token"]) : <any>undefined;
            this.loginRecordID = _data["loginRecordID"];
        }
    }

    static fromJS(data: any): CustomerResponse2 {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerResponse2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>undefined;
        data["token"] = this.token ? this.token.toJSON() : <any>undefined;
        data["loginRecordID"] = this.loginRecordID;
        return data;
    }
}

/** 登录后返回数据 */
export interface ICustomerResponse2 {
    user?: UserItem | undefined;
    token?: RegToken | undefined;
    loginRecordID?: string | undefined;
}

/** 登录后用户数据 */
export class UserItem implements IUserItem {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    birthday?: Date | undefined;
    email?: string | undefined;
    zipCode?: string | undefined;
    storeName?: string | undefined;
    cashRegisterID?: string | undefined;
    phonenumber?: string | undefined;
    defaultTime?: string;
    pointBalance?: number | undefined;
    greetingMessage?: string | undefined;
    logoLink?: string | undefined;
    primaryColor?: string | undefined;

    constructor(data?: IUserItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.birthday = _data["birthday"] ? new Date(_data["birthday"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.zipCode = _data["zipCode"];
            this.storeName = _data["storeName"];
            this.cashRegisterID = _data["cashRegisterID"];
            this.phonenumber = _data["phonenumber"];
            this.defaultTime = _data["defaultTime"];
            this.pointBalance = _data["pointBalance"];
            this.greetingMessage = _data["greetingMessage"];
            this.logoLink = _data["logoLink"];
            this.primaryColor = _data["primaryColor"];
        }
    }

    static fromJS(data: any): UserItem {
        data = typeof data === 'object' ? data : {};
        let result = new UserItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["address"] = this.address;
        data["city"] = this.city;
        data["birthday"] = this.birthday ? this.birthday.toISOString() : <any>undefined;
        data["email"] = this.email;
        data["zipCode"] = this.zipCode;
        data["storeName"] = this.storeName;
        data["cashRegisterID"] = this.cashRegisterID;
        data["phonenumber"] = this.phonenumber;
        data["defaultTime"] = this.defaultTime;
        data["pointBalance"] = this.pointBalance;
        data["greetingMessage"] = this.greetingMessage;
        data["logoLink"] = this.logoLink;
        data["primaryColor"] = this.primaryColor;
        return data;
    }
}

/** 登录后用户数据 */
export interface IUserItem {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    birthday?: Date | undefined;
    email?: string | undefined;
    zipCode?: string | undefined;
    storeName?: string | undefined;
    cashRegisterID?: string | undefined;
    phonenumber?: string | undefined;
    defaultTime?: string;
    pointBalance?: number | undefined;
    greetingMessage?: string | undefined;
    logoLink?: string | undefined;
    primaryColor?: string | undefined;
}

export class RegToken implements IRegToken {
    registerToken?: string | undefined;

    constructor(data?: IRegToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.registerToken = _data["registerToken"];
        }
    }

    static fromJS(data: any): RegToken {
        data = typeof data === 'object' ? data : {};
        let result = new RegToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registerToken"] = this.registerToken;
        return data;
    }
}

export interface IRegToken {
    registerToken?: string | undefined;
}

export enum LoginStatus {
    Waiting = "Waiting",
    Accepted = "Accepted",
    Declined = "Declined",
}

/** 注册后用户数据类 */
export class RegisterRequest implements IRegisterRequest {
    firstName?: string | undefined;
    lastName?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    birthday?: string | undefined;
    email?: string | undefined;
    phonenumber?: string | undefined;
    defaultTime?: string;
    zipCode?: string | undefined;

    constructor(data?: IRegisterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.birthday = _data["birthday"];
            this.email = _data["email"];
            this.phonenumber = _data["phonenumber"];
            this.defaultTime = _data["defaultTime"];
            this.zipCode = _data["zipCode"];
        }
    }

    static fromJS(data: any): RegisterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["address"] = this.address;
        data["city"] = this.city;
        data["birthday"] = this.birthday;
        data["email"] = this.email;
        data["phonenumber"] = this.phonenumber;
        data["defaultTime"] = this.defaultTime;
        data["zipCode"] = this.zipCode;
        return data;
    }
}

/** 注册后用户数据类 */
export interface IRegisterRequest {
    firstName?: string | undefined;
    lastName?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    birthday?: string | undefined;
    email?: string | undefined;
    phonenumber?: string | undefined;
    defaultTime?: string;
    zipCode?: string | undefined;
}

export class CustomUpdateRequest implements ICustomUpdateRequest {
    firstName?: string | undefined;
    lastName?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    birthday?: string | undefined;
    email?: string | undefined;
    defaultTime?: string;
    zipCode?: string | undefined;

    constructor(data?: ICustomUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.birthday = _data["birthday"];
            this.email = _data["email"];
            this.defaultTime = _data["defaultTime"];
            this.zipCode = _data["zipCode"];
        }
    }

    static fromJS(data: any): CustomUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CustomUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["address"] = this.address;
        data["city"] = this.city;
        data["birthday"] = this.birthday;
        data["email"] = this.email;
        data["defaultTime"] = this.defaultTime;
        data["zipCode"] = this.zipCode;
        return data;
    }
}

export interface ICustomUpdateRequest {
    firstName?: string | undefined;
    lastName?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    birthday?: string | undefined;
    email?: string | undefined;
    defaultTime?: string;
    zipCode?: string | undefined;
}

export class CustomerTotalAmountResponse implements ICustomerTotalAmountResponse {
    /** 年度总消费金额 */
    yearlyTotalAmount?: number;
    /** 最后一次消费金额 */
    lastPurchaseAmount?: number;
    lastPurchaseDate?: Date;

    constructor(data?: ICustomerTotalAmountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.yearlyTotalAmount = _data["yearlyTotalAmount"];
            this.lastPurchaseAmount = _data["lastPurchaseAmount"];
            this.lastPurchaseDate = _data["lastPurchaseDate"] ? new Date(_data["lastPurchaseDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomerTotalAmountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerTotalAmountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["yearlyTotalAmount"] = this.yearlyTotalAmount;
        data["lastPurchaseAmount"] = this.lastPurchaseAmount;
        data["lastPurchaseDate"] = this.lastPurchaseDate ? this.lastPurchaseDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICustomerTotalAmountResponse {
    /** 年度总消费金额 */
    yearlyTotalAmount?: number;
    /** 最后一次消费金额 */
    lastPurchaseAmount?: number;
    lastPurchaseDate?: Date;
}

export class CompanyProductsDTO implements ICompanyProductsDTO {
    products?: StoreProductsDTO[] | undefined;

    constructor(data?: ICompanyProductsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(StoreProductsDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CompanyProductsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyProductsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ICompanyProductsDTO {
    products?: StoreProductsDTO[] | undefined;
}

/** 商店下的商品 */
export class StoreProductsDTO implements IStoreProductsDTO {
    upc?: string | undefined;
    isScale?: number;
    everyDayLowPrice?: string | undefined;
    productName?: string | undefined;
    vendorID?: string | undefined;
    department?: string | undefined;
    itemSize?: number | undefined;
    itemUnit?: string | undefined;
    priceBase?: number;
    unitCost?: number | undefined;
    regular_Price?: number | undefined;
    pluUseSingleSplitPrice?: boolean | undefined;
    pluSingleSplitPrice?: number | undefined;
    beginDate?: Date | undefined;
    endDate?: Date | undefined;
    promoDescription?: string | undefined;
    plu_id?: string | undefined;
    last_Sold?: Date | undefined;
    last_Received?: Date | undefined;
    onHand?: number | undefined;
    deposit?: number | undefined;
    ptD30?: number | undefined;
    aisle?: string | undefined;
    store?: CompanyStoreDTO | undefined;

    constructor(data?: IStoreProductsDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.upc = _data["upc"];
            this.isScale = _data["isScale"];
            this.everyDayLowPrice = _data["everyDayLowPrice"];
            this.productName = _data["productName"];
            this.vendorID = _data["vendorID"];
            this.department = _data["department"];
            this.itemSize = _data["itemSize"];
            this.itemUnit = _data["itemUnit"];
            this.priceBase = _data["priceBase"];
            this.unitCost = _data["unitCost"];
            this.regular_Price = _data["regular_Price"];
            this.pluUseSingleSplitPrice = _data["pluUseSingleSplitPrice"];
            this.pluSingleSplitPrice = _data["pluSingleSplitPrice"];
            this.beginDate = _data["beginDate"] ? new Date(_data["beginDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.promoDescription = _data["promoDescription"];
            this.plu_id = _data["plu_id"];
            this.last_Sold = _data["last_Sold"] ? new Date(_data["last_Sold"].toString()) : <any>undefined;
            this.last_Received = _data["last_Received"] ? new Date(_data["last_Received"].toString()) : <any>undefined;
            this.onHand = _data["onHand"];
            this.deposit = _data["deposit"];
            this.ptD30 = _data["ptD30"];
            this.aisle = _data["aisle"];
            this.store = _data["store"] ? CompanyStoreDTO.fromJS(_data["store"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StoreProductsDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StoreProductsDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["upc"] = this.upc;
        data["isScale"] = this.isScale;
        data["everyDayLowPrice"] = this.everyDayLowPrice;
        data["productName"] = this.productName;
        data["vendorID"] = this.vendorID;
        data["department"] = this.department;
        data["itemSize"] = this.itemSize;
        data["itemUnit"] = this.itemUnit;
        data["priceBase"] = this.priceBase;
        data["unitCost"] = this.unitCost;
        data["regular_Price"] = this.regular_Price;
        data["pluUseSingleSplitPrice"] = this.pluUseSingleSplitPrice;
        data["pluSingleSplitPrice"] = this.pluSingleSplitPrice;
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["promoDescription"] = this.promoDescription;
        data["plu_id"] = this.plu_id;
        data["last_Sold"] = this.last_Sold ? this.last_Sold.toISOString() : <any>undefined;
        data["last_Received"] = this.last_Received ? this.last_Received.toISOString() : <any>undefined;
        data["onHand"] = this.onHand;
        data["deposit"] = this.deposit;
        data["ptD30"] = this.ptD30;
        data["aisle"] = this.aisle;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        return data;
    }
}

/** 商店下的商品 */
export interface IStoreProductsDTO {
    upc?: string | undefined;
    isScale?: number;
    everyDayLowPrice?: string | undefined;
    productName?: string | undefined;
    vendorID?: string | undefined;
    department?: string | undefined;
    itemSize?: number | undefined;
    itemUnit?: string | undefined;
    priceBase?: number;
    unitCost?: number | undefined;
    regular_Price?: number | undefined;
    pluUseSingleSplitPrice?: boolean | undefined;
    pluSingleSplitPrice?: number | undefined;
    beginDate?: Date | undefined;
    endDate?: Date | undefined;
    promoDescription?: string | undefined;
    plu_id?: string | undefined;
    last_Sold?: Date | undefined;
    last_Received?: Date | undefined;
    onHand?: number | undefined;
    deposit?: number | undefined;
    ptD30?: number | undefined;
    aisle?: string | undefined;
    store?: CompanyStoreDTO | undefined;
}

export class CompanyStoreDTO implements ICompanyStoreDTO {
    storeName?: string;
    storeId?: number;

    constructor(data?: ICompanyStoreDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeName = _data["storeName"];
            this.storeId = _data["storeId"];
        }
    }

    static fromJS(data: any): CompanyStoreDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyStoreDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeName"] = this.storeName;
        data["storeId"] = this.storeId;
        return data;
    }
}

export interface ICompanyStoreDTO {
    storeName?: string;
    storeId?: number;
}

export class GetStoreProductDto implements IGetStoreProductDto {
    price?: number;
    priceBase?: number;
    singleSplitPrice?: number;
    description?: string | undefined;
    barCode?: string | undefined;
    storeName?: string | undefined;
    storeId?: number;
    departmentName?: string | undefined;
    departmentId?: number;
    imageId?: string | undefined;
    productImageUrl?: string | undefined;

    constructor(data?: IGetStoreProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.price = _data["price"];
            this.priceBase = _data["priceBase"];
            this.singleSplitPrice = _data["singleSplitPrice"];
            this.description = _data["description"];
            this.barCode = _data["barCode"];
            this.storeName = _data["storeName"];
            this.storeId = _data["storeId"];
            this.departmentName = _data["departmentName"];
            this.departmentId = _data["departmentId"];
            this.imageId = _data["imageId"];
            this.productImageUrl = _data["productImageUrl"];
        }
    }

    static fromJS(data: any): GetStoreProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetStoreProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["price"] = this.price;
        data["priceBase"] = this.priceBase;
        data["singleSplitPrice"] = this.singleSplitPrice;
        data["description"] = this.description;
        data["barCode"] = this.barCode;
        data["storeName"] = this.storeName;
        data["storeId"] = this.storeId;
        data["departmentName"] = this.departmentName;
        data["departmentId"] = this.departmentId;
        data["imageId"] = this.imageId;
        data["productImageUrl"] = this.productImageUrl;
        return data;
    }
}

export interface IGetStoreProductDto {
    price?: number;
    priceBase?: number;
    singleSplitPrice?: number;
    description?: string | undefined;
    barCode?: string | undefined;
    storeName?: string | undefined;
    storeId?: number;
    departmentName?: string | undefined;
    departmentId?: number;
    imageId?: string | undefined;
    productImageUrl?: string | undefined;
}

export class ProductImageSynchronizationBody implements IProductImageSynchronizationBody {
    sourceStoreAccessKeys?: string[] | undefined;
    pluUpcs?: string[] | undefined;
    mode?: ProductImageSynchronizationMode;

    constructor(data?: IProductImageSynchronizationBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sourceStoreAccessKeys"])) {
                this.sourceStoreAccessKeys = [] as any;
                for (let item of _data["sourceStoreAccessKeys"])
                    this.sourceStoreAccessKeys!.push(item);
            }
            if (Array.isArray(_data["pluUpcs"])) {
                this.pluUpcs = [] as any;
                for (let item of _data["pluUpcs"])
                    this.pluUpcs!.push(item);
            }
            this.mode = _data["mode"];
        }
    }

    static fromJS(data: any): ProductImageSynchronizationBody {
        data = typeof data === 'object' ? data : {};
        let result = new ProductImageSynchronizationBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sourceStoreAccessKeys)) {
            data["sourceStoreAccessKeys"] = [];
            for (let item of this.sourceStoreAccessKeys)
                data["sourceStoreAccessKeys"].push(item);
        }
        if (Array.isArray(this.pluUpcs)) {
            data["pluUpcs"] = [];
            for (let item of this.pluUpcs)
                data["pluUpcs"].push(item);
        }
        data["mode"] = this.mode;
        return data;
    }
}

export interface IProductImageSynchronizationBody {
    sourceStoreAccessKeys?: string[] | undefined;
    pluUpcs?: string[] | undefined;
    mode?: ProductImageSynchronizationMode;
}

export enum ProductImageSynchronizationMode {
    SkipIfExists = "SkipIfExists",
    Cover = "Cover",
}

export class BarcodeInfo implements IBarcodeInfo {
    barcode?: string | undefined;
    deposit?: string | undefined;
    department?: string | undefined;

    constructor(data?: IBarcodeInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.barcode = _data["barcode"];
            this.deposit = _data["deposit"];
            this.department = _data["department"];
        }
    }

    static fromJS(data: any): BarcodeInfo {
        data = typeof data === 'object' ? data : {};
        let result = new BarcodeInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["barcode"] = this.barcode;
        data["deposit"] = this.deposit;
        data["department"] = this.department;
        return data;
    }
}

export interface IBarcodeInfo {
    barcode?: string | undefined;
    deposit?: string | undefined;
    department?: string | undefined;
}

export class BarcodesBody implements IBarcodesBody {
    barcodes?: string[] | undefined;
    storeIds?: number[] | undefined;

    constructor(data?: IBarcodesBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["barcodes"])) {
                this.barcodes = [] as any;
                for (let item of _data["barcodes"])
                    this.barcodes!.push(item);
            }
            if (Array.isArray(_data["storeIds"])) {
                this.storeIds = [] as any;
                for (let item of _data["storeIds"])
                    this.storeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): BarcodesBody {
        data = typeof data === 'object' ? data : {};
        let result = new BarcodesBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.barcodes)) {
            data["barcodes"] = [];
            for (let item of this.barcodes)
                data["barcodes"].push(item);
        }
        if (Array.isArray(this.storeIds)) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        return data;
    }
}

export interface IBarcodesBody {
    barcodes?: string[] | undefined;
    storeIds?: number[] | undefined;
}

export class ServiceResponseOfProductResult implements IServiceResponseOfProductResult {
    statues?: ServiceStatues;
    errorMessage?: string;
    responseCode?: HttpStatusCode;
    result?: ProductResult | undefined;

    constructor(data?: IServiceResponseOfProductResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statues = _data["statues"];
            this.errorMessage = _data["errorMessage"];
            this.responseCode = _data["responseCode"];
            this.result = _data["result"] ? ProductResult.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceResponseOfProductResult {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceResponseOfProductResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statues"] = this.statues;
        data["errorMessage"] = this.errorMessage;
        data["responseCode"] = this.responseCode;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IServiceResponseOfProductResult {
    statues?: ServiceStatues;
    errorMessage?: string;
    responseCode?: HttpStatusCode;
    result?: ProductResult | undefined;
}

export enum ServiceStatues {
    Success = "Success",
    Failure = "Failure",
}

export enum HttpStatusCode {
    Continue = "Continue",
    SwitchingProtocols = "SwitchingProtocols",
    Processing = "Processing",
    EarlyHints = "EarlyHints",
    OK = "OK",
    Created = "Created",
    Accepted = "Accepted",
    NonAuthoritativeInformation = "NonAuthoritativeInformation",
    NoContent = "NoContent",
    ResetContent = "ResetContent",
    PartialContent = "PartialContent",
    MultiStatus = "MultiStatus",
    AlreadyReported = "AlreadyReported",
    IMUsed = "IMUsed",
    MultipleChoices = "MultipleChoices",
    Ambiguous = "MultipleChoices",
    MovedPermanently = "MovedPermanently",
    Moved = "MovedPermanently",
    Found = "Found",
    Redirect = "Found",
    SeeOther = "SeeOther",
    RedirectMethod = "SeeOther",
    NotModified = "NotModified",
    UseProxy = "UseProxy",
    Unused = "Unused",
    TemporaryRedirect = "TemporaryRedirect",
    RedirectKeepVerb = "TemporaryRedirect",
    PermanentRedirect = "PermanentRedirect",
    BadRequest = "BadRequest",
    Unauthorized = "Unauthorized",
    PaymentRequired = "PaymentRequired",
    Forbidden = "Forbidden",
    NotFound = "NotFound",
    MethodNotAllowed = "MethodNotAllowed",
    NotAcceptable = "NotAcceptable",
    ProxyAuthenticationRequired = "ProxyAuthenticationRequired",
    RequestTimeout = "RequestTimeout",
    Conflict = "Conflict",
    Gone = "Gone",
    LengthRequired = "LengthRequired",
    PreconditionFailed = "PreconditionFailed",
    RequestEntityTooLarge = "RequestEntityTooLarge",
    RequestUriTooLong = "RequestUriTooLong",
    UnsupportedMediaType = "UnsupportedMediaType",
    RequestedRangeNotSatisfiable = "RequestedRangeNotSatisfiable",
    ExpectationFailed = "ExpectationFailed",
    MisdirectedRequest = "MisdirectedRequest",
    UnprocessableEntity = "UnprocessableEntity",
    UnprocessableContent = "UnprocessableEntity",
    Locked = "Locked",
    FailedDependency = "FailedDependency",
    UpgradeRequired = "UpgradeRequired",
    PreconditionRequired = "PreconditionRequired",
    TooManyRequests = "TooManyRequests",
    RequestHeaderFieldsTooLarge = "RequestHeaderFieldsTooLarge",
    UnavailableForLegalReasons = "UnavailableForLegalReasons",
    InternalServerError = "InternalServerError",
    NotImplemented = "NotImplemented",
    BadGateway = "BadGateway",
    ServiceUnavailable = "ServiceUnavailable",
    GatewayTimeout = "GatewayTimeout",
    HttpVersionNotSupported = "HttpVersionNotSupported",
    VariantAlsoNegotiates = "VariantAlsoNegotiates",
    InsufficientStorage = "InsufficientStorage",
    LoopDetected = "LoopDetected",
    NotExtended = "NotExtended",
    NetworkAuthenticationRequired = "NetworkAuthenticationRequired",
}

export class ProductResult implements IProductResult {
    items?: WalmartProduct[] | undefined;

    constructor(data?: IProductResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(WalmartProduct.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductResult {
        data = typeof data === 'object' ? data : {};
        let result = new ProductResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IProductResult {
    items?: WalmartProduct[] | undefined;
}

export class WalmartProduct implements IWalmartProduct {
    name?: string | undefined;
    categoryPath?: string | undefined;
    shortDescription?: string | undefined;
    longDescription?: string | undefined;
    brandName?: string | undefined;
    largeImage?: string | undefined;
    size?: string | undefined;
    imageEntities?: ImageEntity[] | undefined;

    constructor(data?: IWalmartProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.categoryPath = _data["categoryPath"];
            this.shortDescription = _data["shortDescription"];
            this.longDescription = _data["longDescription"];
            this.brandName = _data["brandName"];
            this.largeImage = _data["largeImage"];
            this.size = _data["size"];
            if (Array.isArray(_data["imageEntities"])) {
                this.imageEntities = [] as any;
                for (let item of _data["imageEntities"])
                    this.imageEntities!.push(ImageEntity.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WalmartProduct {
        data = typeof data === 'object' ? data : {};
        let result = new WalmartProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["categoryPath"] = this.categoryPath;
        data["shortDescription"] = this.shortDescription;
        data["longDescription"] = this.longDescription;
        data["brandName"] = this.brandName;
        data["largeImage"] = this.largeImage;
        data["size"] = this.size;
        if (Array.isArray(this.imageEntities)) {
            data["imageEntities"] = [];
            for (let item of this.imageEntities)
                data["imageEntities"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IWalmartProduct {
    name?: string | undefined;
    categoryPath?: string | undefined;
    shortDescription?: string | undefined;
    longDescription?: string | undefined;
    brandName?: string | undefined;
    largeImage?: string | undefined;
    size?: string | undefined;
    imageEntities?: ImageEntity[] | undefined;
}

export class ImageEntity implements IImageEntity {
    largeImage?: string | undefined;
    entityType?: string | undefined;

    constructor(data?: IImageEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.largeImage = _data["largeImage"];
            this.entityType = _data["entityType"];
        }
    }

    static fromJS(data: any): ImageEntity {
        data = typeof data === 'object' ? data : {};
        let result = new ImageEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["largeImage"] = this.largeImage;
        data["entityType"] = this.entityType;
        return data;
    }
}

export interface IImageEntity {
    largeImage?: string | undefined;
    entityType?: string | undefined;
}

export class KeyValuePairedOfIntegerAndString implements IKeyValuePairedOfIntegerAndString {
    key?: number;
    value?: string;

    constructor(data?: IKeyValuePairedOfIntegerAndString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): KeyValuePairedOfIntegerAndString {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePairedOfIntegerAndString();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IKeyValuePairedOfIntegerAndString {
    key?: number;
    value?: string;
}

export class ProductInfoDto implements IProductInfoDto {
    storeID?: number;
    storeName?: string | undefined;
    productId?: string;
    productDescript?: string | undefined;
    barcode?: string | undefined;
    department?: Department | undefined;
    vendor?: string | undefined;
    brand?: Brand | undefined;
    taxRuleSource?: TaxRuleSource | undefined;
    taxs?: TaxDto[] | undefined;
    price?: number;
    priceBase?: number;
    scaleSaleMode?: ScaleSaleMode | undefined;
    departmentGroup?: DepartmentGroupDto | undefined;
    /** 每箱的单位数量（每箱有多少个单品） */
    unitsPerCase?: number | undefined;
    /** 整箱成本价 */
    caseCost?: number | undefined;
    /** 单个商品的成本价 */
    unitCost?: number | undefined;
    /** 商品的规格或容量 */
    size?: number | undefined;
    /** 商品单位 */
    unitOfMeasure?: string | undefined;
    /** 毛利率 */
    profitMargin?: number | undefined;
    /** 最近购买日期 */
    lastPurchaseDate?: Date | undefined;
    lastSoldDate?: Date | undefined;

    constructor(data?: IProductInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeID = _data["storeID"];
            this.storeName = _data["storeName"];
            this.productId = _data["productId"];
            this.productDescript = _data["productDescript"];
            this.barcode = _data["barcode"];
            this.department = _data["department"] ? Department.fromJS(_data["department"]) : <any>undefined;
            this.vendor = _data["vendor"];
            this.brand = _data["brand"] ? Brand.fromJS(_data["brand"]) : <any>undefined;
            this.taxRuleSource = _data["taxRuleSource"] ? TaxRuleSource.fromJS(_data["taxRuleSource"]) : <any>undefined;
            if (Array.isArray(_data["taxs"])) {
                this.taxs = [] as any;
                for (let item of _data["taxs"])
                    this.taxs!.push(TaxDto.fromJS(item));
            }
            this.price = _data["price"];
            this.priceBase = _data["priceBase"];
            this.scaleSaleMode = _data["scaleSaleMode"];
            this.departmentGroup = _data["departmentGroup"] ? DepartmentGroupDto.fromJS(_data["departmentGroup"]) : <any>undefined;
            this.unitsPerCase = _data["unitsPerCase"];
            this.caseCost = _data["caseCost"];
            this.unitCost = _data["unitCost"];
            this.size = _data["size"];
            this.unitOfMeasure = _data["unitOfMeasure"];
            this.profitMargin = _data["profitMargin"];
            this.lastPurchaseDate = _data["lastPurchaseDate"] ? new Date(_data["lastPurchaseDate"].toString()) : <any>undefined;
            this.lastSoldDate = _data["lastSoldDate"] ? new Date(_data["lastSoldDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProductInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProductInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeID"] = this.storeID;
        data["storeName"] = this.storeName;
        data["productId"] = this.productId;
        data["productDescript"] = this.productDescript;
        data["barcode"] = this.barcode;
        data["department"] = this.department ? this.department.toJSON() : <any>undefined;
        data["vendor"] = this.vendor;
        data["brand"] = this.brand ? this.brand.toJSON() : <any>undefined;
        data["taxRuleSource"] = this.taxRuleSource ? this.taxRuleSource.toJSON() : <any>undefined;
        if (Array.isArray(this.taxs)) {
            data["taxs"] = [];
            for (let item of this.taxs)
                data["taxs"].push(item ? item.toJSON() : <any>undefined);
        }
        data["price"] = this.price;
        data["priceBase"] = this.priceBase;
        data["scaleSaleMode"] = this.scaleSaleMode;
        data["departmentGroup"] = this.departmentGroup ? this.departmentGroup.toJSON() : <any>undefined;
        data["unitsPerCase"] = this.unitsPerCase;
        data["caseCost"] = this.caseCost;
        data["unitCost"] = this.unitCost;
        data["size"] = this.size;
        data["unitOfMeasure"] = this.unitOfMeasure;
        data["profitMargin"] = this.profitMargin;
        data["lastPurchaseDate"] = this.lastPurchaseDate ? this.lastPurchaseDate.toISOString() : <any>undefined;
        data["lastSoldDate"] = this.lastSoldDate ? this.lastSoldDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IProductInfoDto {
    storeID?: number;
    storeName?: string | undefined;
    productId?: string;
    productDescript?: string | undefined;
    barcode?: string | undefined;
    department?: Department | undefined;
    vendor?: string | undefined;
    brand?: Brand | undefined;
    taxRuleSource?: TaxRuleSource | undefined;
    taxs?: TaxDto[] | undefined;
    price?: number;
    priceBase?: number;
    scaleSaleMode?: ScaleSaleMode | undefined;
    departmentGroup?: DepartmentGroupDto | undefined;
    /** 每箱的单位数量（每箱有多少个单品） */
    unitsPerCase?: number | undefined;
    /** 整箱成本价 */
    caseCost?: number | undefined;
    /** 单个商品的成本价 */
    unitCost?: number | undefined;
    /** 商品的规格或容量 */
    size?: number | undefined;
    /** 商品单位 */
    unitOfMeasure?: string | undefined;
    /** 毛利率 */
    profitMargin?: number | undefined;
    /** 最近购买日期 */
    lastPurchaseDate?: Date | undefined;
    lastSoldDate?: Date | undefined;
}

export class TaxRuleSource implements ITaxRuleSource {
    id?: string | undefined;
    type?: TaxRuleSourceType;
    description?: string | undefined;

    constructor(data?: ITaxRuleSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): TaxRuleSource {
        data = typeof data === 'object' ? data : {};
        let result = new TaxRuleSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["description"] = this.description;
        return data;
    }
}

export interface ITaxRuleSource {
    id?: string | undefined;
    type?: TaxRuleSourceType;
    description?: string | undefined;
}

export enum TaxRuleSourceType {
    Department = "Department",
    Custom = "Custom",
}

export enum ScaleSaleMode {
    ByWeight = "ByWeight",
    ByPC = "ByPC",
}

export class UpdateProductDto implements IUpdateProductDto {
    storeId!: number;
    productId!: string;
    updatedProductInfo?: ProductInfo | undefined;
    originalProductInfo?: ProductInfo | undefined;
    newProductInfo?: ProductInfo | undefined;

    constructor(data?: IUpdateProductDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeId = _data["storeId"];
            this.productId = _data["productId"];
            this.updatedProductInfo = _data["updatedProductInfo"] ? ProductInfo.fromJS(_data["updatedProductInfo"]) : <any>undefined;
            this.originalProductInfo = _data["originalProductInfo"] ? ProductInfo.fromJS(_data["originalProductInfo"]) : <any>undefined;
            this.newProductInfo = _data["newProductInfo"] ? ProductInfo.fromJS(_data["newProductInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateProductDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["productId"] = this.productId;
        data["updatedProductInfo"] = this.updatedProductInfo ? this.updatedProductInfo.toJSON() : <any>undefined;
        data["originalProductInfo"] = this.originalProductInfo ? this.originalProductInfo.toJSON() : <any>undefined;
        data["newProductInfo"] = this.newProductInfo ? this.newProductInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateProductDto {
    storeId: number;
    productId: string;
    updatedProductInfo?: ProductInfo | undefined;
    originalProductInfo?: ProductInfo | undefined;
    newProductInfo?: ProductInfo | undefined;
}

export class ProductInfo implements IProductInfo {
    productDesccript?: string | undefined;
    departmentId?: number | undefined;
    vendorDesc?: string | undefined;
    brandId?: number | undefined;
    taxType?: TaxRuleSourceType | undefined;
    taxIds?: number[] | undefined;

    constructor(data?: IProductInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productDesccript = _data["productDesccript"];
            this.departmentId = _data["departmentId"];
            this.vendorDesc = _data["vendorDesc"];
            this.brandId = _data["brandId"];
            this.taxType = _data["taxType"];
            if (Array.isArray(_data["taxIds"])) {
                this.taxIds = [] as any;
                for (let item of _data["taxIds"])
                    this.taxIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ProductInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ProductInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productDesccript"] = this.productDesccript;
        data["departmentId"] = this.departmentId;
        data["vendorDesc"] = this.vendorDesc;
        data["brandId"] = this.brandId;
        data["taxType"] = this.taxType;
        if (Array.isArray(this.taxIds)) {
            data["taxIds"] = [];
            for (let item of this.taxIds)
                data["taxIds"].push(item);
        }
        return data;
    }
}

export interface IProductInfo {
    productDesccript?: string | undefined;
    departmentId?: number | undefined;
    vendorDesc?: string | undefined;
    brandId?: number | undefined;
    taxType?: TaxRuleSourceType | undefined;
    taxIds?: number[] | undefined;
}

export class ProductReportResponse implements IProductReportResponse {
    products?: ProductReport[] | undefined;

    constructor(data?: IProductReportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(ProductReport.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProductReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IProductReportResponse {
    products?: ProductReport[] | undefined;
}

export class ProductReport implements IProductReport {
    barCode?: string | undefined;
    description?: string | undefined;
    priceBase?: number;
    price?: number;
    onhand?: number | undefined;
    lastSold?: Date | undefined;
    createdDate?: Date | undefined;

    constructor(data?: IProductReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.barCode = _data["barCode"];
            this.description = _data["description"];
            this.priceBase = _data["priceBase"];
            this.price = _data["price"];
            this.onhand = _data["onhand"];
            this.lastSold = _data["lastSold"] ? new Date(_data["lastSold"].toString()) : <any>undefined;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ProductReport {
        data = typeof data === 'object' ? data : {};
        let result = new ProductReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["barCode"] = this.barCode;
        data["description"] = this.description;
        data["priceBase"] = this.priceBase;
        data["price"] = this.price;
        data["onhand"] = this.onhand;
        data["lastSold"] = this.lastSold ? this.lastSold.toISOString() : <any>undefined;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IProductReport {
    barCode?: string | undefined;
    description?: string | undefined;
    priceBase?: number;
    price?: number;
    onhand?: number | undefined;
    lastSold?: Date | undefined;
    createdDate?: Date | undefined;
}

export class PromoSalesDto implements IPromoSalesDto {
    /** 商品唯一编号
             */
    barcode?: string;
    /** 商品名称 */
    productName?: string;
    /** 促销名称 */
    promoName?: string;
    /** 门店编号 */
    storeId?: number | undefined;
    /** 商品单价 */
    regularPrice?: number | undefined;
    /** 促销销售单价 */
    promoSaleUnitPrice?: number | undefined;
    /** 折扣百分比 */
    percentDiscount?: number | undefined;
    /** 促销期间销量 */
    qtySold?: number | undefined;
    /** 促销期间销售额 */
    revenue?: number | undefined;
    /** 非促销期间以正常价格销售数量 */
    nonePromoQtySold?: number | undefined;
    /** 非促销期间以正常价格销售额 */
    nonePromoRevenue?: number | undefined;
    /** 非促销期间以促销价格销售数量 */
    leakageQtySold?: number | undefined;
    /** 非促销期间以促销价格销售总额 */
    leakageRevenue?: number | undefined;
    /** 部门名称 */
    department?: string;
    /** 部门总销售额 */
    departmentTotalRevenue?: number | undefined;
    /** 占部门销售百分比 */
    percentOfDept?: number | undefined;
    /** 促销开始日期 */
    promotionStartDate?: Date | undefined;
    /** 促销结束日期 */
    promotionEndDate?: Date | undefined;
    /** 促销持续天数 */
    promotionDuration?: number | undefined;
    /** 创建时间 */
    createDate?: Date | undefined;
    /** 上一次促销名称 */
    previousPromoName?: string;
    /** 上一次促销开始日期 */
    previousPromotionStartDate?: Date | undefined;
    /** 上一次促销结束日期 */
    previousPromotionEndDate?: Date | undefined;
    previousJRDATE?: Date | undefined;
    /** 上一次促销活动期间该 SKU 的销量 */
    previousPromoUnitSales?: number | undefined;
    /** 上次促销销售额 */
    previousPromoRevenue?: number | undefined;
    lastYearID?: string | undefined;
    /** 去年同期促销名称 */
    lastYearPromoName?: string | undefined;
    /** 去年同期促销开始日期 */
    lastYearPromotionStartDate?: Date | undefined;
    /** 去年同期促销结束日期 */
    lastYearPromotionEndDate?: Date | undefined;
    /** 去年同期相同时间段该 SKU 的销量  */
    yoyUnitSales?: number | undefined;
    /** 去年同期相同时间段该 SKU 的销售额 */
    yoyRevenue?: number | undefined;
    /** 年度销售额增长百分比 */
    yoyRevenueGrowth?: number | undefined;
    /** 销量提升百分比 */
    incrementalLift?: number | undefined;
    /** 与上次促销对比 */
    performanceVSPriorPromotion?: number | undefined;
    /** 历史平均促销效果 */
    averagePromotionalEffectiveness?: number | undefined;

    constructor(data?: IPromoSalesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.barcode = _data["barcode"];
            this.productName = _data["productName"];
            this.promoName = _data["promoName"];
            this.storeId = _data["storeId"];
            this.regularPrice = _data["regularPrice"];
            this.promoSaleUnitPrice = _data["promoSaleUnitPrice"];
            this.percentDiscount = _data["percentDiscount"];
            this.qtySold = _data["qtySold"];
            this.revenue = _data["revenue"];
            this.nonePromoQtySold = _data["nonePromoQtySold"];
            this.nonePromoRevenue = _data["nonePromoRevenue"];
            this.leakageQtySold = _data["leakageQtySold"];
            this.leakageRevenue = _data["leakageRevenue"];
            this.department = _data["department"];
            this.departmentTotalRevenue = _data["departmentTotalRevenue"];
            this.percentOfDept = _data["percentOfDept"];
            this.promotionStartDate = _data["promotionStartDate"] ? new Date(_data["promotionStartDate"].toString()) : <any>undefined;
            this.promotionEndDate = _data["promotionEndDate"] ? new Date(_data["promotionEndDate"].toString()) : <any>undefined;
            this.promotionDuration = _data["promotionDuration"];
            this.createDate = _data["createDate"] ? new Date(_data["createDate"].toString()) : <any>undefined;
            this.previousPromoName = _data["previousPromoName"];
            this.previousPromotionStartDate = _data["previousPromotionStartDate"] ? new Date(_data["previousPromotionStartDate"].toString()) : <any>undefined;
            this.previousPromotionEndDate = _data["previousPromotionEndDate"] ? new Date(_data["previousPromotionEndDate"].toString()) : <any>undefined;
            this.previousJRDATE = _data["previousJRDATE"] ? new Date(_data["previousJRDATE"].toString()) : <any>undefined;
            this.previousPromoUnitSales = _data["previousPromoUnitSales"];
            this.previousPromoRevenue = _data["previousPromoRevenue"];
            this.lastYearID = _data["lastYearID"];
            this.lastYearPromoName = _data["lastYearPromoName"];
            this.lastYearPromotionStartDate = _data["lastYearPromotionStartDate"] ? new Date(_data["lastYearPromotionStartDate"].toString()) : <any>undefined;
            this.lastYearPromotionEndDate = _data["lastYearPromotionEndDate"] ? new Date(_data["lastYearPromotionEndDate"].toString()) : <any>undefined;
            this.yoyUnitSales = _data["yoyUnitSales"];
            this.yoyRevenue = _data["yoyRevenue"];
            this.yoyRevenueGrowth = _data["yoyRevenueGrowth"];
            this.incrementalLift = _data["incrementalLift"];
            this.performanceVSPriorPromotion = _data["performanceVSPriorPromotion"];
            this.averagePromotionalEffectiveness = _data["averagePromotionalEffectiveness"];
        }
    }

    static fromJS(data: any): PromoSalesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PromoSalesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["barcode"] = this.barcode;
        data["productName"] = this.productName;
        data["promoName"] = this.promoName;
        data["storeId"] = this.storeId;
        data["regularPrice"] = this.regularPrice;
        data["promoSaleUnitPrice"] = this.promoSaleUnitPrice;
        data["percentDiscount"] = this.percentDiscount;
        data["qtySold"] = this.qtySold;
        data["revenue"] = this.revenue;
        data["nonePromoQtySold"] = this.nonePromoQtySold;
        data["nonePromoRevenue"] = this.nonePromoRevenue;
        data["leakageQtySold"] = this.leakageQtySold;
        data["leakageRevenue"] = this.leakageRevenue;
        data["department"] = this.department;
        data["departmentTotalRevenue"] = this.departmentTotalRevenue;
        data["percentOfDept"] = this.percentOfDept;
        data["promotionStartDate"] = this.promotionStartDate ? this.promotionStartDate.toISOString() : <any>undefined;
        data["promotionEndDate"] = this.promotionEndDate ? this.promotionEndDate.toISOString() : <any>undefined;
        data["promotionDuration"] = this.promotionDuration;
        data["createDate"] = this.createDate ? this.createDate.toISOString() : <any>undefined;
        data["previousPromoName"] = this.previousPromoName;
        data["previousPromotionStartDate"] = this.previousPromotionStartDate ? this.previousPromotionStartDate.toISOString() : <any>undefined;
        data["previousPromotionEndDate"] = this.previousPromotionEndDate ? this.previousPromotionEndDate.toISOString() : <any>undefined;
        data["previousJRDATE"] = this.previousJRDATE ? this.previousJRDATE.toISOString() : <any>undefined;
        data["previousPromoUnitSales"] = this.previousPromoUnitSales;
        data["previousPromoRevenue"] = this.previousPromoRevenue;
        data["lastYearID"] = this.lastYearID;
        data["lastYearPromoName"] = this.lastYearPromoName;
        data["lastYearPromotionStartDate"] = this.lastYearPromotionStartDate ? this.lastYearPromotionStartDate.toISOString() : <any>undefined;
        data["lastYearPromotionEndDate"] = this.lastYearPromotionEndDate ? this.lastYearPromotionEndDate.toISOString() : <any>undefined;
        data["yoyUnitSales"] = this.yoyUnitSales;
        data["yoyRevenue"] = this.yoyRevenue;
        data["yoyRevenueGrowth"] = this.yoyRevenueGrowth;
        data["incrementalLift"] = this.incrementalLift;
        data["performanceVSPriorPromotion"] = this.performanceVSPriorPromotion;
        data["averagePromotionalEffectiveness"] = this.averagePromotionalEffectiveness;
        return data;
    }
}

export interface IPromoSalesDto {
    /** 商品唯一编号
             */
    barcode?: string;
    /** 商品名称 */
    productName?: string;
    /** 促销名称 */
    promoName?: string;
    /** 门店编号 */
    storeId?: number | undefined;
    /** 商品单价 */
    regularPrice?: number | undefined;
    /** 促销销售单价 */
    promoSaleUnitPrice?: number | undefined;
    /** 折扣百分比 */
    percentDiscount?: number | undefined;
    /** 促销期间销量 */
    qtySold?: number | undefined;
    /** 促销期间销售额 */
    revenue?: number | undefined;
    /** 非促销期间以正常价格销售数量 */
    nonePromoQtySold?: number | undefined;
    /** 非促销期间以正常价格销售额 */
    nonePromoRevenue?: number | undefined;
    /** 非促销期间以促销价格销售数量 */
    leakageQtySold?: number | undefined;
    /** 非促销期间以促销价格销售总额 */
    leakageRevenue?: number | undefined;
    /** 部门名称 */
    department?: string;
    /** 部门总销售额 */
    departmentTotalRevenue?: number | undefined;
    /** 占部门销售百分比 */
    percentOfDept?: number | undefined;
    /** 促销开始日期 */
    promotionStartDate?: Date | undefined;
    /** 促销结束日期 */
    promotionEndDate?: Date | undefined;
    /** 促销持续天数 */
    promotionDuration?: number | undefined;
    /** 创建时间 */
    createDate?: Date | undefined;
    /** 上一次促销名称 */
    previousPromoName?: string;
    /** 上一次促销开始日期 */
    previousPromotionStartDate?: Date | undefined;
    /** 上一次促销结束日期 */
    previousPromotionEndDate?: Date | undefined;
    previousJRDATE?: Date | undefined;
    /** 上一次促销活动期间该 SKU 的销量 */
    previousPromoUnitSales?: number | undefined;
    /** 上次促销销售额 */
    previousPromoRevenue?: number | undefined;
    lastYearID?: string | undefined;
    /** 去年同期促销名称 */
    lastYearPromoName?: string | undefined;
    /** 去年同期促销开始日期 */
    lastYearPromotionStartDate?: Date | undefined;
    /** 去年同期促销结束日期 */
    lastYearPromotionEndDate?: Date | undefined;
    /** 去年同期相同时间段该 SKU 的销量  */
    yoyUnitSales?: number | undefined;
    /** 去年同期相同时间段该 SKU 的销售额 */
    yoyRevenue?: number | undefined;
    /** 年度销售额增长百分比 */
    yoyRevenueGrowth?: number | undefined;
    /** 销量提升百分比 */
    incrementalLift?: number | undefined;
    /** 与上次促销对比 */
    performanceVSPriorPromotion?: number | undefined;
    /** 历史平均促销效果 */
    averagePromotionalEffectiveness?: number | undefined;
}

export class GetPromoSalesRequest implements IGetPromoSalesRequest {
    stores!: number[];
    /** 开始日期 (ISO 8601 格式: yyyy-MM-ddTHH:mm:ssZ)
  */
    promoBegin!: Date;
    /** 结束日期 (ISO 8601 格式: yyyy-MM-ddTHH:mm:ssZ) */
    promoEnd!: Date;
    /** false 不包含 002开头 00000结尾的商品 */
    includedRandomweightItem!: boolean;
    /** 非促销时间段 */
    noPromoBegin?: Date | undefined;
    /** 非促销时间段 */
    noPromoEnd?: Date | undefined;
    /** 促销批次ID */
    batchs?: SelectBatch[] | undefined;

    constructor(data?: IGetPromoSalesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.stores = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["stores"])) {
                this.stores = [] as any;
                for (let item of _data["stores"])
                    this.stores!.push(item);
            }
            this.promoBegin = _data["promoBegin"] ? new Date(_data["promoBegin"].toString()) : <any>undefined;
            this.promoEnd = _data["promoEnd"] ? new Date(_data["promoEnd"].toString()) : <any>undefined;
            this.includedRandomweightItem = _data["includedRandomweightItem"];
            this.noPromoBegin = _data["noPromoBegin"] ? new Date(_data["noPromoBegin"].toString()) : <any>undefined;
            this.noPromoEnd = _data["noPromoEnd"] ? new Date(_data["noPromoEnd"].toString()) : <any>undefined;
            if (Array.isArray(_data["batchs"])) {
                this.batchs = [] as any;
                for (let item of _data["batchs"])
                    this.batchs!.push(SelectBatch.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetPromoSalesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPromoSalesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.stores)) {
            data["stores"] = [];
            for (let item of this.stores)
                data["stores"].push(item);
        }
        data["promoBegin"] = this.promoBegin ? this.promoBegin.toISOString() : <any>undefined;
        data["promoEnd"] = this.promoEnd ? this.promoEnd.toISOString() : <any>undefined;
        data["includedRandomweightItem"] = this.includedRandomweightItem;
        data["noPromoBegin"] = this.noPromoBegin ? this.noPromoBegin.toISOString() : <any>undefined;
        data["noPromoEnd"] = this.noPromoEnd ? this.noPromoEnd.toISOString() : <any>undefined;
        if (Array.isArray(this.batchs)) {
            data["batchs"] = [];
            for (let item of this.batchs)
                data["batchs"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IGetPromoSalesRequest {
    stores: number[];
    /** 开始日期 (ISO 8601 格式: yyyy-MM-ddTHH:mm:ssZ)
  */
    promoBegin: Date;
    /** 结束日期 (ISO 8601 格式: yyyy-MM-ddTHH:mm:ssZ) */
    promoEnd: Date;
    /** false 不包含 002开头 00000结尾的商品 */
    includedRandomweightItem: boolean;
    /** 非促销时间段 */
    noPromoBegin?: Date | undefined;
    /** 非促销时间段 */
    noPromoEnd?: Date | undefined;
    /** 促销批次ID */
    batchs?: SelectBatch[] | undefined;
}

export class SelectBatch implements ISelectBatch {
    storeId?: number;
    batchID?: number;

    constructor(data?: ISelectBatch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeId = _data["storeId"];
            this.batchID = _data["batchID"];
        }
    }

    static fromJS(data: any): SelectBatch {
        data = typeof data === 'object' ? data : {};
        let result = new SelectBatch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["batchID"] = this.batchID;
        return data;
    }
}

export interface ISelectBatch {
    storeId?: number;
    batchID?: number;
}

export class BatchPromoDto implements IBatchPromoDto {
    id?: number;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    description?: string | undefined;
    storeId?: number;
    storeName?: string;

    constructor(data?: IBatchPromoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.description = _data["description"];
            this.storeId = _data["storeId"];
            this.storeName = _data["storeName"];
        }
    }

    static fromJS(data: any): BatchPromoDto {
        data = typeof data === 'object' ? data : {};
        let result = new BatchPromoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["description"] = this.description;
        data["storeId"] = this.storeId;
        data["storeName"] = this.storeName;
        return data;
    }
}

export interface IBatchPromoDto {
    id?: number;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    description?: string | undefined;
    storeId?: number;
    storeName?: string;
}

export class PricePeriodSalesDto implements IPricePeriodSalesDto {
    promoDesc?: string;
    /** 时间段（格式：yyyy-MM-dd to yyyy-MM-dd） */
    timePeriod?: string;
    /** 商品编码 */
    itemCode?: string;
    /** 商品描述 */
    itemDescription?: string;
    /** 单价（周期内的价格） */
    unitPrice?: number | undefined;
    /** 是否促销价格（Yes/No） */
    isOnSale?: string;
    /** 周期内总销量 */
    totalQuantity?: number;
    /** 周期内总销售额（PackPrice 汇总） */
    totalAmount?: number;
    /** 周期内有销售的天数 */
    saleDays?: number;
    /** 促销交易次数（MarkDisc != 0） */
    promotionTransactionCount?: number;
    /** 促销数量 */
    promotionQuantity?: number;
    /** 促销金额 */
    promotionAmount?: number;
    /** 平均单价（TotalAmount / TotalQuantity） */
    avgPricePerUnit?: number;
    /** 促销数量占比（百分比） */
    promotionQuantityPercentage?: number;
    storeId?: number;
    storeName?: string;

    constructor(data?: IPricePeriodSalesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.promoDesc = _data["promoDesc"];
            this.timePeriod = _data["timePeriod"];
            this.itemCode = _data["itemCode"];
            this.itemDescription = _data["itemDescription"];
            this.unitPrice = _data["unitPrice"];
            this.isOnSale = _data["isOnSale"];
            this.totalQuantity = _data["totalQuantity"];
            this.totalAmount = _data["totalAmount"];
            this.saleDays = _data["saleDays"];
            this.promotionTransactionCount = _data["promotionTransactionCount"];
            this.promotionQuantity = _data["promotionQuantity"];
            this.promotionAmount = _data["promotionAmount"];
            this.avgPricePerUnit = _data["avgPricePerUnit"];
            this.promotionQuantityPercentage = _data["promotionQuantityPercentage"];
            this.storeId = _data["storeId"];
            this.storeName = _data["storeName"];
        }
    }

    static fromJS(data: any): PricePeriodSalesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PricePeriodSalesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["promoDesc"] = this.promoDesc;
        data["timePeriod"] = this.timePeriod;
        data["itemCode"] = this.itemCode;
        data["itemDescription"] = this.itemDescription;
        data["unitPrice"] = this.unitPrice;
        data["isOnSale"] = this.isOnSale;
        data["totalQuantity"] = this.totalQuantity;
        data["totalAmount"] = this.totalAmount;
        data["saleDays"] = this.saleDays;
        data["promotionTransactionCount"] = this.promotionTransactionCount;
        data["promotionQuantity"] = this.promotionQuantity;
        data["promotionAmount"] = this.promotionAmount;
        data["avgPricePerUnit"] = this.avgPricePerUnit;
        data["promotionQuantityPercentage"] = this.promotionQuantityPercentage;
        data["storeId"] = this.storeId;
        data["storeName"] = this.storeName;
        return data;
    }
}

export interface IPricePeriodSalesDto {
    promoDesc?: string;
    /** 时间段（格式：yyyy-MM-dd to yyyy-MM-dd） */
    timePeriod?: string;
    /** 商品编码 */
    itemCode?: string;
    /** 商品描述 */
    itemDescription?: string;
    /** 单价（周期内的价格） */
    unitPrice?: number | undefined;
    /** 是否促销价格（Yes/No） */
    isOnSale?: string;
    /** 周期内总销量 */
    totalQuantity?: number;
    /** 周期内总销售额（PackPrice 汇总） */
    totalAmount?: number;
    /** 周期内有销售的天数 */
    saleDays?: number;
    /** 促销交易次数（MarkDisc != 0） */
    promotionTransactionCount?: number;
    /** 促销数量 */
    promotionQuantity?: number;
    /** 促销金额 */
    promotionAmount?: number;
    /** 平均单价（TotalAmount / TotalQuantity） */
    avgPricePerUnit?: number;
    /** 促销数量占比（百分比） */
    promotionQuantityPercentage?: number;
    storeId?: number;
    storeName?: string;
}

export class PricePeriodSalesRequest implements IPricePeriodSalesRequest {
    storeId!: number;
    startDate!: Date;
    endDate!: Date;
    itemCode!: string;
    itemDesc!: string;

    constructor(data?: IPricePeriodSalesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeId = _data["storeId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.itemCode = _data["itemCode"];
            this.itemDesc = _data["itemDesc"];
        }
    }

    static fromJS(data: any): PricePeriodSalesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PricePeriodSalesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["itemCode"] = this.itemCode;
        data["itemDesc"] = this.itemDesc;
        return data;
    }
}

export interface IPricePeriodSalesRequest {
    storeId: number;
    startDate: Date;
    endDate: Date;
    itemCode: string;
    itemDesc: string;
}

export class GetTokenRequestDto implements IGetTokenRequestDto {
    userName!: string;
    password!: string;

    constructor(data?: IGetTokenRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): GetTokenRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTokenRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["password"] = this.password;
        return data;
    }
}

export interface IGetTokenRequestDto {
    userName: string;
    password: string;
}

export class DiscountStoreCouponResponseDto implements IDiscountStoreCouponResponseDto {
    discountStoreCoupons?: DiscountStoreCouponDto[] | undefined;

    constructor(data?: IDiscountStoreCouponResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["discountStoreCoupons"])) {
                this.discountStoreCoupons = [] as any;
                for (let item of _data["discountStoreCoupons"])
                    this.discountStoreCoupons!.push(DiscountStoreCouponDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DiscountStoreCouponResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiscountStoreCouponResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.discountStoreCoupons)) {
            data["discountStoreCoupons"] = [];
            for (let item of this.discountStoreCoupons)
                data["discountStoreCoupons"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IDiscountStoreCouponResponseDto {
    discountStoreCoupons?: DiscountStoreCouponDto[] | undefined;
}

export class DiscountStoreCouponDto implements IDiscountStoreCouponDto {
    storeName?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    qty?: number;
    total?: number | undefined;

    constructor(data?: IDiscountStoreCouponDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeName = _data["storeName"];
            this.code = _data["code"];
            this.description = _data["description"];
            this.qty = _data["qty"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): DiscountStoreCouponDto {
        data = typeof data === 'object' ? data : {};
        let result = new DiscountStoreCouponDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeName"] = this.storeName;
        data["code"] = this.code;
        data["description"] = this.description;
        data["qty"] = this.qty;
        data["total"] = this.total;
        return data;
    }
}

export interface IDiscountStoreCouponDto {
    storeName?: string | undefined;
    code?: string | undefined;
    description?: string | undefined;
    qty?: number;
    total?: number | undefined;
}

export class StoreListDto implements IStoreListDto {
    stores?: ReportStoreDto[] | undefined;

    constructor(data?: IStoreListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["stores"])) {
                this.stores = [] as any;
                for (let item of _data["stores"])
                    this.stores!.push(ReportStoreDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StoreListDto {
        data = typeof data === 'object' ? data : {};
        let result = new StoreListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.stores)) {
            data["stores"] = [];
            for (let item of this.stores)
                data["stores"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IStoreListDto {
    stores?: ReportStoreDto[] | undefined;
}

export class ReportStoreDto implements IReportStoreDto {
    storeId?: number;
    storeName?: string | undefined;
    startingHourOfTheDay?: number;
    beginDayOfWeek?: number;

    constructor(data?: IReportStoreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeId = _data["storeId"];
            this.storeName = _data["storeName"];
            this.startingHourOfTheDay = _data["startingHourOfTheDay"];
            this.beginDayOfWeek = _data["beginDayOfWeek"];
        }
    }

    static fromJS(data: any): ReportStoreDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportStoreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["storeName"] = this.storeName;
        data["startingHourOfTheDay"] = this.startingHourOfTheDay;
        data["beginDayOfWeek"] = this.beginDayOfWeek;
        return data;
    }
}

export interface IReportStoreDto {
    storeId?: number;
    storeName?: string | undefined;
    startingHourOfTheDay?: number;
    beginDayOfWeek?: number;
}

export class HourlySalesResponseDto implements IHourlySalesResponseDto {
    sales?: HourlySalesDto[] | undefined;

    constructor(data?: IHourlySalesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["sales"])) {
                this.sales = [] as any;
                for (let item of _data["sales"])
                    this.sales!.push(HourlySalesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HourlySalesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new HourlySalesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sales)) {
            data["sales"] = [];
            for (let item of this.sales)
                data["sales"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IHourlySalesResponseDto {
    sales?: HourlySalesDto[] | undefined;
}

export class HourlySalesDto implements IHourlySalesDto {
    hour?: string | undefined;
    qty?: number | undefined;
    sales?: number | undefined;
    percentage?: number | undefined;
    trxCount?: number | undefined;

    constructor(data?: IHourlySalesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hour = _data["hour"];
            this.qty = _data["qty"];
            this.sales = _data["sales"];
            this.percentage = _data["percentage"];
            this.trxCount = _data["trxCount"];
        }
    }

    static fromJS(data: any): HourlySalesDto {
        data = typeof data === 'object' ? data : {};
        let result = new HourlySalesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hour"] = this.hour;
        data["qty"] = this.qty;
        data["sales"] = this.sales;
        data["percentage"] = this.percentage;
        data["trxCount"] = this.trxCount;
        return data;
    }
}

export interface IHourlySalesDto {
    hour?: string | undefined;
    qty?: number | undefined;
    sales?: number | undefined;
    percentage?: number | undefined;
    trxCount?: number | undefined;
}

export class DepartmentGroupSalesResponseDto implements IDepartmentGroupSalesResponseDto {
    departmentGroupSalesList?: DepartmentGroupSalesDto[] | undefined;

    constructor(data?: IDepartmentGroupSalesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["departmentGroupSalesList"])) {
                this.departmentGroupSalesList = [] as any;
                for (let item of _data["departmentGroupSalesList"])
                    this.departmentGroupSalesList!.push(DepartmentGroupSalesDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DepartmentGroupSalesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentGroupSalesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.departmentGroupSalesList)) {
            data["departmentGroupSalesList"] = [];
            for (let item of this.departmentGroupSalesList)
                data["departmentGroupSalesList"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IDepartmentGroupSalesResponseDto {
    departmentGroupSalesList?: DepartmentGroupSalesDto[] | undefined;
}

export class DepartmentGroupSalesDto implements IDepartmentGroupSalesDto {
    department?: string | undefined;
    group?: string | undefined;
    qty?: number | undefined;
    sales?: number | undefined;
    trxCount?: number | undefined;
    avgItemsTrx?: number | undefined;

    constructor(data?: IDepartmentGroupSalesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.department = _data["department"];
            this.group = _data["group"];
            this.qty = _data["qty"];
            this.sales = _data["sales"];
            this.trxCount = _data["trxCount"];
            this.avgItemsTrx = _data["avgItemsTrx"];
        }
    }

    static fromJS(data: any): DepartmentGroupSalesDto {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentGroupSalesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["department"] = this.department;
        data["group"] = this.group;
        data["qty"] = this.qty;
        data["sales"] = this.sales;
        data["trxCount"] = this.trxCount;
        data["avgItemsTrx"] = this.avgItemsTrx;
        return data;
    }
}

export interface IDepartmentGroupSalesDto {
    department?: string | undefined;
    group?: string | undefined;
    qty?: number | undefined;
    sales?: number | undefined;
    trxCount?: number | undefined;
    avgItemsTrx?: number | undefined;
}

export class TenderResponse implements ITenderResponse {
    tenders?: Tender[] | undefined;

    constructor(data?: ITenderResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tenders"])) {
                this.tenders = [] as any;
                for (let item of _data["tenders"])
                    this.tenders!.push(Tender.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TenderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TenderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tenders)) {
            data["tenders"] = [];
            for (let item of this.tenders)
                data["tenders"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ITenderResponse {
    tenders?: Tender[] | undefined;
}

export class Tender implements ITender {
    description?: string | undefined;
    amount?: number;
    count?: number;

    constructor(data?: ITender) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.amount = _data["amount"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): Tender {
        data = typeof data === 'object' ? data : {};
        let result = new Tender();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["amount"] = this.amount;
        data["count"] = this.count;
        return data;
    }
}

export interface ITender {
    description?: string | undefined;
    amount?: number;
    count?: number;
}

export class SummaryResponseDto implements ISummaryResponseDto {
    regularRevenue?: number | undefined;
    returnQty?: number | undefined;
    return?: number | undefined;
    waste?: number | undefined;
    tax?: number | undefined;
    otherRevenue?: number | undefined;
    custCount?: number | undefined;
    loyaltyCustomer?: number | undefined;
    currentTime?: Date | undefined;
    beginDatetime?: string | undefined;
    endDatetime?: string | undefined;

    constructor(data?: ISummaryResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.regularRevenue = _data["regularRevenue"];
            this.returnQty = _data["returnQty"];
            this.return = _data["return"];
            this.waste = _data["waste"];
            this.tax = _data["tax"];
            this.otherRevenue = _data["otherRevenue"];
            this.custCount = _data["custCount"];
            this.loyaltyCustomer = _data["loyaltyCustomer"];
            this.currentTime = _data["currentTime"] ? new Date(_data["currentTime"].toString()) : <any>undefined;
            this.beginDatetime = _data["beginDatetime"];
            this.endDatetime = _data["endDatetime"];
        }
    }

    static fromJS(data: any): SummaryResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SummaryResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["regularRevenue"] = this.regularRevenue;
        data["returnQty"] = this.returnQty;
        data["return"] = this.return;
        data["waste"] = this.waste;
        data["tax"] = this.tax;
        data["otherRevenue"] = this.otherRevenue;
        data["custCount"] = this.custCount;
        data["loyaltyCustomer"] = this.loyaltyCustomer;
        data["currentTime"] = this.currentTime ? this.currentTime.toISOString() : <any>undefined;
        data["beginDatetime"] = this.beginDatetime;
        data["endDatetime"] = this.endDatetime;
        return data;
    }
}

export interface ISummaryResponseDto {
    regularRevenue?: number | undefined;
    returnQty?: number | undefined;
    return?: number | undefined;
    waste?: number | undefined;
    tax?: number | undefined;
    otherRevenue?: number | undefined;
    custCount?: number | undefined;
    loyaltyCustomer?: number | undefined;
    currentTime?: Date | undefined;
    beginDatetime?: string | undefined;
    endDatetime?: string | undefined;
}

export class HelloReply2Dto implements IHelloReply2Dto {
    message?: string | undefined;

    constructor(data?: IHelloReply2Dto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): HelloReply2Dto {
        data = typeof data === 'object' ? data : {};
        let result = new HelloReply2Dto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        return data;
    }
}

export interface IHelloReply2Dto {
    message?: string | undefined;
}

export enum ReportJobType {
    DepartmentComparison = "DepartmentComparison",
    StoreGroupComparison = "StoreGroupComparison",
}

export enum ReportDataDateRangeType {
    PreviousDay = "PreviousDay",
    PreviousWeek = "PreviousWeek",
    PreviousMonth = "PreviousMonth",
}

export class ReportJobRequest implements IReportJobRequest {
    description!: string;
    /** 报表类型 */
    jobType!: ReportJobType;
    /** 报表数据时间范围 */
    reportDataDateRange!: ReportDataDateRangeType;
    /** 任务执行时间 */
    excuteDate!: JobExcuteDate;
    /** 店铺 */
    storeIds!: number[];
    /** 用户邮箱 */
    users!: UserInfo[];

    constructor(data?: IReportJobRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.excuteDate = new JobExcuteDate();
            this.storeIds = [];
            this.users = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.jobType = _data["jobType"];
            this.reportDataDateRange = _data["reportDataDateRange"];
            this.excuteDate = _data["excuteDate"] ? JobExcuteDate.fromJS(_data["excuteDate"]) : new JobExcuteDate();
            if (Array.isArray(_data["storeIds"])) {
                this.storeIds = [] as any;
                for (let item of _data["storeIds"])
                    this.storeIds!.push(item);
            }
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportJobRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReportJobRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["jobType"] = this.jobType;
        data["reportDataDateRange"] = this.reportDataDateRange;
        data["excuteDate"] = this.excuteDate ? this.excuteDate.toJSON() : <any>undefined;
        if (Array.isArray(this.storeIds)) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IReportJobRequest {
    description: string;
    /** 报表类型 */
    jobType: ReportJobType;
    /** 报表数据时间范围 */
    reportDataDateRange: ReportDataDateRangeType;
    /** 任务执行时间 */
    excuteDate: JobExcuteDate;
    /** 店铺 */
    storeIds: number[];
    /** 用户邮箱 */
    users: UserInfo[];
}

export class ReportJobItem extends ReportJobRequest implements IReportJobItem {
    jobKey?: string;
    createUser?: string;
    nextFireTime?: Date | undefined;
    cronExpression?: string | undefined;
    lastModifiedAt?: Date | undefined;

    constructor(data?: IReportJobItem) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.jobKey = _data["jobKey"];
            this.createUser = _data["createUser"];
            this.nextFireTime = _data["nextFireTime"] ? new Date(_data["nextFireTime"].toString()) : <any>undefined;
            this.cronExpression = _data["cronExpression"];
            this.lastModifiedAt = _data["lastModifiedAt"] ? new Date(_data["lastModifiedAt"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): ReportJobItem {
        data = typeof data === 'object' ? data : {};
        let result = new ReportJobItem();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobKey"] = this.jobKey;
        data["createUser"] = this.createUser;
        data["nextFireTime"] = this.nextFireTime ? this.nextFireTime.toISOString() : <any>undefined;
        data["cronExpression"] = this.cronExpression;
        data["lastModifiedAt"] = this.lastModifiedAt ? this.lastModifiedAt.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IReportJobItem extends IReportJobRequest {
    jobKey?: string;
    createUser?: string;
    nextFireTime?: Date | undefined;
    cronExpression?: string | undefined;
    lastModifiedAt?: Date | undefined;
}

export class JobExcuteDate implements IJobExcuteDate {
    /** [Frequency = "Daily", Hour = 0, Minute = 0]  (每天 0:00 执行)
[Frequency = "Weekly",WeekDay = "Monday" Hour = 0, Minute = 0]  (每周一 00：00执行 )
[Frequency = "Monthly", Hour = 0, Minute = 0, DayOfMonth = 1] (每月 1 号 9:00 执行)
[Frequency = "Yearly", Hour = 0, Minute = 0, DayOfMonth = 1, Month = 1] (每年 1 月 1 日 8:00 执行) */
    frequency?: Frequency;
    /** 星期 */
    weekDay?: string | undefined;
    /** 时 */
    hour?: number;
    /** 分 */
    minute?: number;
    /** 每月或每年执行的日期（1~31） */
    dayOfMonth?: number;
    /** 每年执行的月份（1~12） */
    month?: number;

    constructor(data?: IJobExcuteDate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.frequency = _data["frequency"];
            this.weekDay = _data["weekDay"];
            this.hour = _data["hour"];
            this.minute = _data["minute"];
            this.dayOfMonth = _data["dayOfMonth"];
            this.month = _data["month"];
        }
    }

    static fromJS(data: any): JobExcuteDate {
        data = typeof data === 'object' ? data : {};
        let result = new JobExcuteDate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["frequency"] = this.frequency;
        data["weekDay"] = this.weekDay;
        data["hour"] = this.hour;
        data["minute"] = this.minute;
        data["dayOfMonth"] = this.dayOfMonth;
        data["month"] = this.month;
        return data;
    }
}

export interface IJobExcuteDate {
    /** [Frequency = "Daily", Hour = 0, Minute = 0]  (每天 0:00 执行)
[Frequency = "Weekly",WeekDay = "Monday" Hour = 0, Minute = 0]  (每周一 00：00执行 )
[Frequency = "Monthly", Hour = 0, Minute = 0, DayOfMonth = 1] (每月 1 号 9:00 执行)
[Frequency = "Yearly", Hour = 0, Minute = 0, DayOfMonth = 1, Month = 1] (每年 1 月 1 日 8:00 执行) */
    frequency?: Frequency;
    /** 星期 */
    weekDay?: string | undefined;
    /** 时 */
    hour?: number;
    /** 分 */
    minute?: number;
    /** 每月或每年执行的日期（1~31） */
    dayOfMonth?: number;
    /** 每年执行的月份（1~12） */
    month?: number;
}

export enum Frequency {
    Daily = "Daily",
    Weekly = "Weekly",
    Monthly = "Monthly",
    Yearly = "Yearly",
}

export class UserInfo implements IUserInfo {
    email?: string;
    lastName?: string;
    firstName?: string;

    constructor(data?: IUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
        }
    }

    static fromJS(data: any): UserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        return data;
    }
}

export interface IUserInfo {
    email?: string;
    lastName?: string;
    firstName?: string;
}

export class SettingConfigResponse implements ISettingConfigResponse {
    items?: SettingConfigItem[] | undefined;

    constructor(data?: ISettingConfigResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SettingConfigItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SettingConfigResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SettingConfigResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ISettingConfigResponse {
    items?: SettingConfigItem[] | undefined;
}

export class SettingConfigItem implements ISettingConfigItem {
    filedName?: string | undefined;
    visibilityStatus?: FieldVisibility;
    selectStatus?: FieldSelection;

    constructor(data?: ISettingConfigItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filedName = _data["filedName"];
            this.visibilityStatus = _data["visibilityStatus"];
            this.selectStatus = _data["selectStatus"];
        }
    }

    static fromJS(data: any): SettingConfigItem {
        data = typeof data === 'object' ? data : {};
        let result = new SettingConfigItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filedName"] = this.filedName;
        data["visibilityStatus"] = this.visibilityStatus;
        data["selectStatus"] = this.selectStatus;
        return data;
    }
}

export interface ISettingConfigItem {
    filedName?: string | undefined;
    visibilityStatus?: FieldVisibility;
    selectStatus?: FieldSelection;
}

export enum FieldVisibility {
    Show = "Show",
    Hide = "Hide",
}

export enum FieldSelection {
    Required = "Required",
    Optional = "Optional",
}

export class SharedTemplate implements ISharedTemplate {
    templates?: Template[] | undefined;

    constructor(data?: ISharedTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["templates"])) {
                this.templates = [] as any;
                for (let item of _data["templates"])
                    this.templates!.push(Template.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SharedTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new SharedTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.templates)) {
            data["templates"] = [];
            for (let item of this.templates)
                data["templates"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ISharedTemplate {
    templates?: Template[] | undefined;
}

export class Template implements ITemplate {
    id?: string | undefined;
    templateName?: string | undefined;
    storeId?: number;

    constructor(data?: ITemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.templateName = _data["templateName"];
            this.storeId = _data["storeId"];
        }
    }

    static fromJS(data: any): Template {
        data = typeof data === 'object' ? data : {};
        let result = new Template();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["templateName"] = this.templateName;
        data["storeId"] = this.storeId;
        return data;
    }
}

export interface ITemplate {
    id?: string | undefined;
    templateName?: string | undefined;
    storeId?: number;
}

export class SearchTemplate implements ISearchTemplate {
    id?: string | undefined;
    templateName?: string | undefined;
    templateJson?: string | undefined;
    lastModified?: Date | undefined;
    created?: Date | undefined;

    constructor(data?: ISearchTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.templateName = _data["templateName"];
            this.templateJson = _data["templateJson"];
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SearchTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new SearchTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["templateName"] = this.templateName;
        data["templateJson"] = this.templateJson;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISearchTemplate {
    id?: string | undefined;
    templateName?: string | undefined;
    templateJson?: string | undefined;
    lastModified?: Date | undefined;
    created?: Date | undefined;
}

export class SqlExecutorResponseDto implements ISqlExecutorResponseDto {
    storeId?: number;
    storename?: string | undefined;
    result?: { [key: string]: any; }[] | undefined;

    constructor(data?: ISqlExecutorResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeId = _data["StoreId"];
            this.storename = _data["Storename"];
            if (Array.isArray(_data["Result"])) {
                this.result = [] as any;
                for (let item of _data["Result"])
                    this.result!.push(item);
            }
        }
    }

    static fromJS(data: any): SqlExecutorResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SqlExecutorResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["StoreId"] = this.storeId;
        data["Storename"] = this.storename;
        if (Array.isArray(this.result)) {
            data["Result"] = [];
            for (let item of this.result)
                data["Result"].push(item);
        }
        return data;
    }
}

export interface ISqlExecutorResponseDto {
    storeId?: number;
    storename?: string | undefined;
    result?: { [key: string]: any; }[] | undefined;
}

export class QuerySqlRequest implements IQuerySqlRequest {
    storeIdArray?: number[] | undefined;
    sql?: string | undefined;

    constructor(data?: IQuerySqlRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["storeIdArray"])) {
                this.storeIdArray = [] as any;
                for (let item of _data["storeIdArray"])
                    this.storeIdArray!.push(item);
            }
            this.sql = _data["sql"];
        }
    }

    static fromJS(data: any): QuerySqlRequest {
        data = typeof data === 'object' ? data : {};
        let result = new QuerySqlRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.storeIdArray)) {
            data["storeIdArray"] = [];
            for (let item of this.storeIdArray)
                data["storeIdArray"].push(item);
        }
        data["sql"] = this.sql;
        return data;
    }
}

export interface IQuerySqlRequest {
    storeIdArray?: number[] | undefined;
    sql?: string | undefined;
}

export class SqlTempleteDto implements ISqlTempleteDto {
    templeteDescription?: string | undefined;
    sqlText?: string | undefined;

    constructor(data?: ISqlTempleteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.templeteDescription = _data["templeteDescription"];
            this.sqlText = _data["sqlText"];
        }
    }

    static fromJS(data: any): SqlTempleteDto {
        data = typeof data === 'object' ? data : {};
        let result = new SqlTempleteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["templeteDescription"] = this.templeteDescription;
        data["sqlText"] = this.sqlText;
        return data;
    }
}

export interface ISqlTempleteDto {
    templeteDescription?: string | undefined;
    sqlText?: string | undefined;
}

export enum StoreChainCodeType {
    Internal = "Internal",
    Normal = "Normal",
    None = "None",
}

export class StoreChainCodeInfo implements IStoreChainCodeInfo {
    id?: string | undefined;
    colorId?: number;
    desc?: string | undefined;
    barcode?: string | undefined;
    departmentDesc?: string | undefined;
    vendorDesc?: string | undefined;
    brandDesc?: string | undefined;
    price?: number;
    priceBase?: number;
    scaleSaleMode?: ScaleSaleMode | undefined;
    chainCode?: string | undefined;
    chainDepartment?: string | undefined;
    chainDescription?: string | undefined;
    storeID?: number;
    storeName?: string | undefined;

    constructor(data?: IStoreChainCodeInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.colorId = _data["colorId"];
            this.desc = _data["desc"];
            this.barcode = _data["barcode"];
            this.departmentDesc = _data["departmentDesc"];
            this.vendorDesc = _data["vendorDesc"];
            this.brandDesc = _data["brandDesc"];
            this.price = _data["price"];
            this.priceBase = _data["priceBase"];
            this.scaleSaleMode = _data["scaleSaleMode"];
            this.chainCode = _data["chainCode"];
            this.chainDepartment = _data["chainDepartment"];
            this.chainDescription = _data["chainDescription"];
            this.storeID = _data["storeID"];
            this.storeName = _data["storeName"];
        }
    }

    static fromJS(data: any): StoreChainCodeInfo {
        data = typeof data === 'object' ? data : {};
        let result = new StoreChainCodeInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["colorId"] = this.colorId;
        data["desc"] = this.desc;
        data["barcode"] = this.barcode;
        data["departmentDesc"] = this.departmentDesc;
        data["vendorDesc"] = this.vendorDesc;
        data["brandDesc"] = this.brandDesc;
        data["price"] = this.price;
        data["priceBase"] = this.priceBase;
        data["scaleSaleMode"] = this.scaleSaleMode;
        data["chainCode"] = this.chainCode;
        data["chainDepartment"] = this.chainDepartment;
        data["chainDescription"] = this.chainDescription;
        data["storeID"] = this.storeID;
        data["storeName"] = this.storeName;
        return data;
    }
}

export interface IStoreChainCodeInfo {
    id?: string | undefined;
    colorId?: number;
    desc?: string | undefined;
    barcode?: string | undefined;
    departmentDesc?: string | undefined;
    vendorDesc?: string | undefined;
    brandDesc?: string | undefined;
    price?: number;
    priceBase?: number;
    scaleSaleMode?: ScaleSaleMode | undefined;
    chainCode?: string | undefined;
    chainDepartment?: string | undefined;
    chainDescription?: string | undefined;
    storeID?: number;
    storeName?: string | undefined;
}

export class UpdateProductChainCodeDto implements IUpdateProductChainCodeDto {
    storeCode?: KeyValuePairedOfIntegerAndString[];
    chainCodeInfo?: StoreChainCodeUpdateRequest;

    constructor(data?: IUpdateProductChainCodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["storeCode"])) {
                this.storeCode = [] as any;
                for (let item of _data["storeCode"])
                    this.storeCode!.push(KeyValuePairedOfIntegerAndString.fromJS(item));
            }
            this.chainCodeInfo = _data["chainCodeInfo"] ? StoreChainCodeUpdateRequest.fromJS(_data["chainCodeInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UpdateProductChainCodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProductChainCodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.storeCode)) {
            data["storeCode"] = [];
            for (let item of this.storeCode)
                data["storeCode"].push(item ? item.toJSON() : <any>undefined);
        }
        data["chainCodeInfo"] = this.chainCodeInfo ? this.chainCodeInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUpdateProductChainCodeDto {
    storeCode?: KeyValuePairedOfIntegerAndString[];
    chainCodeInfo?: StoreChainCodeUpdateRequest;
}

export class StoreChainCodeUpdateRequest implements IStoreChainCodeUpdateRequest {
    chainCode?: string | undefined;
    chainDepartment?: string | undefined;
    chainDescription?: string | undefined;

    constructor(data?: IStoreChainCodeUpdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.chainCode = _data["chainCode"];
            this.chainDepartment = _data["chainDepartment"];
            this.chainDescription = _data["chainDescription"];
        }
    }

    static fromJS(data: any): StoreChainCodeUpdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StoreChainCodeUpdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["chainCode"] = this.chainCode;
        data["chainDepartment"] = this.chainDepartment;
        data["chainDescription"] = this.chainDescription;
        return data;
    }
}

export interface IStoreChainCodeUpdateRequest {
    chainCode?: string | undefined;
    chainDepartment?: string | undefined;
    chainDescription?: string | undefined;
}

export class KeyValuePairedOfIntegerAndBoolean implements IKeyValuePairedOfIntegerAndBoolean {
    key?: number;
    value?: boolean;

    constructor(data?: IKeyValuePairedOfIntegerAndBoolean) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): KeyValuePairedOfIntegerAndBoolean {
        data = typeof data === 'object' ? data : {};
        let result = new KeyValuePairedOfIntegerAndBoolean();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface IKeyValuePairedOfIntegerAndBoolean {
    key?: number;
    value?: boolean;
}

export class StoreDataCloneBody implements IStoreDataCloneBody {
    currentStore!: number;
    targentStore!: number;
    barCodes!: string[];

    constructor(data?: IStoreDataCloneBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.barCodes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentStore = _data["currentStore"];
            this.targentStore = _data["targentStore"];
            if (Array.isArray(_data["barCodes"])) {
                this.barCodes = [] as any;
                for (let item of _data["barCodes"])
                    this.barCodes!.push(item);
            }
        }
    }

    static fromJS(data: any): StoreDataCloneBody {
        data = typeof data === 'object' ? data : {};
        let result = new StoreDataCloneBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentStore"] = this.currentStore;
        data["targentStore"] = this.targentStore;
        if (Array.isArray(this.barCodes)) {
            data["barCodes"] = [];
            for (let item of this.barCodes)
                data["barCodes"].push(item);
        }
        return data;
    }
}

export interface IStoreDataCloneBody {
    currentStore: number;
    targentStore: number;
    barCodes: string[];
}

export class MutiBarcodeCloneBody implements IMutiBarcodeCloneBody {
    fromStore?: number;
    toStore?: number;
    mainItemBarcodes?: string[] | undefined;

    constructor(data?: IMutiBarcodeCloneBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromStore = _data["fromStore"];
            this.toStore = _data["toStore"];
            if (Array.isArray(_data["mainItemBarcodes"])) {
                this.mainItemBarcodes = [] as any;
                for (let item of _data["mainItemBarcodes"])
                    this.mainItemBarcodes!.push(item);
            }
        }
    }

    static fromJS(data: any): MutiBarcodeCloneBody {
        data = typeof data === 'object' ? data : {};
        let result = new MutiBarcodeCloneBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromStore"] = this.fromStore;
        data["toStore"] = this.toStore;
        if (Array.isArray(this.mainItemBarcodes)) {
            data["mainItemBarcodes"] = [];
            for (let item of this.mainItemBarcodes)
                data["mainItemBarcodes"].push(item);
        }
        return data;
    }
}

export interface IMutiBarcodeCloneBody {
    fromStore?: number;
    toStore?: number;
    mainItemBarcodes?: string[] | undefined;
}

export class GroupSaleResponse implements IGroupSaleResponse {
    items?: SaleItem[];

    constructor(data?: IGroupSaleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SaleItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GroupSaleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GroupSaleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IGroupSaleResponse {
    items?: SaleItem[];
}

export class SaleItem implements ISaleItem {
    storeId?: number;
    storeName?: string | undefined;
    groupText?: string | undefined;
    totalSale?: number | undefined;
    accountNumber?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phonenumber?: string | undefined;
    createdDate?: Date | undefined;
    transactionCount?: number | undefined;

    constructor(data?: ISaleItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeId = _data["storeId"];
            this.storeName = _data["storeName"];
            this.groupText = _data["groupText"];
            this.totalSale = _data["totalSale"];
            this.accountNumber = _data["accountNumber"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phonenumber = _data["phonenumber"];
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.transactionCount = _data["transactionCount"];
        }
    }

    static fromJS(data: any): SaleItem {
        data = typeof data === 'object' ? data : {};
        let result = new SaleItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["storeName"] = this.storeName;
        data["groupText"] = this.groupText;
        data["totalSale"] = this.totalSale;
        data["accountNumber"] = this.accountNumber;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phonenumber"] = this.phonenumber;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["transactionCount"] = this.transactionCount;
        return data;
    }
}

export interface ISaleItem {
    storeId?: number;
    storeName?: string | undefined;
    groupText?: string | undefined;
    totalSale?: number | undefined;
    accountNumber?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phonenumber?: string | undefined;
    createdDate?: Date | undefined;
    transactionCount?: number | undefined;
}

export enum SearchType {
    Text = "Text",
    UPC = "UPC",
}

export class StoreInventoryDto implements IStoreInventoryDto {
    storeId?: number;
    storeName?: string | undefined;
    wareHouseID?: string | undefined;
    wareHouseName?: string | undefined;
    /** 商品条码 */
    upc?: string;
    /** 商品名 */
    productDescription?: string | undefined;
    brandDesc?: string | undefined;
    vendorDesc?: string | undefined;
    departmentDesc?: string | undefined;
    /** 库存 */
    onHand?: string | undefined;

    constructor(data?: IStoreInventoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeId = _data["storeId"];
            this.storeName = _data["storeName"];
            this.wareHouseID = _data["wareHouseID"];
            this.wareHouseName = _data["wareHouseName"];
            this.upc = _data["upc"];
            this.productDescription = _data["productDescription"];
            this.brandDesc = _data["brandDesc"];
            this.vendorDesc = _data["vendorDesc"];
            this.departmentDesc = _data["departmentDesc"];
            this.onHand = _data["onHand"];
        }
    }

    static fromJS(data: any): StoreInventoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new StoreInventoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["storeName"] = this.storeName;
        data["wareHouseID"] = this.wareHouseID;
        data["wareHouseName"] = this.wareHouseName;
        data["upc"] = this.upc;
        data["productDescription"] = this.productDescription;
        data["brandDesc"] = this.brandDesc;
        data["vendorDesc"] = this.vendorDesc;
        data["departmentDesc"] = this.departmentDesc;
        data["onHand"] = this.onHand;
        return data;
    }
}

export interface IStoreInventoryDto {
    storeId?: number;
    storeName?: string | undefined;
    wareHouseID?: string | undefined;
    wareHouseName?: string | undefined;
    /** 商品条码 */
    upc?: string;
    /** 商品名 */
    productDescription?: string | undefined;
    brandDesc?: string | undefined;
    vendorDesc?: string | undefined;
    departmentDesc?: string | undefined;
    /** 库存 */
    onHand?: string | undefined;
}

export class SearchStoreInventroyRequest implements ISearchStoreInventroyRequest {
    storeIdList!: number[];
    barCodeList!: string[];

    constructor(data?: ISearchStoreInventroyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.storeIdList = [];
            this.barCodeList = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["storeIdList"])) {
                this.storeIdList = [] as any;
                for (let item of _data["storeIdList"])
                    this.storeIdList!.push(item);
            }
            if (Array.isArray(_data["barCodeList"])) {
                this.barCodeList = [] as any;
                for (let item of _data["barCodeList"])
                    this.barCodeList!.push(item);
            }
        }
    }

    static fromJS(data: any): SearchStoreInventroyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchStoreInventroyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.storeIdList)) {
            data["storeIdList"] = [];
            for (let item of this.storeIdList)
                data["storeIdList"].push(item);
        }
        if (Array.isArray(this.barCodeList)) {
            data["barCodeList"] = [];
            for (let item of this.barCodeList)
                data["barCodeList"].push(item);
        }
        return data;
    }
}

export interface ISearchStoreInventroyRequest {
    storeIdList: number[];
    barCodeList: string[];
}

export class GetTransferResponseDto implements IGetTransferResponseDto {
    description?: string | undefined;
    id?: string;
    currentStore?: StoreInfoDto | undefined;
    targetStore?: StoreInfoDto | undefined;
    currentWareHouse?: WareHouseInfoDto | undefined;
    targetWareHouse?: WareHouseInfoDto | undefined;
    createdDate?: Date | undefined;
    transferDate?: Date | undefined;
    receivedDate?: Date | undefined;
    transferStatus?: TransferStatus;
    /** 商品总数量 */
    totalQty?: number;
    /** 商品条目数量 */
    itemCount?: number;
    transferProductInfos?: TransferProductInfo[];

    constructor(data?: IGetTransferResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.id = _data["id"];
            this.currentStore = _data["currentStore"] ? StoreInfoDto.fromJS(_data["currentStore"]) : <any>undefined;
            this.targetStore = _data["targetStore"] ? StoreInfoDto.fromJS(_data["targetStore"]) : <any>undefined;
            this.currentWareHouse = _data["currentWareHouse"] ? WareHouseInfoDto.fromJS(_data["currentWareHouse"]) : <any>undefined;
            this.targetWareHouse = _data["targetWareHouse"] ? WareHouseInfoDto.fromJS(_data["targetWareHouse"]) : <any>undefined;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>undefined;
            this.transferDate = _data["transferDate"] ? new Date(_data["transferDate"].toString()) : <any>undefined;
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : <any>undefined;
            this.transferStatus = _data["transferStatus"];
            this.totalQty = _data["totalQty"];
            this.itemCount = _data["itemCount"];
            if (Array.isArray(_data["transferProductInfos"])) {
                this.transferProductInfos = [] as any;
                for (let item of _data["transferProductInfos"])
                    this.transferProductInfos!.push(TransferProductInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetTransferResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransferResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["id"] = this.id;
        data["currentStore"] = this.currentStore ? this.currentStore.toJSON() : <any>undefined;
        data["targetStore"] = this.targetStore ? this.targetStore.toJSON() : <any>undefined;
        data["currentWareHouse"] = this.currentWareHouse ? this.currentWareHouse.toJSON() : <any>undefined;
        data["targetWareHouse"] = this.targetWareHouse ? this.targetWareHouse.toJSON() : <any>undefined;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["transferDate"] = this.transferDate ? this.transferDate.toISOString() : <any>undefined;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : <any>undefined;
        data["transferStatus"] = this.transferStatus;
        data["totalQty"] = this.totalQty;
        data["itemCount"] = this.itemCount;
        if (Array.isArray(this.transferProductInfos)) {
            data["transferProductInfos"] = [];
            for (let item of this.transferProductInfos)
                data["transferProductInfos"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IGetTransferResponseDto {
    description?: string | undefined;
    id?: string;
    currentStore?: StoreInfoDto | undefined;
    targetStore?: StoreInfoDto | undefined;
    currentWareHouse?: WareHouseInfoDto | undefined;
    targetWareHouse?: WareHouseInfoDto | undefined;
    createdDate?: Date | undefined;
    transferDate?: Date | undefined;
    receivedDate?: Date | undefined;
    transferStatus?: TransferStatus;
    /** 商品总数量 */
    totalQty?: number;
    /** 商品条目数量 */
    itemCount?: number;
    transferProductInfos?: TransferProductInfo[];
}

export class StoreInfoDto implements IStoreInfoDto {
    id?: number;
    storeName?: string | undefined;

    constructor(data?: IStoreInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.storeName = _data["storeName"];
        }
    }

    static fromJS(data: any): StoreInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new StoreInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeName"] = this.storeName;
        return data;
    }
}

export interface IStoreInfoDto {
    id?: number;
    storeName?: string | undefined;
}

export class WareHouseInfoDto implements IWareHouseInfoDto {
    wareHouseId?: string;
    wareHouseDesc?: string | undefined;

    constructor(data?: IWareHouseInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.wareHouseId = _data["wareHouseId"];
            this.wareHouseDesc = _data["wareHouseDesc"];
        }
    }

    static fromJS(data: any): WareHouseInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new WareHouseInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["wareHouseId"] = this.wareHouseId;
        data["wareHouseDesc"] = this.wareHouseDesc;
        return data;
    }
}

export interface IWareHouseInfoDto {
    wareHouseId?: string;
    wareHouseDesc?: string | undefined;
}

export enum TransferStatus {
    Dispatched = "Dispatched",
    Received = "Received",
    JustCreated = "JustCreated",
}

export class TransferProductInfo implements ITransferProductInfo {
    barCode?: string | undefined;
    desciption?: string | undefined;
    transferQty?: number;
    receiveQty?: number | undefined;
    currentPrice?: TransferProductPrcie | undefined;
    targentPrice?: TransferProductPrcie | undefined;

    constructor(data?: ITransferProductInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.barCode = _data["barCode"];
            this.desciption = _data["desciption"];
            this.transferQty = _data["transferQty"];
            this.receiveQty = _data["receiveQty"];
            this.currentPrice = _data["currentPrice"] ? TransferProductPrcie.fromJS(_data["currentPrice"]) : <any>undefined;
            this.targentPrice = _data["targentPrice"] ? TransferProductPrcie.fromJS(_data["targentPrice"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TransferProductInfo {
        data = typeof data === 'object' ? data : {};
        let result = new TransferProductInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["barCode"] = this.barCode;
        data["desciption"] = this.desciption;
        data["transferQty"] = this.transferQty;
        data["receiveQty"] = this.receiveQty;
        data["currentPrice"] = this.currentPrice ? this.currentPrice.toJSON() : <any>undefined;
        data["targentPrice"] = this.targentPrice ? this.targentPrice.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITransferProductInfo {
    barCode?: string | undefined;
    desciption?: string | undefined;
    transferQty?: number;
    receiveQty?: number | undefined;
    currentPrice?: TransferProductPrcie | undefined;
    targentPrice?: TransferProductPrcie | undefined;
}

export class TransferProductPrcie implements ITransferProductPrcie {
    price?: number | undefined;
    priceBase?: number | undefined;

    constructor(data?: ITransferProductPrcie) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.price = _data["price"];
            this.priceBase = _data["priceBase"];
        }
    }

    static fromJS(data: any): TransferProductPrcie {
        data = typeof data === 'object' ? data : {};
        let result = new TransferProductPrcie();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["price"] = this.price;
        data["priceBase"] = this.priceBase;
        return data;
    }
}

export interface ITransferProductPrcie {
    price?: number | undefined;
    priceBase?: number | undefined;
}

export class CreateTransferRequestDto implements ICreateTransferRequestDto {
    description?: string | undefined;
    currentStore?: number;
    targetStore?: number;
    currentWareHouse?: string;
    targetWareHouse?: string;
    transferProductInfos?: TransferProductInfo[] | undefined;

    constructor(data?: ICreateTransferRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.currentStore = _data["currentStore"];
            this.targetStore = _data["targetStore"];
            this.currentWareHouse = _data["currentWareHouse"];
            this.targetWareHouse = _data["targetWareHouse"];
            if (Array.isArray(_data["transferProductInfos"])) {
                this.transferProductInfos = [] as any;
                for (let item of _data["transferProductInfos"])
                    this.transferProductInfos!.push(TransferProductInfo.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CreateTransferRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTransferRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["currentStore"] = this.currentStore;
        data["targetStore"] = this.targetStore;
        data["currentWareHouse"] = this.currentWareHouse;
        data["targetWareHouse"] = this.targetWareHouse;
        if (Array.isArray(this.transferProductInfos)) {
            data["transferProductInfos"] = [];
            for (let item of this.transferProductInfos)
                data["transferProductInfos"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ICreateTransferRequestDto {
    description?: string | undefined;
    currentStore?: number;
    targetStore?: number;
    currentWareHouse?: string;
    targetWareHouse?: string;
    transferProductInfos?: TransferProductInfo[] | undefined;
}

export class UpdateStoreInventoryDto implements IUpdateStoreInventoryDto {
    storeId!: number;
    userId?: number;
    wareHouseId!: string;
    barcode!: string;
    onHand!: number;

    constructor(data?: IUpdateStoreInventoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeId = _data["storeId"];
            this.userId = _data["userId"];
            this.wareHouseId = _data["wareHouseId"];
            this.barcode = _data["barcode"];
            this.onHand = _data["onHand"];
        }
    }

    static fromJS(data: any): UpdateStoreInventoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStoreInventoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["userId"] = this.userId;
        data["wareHouseId"] = this.wareHouseId;
        data["barcode"] = this.barcode;
        data["onHand"] = this.onHand;
        return data;
    }
}

export interface IUpdateStoreInventoryDto {
    storeId: number;
    userId?: number;
    wareHouseId: string;
    barcode: string;
    onHand: number;
}

export class WareHouseDto implements IWareHouseDto {
    storeId?: number;
    storeName?: string;
    id?: string;
    wareHouseDescription?: string | undefined;
    isCurrentStore?: boolean;

    constructor(data?: IWareHouseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeId = _data["storeId"];
            this.storeName = _data["storeName"];
            this.id = _data["id"];
            this.wareHouseDescription = _data["wareHouseDescription"];
            this.isCurrentStore = _data["isCurrentStore"];
        }
    }

    static fromJS(data: any): WareHouseDto {
        data = typeof data === 'object' ? data : {};
        let result = new WareHouseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["storeName"] = this.storeName;
        data["id"] = this.id;
        data["wareHouseDescription"] = this.wareHouseDescription;
        data["isCurrentStore"] = this.isCurrentStore;
        return data;
    }
}

export interface IWareHouseDto {
    storeId?: number;
    storeName?: string;
    id?: string;
    wareHouseDescription?: string | undefined;
    isCurrentStore?: boolean;
}

export class DepartmentDifferenceReportDto implements IDepartmentDifferenceReportDto {
    departmentName?: string | undefined;
    groupName?: string | undefined;
    groupNumber?: string | undefined;
    unitsSoldFirst?: number;
    unitsSoldLast?: number;
    unitsSoldDifference?: number;
    totalSaleFirst?: number;
    totalSaleLast?: number;
    totalSaleDifference?: number;
    transactionsFirst?: number;
    transactionsLast?: number;
    transactionsDifference?: number;
    transactionAvgFirst?: number | undefined;
    transactionAvgLast?: number | undefined;
    transactionAvgDifference?: number | undefined;

    constructor(data?: IDepartmentDifferenceReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.departmentName = _data["departmentName"];
            this.groupName = _data["groupName"];
            this.groupNumber = _data["groupNumber"];
            this.unitsSoldFirst = _data["unitsSoldFirst"];
            this.unitsSoldLast = _data["unitsSoldLast"];
            this.unitsSoldDifference = _data["unitsSoldDifference"];
            this.totalSaleFirst = _data["totalSaleFirst"];
            this.totalSaleLast = _data["totalSaleLast"];
            this.totalSaleDifference = _data["totalSaleDifference"];
            this.transactionsFirst = _data["transactionsFirst"];
            this.transactionsLast = _data["transactionsLast"];
            this.transactionsDifference = _data["transactionsDifference"];
            this.transactionAvgFirst = _data["transactionAvgFirst"];
            this.transactionAvgLast = _data["transactionAvgLast"];
            this.transactionAvgDifference = _data["transactionAvgDifference"];
        }
    }

    static fromJS(data: any): DepartmentDifferenceReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentDifferenceReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["departmentName"] = this.departmentName;
        data["groupName"] = this.groupName;
        data["groupNumber"] = this.groupNumber;
        data["unitsSoldFirst"] = this.unitsSoldFirst;
        data["unitsSoldLast"] = this.unitsSoldLast;
        data["unitsSoldDifference"] = this.unitsSoldDifference;
        data["totalSaleFirst"] = this.totalSaleFirst;
        data["totalSaleLast"] = this.totalSaleLast;
        data["totalSaleDifference"] = this.totalSaleDifference;
        data["transactionsFirst"] = this.transactionsFirst;
        data["transactionsLast"] = this.transactionsLast;
        data["transactionsDifference"] = this.transactionsDifference;
        data["transactionAvgFirst"] = this.transactionAvgFirst;
        data["transactionAvgLast"] = this.transactionAvgLast;
        data["transactionAvgDifference"] = this.transactionAvgDifference;
        return data;
    }
}

export interface IDepartmentDifferenceReportDto {
    departmentName?: string | undefined;
    groupName?: string | undefined;
    groupNumber?: string | undefined;
    unitsSoldFirst?: number;
    unitsSoldLast?: number;
    unitsSoldDifference?: number;
    totalSaleFirst?: number;
    totalSaleLast?: number;
    totalSaleDifference?: number;
    transactionsFirst?: number;
    transactionsLast?: number;
    transactionsDifference?: number;
    transactionAvgFirst?: number | undefined;
    transactionAvgLast?: number | undefined;
    transactionAvgDifference?: number | undefined;
}

export class DepartmentBodys implements IDepartmentBodys {
    firstBody!: DepartmentBody;
    lastBody!: DepartmentBody;

    constructor(data?: IDepartmentBodys) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.firstBody = new DepartmentBody();
            this.lastBody = new DepartmentBody();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstBody = _data["firstBody"] ? DepartmentBody.fromJS(_data["firstBody"]) : new DepartmentBody();
            this.lastBody = _data["lastBody"] ? DepartmentBody.fromJS(_data["lastBody"]) : new DepartmentBody();
        }
    }

    static fromJS(data: any): DepartmentBodys {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentBodys();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstBody"] = this.firstBody ? this.firstBody.toJSON() : <any>undefined;
        data["lastBody"] = this.lastBody ? this.lastBody.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDepartmentBodys {
    firstBody: DepartmentBody;
    lastBody: DepartmentBody;
}

export class DepartmentBody implements IDepartmentBody {
    storeIds!: number[];
    beginDate!: Date;
    endDate!: Date;
    /** 组（可选） */
    groupNames?: string[] | undefined;

    constructor(data?: IDepartmentBody) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.storeIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["storeIds"])) {
                this.storeIds = [] as any;
                for (let item of _data["storeIds"])
                    this.storeIds!.push(item);
            }
            this.beginDate = _data["beginDate"] ? new Date(_data["beginDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["groupNames"])) {
                this.groupNames = [] as any;
                for (let item of _data["groupNames"])
                    this.groupNames!.push(item);
            }
        }
    }

    static fromJS(data: any): DepartmentBody {
        data = typeof data === 'object' ? data : {};
        let result = new DepartmentBody();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.storeIds)) {
            data["storeIds"] = [];
            for (let item of this.storeIds)
                data["storeIds"].push(item);
        }
        data["beginDate"] = this.beginDate ? this.beginDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.groupNames)) {
            data["groupNames"] = [];
            for (let item of this.groupNames)
                data["groupNames"].push(item);
        }
        return data;
    }
}

export interface IDepartmentBody {
    storeIds: number[];
    beginDate: Date;
    endDate: Date;
    /** 组（可选） */
    groupNames?: string[] | undefined;
}

export enum ReportType {
    Store = "Store",
    Department = "Department",
}

export class GroupDifferenceReportDto implements IGroupDifferenceReportDto {
    firstTotalCount?: number;
    lastTotalCount?: number;
    totalDifference?: number;
    groupsDifferences?: GroupDifferenceDto[];

    constructor(data?: IGroupDifferenceReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstTotalCount = _data["firstTotalCount"];
            this.lastTotalCount = _data["lastTotalCount"];
            this.totalDifference = _data["totalDifference"];
            if (Array.isArray(_data["groupsDifferences"])) {
                this.groupsDifferences = [] as any;
                for (let item of _data["groupsDifferences"])
                    this.groupsDifferences!.push(GroupDifferenceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GroupDifferenceReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupDifferenceReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstTotalCount"] = this.firstTotalCount;
        data["lastTotalCount"] = this.lastTotalCount;
        data["totalDifference"] = this.totalDifference;
        if (Array.isArray(this.groupsDifferences)) {
            data["groupsDifferences"] = [];
            for (let item of this.groupsDifferences)
                data["groupsDifferences"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IGroupDifferenceReportDto {
    firstTotalCount?: number;
    lastTotalCount?: number;
    totalDifference?: number;
    groupsDifferences?: GroupDifferenceDto[];
}

export class GroupDifferenceDto implements IGroupDifferenceDto {
    groupName?: string | undefined;
    firstCount?: number;
    lastCount?: number;
    difference?: number;

    constructor(data?: IGroupDifferenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupName = _data["groupName"];
            this.firstCount = _data["firstCount"];
            this.lastCount = _data["lastCount"];
            this.difference = _data["difference"];
        }
    }

    static fromJS(data: any): GroupDifferenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupDifferenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupName"] = this.groupName;
        data["firstCount"] = this.firstCount;
        data["lastCount"] = this.lastCount;
        data["difference"] = this.difference;
        return data;
    }
}

export interface IGroupDifferenceDto {
    groupName?: string | undefined;
    firstCount?: number;
    lastCount?: number;
    difference?: number;
}

export class StoreGroupComparisonDto implements IStoreGroupComparisonDto {
    groupName?: string | undefined;
    groupNumber?: string | undefined;
    storeName?: string | undefined;
    storeId?: number;
    totalSale?: number;
    unitsSold?: number;
    transactions?: number;
    transactionAvg?: number | undefined;

    constructor(data?: IStoreGroupComparisonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupName = _data["groupName"];
            this.groupNumber = _data["groupNumber"];
            this.storeName = _data["storeName"];
            this.storeId = _data["storeId"];
            this.totalSale = _data["totalSale"];
            this.unitsSold = _data["unitsSold"];
            this.transactions = _data["transactions"];
            this.transactionAvg = _data["transactionAvg"];
        }
    }

    static fromJS(data: any): StoreGroupComparisonDto {
        data = typeof data === 'object' ? data : {};
        let result = new StoreGroupComparisonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupName"] = this.groupName;
        data["groupNumber"] = this.groupNumber;
        data["storeName"] = this.storeName;
        data["storeId"] = this.storeId;
        data["totalSale"] = this.totalSale;
        data["unitsSold"] = this.unitsSold;
        data["transactions"] = this.transactions;
        data["transactionAvg"] = this.transactionAvg;
        return data;
    }
}

export interface IStoreGroupComparisonDto {
    groupName?: string | undefined;
    groupNumber?: string | undefined;
    storeName?: string | undefined;
    storeId?: number;
    totalSale?: number;
    unitsSold?: number;
    transactions?: number;
    transactionAvg?: number | undefined;
}

export class SalesRankingDto implements ISalesRankingDto {
    barcode?: string | undefined;
    description?: string | undefined;
    qtySold?: number;
    sales?: number;
    imageUrl?: string | undefined;

    constructor(data?: ISalesRankingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.barcode = _data["barcode"];
            this.description = _data["description"];
            this.qtySold = _data["qtySold"];
            this.sales = _data["sales"];
            this.imageUrl = _data["imageUrl"];
        }
    }

    static fromJS(data: any): SalesRankingDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalesRankingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["barcode"] = this.barcode;
        data["description"] = this.description;
        data["qtySold"] = this.qtySold;
        data["sales"] = this.sales;
        data["imageUrl"] = this.imageUrl;
        return data;
    }
}

export interface ISalesRankingDto {
    barcode?: string | undefined;
    description?: string | undefined;
    qtySold?: number;
    sales?: number;
    imageUrl?: string | undefined;
}

export class StoreDTO implements IStoreDTO {
    id?: number;
    encryptedId?: string | undefined;
    storename?: string | undefined;
    startingHourOfTheDay?: number;
    beginDayOfWeek?: DayOfWeek;
    dataMinerAccessKey?: string | undefined;
    companyId?: number | undefined;
    companyName?: string | undefined;
    selfOrderingSetting?: SelfOrderingSettingDto | undefined;
    settingTabs?: SettingTab[] | undefined;
    storeSetting?: string | undefined;
    connectionStatus?: string | undefined;
    pointBalanceAccessKey?: string | undefined;
    greetingMessage?: string | undefined;
    logoLink?: string | undefined;
    primaryColor?: string | undefined;
    ipAddress?: string | undefined;

    constructor(data?: IStoreDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.encryptedId = _data["encryptedId"];
            this.storename = _data["storename"];
            this.startingHourOfTheDay = _data["startingHourOfTheDay"];
            this.beginDayOfWeek = _data["beginDayOfWeek"];
            this.dataMinerAccessKey = _data["dataMinerAccessKey"];
            this.companyId = _data["companyId"];
            this.companyName = _data["companyName"];
            this.selfOrderingSetting = _data["selfOrderingSetting"] ? SelfOrderingSettingDto.fromJS(_data["selfOrderingSetting"]) : <any>undefined;
            if (Array.isArray(_data["settingTabs"])) {
                this.settingTabs = [] as any;
                for (let item of _data["settingTabs"])
                    this.settingTabs!.push(SettingTab.fromJS(item));
            }
            this.storeSetting = _data["storeSetting"];
            this.connectionStatus = _data["connectionStatus"];
            this.pointBalanceAccessKey = _data["pointBalanceAccessKey"];
            this.greetingMessage = _data["greetingMessage"];
            this.logoLink = _data["logoLink"];
            this.primaryColor = _data["primaryColor"];
            this.ipAddress = _data["ipAddress"];
        }
    }

    static fromJS(data: any): StoreDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StoreDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["encryptedId"] = this.encryptedId;
        data["storename"] = this.storename;
        data["startingHourOfTheDay"] = this.startingHourOfTheDay;
        data["beginDayOfWeek"] = this.beginDayOfWeek;
        data["dataMinerAccessKey"] = this.dataMinerAccessKey;
        data["companyId"] = this.companyId;
        data["companyName"] = this.companyName;
        data["selfOrderingSetting"] = this.selfOrderingSetting ? this.selfOrderingSetting.toJSON() : <any>undefined;
        if (Array.isArray(this.settingTabs)) {
            data["settingTabs"] = [];
            for (let item of this.settingTabs)
                data["settingTabs"].push(item ? item.toJSON() : <any>undefined);
        }
        data["storeSetting"] = this.storeSetting;
        data["connectionStatus"] = this.connectionStatus;
        data["pointBalanceAccessKey"] = this.pointBalanceAccessKey;
        data["greetingMessage"] = this.greetingMessage;
        data["logoLink"] = this.logoLink;
        data["primaryColor"] = this.primaryColor;
        data["ipAddress"] = this.ipAddress;
        return data;
    }
}

export interface IStoreDTO {
    id?: number;
    encryptedId?: string | undefined;
    storename?: string | undefined;
    startingHourOfTheDay?: number;
    beginDayOfWeek?: DayOfWeek;
    dataMinerAccessKey?: string | undefined;
    companyId?: number | undefined;
    companyName?: string | undefined;
    selfOrderingSetting?: SelfOrderingSettingDto | undefined;
    settingTabs?: SettingTab[] | undefined;
    storeSetting?: string | undefined;
    connectionStatus?: string | undefined;
    pointBalanceAccessKey?: string | undefined;
    greetingMessage?: string | undefined;
    logoLink?: string | undefined;
    primaryColor?: string | undefined;
    ipAddress?: string | undefined;
}

export enum DayOfWeek {
    Sunday = "Sunday",
    Monday = "Monday",
    Tuesday = "Tuesday",
    Wednesday = "Wednesday",
    Thursday = "Thursday",
    Friday = "Friday",
    Saturday = "Saturday",
}

export class SelfOrderingSettingDto implements ISelfOrderingSettingDto {
    selfOrderingSettingItems?: SelfOrderingSettingItem[] | undefined;

    constructor(data?: ISelfOrderingSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["selfOrderingSettingItems"])) {
                this.selfOrderingSettingItems = [] as any;
                for (let item of _data["selfOrderingSettingItems"])
                    this.selfOrderingSettingItems!.push(SelfOrderingSettingItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SelfOrderingSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelfOrderingSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.selfOrderingSettingItems)) {
            data["selfOrderingSettingItems"] = [];
            for (let item of this.selfOrderingSettingItems)
                data["selfOrderingSettingItems"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ISelfOrderingSettingDto {
    selfOrderingSettingItems?: SelfOrderingSettingItem[] | undefined;
}

export class SelfOrderingSettingItem implements ISelfOrderingSettingItem {
    fieldName?: string | undefined;
    value?: string | undefined;

    constructor(data?: ISelfOrderingSettingItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldName = _data["fieldName"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SelfOrderingSettingItem {
        data = typeof data === 'object' ? data : {};
        let result = new SelfOrderingSettingItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldName"] = this.fieldName;
        data["value"] = this.value;
        return data;
    }
}

export interface ISelfOrderingSettingItem {
    fieldName?: string | undefined;
    value?: string | undefined;
}

export class SettingTab implements ISettingTab {
    tabType?: SettingTabType;
    items?: SettingItem[];

    constructor(data?: ISettingTab) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tabType = _data["tabType"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SettingItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SettingTab {
        data = typeof data === 'object' ? data : {};
        let result = new SettingTab();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tabType"] = this.tabType;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface ISettingTab {
    tabType?: SettingTabType;
    items?: SettingItem[];
}

export enum SettingTabType {
    SelfOrdering = "SelfOrdering",
    MCRPrcieChecker = "MCRPrcieChecker",
    NationsBenefits = "NationsBenefits",
    UberEAT = "UberEAT",
    ExternalFileProcessing = "ExternalFileProcessing",
}

export class SettingItem implements ISettingItem {
    fieldName?: string | undefined;
    value?: string | undefined;
    /** 扩展字段 */
    extra?: { [key: string]: string; } | undefined;

    constructor(data?: ISettingItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldName = _data["fieldName"];
            this.value = _data["value"];
            if (_data["extra"]) {
                this.extra = {} as any;
                for (let key in _data["extra"]) {
                    if (_data["extra"].hasOwnProperty(key))
                        (<any>this.extra)![key] = _data["extra"][key];
                }
            }
        }
    }

    static fromJS(data: any): SettingItem {
        data = typeof data === 'object' ? data : {};
        let result = new SettingItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldName"] = this.fieldName;
        data["value"] = this.value;
        if (this.extra) {
            data["extra"] = {};
            for (let key in this.extra) {
                if (this.extra.hasOwnProperty(key))
                    (<any>data["extra"])[key] = (<any>this.extra)[key];
            }
        }
        return data;
    }
}

export interface ISettingItem {
    fieldName?: string | undefined;
    value?: string | undefined;
    /** 扩展字段 */
    extra?: { [key: string]: string; } | undefined;
}

export class StoresDTO implements IStoresDTO {
    stores?: StoreDTO[] | undefined;

    constructor(data?: IStoresDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["stores"])) {
                this.stores = [] as any;
                for (let item of _data["stores"])
                    this.stores!.push(StoreDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StoresDTO {
        data = typeof data === 'object' ? data : {};
        let result = new StoresDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.stores)) {
            data["stores"] = [];
            for (let item of this.stores)
                data["stores"].push(item ? item.toJSON() : <any>undefined);
        }
        return data;
    }
}

export interface IStoresDTO {
    stores?: StoreDTO[] | undefined;
}

export class ExcuteJobResponse implements IExcuteJobResponse {
    logFilePath?: string | undefined;
    productCsvPath?: string | undefined;
    logContent?: string | undefined;
    productCsvFileLastModified?: string | undefined;

    constructor(data?: IExcuteJobResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logFilePath = _data["logFilePath"];
            this.productCsvPath = _data["productCsvPath"];
            this.logContent = _data["logContent"];
            this.productCsvFileLastModified = _data["productCsvFileLastModified"];
        }
    }

    static fromJS(data: any): ExcuteJobResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExcuteJobResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logFilePath"] = this.logFilePath;
        data["productCsvPath"] = this.productCsvPath;
        data["logContent"] = this.logContent;
        data["productCsvFileLastModified"] = this.productCsvFileLastModified;
        return data;
    }
}

export interface IExcuteJobResponse {
    logFilePath?: string | undefined;
    productCsvPath?: string | undefined;
    logContent?: string | undefined;
    productCsvFileLastModified?: string | undefined;
}

export class EventResponse extends ResponseBase implements IEventResponse {
    contentModel!: EventItemModel;

    constructor(data?: IEventResponse) {
        super(data);
        if (!data) {
            this.contentModel = new EventItemModel();
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.contentModel = _data["contentModel"] ? EventItemModel.fromJS(_data["contentModel"]) : new EventItemModel();
        }
    }

    static override fromJS(data: any): EventResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EventResponse();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contentModel"] = this.contentModel ? this.contentModel.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IEventResponse extends IResponseBase {
    contentModel: EventItemModel;
}

export class EventItemModel implements IEventItemModel {
    eventId!: number;
    eventDesc!: string;
    eventDate!: Date;
    approved!: EventApproved;
    approvrdById!: string;
    approvedByName!: string;
    jrCashierId!: number;
    jrCashierName!: string;
    neededManagerLevel!: number;
    jrtrx!: string;
    reg!: string;

    constructor(data?: IEventItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventId = _data["eventId"];
            this.eventDesc = _data["eventDesc"];
            this.eventDate = _data["eventDate"] ? new Date(_data["eventDate"].toString()) : <any>undefined;
            this.approved = _data["approved"];
            this.approvrdById = _data["approvrdById"];
            this.approvedByName = _data["approvedByName"];
            this.jrCashierId = _data["jrCashierId"];
            this.jrCashierName = _data["jrCashierName"];
            this.neededManagerLevel = _data["neededManagerLevel"];
            this.jrtrx = _data["jrtrx"];
            this.reg = _data["reg"];
        }
    }

    static fromJS(data: any): EventItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new EventItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventId"] = this.eventId;
        data["eventDesc"] = this.eventDesc;
        data["eventDate"] = this.eventDate ? this.eventDate.toISOString() : <any>undefined;
        data["approved"] = this.approved;
        data["approvrdById"] = this.approvrdById;
        data["approvedByName"] = this.approvedByName;
        data["jrCashierId"] = this.jrCashierId;
        data["jrCashierName"] = this.jrCashierName;
        data["neededManagerLevel"] = this.neededManagerLevel;
        data["jrtrx"] = this.jrtrx;
        data["reg"] = this.reg;
        return data;
    }
}

export interface IEventItemModel {
    eventId: number;
    eventDesc: string;
    eventDate: Date;
    approved: EventApproved;
    approvrdById: string;
    approvedByName: string;
    jrCashierId: number;
    jrCashierName: string;
    neededManagerLevel: number;
    jrtrx: string;
    reg: string;
}

export enum EventApproved {
    Awaiting_Authorization = "Awaiting_Authorization",
    Authorized = "Authorized",
    Deny_Authorization = "Deny_Authorization",
    Cancel_Authorization = "Cancel_Authorization",
}

export class UsersDto implements IUsersDto {
    id?: number;
    userName?: string | undefined;
    companyName?: string | undefined;
    stores?: string | undefined;

    constructor(data?: IUsersDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userName = _data["userName"];
            this.companyName = _data["companyName"];
            this.stores = _data["stores"];
        }
    }

    static fromJS(data: any): UsersDto {
        data = typeof data === 'object' ? data : {};
        let result = new UsersDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userName"] = this.userName;
        data["companyName"] = this.companyName;
        data["stores"] = this.stores;
        return data;
    }
}

export interface IUsersDto {
    id?: number;
    userName?: string | undefined;
    companyName?: string | undefined;
    stores?: string | undefined;
}

export class UpdateUser implements IUpdateUser {
    companyName?: string | undefined;
    stores?: string | undefined;

    constructor(data?: IUpdateUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.stores = _data["stores"];
        }
    }

    static fromJS(data: any): UpdateUser {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["stores"] = this.stores;
        return data;
    }
}

export interface IUpdateUser {
    companyName?: string | undefined;
    stores?: string | undefined;
}

export class SwaggerResponse<TResult> {
    status: number;
    headers: { [key: string]: any; };
    result: TResult;

    constructor(status: number, headers: { [key: string]: any; }, result: TResult)
    {
        this.status = status;
        this.headers = headers;
        this.result = result;
    }
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}